/**
 * CUSTOMIFY AI PHOTO CUSTOMIZATION
 * Clean JavaScript implementation for Shopify theme integration
 */

// ============================================================
// PRODUCT CUSTOM FIELDS CONFIG
// Klucz = product handle z URL.
// ============================================================
const GOOGLE_ADS_PHOTO_UPLOAD = Object.freeze({
  tagId: 'AW-18383629305',
  sendTo: 'AW-18383629305/Wh-BCJfn-OkcEPnX_71E'
});

const PRODUCT_FIELD_CONFIGS = {
"custom-mafia-boss-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Seated in a leather chair","options":["Seated in a leather chair","Standing in a library","By a vintage car"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.mafia_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-mafia-queen-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Seated in a leather chair","options":["Seated in a leather chair","Standing in a library","By a vintage car"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.mafia_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-royal-king-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In a palace gallery","options":["In a palace gallery","Seated on a throne","By tall windows"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.royal_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-viking-man-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a Nordic fjord","options":["By a Nordic fjord","Beside a longship","In a great hall"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.viking"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-viking-woman-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a Nordic fjord","options":["By a Nordic fjord","Beside a longship","In a great hall"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.viking"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-knight-man-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a castle archway","options":["By a castle archway","In a great hall","In a castle courtyard"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.knight_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-knight-woman-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a castle archway","options":["By a castle archway","In a great hall","In a castle courtyard"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.knight_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-knight-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a castle archway","options":["By a castle archway","In a great hall","In a castle courtyard"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.knight_portrait"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
  'personalisierte-paar-karikatur-vom-foto': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add a signature or dedication - it will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Power Couple', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text', maxLength: 80 }
    ]
  },
"custom-western-saloon-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Standing","options":["Standing","Seated at a table","On horseback"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.saloon"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-romantic-woman-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"As shown in the product image","options":["As shown in the product image","Standing in the garden","By a stone balcony"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.romantic"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-royal-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"One seated, one standing","options":["One seated, one standing","Both standing","Both seated"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.royal"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-elegant-legacy-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"As shown in the product image","options":["As shown in the product image","Standing together","Seated together"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.legacy"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-family-memory-swing-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"On the swing","options":["On the swing","On a bench","Standing together"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.swing"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-couple-memory-swing-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"On the swing","options":["On the swing","On a bench","Standing together"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.swing"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-highland-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"On a Highland ridge","options":["On a Highland ridge","Beside a stone castle","By a misty loch"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.highland"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-viking-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"By a Nordic fjord","options":["By a Nordic fjord","Beside a longship","In a great hall"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.viking"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-fairytale-child-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"As shown in the product image","options":["As shown in the product image","Standing in the garden","Holding a small bouquet"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.fairytale"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-dynasty-family-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In a stately manor","options":["In a stately manor","In a grand library","On a garden terrace"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.dynasty"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-floral-grace-woman-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In a flower conservatory","options":["In a flower conservatory","By a stone balustrade","On a rose garden path"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.floral"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-grand-ballroom-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Dancing in the ballroom","options":["Dancing in the ballroom","Standing beneath chandeliers","By tall ballroom windows"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.ballroom"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-regal-oath-man-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In an old great hall","options":["In an old great hall","In a private library","By a tall stone window"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.regal"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-tree-of-life-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Beneath the ancient tree","options":["Beneath the ancient tree","In a wildflower meadow","Overlooking rolling hills"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.tree"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-deco-gentleman-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In an Art Deco lobby","options":["In an Art Deco lobby","By a vintage car","At a grand staircase"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.deco"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-sapphire-queen-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In a palace gallery","options":["In a palace gallery","By tall windows","On a garden terrace"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.sapphire"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-little-aviator-child-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Beside a parked plane","options":["Beside a parked plane","In an airfield hangar","On a grassy runway"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.aviator"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-modern-power-couple-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"In a city penthouse","options":["In a city penthouse","By skyline windows","On a rooftop terrace"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.power"},{"id":"imiona","label":"Add a short dedication (optional)","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","maxLength":60,"localizationKey":"customizer.field.story_dedication"}]},
"custom-pirate-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"Standing together on deck","options":["Standing together on deck","At the ship’s wheel","Seated on a chest"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.pirate"},{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","localizationKey":"customizer.field.story_dedication","maxLength":60}]},
"custom-bonnie-and-clyde-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-wild-west-cowboy-portrait-from-photo": {"title":"Personalize your portrait","fields":[{"id":"scene_pose","label":"Pose or scene (optional)","type":"select","required":false,"promptKey":"SCENE_POSE","defaultValue":"On horseback","options":["On horseback","Standing in town","Standing against a canyon"],"localizationKey":"customizer.field.story_scene","optionLocalizationKey":"customizer.story.cowboy"},{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"promptKey":"FLOATING_TEXT","localizationKey":"customizer.field.story_dedication","maxLength":60}]},
"custom-minecraft-style-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-lego-style-brick-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-cubist-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-japanese-style-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-victorian-lady-portrait-from-photo": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
"custom-native-american-inspired-headdress-portrait": {"title":"Add a dedication","fields":[{"id":"imiona","label":"Add a signature or dedication – it will appear near the bottom of the artwork","type":"text","placeholder":"e.g. Forever Together","required":false,"localizationKey":"customizer.field.watercolor_text"}]},
  'soft-watercolor-couple-portrait-from-photo': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add text, names, or a dedication - it will appear safely near the bottom of the image', type: 'text', placeholder: 'e.g. Forever Together', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text', maxLength: 80 }
    ]
  },
  'splash-watercolor-portrait-from-photo': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add text, names, or a dedication - it will appear safely near the bottom of the image', type: 'text', placeholder: 'e.g. Forever Together', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text', maxLength: 80 }
    ]
  },
  'delicate-watercolor-portrait-from-photo': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add text, names, or a dedication - it will appear safely near the bottom of the image', type: 'text', placeholder: 'e.g. Forever Together', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text', maxLength: 80 }
    ]
  },
  'classic-watercolor-portrait-from-photo': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add text, names, or a dedication - it will appear safely near the bottom of the image', type: 'text', placeholder: 'e.g. Forever Together', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text', maxLength: 80 }
    ]
  },
  'obraz-ze-zdjecia-akwarela': {
    title: 'Personalization',
    fields: [
      { id: 'napis', label: 'Add a signature or dedication - it will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Power Couple', required: false, promptKey: 'WATERCOLOR_TEXT', localizationKey: 'customizer.field.watercolor_text' }
    ]
  },
  'obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Add a signature or dedication - it will appear near the bottom of the artwork', type: 'text', placeholder: 'e.g. My Queen', required: false, promptKey: 'FLOATING_TEXT', localizationKey: 'customizer.field.watercolor_text' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-policjantka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-lekarka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-psycholog': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-kucharka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-fitness': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nurse, travel | teacher, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-dla-niej-szefowa': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. store owner, groceries', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. farmer, fisherman, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. farmer, tractor, field, countryside', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. mechanic, workshop, tools, car', required: false, promptKey: 'personalization' }
    ]
  },
  'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. motorcycle, road, passion for riding', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Kacper', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. soccer player, winner, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Karol', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 35', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. firefighter, rescuer, hero', required: false, promptKey: 'personalization' }
    ]
  },
  'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Piotr', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. doctor, surgeon, pediatrician', required: false, promptKey: 'personalization' }
    ]
  },
  'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Marek', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. construction worker, bricklayer, foreman', required: false, promptKey: 'personalization' }
    ]
  },
  'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Tomek', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. truck driver, road, travel', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Marek', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. police officer, detective, guard', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-szefa': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Marek', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. company owner, CEO, office', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna i Marek', required: false, promptKey: 'name' },
      { id: 'opis_charakteru', label: 'Describe the couple, mood, and details - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. grandparents, family, travel, shared hobby', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Babcia i Dziadek', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Number of years / anniversary - enter the exact number that should appear large on the image (e.g. 50, 55, 60)', type: 'text', placeholder: 'e.g. 50, 55, 60', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the people, mood, and details - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. garden, gold, family', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Ania i Piotr', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Liczba lat / rocznica (jubileusz) — opcjonalne, puste = brak liczby na obrazku', type: 'text', placeholder: 'e.g. 30, 40, 45', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the couple, mood, and details - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. travel, suitcases, world map, airplane', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Name / dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Emily and Mark', required: false, promptKey: 'name' },
      { id: 'poza', label: 'Couple pose', type: 'select', required: false, promptKey: 'POSE', options: [
        'As in the photo',
        'Standing side by side',
        'Sitting together',
        'He is holding her in his arms',
        'Dancing / embracing',
        'Romantic pose (he is kneeling)'
      ]},
      { id: 'ubranie_pana', label: "Groom's outfit", type: 'text', placeholder: 'e.g. green suit, black tuxedo, navy blazer', required: false, promptKey: 'GROOM_OUTFIT' },
      { id: 'ubranie_panny', label: "Bride's outfit", type: 'text', placeholder: 'e.g. white dress with a veil, strapless wedding dress', required: false, promptKey: 'BRIDE_OUTFIT' },
      { id: 'tlo', label: 'Background / location', type: 'text', placeholder: 'e.g. church, outdoor ceremony, wedding venue, beach at sunset', required: false, promptKey: 'WEDDING_BG' },
      { id: 'opis_charakteru', label: 'What else should appear in the image? (optional)', type: 'text', placeholder: 'e.g. pink bouquet, cake, no text, gold accents', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anniversary Couple', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Enter the anniversary year count - this number will appear on the image', type: 'text', placeholder: 'e.g. 25, 30, 40, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the location, style, and colors - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. elegant, gold, flowers, celebration', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anniversary Couple', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Enter the anniversary year count - this number will appear on the image', type: 'text', placeholder: 'e.g. 25, 30, 40, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the location, style, and colors - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. elegant, gold, flowers, celebration', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anniversary Couple', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Enter the anniversary year count - this number will appear on the image', type: 'text', placeholder: 'e.g. 20, 30, 40', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the location, style, and colors - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. elegant, gold, flowers, celebration', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. fisherman, fish, lake', required: false, promptKey: 'personalization' }
    ]
  },
  'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. soccer player, soccer, football', required: false, promptKey: 'personalization' }
    ]
  },
  'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Jan', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. bodybuilder, gym, sports', required: false, promptKey: 'personalization' }
    ]
  },
  'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. fitness, sports, gym', required: false, promptKey: 'personalization' }
    ]
  },
  'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. fitness, sports, gym', required: false, promptKey: 'personalization' }
    ]
  },
  'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. nail salon, nails, lashes', required: false, promptKey: 'personalization' }
    ]
  },
  'portret-ze-zdjecia-superbohater-prezent-dla-chlopca': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name - it will appear on the superhero-style poster', type: 'text', placeholder: 'e.g. Kuba, Wojtek', required: false, promptKey: 'name' }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Ania', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 40', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. fitness, travel, fashion', required: false, promptKey: 'personalization' }
    ]
  },
  'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 18, 25, 30', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. glamour, Hollywood, red carpet', required: false, promptKey: 'personalization' }
    ]
  },
  'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent': {
    title: 'Personalization',
    fields: [
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'name' },
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 30', required: false, promptKey: 'YEARS' },
      { id: 'opis_charakteru', label: 'Describe the person, their job, or hobbies - this text will not appear on the image but shapes the final look', type: 'text', placeholder: 'e.g. teacher, school, books', required: false, promptKey: 'personalization' }
    ]
  },
  'obraz-ze-zdjecia-biznes-woman-personalizowany-prezent': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'NAMES' }
    ]
  },
  'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'NAMES' }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'NAMES' }
    ]
  },
  'obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna', required: false, promptKey: 'NAMES' }
    ]
  },
  'obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna i Marek', required: false, promptKey: 'NAMES' }
    ]
  },
  'obraz-ze-zdjecia-karykatura-na-50-ta-rocznice': {
    title: 'Personalization',
    fields: [
      { id: 'rocznica', label: 'Anniversary / number of years - this number will appear on the image', type: 'text', placeholder: 'e.g. 10, 25, 50', required: false, promptKey: 'YEARS' },
      { id: 'imiona', label: 'Enter a name or dedication - this text will appear at the bottom of the image', type: 'text', placeholder: 'e.g. Anna i Marek', required: false, promptKey: 'NAMES' }
    ]
  },
  'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk': {
    title: 'Personalization',
    multiUpload: true,
    maxImages: 8,
    fields: [
      { id: 'scena', label: 'Describe the scene or mood', type: 'text', placeholder: 'e.g. rodzinny obiad, spotkanie biznesowe, piknik w parku', required: false, promptKey: 'SCENE_DESC' },
      { id: 'dedykacja', label: 'Add text or dedication', type: 'text', placeholder: 'e.g. Dear Mom, Happy Holidays!', required: false, promptKey: 'DEDICATION' }
    ]
  },
  'prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia': {
    title: 'Personalization',
    fields: [
      { id: 'napis_banner', label: 'Add text to appear on the ribbon in the image', type: 'text', placeholder: 'e.g. Anna and Mark, always together', required: false, promptKey: 'BANNER_TEXT' }
    ]
  },
  'portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany': {
    title: 'Personalization',
    fields: [
      { id: 'napis_banner', label: 'Add text to appear on the ribbon in the image', type: 'text', placeholder: 'e.g. Royal Love, 15 years together', required: false, promptKey: 'BANNER_TEXT' }
    ]
  },
  'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent': {
    title: 'Personalization',
    fields: [
      { id: 'napis_gta', label: 'Add text at the bottom (optional)', type: 'text', placeholder: 'e.g. Power Couple', required: false, promptKey: 'GTA_TEXT', localizationKey: 'customizer.field.gta_text', maxLength: 80 },
      { id: 'wyglad_gta', label: 'Outfit / look', type: 'select', required: false, promptKey: 'GTA_LOOK', localizationKey: 'customizer.field.gta_look', optionLocalizationKey: 'customizer.gta.look', defaultValue: 'Vice City – Hawaiian shirt, bikini/crop top', options: [
        'Vice City – Hawaiian shirt, bikini/crop top', 'Gangster – gold chains, tank top, bandana', 'Street – leather jacket, hoodie, sneakers', 'Boss – suit, cocktail dress', 'As in the photo'
      ]},
      { id: 'scena_gta', label: 'Scene / city', type: 'select', required: false, promptKey: 'GTA_SCENE', localizationKey: 'customizer.field.gta_scene', optionLocalizationKey: 'customizer.gta.scene', defaultValue: 'Vice City – beach, palms, neon', options: [
        'Vice City – beach, palms, neon', 'Los Santos – downtown, skyscrapers', 'City at night – rain, neon', 'Hills – pool villa, city view', 'Garage / workshop'
      ]},
      { id: 'pojazd_gta', label: 'Vehicle', type: 'select', required: false, promptKey: 'GTA_VEHICLE', localizationKey: 'customizer.field.gta_vehicle', optionLocalizationKey: 'customizer.gta.vehicle', defaultValue: 'Supercar', options: [
        'Supercar', 'Motorcycle', 'Retro convertible', 'Helicopter in the background', 'No vehicle'
      ]},
      { id: 'klimat_gta', label: 'Mood', type: 'select', required: false, promptKey: 'GTA_MOOD', localizationKey: 'customizer.field.gta_mood', optionLocalizationKey: 'customizer.gta.mood', defaultValue: 'Action – money, explosions, police in the background', options: [
        'Action – money, explosions, police in the background', 'Relaxed – vacation, beach, drinks', 'Elegant – suits, casino, city at night'
      ]},
      { id: 'dodatki_gta', label: 'What else should be in the image? (optional)', type: 'text', placeholder: 'e.g. husky, guitar, my black BMW E46', required: false, promptKey: 'GTA_PROPS', localizationKey: 'customizer.field.gta_props', maxLength: 180 }
    ]
  },
  'obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny': {
    title: 'Personalization',
    fields: [
      { id: 'imie_nazwisko', label: 'Full name (signature at the bottom)', type: 'text', placeholder: 'e.g. MAREK SKWIERCZEK', required: true, promptKey: 'FORBES_SIGNATURE' },
      { id: 'haslo_1', label: 'Headline 1 (optional)', type: 'text', placeholder: 'Default: ARCHITECT OF YOUR OWN EMPIRE', required: false, promptKey: 'FORBES_MAIN_HEADLINE' },
      { id: 'haslo_2', label: 'Headline 2 (optional)', type: 'text', placeholder: 'Default: SUCCESS IS STRATEGY, NOT LUCK', required: false, promptKey: 'FORBES_SECOND_HEADLINE' }
    ]
  },
  'plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia': {
    title: 'Personalization',
    fields: [
      { id: 'imie_nazwisko', label: 'Full name (signature at the bottom)', type: 'text', placeholder: 'e.g. MAREK SKWIERCZEK', required: true, promptKey: 'FORBES_SIGNATURE' },
      { id: 'haslo_1', label: 'Headline 1 (optional)', type: 'text', placeholder: 'Default: ARCHITECT OF YOUR OWN EMPIRE', required: false, promptKey: 'FORBES_MAIN_HEADLINE' },
      { id: 'haslo_2', label: 'Headline 2 (optional)', type: 'text', placeholder: 'Default: SUCCESS IS STRATEGY, NOT LUCK', required: false, promptKey: 'FORBES_SECOND_HEADLINE' }
    ]
  }
};

/** Produkty "dla niej" z polem rocznica — używają innej logiki YEARS_SECTION (character zamiast woman, explicit "no numbers" gdy puste). */
const DLA_NIEJ_WITH_YEARS = ['obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania', 'obraz-ze-zdjecia-karykatura-dla-niej-policjantka', 'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka', 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka', 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka', 'obraz-ze-zdjecia-karykatura-dla-niej-psycholog', 'obraz-ze-zdjecia-karykatura-dla-niej-kucharka', 'obraz-ze-zdjecia-karykatura-dla-niej-fitness', 'obraz-ze-zdjecia-karykatura-dla-niej-szefowa', 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny', 'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem', 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata', 'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego', 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny', 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta', 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty', 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta', 'obraz-ze-zdjecia-karykatura-szefa', 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza', 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka', 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty', 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz', 'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz', 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle', 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy', 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa', 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle', 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan', 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent'];
const PERSONALIZATION_CONTEXT_TEXT_POLICY_HANDLES = new Set(DLA_NIEJ_WITH_YEARS);

/** Para + rocznica ślubu — YEARS jako duża cyfra w scenie (nie logika „pojedyncza postać z DLA_NIEJ_WITH_YEARS”). */
const COUPLE_ANNIVERSARY_FIELD_HANDLES = ['karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu'];

const DIAMENTOWE_GODY_PRODUCT_HANDLE = 'karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu';
/** Karykatura „Weseli staruszkowie” — jak Diamentowe Gody (prepend opisu). Handle = lumly.pl/products/karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent */
const WIESELI_STARUSZKOWIE_PRODUCT_HANDLE = 'karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent';
/** Karykatura pary podróżników — domyślna rocznica 40 i styl podróżnicy. */
const PODROZNICY_PARA_PRODUCT_HANDLE = 'karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary';
/** Karykatura ślubna młodej pary — bez domyślnej liczby, domyślny klimat ślubny. */
const MLODA_PARA_SLUB_PRODUCT_HANDLE = 'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary';
/** Karykatura rocznicowa ślubu — ma pole liczby, ale bez domyślnej liczby gdy puste. */
const ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE = 'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie';
/** Karykatura 50 rocznica slubu — domyślna liczba 50 w prompcie gdy pole YEARS puste. */
const ROCZNICA_50_SLUBU_PRODUCT_HANDLE = 'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie';
const ROCZNICA_40_SLUBU_PRODUCT_HANDLE = 'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie';

/** Para — duża cyfra jubileuszowa z pola formularza (dokładnie jak wpisał klient; inna liczba = inna na obrazku). */
const COUPLE_CUSTOM_YEAR_FIELD_HANDLES = [WIESELI_STARUSZKOWIE_PRODUCT_HANDLE, PODROZNICY_PARA_PRODUCT_HANDLE, ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE, ROCZNICA_50_SLUBU_PRODUCT_HANDLE, ROCZNICA_40_SLUBU_PRODUCT_HANDLE];
/** Produkty z domyślną rocznicą 40, gdy pole YEARS puste. */
const COUPLE_DEFAULT_40_YEAR_FIELD_HANDLES = [ROCZNICA_40_SLUBU_PRODUCT_HANDLE];
/** Produkty z domyślną rocznicą 50, gdy pole YEARS puste (tylko 50-lecie ślubu). */
const COUPLE_DEFAULT_50_YEAR_FIELD_HANDLES = [ROCZNICA_50_SLUBU_PRODUCT_HANDLE];
/** Para podróżników / ogólna rocznica — gdy YEARS puste, nie dodawaj domyślnej liczby (albo inna reguła per produkt). */
const COUPLE_NO_DEFAULT_YEAR_FIELD_HANDLES = [PODROZNICY_PARA_PRODUCT_HANDLE, ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE];

/** Personalizacja: baza zawsze w promptcie + opcjonalnie dopisek klienta (opcja B). */
const PERSONALIZATION_PREPEND_BASE_HANDLES = new Set([
  DIAMENTOWE_GODY_PRODUCT_HANDLE,
  WIESELI_STARUSZKOWIE_PRODUCT_HANDLE,
  PODROZNICY_PARA_PRODUCT_HANDLE,
  MLODA_PARA_SLUB_PRODUCT_HANDLE,
  ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE,
  ROCZNICA_50_SLUBU_PRODUCT_HANDLE,
  ROCZNICA_40_SLUBU_PRODUCT_HANDLE,
  'obraz-ze-zdjecia-karykatura-szefa'
]);

/** Domyślne wartości "Opis osoby" per produkt — na stałe, niezależne od tytułu. Gdy pole puste, używamy tej wartości. */
const DEFAULT_PERSONALIZATION_PER_PRODUCT = {
  'obraz-ze-zdjecia-karykatura-dla-niej-lekarka': 'lekarka, szpital, medycyna, stetoskop',
  'obraz-ze-zdjecia-karykatura-dla-niej-policjantka': 'policjantka, policja, mundur',
  'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka': 'rolniczka, farmerka, wieś, rolnictwo',
  'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka': 'podróżniczka, podróże, walizka',
  'obraz-ze-zdjecia-karykatura-dla-niej-psycholog': 'psycholog, gabinet',
  'obraz-ze-zdjecia-karykatura-dla-niej-kucharka': 'kucharka, gotowanie, kuchnia',
  'obraz-ze-zdjecia-karykatura-dla-niej-fitness': 'fitness, sport, aktywność',
  'obraz-ze-zdjecia-karykatura-dla-niej-szefowa': 'szefowa sklepu spożywczego, produkty, zarządzanie',
  'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle': 'fitness, sport, aktywność fizyczna',
  'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy': 'fitness, sport, aktywność fizyczna',
  'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa': 'nail salon, nails, lashes',
  'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle': 'glamorous woman, red sequin dress, Hollywood red carpet, paparazzi, spotlights, champagne, black and gold luxury',
  'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan': 'glamorous woman, red carpet, elegant dress, Hollywood spotlight, birthday celebration, 40th birthday',
  'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent': 'teacher, smart blazer, blackboard with chalk drawings, warm classroom, bookshelves, cozy academic atmosphere',
  'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania': 'elegant, versatile person',
  'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny': 'rolnik, farmer, wieś, rolnictwo',
  'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem': 'polski farmer, tractor, field, countryside',
  'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata': 'mechanik samochodowy, warsztat, narzędzia, auto',
  'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego': 'motocyklista, motor, trasa, pasja do jazdy',
  'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny': 'kulturysta, bodybuilding, siłownia, mięśnie',
  'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta': 'wędkarz, wędkarstwo, ryby, jezioro',
  'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty': 'soccer player, soccer, football, trofeum',
  'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta': 'American police officer, U.S. police uniform, badge, patrol car',
  'obraz-ze-zdjecia-karykatura-szefa': 'szef firmy, boss, prezes, w biurze',
  'karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu': 'Elegancka grafika napisem \u201eDiamentowe Gody\u201d',
  'karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent': 'Weseli staruszkowie',
  'karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary': 'Podróżnicy, podróże, walizki, mapa świata',
  'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary': 'young wedding couple, elegant wedding styling, romantic atmosphere',
  'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie': 'Anniversary Couple ślubu, elegancka celebracja',
  'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie': 'Anniversary Couple ślubu, elegancka celebracja',
  'karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie': 'Anniversary Couple ślubu, elegancka celebracja',
  'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza': 'American firefighter, U.S. turnout gear, fire helmet, fire hose, red fire engine',
  'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka': 'lekarz, biały fartuch, stetoskop, medycyna',
  'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty': 'construction worker, bricklayer, foreman, kask, narzędzia',
  'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz': 'American truck driver, long-hood semi-truck, highway, road travel',
  'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz': 'piłkarz, zwycięzca, football, trofeum'
};

// 🏷️ Rozbudowane nazwy rodzajów wydruku (koszyk, zamówienie) – jedno źródło prawdy
const PRODUCT_TYPE_LABELS = {
  plakat: 'Poster - photographic paper print',
  canvas: 'Canvas print',
  szklo: 'Unavailable print type',
  digital: 'Digital file download',
  spotify_frame: 'Spotify frame with photo',
  etui: 'Phone case with your photo'
};

window.CustomifyHideGlassPrint = true;

const LUMLY_USA_PRODUCT_HANDLE_ALIASES = {
  'personalisiertes-mafiaboss-portraet-vom-foto': 'custom-mafia-boss-portrait-from-photo',
  'personalisiertes-mafia-queen-portraet-vom-foto': 'custom-mafia-queen-portrait-from-photo',
  'personalisiertes-koenigsportraet-vom-foto': 'custom-royal-king-portrait-from-photo',
  'personalisiertes-wikingerportraet-vom-foto': 'custom-viking-man-portrait-from-photo',
  'personalisiertes-wikingerinnenportraet-vom-foto': 'custom-viking-woman-portrait-from-photo',
  'personalisiertes-ritterportraet-vom-foto': 'custom-knight-man-portrait-from-photo',
  'personalisiertes-ritterinnenportraet-vom-foto': 'custom-knight-woman-portrait-from-photo',
  'personalisiertes-ritter-paarportraet-vom-foto': 'custom-knight-couple-portrait-from-photo',
  'custom-portrait-watercolor': 'obraz-ze-zdjecia-akwarela',
  'personalisiertes-aquarell-portraet-vom-foto': 'obraz-ze-zdjecia-akwarela',
  'together-couple-portrait-from-two-photos': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'custom-couple-painting-from-two-photos': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'family-portrait-add-loved-one': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'grandparents-and-grandchildren-portrait-from-photos': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'grosseltern-enkel-familienportraet-aus-fotos': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'personalisiertes-paarportraet-aus-zwei-fotos': 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk',
  'personalized-dog-caricature-portrait-from-photo': 'portret-karykatura-psa-ze-zdjecia-personalizowany-prezent',
  'personalized-minimalist-portrait-from-photo': 'personalizowany-portret-w-stylu-boho',
  'custom-couple-caricature-from-photo-funny-personalized-anniversary-canvas': 'karykatura-prezent-na-rocznice-prezent-ze-zdjecia',
  'personalized-gta-style-portrait-from-photo-personalized-gaming-gift-for-couple': 'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent',
  'active-woman-portrait-photo-anniversary-print-glass': 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle',
  'fitness-girl-caricature-photo': 'obraz-ze-zdjecia-karykatura-dla-niej-fitness',
  'truck-driver-caricature-gift': 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz',
  'bodybuilder-caricature-photo-gift': 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny',
  'boss-caricature-from-photo-personalized-gift': 'obraz-ze-zdjecia-karykatura-szefa',
  'car-mechanic-caricature-from-photo-personalized-gift': 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata',
  'construction-worker-caricature-from-photo-personalized-gift': 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty',
  'traveler-caricature-from-photo-personalized-gift-for-her': 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka',
  'wedding-caricature-from-photo-personalized-gift-for-newlyweds': 'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary',
  'wedding-caricature-from-photo-personalized-gift-for-couple': 'karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary',
  '50th-wedding-anniversary-caricature-from-photo': 'karykatura-na-50-rocznice-slubu-prezent-na-50-lecie',
  'personalized-wedding-anniversary-caricature-from-photo': 'karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie',
  'doctor-caricature-personalized-birthday-gift': 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka',
  'female-doctor-caricature-from-photo': 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka',
  'firefighter-caricature-from-photo-birthday-gift-for-husband': 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza',
  'police-officer-caricature-from-photo-gift-for-him': 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta',
  'soccer-player-caricature-from-photo': 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty',
  'caricature-fisherman-personalized-gift': 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta',
  'forbes-style-cover-photo-print-gold': 'obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny',
  'image-from-photo-business-woman-gift': 'obraz-ze-zdjecia-biznes-woman-personalizowany-prezent',
  'picture-from-photo-personalized-gift-for-her-watercolor': 'obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela',
  'picture-from-photo-western-style-gift': 'obraz-ze-zdjecia-dla-kobiety-w-stylu-western-wanted-poszukiwana',
  'image-from-photo-gift-for-women-birthday': 'obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman',
  'canvas-print-from-photo-gift-for-woman-40th-birthday': 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan',
  'image-from-photo-gift-for-50th-birthday': 'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman',
  'personalized-photo-print-western-wanted': 'personalizowany-obraz-z-twojego-zdjecia-dla-mezczyzny-w-stylu-western-wanted',
  'forbes-style-cover-poster-silver': 'plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia',
  'portrait-for-teacher-anniversary': 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent',
  'child-portrait-unicorn-outfit': 'portret-dziecka-w-stroju-jednorozca-obraz-ze-zdjecia-dla-dziewczynki',
  '18th-birthday-portrait-girl-red-carpet-glamour': 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle',
  '18th-birthday-portrait-for-girl-sport-glass-print': 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy',
  'portrait-from-your-photo-neon-lights-gift-for-her': 'portret-z-twojego-zdjecia-neon-lights-dla-dziewczyny-prezent',
  'portrait-photo-girl-winter-princess': 'portret-ze-zdjecia-dla-dziewczynki-zimowa-ksiezniczka-obraz',
  'portrait-from-photo-birthday-gift-friend-manager': 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa',
  'hip-hop-style-portrait': 'portret-w-stylu-hip-hop-obraz-na-plotnie-z-twojego-zdjecia',
  'farmer-caricature-gift': 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny',
  'glass-print-business-woman-birthday-gift': 'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety'
};

function resolveLumlyUsaLogicHandle(handle) {
  const logicTag = Array.isArray(window.ShopifyProduct?.tags)
    ? window.ShopifyProduct.tags.find((tag) => String(tag).startsWith('customify-logic-handle='))
    : null;
  if (logicTag) return String(logicTag).slice('customify-logic-handle='.length) || handle;
  return LUMLY_USA_PRODUCT_HANDLE_ALIASES[handle] || handle;
}

const THEMED_STYLE_BY_HANDLE = Object.freeze({
  "custom-mafia-boss-portrait-from-photo": "mafia-boss",
  "custom-mafia-queen-portrait-from-photo": "mafia-queen",
  "custom-royal-king-portrait-from-photo": "royal-king",
  "custom-viking-man-portrait-from-photo": "viking-man",
  "custom-viking-woman-portrait-from-photo": "viking-woman",
  "custom-knight-man-portrait-from-photo": "knight-man",
  "custom-knight-woman-portrait-from-photo": "knight-woman",
  "custom-knight-couple-portrait-from-photo": "knight-couple",
  "custom-western-saloon-portrait-from-photo": "western-saloon",
  "custom-romantic-woman-portrait-from-photo": "romantic-woman",
  "custom-royal-couple-portrait-from-photo": "royal-couple",
  "custom-elegant-legacy-couple-portrait-from-photo": "elegant-legacy-couple",
  "custom-family-memory-swing-portrait-from-photo": "memory-swing",
  "custom-couple-memory-swing-portrait-from-photo": "memory-swing-couple",
  "custom-highland-couple-portrait-from-photo": "highland-couple",
  "custom-viking-couple-portrait-from-photo": "viking-couple",
  "custom-fairytale-child-portrait-from-photo": "fairytale-child",
  "custom-dynasty-family-portrait-from-photo": "dynasty-family",
  "custom-floral-grace-woman-portrait-from-photo": "floral-grace-woman",
  "custom-grand-ballroom-couple-portrait-from-photo": "grand-ballroom-couple",
  "custom-regal-oath-man-portrait-from-photo": "regal-oath-man",
  "custom-tree-of-life-couple-portrait-from-photo": "tree-of-life-couple",
  "custom-deco-gentleman-portrait-from-photo": "deco-gentleman",
  "custom-sapphire-queen-portrait-from-photo": "sapphire-queen",
  "custom-little-aviator-child-portrait-from-photo": "little-aviator",
  "custom-modern-power-couple-portrait-from-photo": "modern-power-couple",
  "custom-pirate-portrait-from-photo": "pirates",
  "custom-bonnie-and-clyde-portrait-from-photo": "bonnie-clyde",
  "custom-wild-west-cowboy-portrait-from-photo": "cowboys",
  "custom-minecraft-style-portrait-from-photo": "minecraft",
  "custom-lego-style-brick-portrait-from-photo": "brick-figures",
  "custom-cubist-portrait-from-photo": "cubist",
  "custom-japanese-style-portrait-from-photo": "japanese",
  "custom-victorian-lady-portrait-from-photo": "victorian-lady",
  "custom-native-american-inspired-headdress-portrait": "headdress-portrait"
});


const DEFAULT_WATERCOLOUR_STYLE_BY_PRODUCT = Object.freeze({
  'soft-watercolor-couple-portrait-from-photo': 'watercolor-soft-wash',
  'splash-watercolor-portrait-from-photo': 'watercolor-color-splash',
  'delicate-watercolor-portrait-from-photo': 'watercolor-delicate',
  'classic-watercolor-portrait-from-photo': 'watercolor-classic-realistic',
  'weiches-aquarell-paarportraet-vom-foto': 'watercolor-soft-wash',
  'farbenfrohes-aquarell-portraet-vom-foto': 'watercolor-color-splash',
  'zartes-aquarell-portraet-vom-foto': 'watercolor-delicate',
  'klassisches-aquarell-portraet-vom-foto': 'watercolor-classic-realistic'
});

function localizeLumlyUsaField(field) {
  const byPromptKey = {
    name: { label: 'Name or dedication - this text will appear at the bottom of the image', placeholder: 'e.g. Anna' },
    NAMES: { label: 'Names or dedication - this text will appear on the image', placeholder: 'e.g. Anna & Mark' },
    YEARS: { label: 'Anniversary / number of years - this number will appear on the image', placeholder: 'e.g. 10, 25, 50' },
    personalization: { label: 'Describe the person, job, hobby or theme - this will guide the image style', placeholder: 'e.g. nurse, travel | teacher, sport' },
    FORBES_SIGNATURE: { label: 'Name and surname (signature at the bottom)', placeholder: 'e.g. MARK SMITH' },
    FORBES_MAIN_HEADLINE: { label: 'Headline 1 (optional)', placeholder: 'Default: ARCHITECT OF MY OWN EMPIRE' },
    FORBES_SECOND_HEADLINE: { label: 'Headline 2 (optional)', placeholder: 'Default: SUCCESS IS STRATEGY, NOT LUCK' },
    SCENE_TYPE: { label: 'Scene type', placeholder: 'e.g. anniversary' },
    CHARACTER_DESC: { label: 'Describe the character or mood', placeholder: 'e.g. elegant, romantic, celebratory' },
    POSE: { label: 'Couple pose' },
    GROOM_OUTFIT: { label: "Groom's outfit", placeholder: 'e.g. green suit, black tuxedo, navy blazer' },
    BRIDE_OUTFIT: { label: "Bride's outfit", placeholder: 'e.g. white dress with a veil, strapless wedding dress' },
    WEDDING_BG: { label: 'Background / location', placeholder: 'e.g. church, outdoor ceremony, wedding venue, beach at sunset' },
    SCENE_DESC: { label: 'Describe the scene or mood', placeholder: 'e.g. family dinner, business meeting, picnic in the park' },
    DEDICATION: { label: 'Add text or dedication', placeholder: 'e.g. Dear Mom, Happy Holidays!' },
    BANNER_TEXT: { label: 'Add text to appear on the ribbon in the image', placeholder: 'e.g. Anna and Mark, always together' },
    GTA_TEXT: { label: 'You can add text; it will appear at the bottom of the image', placeholder: 'e.g. Power Couple' }
  };
  const i18nKeyByPromptKey = {
    name: 'customizer.field.name', NAMES: 'customizer.field.names', YEARS: 'customizer.field.years',
    personalization: 'customizer.field.personalization', FORBES_SIGNATURE: 'customizer.field.signature',
    FORBES_MAIN_HEADLINE: 'customizer.field.headline_1', FORBES_SECOND_HEADLINE: 'customizer.field.headline_2',
    SCENE_TYPE: 'customizer.field.scene_type', CHARACTER_DESC: 'customizer.field.character_description',
    POSE: 'customizer.field.couple_pose', GROOM_OUTFIT: 'customizer.field.groom_outfit',
    BRIDE_OUTFIT: 'customizer.field.bride_outfit', WEDDING_BG: 'customizer.field.wedding_background',
    SCENE_DESC: 'customizer.field.scene_description', DEDICATION: 'customizer.field.dedication',
    BANNER_TEXT: 'customizer.field.banner_text', GTA_TEXT: 'customizer.field.gta_text',
    GTA_LOOK: 'customizer.field.gta_look', GTA_SCENE: 'customizer.field.gta_scene',
    GTA_VEHICLE: 'customizer.field.gta_vehicle', GTA_MOOD: 'customizer.field.gta_mood',
    GTA_PROPS: 'customizer.field.gta_props'
  };
  const key = field.localizationKey || i18nKeyByPromptKey[field.promptKey];
  const i18n = window.CustomifyI18n;
  if (key && i18n && typeof i18n.t === 'function') {
    return {
      label: i18n.t(`${key}.label`),
      placeholder: field.placeholder ? i18n.t(`${key}.placeholder`) : undefined
    };
  }
  return byPromptKey[field.promptKey] || {
    label: field.label,
    placeholder: field.placeholder
  };
}

let customifyStorageWarningShown = false;

function warnStorageUnavailable(error) {
  if (customifyStorageWarningShown) return;
  customifyStorageWarningShown = true;
  console.warn('⚠️ [STORAGE] Browser storage is unavailable; continuing with server-side limits.', error?.message || error);
}

function safeLocalStorageGet(key, fallback = null) {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value;
  } catch (error) {
    warnStorageUnavailable(error);
    return fallback;
  }
}

function safeLocalStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    warnStorageUnavailable(error);
    return false;
  }
}

function safeLocalStorageRemove(key) {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    warnStorageUnavailable(error);
    return false;
  }
}

// Shared upload checks. Private file names never enter Sentry.
window.CustomifyPhotoUpload = (() => {
  const MAX_BYTES = 10 * 1024 * 1024;
  const TIMEOUT_MS = 20000;
  const reported = new WeakSet();

  function error(code, details = {}) {
    const result = new Error(`Photo upload: ${code}`);
    result.name = 'PhotoUploadError';
    result.code = code;
    result.details = details;
    return result;
  }

  function validateFile(file, maxBytes = MAX_BYTES) {
    if (!file || !String(file.type || '').startsWith('image/')) throw error('file_type');
    if (file.size > maxBytes) throw error('file_size');
    if (!file.size) throw error('file_empty');
  }

  // Only crop uploads opt in. Ordinary files keep their original bytes and latency.
  async function prepareCropFile(file) {
    validateFile(file, 30 * 1024 * 1024);
    if (file.size <= MAX_BYTES) return file;
    const image = new Image();
    let url;
    let timer;
    let canvas;
    try {
      await new Promise((resolve, reject) => {
        timer = setTimeout(() => reject(error('file_timeout')), TIMEOUT_MS);
        image.onload = () => resolve();
        image.onerror = () => reject(error('file_decode'));
        try { url = URL.createObjectURL(file); image.src = url; }
        catch (_) { reject(error('file_read')); }
      });
      clearTimeout(timer);
      const width = image.naturalWidth, height = image.naturalHeight;
      if (!width || !height) throw error('file_decode');
      // Bound canvas allocation on phones; never upscale a photo.
      if (width * height > 64000000) throw error('compression');
      const scale = Math.min(1, 4096 / Math.max(width, height));
      canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      const context = canvas.getContext('2d');
      if (!context) throw error('compression');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      for (const quality of [0.92, 0.85, 0.75]) {
        const blob = await withTimeout(new Promise((resolve, reject) => {
          canvas.toBlob(value => value ? resolve(value) : reject(error('compression')), 'image/jpeg', quality);
        }));
        if (blob.size > 0 && blob.size <= MAX_BYTES) {
          return new File([blob], 'prepared-photo.jpg', { type: 'image/jpeg', lastModified: file.lastModified });
        }
      }
      throw error('compression');
    } catch (failure) {
      throw failure?.code ? failure : error('compression');
    } finally {
      clearTimeout(timer);
      image.onload = image.onerror = null;
      image.src = '';
      if (url) URL.revokeObjectURL(url);
      if (canvas) { canvas.width = 0; canvas.height = 0; }
    }
  }

  function withTimeout(promise, code = 'file_timeout', timeoutMs = TIMEOUT_MS) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(error(code)), timeoutMs);
      Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timer));
    });
  }

  function probe(file, minDimension = 0) {
    validateFile(file);
    return new Promise((resolve, reject) => {
      const image = new Image();
      let url;
      let finished = false;
      const timer = setTimeout(() => finish(error('file_timeout')), TIMEOUT_MS);
      function finish(failure) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        image.onload = image.onerror = null;
        if (url) URL.revokeObjectURL(url);
        const width = image.naturalWidth || image.width;
        const height = image.naturalHeight || image.height;
        if (failure) reject(failure);
        else if (!width || !height) reject(error('file_decode'));
        else if (width < minDimension || height < minDimension) reject(error('file_resolution', { width, height, minimum: minDimension }));
        else resolve({ width, height });
      }
      image.onload = () => finish();
      image.onerror = () => finish(error('file_decode'));
      try { url = URL.createObjectURL(file); image.src = url; }
      catch (_) { finish(error('file_read')); }
    });
  }

  async function readDataURL(file) {
    validateFile(file);
    if (typeof FileReader === 'undefined') throw error('browser_unsupported');
    try {
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        const timer = setTimeout(() => { reject(error('file_timeout')); reader.abort(); }, TIMEOUT_MS);
        const finish = (failure) => {
          clearTimeout(timer);
          reader.onload = reader.onerror = reader.onabort = null;
          if (failure) reject(failure);
          else if (typeof reader.result !== 'string' || !reader.result.includes(',') || !reader.result.split(',')[1]) reject(error('file_read'));
          else resolve(reader.result);
        };
        reader.onload = () => finish();
        reader.onerror = reader.onabort = () => finish(error('file_read'));
        try { reader.readAsDataURL(file); } catch (_) { finish(error('file_read')); }
      });
    } catch (failure) {
      if (typeof file.arrayBuffer !== 'function') throw failure;
      try {
        const bytes = new Uint8Array(await withTimeout(file.arrayBuffer()));
        if (!bytes.length) throw error('file_empty');
        let binary = '';
        for (let i = 0; i < bytes.length; i += 8192) binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 8192));
        return `data:${file.type};base64,${btoa(binary)}`;
      } catch (_) { throw error('file_read'); }
    }
  }

  // Retry only an additional reference upload, never the transform request.
  async function uploadReference(imageData, filename) {
    const body = JSON.stringify({ imageData, filename });
    for (let attempt = 1; attempt <= 3; attempt++) {
      const controller = new AbortController();
      let timer;
      let failure;
      try {
        const request = (async () => {
          const response = await fetch(window.CustomifyApi.url('/api/upload-temp-image'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body, signal: controller.signal
          });
          if (!response.ok) throw error('file_upload', { reason: 'http', status: response.status, attempt });
          let result;
          try { result = await response.json(); }
          catch (_) { throw error('file_upload', { reason: 'response', attempt }); }
          if (typeof result?.url !== 'string' || !result.url.startsWith('https://')) {
            throw error('file_upload', { reason: 'response', attempt });
          }
          return result.url;
        })();
        const timeout = new Promise((_, reject) => {
          timer = setTimeout(() => {
            reject(error('file_upload', { reason: 'timeout', attempt }));
            controller.abort();
          }, 20000);
        });
        return await Promise.race([request, timeout]);
      } catch (caught) {
        failure = caught?.code === 'file_upload' ? caught : error('file_upload', { reason: 'network', attempt });
      } finally {
        clearTimeout(timer);
      }
      const details = failure.details;
      const retryable = ['network', 'timeout'].includes(details.reason) ||
        (details.reason === 'http' && [408, 500, 502, 503, 504].includes(details.status));
      if (!retryable || attempt === 3) throw failure;
      await new Promise(resolve => setTimeout(resolve, attempt * 500));
    }
  }

  function text(code, params = {}) {
    return window.CustomifyI18n.t(`customizer.upload.${code}`, params);
  }

  function label(file, slot) {
    const name = String(file?.name || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 100);
    const photo = text('photo', { number: Number.isInteger(slot) ? slot + 1 : 1 });
    return name ? `${photo} (${name})` : photo;
  }

  function message(failure, file, slot, retained = false) {
    const code = failure?.name === 'FileReadError' ? 'file_read' : failure?.code || 'file_decode';
    return `${text(code)} ${retained ? text('previous_kept') : text('choose_another')}`;
  }

  async function report(failure, file, stage, slot) {
    try {
      if (failure && reported.has(failure)) return;
      if (typeof Sentry === 'undefined' || !Sentry.captureMessage) return;
      const code = failure?.name === 'FileReadError' ? 'file_read' : failure?.code || 'file_decode';
      if (failure && typeof failure === 'object') reported.add(failure);
      const nativeNames = ['EncodingError', 'NotReadableError', 'NotFoundError', 'SecurityError', 'AbortError', 'InvalidStateError', 'TypeError'];
      const diagnostics = {};
      // Run only after a crop decode failure. UI displays its error immediately;
      // this bounded, local read enriches telemetry without uploading photo bytes.
      if (['crop-open', 'crop-replace'].includes(stage) && ['file_decode', 'file_timeout'].includes(code)) {
        const started = Date.now();
        if (typeof file?.arrayBuffer !== 'function' || !(file.size > 0 && file.size <= MAX_BYTES)) {
          diagnostics.byteRead = 'not_checked';
        } else {
          try {
            const buffer = await withTimeout(file.arrayBuffer(), 'diagnostic_timeout', 5000);
            diagnostics.byteRead = buffer.byteLength === file.size ? 'readable' : 'incomplete';
          } catch (readFailure) {
            diagnostics.byteRead = readFailure?.code === 'diagnostic_timeout' ? 'timeout' : 'unreadable';
            diagnostics.readErrorName = nativeNames.includes(readFailure?.name) ? readFailure.name : 'Other';
          }
        }
        diagnostics.readCheckMs = Math.min(60000, Math.max(0, Date.now() - started));
      }
      Sentry.withScope(scope => {
        // Existing console breadcrumbs may contain local file names.
        scope.clearBreadcrumbs();
        scope.setTag('customify_area', 'photo-upload');
        scope.setTag('photo_error_code', code);
        scope.setTag('photo_upload_stage', stage);
        scope.setTag('photo_diagnostics_version', 'family-photo-v1');
        scope.setTag('customify_product', window.location?.pathname?.split('/products/')[1]?.split('/')[0] || 'unknown');
        scope.setTag('locale', window.CustomifyI18n?.locale || 'unknown');
        scope.setFingerprint(['photo-upload', code, stage]);
        const details = failure?.details || {};
        scope.setExtra('photo', {
          ...diagnostics,
          nativeErrorName: nativeNames.includes(details.nativeErrorName) ? details.nativeErrorName : undefined,
          decodeMs: Number.isFinite(details.decodeMs) ? Math.min(60000, Math.max(0, details.decodeMs)) : undefined,
          slot: Number.isInteger(slot) ? slot + 1 : 1,
          type: /^image\/[a-z0-9.+-]+$/i.test(file?.type || '') ? file.type : 'other',
          bytes: Number(file?.size) || 0,
          width: Number(details.width) || undefined,
          height: Number(details.height) || undefined,
          uploadStatus: Number(details.status) || undefined,
          uploadAttempt: Number(details.attempt) || undefined,
          uploadReason: ['http', 'network', 'timeout', 'response'].includes(details.reason) ? details.reason : undefined
        });
        const level = ['file_type', 'file_size', 'file_empty', 'file_resolution', 'compression', 'crop_required', 'missing_photo'].includes(code) ? 'warning' : 'error';
        Sentry.captureMessage(`Photo upload failed: ${code}`, level);
      });
      if (failure && typeof failure === 'object') reported.add(failure);
    } catch (_) {}
  }

  function styleFeedback(node) {
    node.setAttribute('role', 'alert');
    node.setAttribute('aria-live', 'assertive');
    node.tabIndex = -1;
    node.style.cssText = 'display:block;box-sizing:border-box;margin:10px 0;padding:12px;border:1px solid #bf3535;border-radius:8px;background:#fff4f4;color:#8d2020;font-size:14px;line-height:1.45;overflow-wrap:anywhere;';
    return node;
  }

  return { error, validateFile, prepareCropFile, withTimeout, probe, readDataURL, uploadReference, text, label, message, report, styleFeedback };
})();


class CustomifyEmbed {
  _reportUploadError(error, file, stage, slot) {
    window.CustomifyPhotoUpload.report(error, file, stage, slot);
  }

  _uploadFeedback(file, slot, failure) {
    const multi = Number.isInteger(slot);
    if (!multi) document.getElementById('photoResolutionWarning')?.remove();
    const area = multi ? document.getElementById('multiUploadArea') : this.uploadArea;
    if (!area) return;
    const id = multi ? `photoUploadFeedback-${slot}` : 'photoUploadFeedback-single';
    let feedback = document.getElementById(id);
    const photoSlot = multi ? document.querySelectorAll('.multi-upload-slot')[slot] : null;
    const input = multi ? photoSlot?.querySelector('.multi-slot-input') : this.fileInput;
    if (!failure) {
      feedback?.remove();
      input?.removeAttribute('aria-invalid');
      input?.removeAttribute('aria-describedby');
      if (photoSlot) photoSlot.style.borderColor = '';
      return;
    }
    if (!feedback) {
      feedback = window.CustomifyPhotoUpload.styleFeedback(document.createElement('p'));
      feedback.id = id;
      if (multi) {
        const grid = area.querySelector('.multi-upload-grid');
        if (grid) grid.insertAdjacentElement('afterend', feedback);
        else area.append(feedback);
      } else area.insertAdjacentElement('afterend', feedback);
    }
    const retained = multi ? Boolean(this.multiUploadFiles[slot]) : Boolean(this.uploadedFile);
    feedback.textContent = window.CustomifyPhotoUpload.message(failure, file, slot, retained);
    input?.setAttribute('aria-invalid', 'true');
    input?.setAttribute('aria-describedby', id);
    if (photoSlot) photoSlot.style.borderColor = '#bf3535';
    feedback.focus({ preventScroll: true });
    feedback.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  }

  _showResolutionWarning(dimensions) {
    document.getElementById('photoResolutionWarning')?.remove();
    const shortest = Math.min(dimensions?.width || 0, dimensions?.height || 0);
    if (shortest < 300 || shortest >= 500 || !this.uploadArea) return;
    const notice = document.createElement('p');
    notice.id = 'photoResolutionWarning';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.textContent = this.t('customizer.upload.low_resolution_warning');
    notice.style.cssText = 'display:block;box-sizing:border-box;margin:10px 0;padding:12px;border:1px solid #e0c778;border-radius:8px;background:#fff8df;color:#654d13;font-size:14px;line-height:1.45;';
    this.uploadArea.append(notice);
  }

  _showUploadError(error, file, stage, slot) {
    this._reportUploadError(error, file, stage, slot);
    const activeModal = document.querySelector('#spotifyCropModal.is-open, #phoneCropModal.is-open, #phonePhotoCropModal.is-open');
    if (activeModal) {
      let notice = activeModal.querySelector('.photo-crop-error');
      if (!notice) {
        notice = window.CustomifyPhotoUpload.styleFeedback(document.createElement('p'));
        notice.className = 'photo-crop-error';
        const dialog = activeModal.querySelector('[class$="crop-dialog"]') || activeModal.firstElementChild;
        dialog.prepend(notice);
      }
      notice.textContent = window.CustomifyPhotoUpload.message(error, file, slot);
      notice.focus({ preventScroll: true });
      notice.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    } else this._uploadFeedback(file, slot, error);
  }

  _reportToSentry(error, context, extra = {}) {
    try {
      if (typeof Sentry !== 'undefined' && Sentry.captureException) {
        Sentry.withScope(scope => {
          scope.setTag('customify_area', context || 'unknown');
          scope.setTag('customify_style', this.selectedStyle || 'none');
          scope.setTag('customify_product', this.getProductHandle ? this.getProductHandle() : 'unknown');
          scope.setTag('is_online', navigator.onLine ? 'yes' : 'no');
          const net = this._networkInfo();
          if (net) {
            scope.setTag('network_type', net.effectiveType || 'unknown');
            scope.setExtra('network', net);
          }
          scope.setExtra('url', window.location.href);
          scope.setExtra('selectedSize', this.selectedSize || 'none');
          scope.setExtra('selectedProductType', this.selectedProductType || 'none');
          scope.setExtra('hasUploadedFile', !!this.uploadedFile);
          scope.setExtra('hasTransformedImage', !!this.transformedImage);
          if (extra) {
            Object.entries(extra).forEach(([k, v]) => scope.setExtra(k, v));
          }
          scope.setLevel(error instanceof ReferenceError || error instanceof TypeError ? 'error' : 'warning');
          Sentry.captureException(error);
        });
      }
    } catch (_) {}
  }

  _sentryCrumb(category, message, data) {
    try {
      if (typeof Sentry !== 'undefined' && Sentry.addBreadcrumb) {
        Sentry.addBreadcrumb({ category: 'customify.' + category, message, data, level: 'info' });
      }
    } catch (_) {}
  }

  _networkInfo() {
    try {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn) return { effectiveType: conn.effectiveType, downlink: conn.downlink, rtt: conn.rtt };
    } catch (_) {}
    return null;
  }

  t(key, params = {}) {
    const i18n = window.CustomifyI18n;
    return i18n && typeof i18n.t === 'function' ? i18n.t(key, params) : '';
  }

  constructor() {
    this.uploadArea = document.getElementById('uploadArea');
    this.fileInput = document.getElementById('fileInput');
    this.previewArea = document.getElementById('previewArea');
    this.previewImage = document.getElementById('previewImage');
    this.stylesArea = document.getElementById('stylesArea');
    this.sizeArea = document.getElementById('sizeArea');
    this.productTypeArea = document.getElementById('productTypeArea');
    this.actionsArea = document.getElementById('actionsArea');
    this.loadingArea = document.getElementById('loadingArea');
    this.resultArea = document.getElementById('resultArea');
    this.resultImage = document.getElementById('resultImage');
    this.errorMessage = document.getElementById('errorMessage');
    this.errorMessageBottom = document.getElementById('errorMessageBottom');
    this.errorMessageTransform = document.getElementById('errorMessageTransform');
    this.successMessage = document.getElementById('successMessage');

    // 🆕 Tekst na obrazie (pilotaż)
    this.textOverlayPanel = document.getElementById('textOverlayPanel');
    this.textOverlayInput = document.getElementById('textOverlayInput');
    this.textOverlayCounter = document.getElementById('textOverlayCounter');
    this.textOverlaySaveBtn = document.getElementById('textOverlaySaveBtn');
    this.textOverlayHint = document.getElementById('textOverlayHint');
    this.textOverlayColorSelect = document.getElementById('textOverlayColorSelect');
    this.textOverlayFontSelect = document.getElementById('textOverlayFontSelect');
    this.textOverlaySizeSelect = document.getElementById('textOverlaySizeSelect');
    this.textOverlayToggleBtn = document.getElementById('textOverlayToggleBtn');
    this.textOverlayEnabled = this.isTextOverlayProduct();
    this.textOverlayState = {
      text: '',
      preset: 'classic',
      color: null,
      font: null,
      size: null,
      applied: false,
      previewUrl: null
    };
    this.textOverlayBaseImage = null; // Oryginał bez tekstu (URL z Blob)
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayDebounceTimer = null; // Timer dla debounce preview

    // 🎵 Spotify frame fields
    this.spotifyFieldsPanel = document.getElementById('spotifyFieldsPanel');
    this.spotifyTitleInput = document.getElementById('spotifyTitle');
    this.spotifyArtistInput = document.getElementById('spotifyArtist');
    this.spotifyCropModal = document.getElementById('spotifyCropModal');
    this.spotifyCropImage = document.getElementById('spotifyCropImage');
    this.spotifyCropConfirmBtn = document.getElementById('spotifyCropConfirmBtn');
    this.spotifyCropCancelBtn = document.getElementById('spotifyCropCancelBtn');
    this.spotifyCropper = null;
    this.spotifyCropSourceUrl = null;
    this.spotifyCropConfirmed = false;
    
    // 📱 Telefon - cropper
    this.phoneCropModal = document.getElementById('phoneCropModal');
    this.phoneCropImage = document.getElementById('phoneCropImage');
    this.phoneCropConfirmBtn = document.getElementById('phoneCropConfirmBtn');
    this.phoneCropCancelBtn = document.getElementById('phoneCropCancelBtn');
    this.phoneCropper = null;
    this.phoneCropSourceUrl = null;
    this.phoneCropConfirmed = false;
    this.phoneCropDataUrl = null;
    this.originalPhoneFile = null;
    
    // 📱 Telefon (etui) - osobny cropper
    this.phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    this.phonePhotoCropImage = document.getElementById('phonePhotoCropImage');
    this.phonePhotoCropConfirmBtn = document.getElementById('phonePhotoCropConfirmBtn');
    this.phonePhotoCropCancelBtn = document.getElementById('phonePhotoCropCancelBtn');
    this.phonePhotoCropper = null;
    this.phonePhotoCropSourceUrl = null;
    this.phonePhotoCropConfirmed = false;
    this.phonePhotoCropDataUrl = null;
    this.phonePhotoCropSourceIsWatermarked = false;
    this.originalPhonePhotoFile = null;
    this.selectedPhoneBrand = null;
    this.selectedPhoneModel = null;
    this.phoneModelsData = null;

    this.uploadedFile = null;
    this.selectedStyle = null;
    this.selectedSize = null;
    this.selectedProductType = 'plakat'; // Domyślny wybór: Plakat
    this.transformedImage = null;
    this.artworkId = null;
    this.generationId = null;

    // 📸 Multi-upload (dodaj-osobe)
    const multiUploadSlots = this.isMultiUploadProduct() ? 8 : 4;
    this.multiUploadFiles = Array(multiUploadSlots).fill(null);
    this.multiUploadPreviews = Array(multiUploadSlots).fill(null);
    
    // 🎨 GLFX Filters
    this.glfxInitialized = false;
    this.originalCroppedImage = null; // Oryginał przed filtrami
    this.filterConfig = null; // Konfiguracja filtrów z API
    this.filterConfigLoading = false; // Flaga ładowania
    
    // ✅ PENDING WATERMARK UPLOAD: Dane do wysłania jeśli użytkownik zmieni stronę
    this.pendingWatermarkUpload = null; // { generationId, watermarkedImage, customerId, email }
    this.watermarkUploadInProgress = false;
    this.sizePricing = {
      plakat: {
        a4: 0,   // Domyślny rozmiar - bez dopłaty
        a3: 10,
        a2: 30,
        a0: 45,
        a1: 60
      },
      canvas: {
        a4: 20,
        a3: 40,
        a2: 60,
        a0: 85,
        a1: 110
      },
      szklo: {               // 🆕 NOWY TYP: Nadruk na szkle
        a5: 0,               // Domyślny rozmiar - bez dopłaty (A5 = ~15×21 cm)
        a4: 30               // A4 dodaje 30 zł
      },
      spotify_frame: {
        a4: 0,   // Domyślny rozmiar - bez dopłaty
        a3: 9,
        a2: 30,
        a0: 45,
        a1: 60
      },
      etui: { etui: 0 }  // 📱 Etui - jeden rozmiar, cena z produktu
    };
    
    // Dopłaty za ramkę według typu produktu i rozmiaru.
    // Razem z bazą $39 oraz sizePricing dają docelową tabelę cen USA.
    this.framePricing = {
      plakat: {
        a4: 49,
        a3: 70,
        a2: 86,
        a0: 99,
        a1: 116
      },
      canvas: {
        a4: 29,
        a3: 39,
        a2: 49,
        a0: 59,
        a1: 69
      }
    };

    // UK uses fixed GBP surcharges relative to its 29 GBP catalog base price.
    this.ukSizePricing = {
      plakat: { a4: 0, a3: 3, a2: 9, a1: 18 },
      canvas: { a4: 15, a3: 29, a2: 44, a0: 50, a1: 59 }
    };
    this.ukFramePricing = {
      plakat: { a4: 30, a3: 51, a2: 69, a1: 120 },
      canvas: { a4: 23, a3: 35, a2: 44, a0: 56, a1: 67 }
    };
    // Germany uses fixed EUR surcharges relative to its 29 EUR catalog base price.
    this.germanySizePricing = {
      // a0 (50×75 cm) is intentionally unavailable for Germany posters because
      // Gelato only offers the different 50×70 cm format there.
      plakat: { a4: 0, a3: 10, a2: 20, a1: 50 },
      canvas: { a4: 20, a3: 30, a2: 50, a0: 70, a1: 90 }
    };
    this.germanyFramedPosterPricing = {
      a4: 20,
      a3: 40,
      a2: 60,
      a1: 110
    };
    this.germanyCanvasFramePricing = {
      a4: 29,
      a3: 39,
      a2: 49,
      a0: 59,
      a1: 69
    };
    
    // 🆕 Ceny podstawek (tylko dla szkła) - jedna cena dla wszystkich rozmiarów
    this.standPricing = {
      none: 0,             // Brak podstawki
      wood: 29,            // Podstawka drewniana/metalowa
      led: 39.90           // Podstawka z LED
    };
    
    this.init();

    // Udostępnij instancję globalnie do aktualizacji ceny z zewnątrz (e.g. wybór ramki)
    window.__customify = this;
    
    // ✅ PAGE UNLOAD PROTECTION: Obsługa zmiany/zamknięcia strony podczas upload watermarku
    this.setupPageUnloadProtection();
  }

  setupPageUnloadProtection() {
    // ✅ pagehide event - bardziej niezawodny niż beforeunload
    window.addEventListener('pagehide', (event) => {
      if (this.pendingWatermarkUpload && this.watermarkUploadInProgress) {
        console.warn('⚠️ [WATERMARK] Strona się zamyka - próbuję wysłać watermark przed zamknięciem...');
        
        // Spróbuj wysłać przez fetch z keepalive: true (kontynuuje request po zamknięciu strony)
        // ⚠️ LIMIT: keepalive ma limit ~64KB, ale spróbujemy (watermark może być większy)
        const payload = JSON.stringify({
          generationId: this.pendingWatermarkUpload.generationId,
          watermarkedImage: this.pendingWatermarkUpload.watermarkedImage,
          customerId: this.pendingWatermarkUpload.customerId,
          email: this.pendingWatermarkUpload.email
        });
        
        // Tylko jeśli payload jest mniejszy niż ~50KB (bezpieczny limit)
        if (payload.length < 50000) {
          try {
            navigator.sendBeacon(
              window.CustomifyApi.url('/api/update-generation-watermark'),
              new Blob([payload], { type: 'application/json' })
            );
            console.log('✅ [WATERMARK] Watermark wysłany przez sendBeacon przed zamknięciem strony');
          } catch (beaconError) {
            console.warn('⚠️ [WATERMARK] sendBeacon failed, próbuję fetch z keepalive...', beaconError);
            // Fallback: fetch z keepalive (może działać dla większych payloads)
            fetch(window.CustomifyApi.url('/api/update-generation-watermark'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: payload,
              keepalive: true // Kontynuuj request po zamknięciu strony
            }).catch(err => {
              console.warn('⚠️ [WATERMARK] Fetch z keepalive też nie zadziałał:', err);
            });
          }
        } else {
          console.warn('⚠️ [WATERMARK] Payload za duży dla sendBeacon/fetch keepalive (~' + Math.round(payload.length/1024) + 'KB) - watermark może nie zostać zapisany');
        }
      }
    });
  }

  /**
   * Sprawdza czy funkcja napisów jest dostępna (pilotaż na jednym produkcie)
   */
  isTextOverlayProduct() {
    return this.getProductLogicHandle() === 'karykatura-prezent-na-rocznice-prezent-ze-zdjecia';
  }

  isGermanCoupleBrowserCaptionStyle() {
    return this.getProductHandle() === 'personalisierte-paar-karikatur-vom-foto'
      && this.selectedStyle === 'karykatura';
  }

  isSpotifyProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('ramka-spotify') || currentUrl.includes('zdjecie-na-szkle-ramka-spotify');
  }

  // ============================================================
  // CUSTOM FIELDS – pola personalizacji per produkt
  // ============================================================

  /** Zwraca handle produktu z URL (e.g. "obraz-ze-zdjecia-karykatura-na-50-ta-rocznice") */
  getProductHandle() {
    const parts = window.location.pathname.toLowerCase().split('/');
    const idx = parts.indexOf('products');
    const handle = (idx !== -1 && parts[idx + 1]) ? parts[idx + 1].split('?')[0] : null;
    // Alternate storefront listings retain all Together portrait options.
    if (handle === 'together-couple-portrait-from-two-photos-watercolor' || handle === 'together-couple-portrait-from-two-photos-pencil-sketch') {
      return 'together-couple-portrait-from-two-photos';
    }
    return handle;
  }

  getDefaultWatercolourStyle() {
    return THEMED_STYLE_BY_HANDLE[this.getProductHandle()] || DEFAULT_WATERCOLOUR_STYLE_BY_PRODUCT[this.getProductHandle()] || null;
  }

  applyDefaultWatercolourStyle() {
    const defaultStyle = this.getDefaultWatercolourStyle();
    if (!defaultStyle) return false;

    this.stylesArea.style.display = 'none';
    this.selectedStyle = defaultStyle;
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    const defaultCard = this.stylesArea.querySelector(`.customify-style-card[data-style="${defaultStyle}"]`);
    if (defaultCard) defaultCard.classList.add('active');
    return true;
  }

  applySingleStyleSelection() {
    const cards = Array.from(this.stylesArea.querySelectorAll('.customify-style-card'));
    if (cards.length !== 1 || !cards[0].dataset.style) return false;

    this.stylesArea.style.display = 'none';
    this.selectedStyle = cards[0].dataset.style;
    cards[0].classList.add('active');
    return true;
  }

  getProductLogicHandle() {
    return resolveLumlyUsaLogicHandle(this.getProductHandle());
  }

  isFamilyGrandparentsPilot() {
    return ['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos'].includes(this.getProductHandle());
  }

  usesFamilyPhotoCrop() {
    return ['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos', 'family-portrait-add-loved-one', 'personalisiertes-familienportraet-aus-mehreren-fotos', 'custom-couple-painting-from-two-photos', 'personalisiertes-paarportraet-aus-zwei-fotos', 'together-couple-portrait-from-two-photos'].includes(this.getProductHandle());
  }

  /** Zwraca config pól dla bieżącego produktu lub null */
  getCustomFieldConfig() {
    if (['custom-couple-painting-from-two-photos', 'personalisiertes-paarportraet-aus-zwei-fotos'].includes(this.getProductHandle())) {
      const isGerman = this.getProductHandle() === 'personalisiertes-paarportraet-aus-zwei-fotos';
      const copy = (en, de) => isGerman ? de : en;
      return {
        multiUpload: true,
        minImages: 2,
        maxImages: 8,
        fields: [
          { id: 'couple_art_style', label: copy('Choose your art style', 'Kunststil wählen'), type: 'family-select', defaultValue: 'watercolor', options: [
            ['sketch', copy('Sketch', 'Skizze')],
            ['watercolor', copy('Watercolor', 'Aquarell')],
            ['oil', copy('Oil Painting', 'Ölgemälde')]
          ] },
          { id: 'together_scene', label: copy('Choose your scene', 'Szene wählen'), type: 'family-select', defaultValue: 'classic', options: [
            ['classic', copy('Classic portrait', 'Klassisches Porträt')],
            ['sunset', copy('Sunset walk', 'Spaziergang bei Sonnenuntergang')],
            ['evening', copy('Elegant evening', 'Eleganter Abend')]
          ] },
          { id: 'scena', label: copy('Additional wishes (optional)', 'Zusätzliche Wünsche (optional)'), type: 'text', placeholder: copy('e.g. our favorite beach, relaxed clothing, a gentle embrace', 'z. B. unser Lieblingsstrand, legere Kleidung, eine liebevolle Umarmung') },
          { id: 'dedykacja', label: copy('Names, date or dedication (optional)', 'Namen, Datum oder Widmung (optional)'), type: 'text', maxLength: 120, placeholder: copy('e.g. Emma & James — Together, always', 'z. B. Emma & James – Für immer zusammen') }
        ]
      };
    }
    if (this.getProductHandle() === 'together-couple-portrait-from-two-photos') {
      return {
        multiUpload: true,
        minImages: 2,
        maxImages: 8,
        fields: [
          { id: 'family_background', label: 'Choose your background', type: 'family-select', defaultValue: 'studio', options: [
            ['photo', 'From your first photo'], ['studio', 'Bright studio'], ['home', 'Cozy home'], ['garden', 'Sunset garden'], ['custom', 'Your own idea']
          ] },
          { id: 'family_background_desc', label: 'Describe your background', type: 'text', maxLength: 1000, placeholder: 'e.g. our favorite beach at sunset', showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: 'Choose your portrait style', type: 'family-select', defaultValue: 'photo', options: [
            ['photo', 'Natural photo'], ['watercolor', 'Soft watercolor'], ['oil', 'Classic oil painting'], ['sketch', 'Sketch']
          ] },
          { id: 'family_clothing', label: 'Choose your outfits', type: 'family-select', defaultValue: 'original', options: [
            ['original', 'Keep outfits from photos'], ['casual', 'Coordinated casual outfits'], ['elegant', 'Coordinated elegant outfits']
          ] },
          { id: 'scena', label: 'People arrangement & requests (optional)', type: 'text', placeholder: 'e.g. Person 1 on the left. Keep the wedding dress.' },
          { id: 'dedykacja', label: 'Names, date or dedication (optional)', type: 'text', maxLength: 120, placeholder: 'e.g. Emma & James — Together, always' }
        ]
      };
    }
    if (this.getProductHandle() === 'personalisierte-paar-karikatur-vom-foto') {
      return PRODUCT_FIELD_CONFIGS['personalisierte-paar-karikatur-vom-foto'];
    }
    if (['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos'].includes(this.getProductHandle())) {
      const isGerman = this.getProductHandle() === 'grosseltern-enkel-familienportraet-aus-fotos';
      const copy = (en, de) => isGerman ? de : en;
      return {
        multiUpload: true,
        minImages: 1,
        maxImages: 8,
        fields: [
          { id: 'family_background', label: copy('Choose your background', 'Hintergrund wählen'), type: 'family-select', defaultValue: 'studio', options: [
            ['photo', copy('From your first photo', 'Aus deinem ersten Foto')], ['studio', copy('Bright studio', 'Helles Studio')], ['home', copy('Cozy home', 'Gemütliches Zuhause')], ['garden', copy('Sunset garden', 'Garten bei Sonnenuntergang')], ['custom', copy('Your own idea', 'Eigene Idee')]
          ] },
          { id: 'family_background_desc', label: copy('Describe your background', 'Hintergrund beschreiben'), type: 'text', maxLength: 1000, placeholder: copy('e.g. our favorite beach at sunset', 'z. B. unser Lieblingsstrand bei Sonnenuntergang'), showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: copy('Choose your portrait style', 'Porträtstil wählen'), type: 'family-select', defaultValue: 'photo', options: [
            ['photo', copy('Natural photo', 'Natürliches Foto')], ['watercolor', copy('Soft watercolor', 'Zartes Aquarell')], ['oil', copy('Classic oil painting', 'Klassisches Ölgemälde')], ['sketch', copy('Sketch', 'Skizze')]
          ] },
          { id: 'family_clothing', label: copy('Choose your outfits', 'Kleidung wählen'), type: 'family-select', defaultValue: 'original', options: [
            ['original', copy('Keep outfits from photos', 'Kleidung aus den Fotos beibehalten')], ['casual', copy('Coordinated casual outfits', 'Abgestimmte Freizeitkleidung')], ['elegant', copy('Coordinated elegant outfits', 'Abgestimmte elegante Kleidung')]
          ] },
          { id: 'scena', label: copy('People arrangement & requests (optional)', 'Anordnung und Wünsche (optional)'), type: 'text', placeholder: copy('Left to right: Grandma, children, Grandpa. Keep Grandpa’s uniform.', 'Von links nach rechts: Oma, Kinder, Opa. Opas Uniform beibehalten.') },
          { id: 'dedykacja', label: copy('Signature or dedication (optional)', 'Unterschrift oder Widmung (optional)'), type: 'text', placeholder: copy('e.g. Together, always', 'z. B. Für immer zusammen') }
        ]
      };
    }
    const handle = this.getProductLogicHandle();
    const isGermanFamily = this.getProductHandle() === 'personalisiertes-familienportraet-aus-mehreren-fotos';
    if (isGermanFamily || this.getProductHandle() === 'family-portrait-add-loved-one') {
      const copy = (en, de) => isGermanFamily ? de : en;
      return {
        ...PRODUCT_FIELD_CONFIGS[handle],
        maxImages: 8,
        fields: [
          { id: 'family_background', label: copy('Choose your background', 'Hintergrund wählen'), type: 'family-select', defaultValue: 'studio', options: [
            ['photo', copy('From your first photo', 'Aus deinem ersten Foto')],
            ['studio', copy('Bright studio', 'Helles Studio')],
            ['home', copy('Cozy home', 'Gemütliches Zuhause')],
            ['garden', copy('Sunset garden', 'Garten bei Sonnenuntergang')],
            ['custom', copy('Your own idea', 'Eigene Idee')]
          ] },
          { id: 'family_background_desc', label: copy('Describe your background', 'Hintergrund beschreiben'), type: 'text', maxLength: 1000, placeholder: copy('e.g. our favorite beach at sunset', 'z. B. unser Lieblingsstrand bei Sonnenuntergang'), showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: copy('Choose your portrait style', 'Porträtstil wählen'), type: 'family-select', defaultValue: 'photo', options: [
            ['photo', copy('Natural photo', 'Natürliches Foto')],
            ['watercolor', copy('Soft watercolor', 'Zartes Aquarell')],
            ['oil', copy('Classic oil painting', 'Klassisches Ölgemälde')],
            ...(!isGermanFamily ? [['sketch', 'Sketch']] : [])
          ] },
          ...(!isGermanFamily ? [{ id: 'family_clothing', label: 'Choose your outfits', type: 'family-select', defaultValue: 'original', options: [
            ['original', 'Keep outfits from photos'], ['casual', 'Coordinated casual outfits'], ['elegant', 'Coordinated elegant outfits']
          ] }] : []),
          { id: 'scena', label: copy('Additional wishes (optional)', 'Weitere Wünsche (optional)'), type: 'text',
            placeholder: copy('e.g. Grandma in the center, with the grandchildren beside her', 'z. B. Oma in der Mitte, die Enkelkinder neben ihr') },
          { id: 'dedykacja', label: copy('Signature or dedication (optional)', 'Text oder Widmung (optional)'), type: 'text', placeholder: copy('e.g. Together, always', 'z. B. Für immer zusammen') }
        ]
      };
    }
    return handle ? (PRODUCT_FIELD_CONFIGS[handle] || null) : null;
  }

  /** Renderuje sekcję z polami personalizacji – wstawia przed actionsArea */
  renderCustomFields() {
    const config = this.getCustomFieldConfig();
    if (!config || !config.fields || config.fields.length === 0) return;
    if (document.getElementById('customFieldsArea')) return; // już wyrenderowane

    const actionsArea = document.getElementById('actionsArea');
    if (!actionsArea) return;

    const container = document.createElement('div');
    container.id = 'customFieldsArea';
    container.style.cssText = [
      'padding: 12px 16px',
      'margin: 8px 0 0 0',
      'border-top: 1px solid #e5e5e5',
      'border-bottom: 1px solid #e5e5e5',
      'background: #fafafa',
      'border-radius: 4px'
    ].join(';');

    // Placeholder bledszy — wstrzykuj styl (gwarantowane działanie)
    if (!document.getElementById('customify-placeholder-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'customify-placeholder-style';
      styleEl.textContent = '.customify-personalization-input::placeholder { color: #999 !important; opacity: 0.95 !important; }';
      document.head.appendChild(styleEl);
    }

    const title = document.createElement('h4');
    const personalizationTitle = this.t('customizer.personalization.title');
    const showOptionalInTitle = personalizationTitle === 'Personalization';
    title.textContent = showOptionalInTitle ? 'Personalization - optional' : personalizationTitle;
    title.style.cssText = 'margin: 0 0 10px 0; font-size: 14px; font-weight: 600; color: #222;';
    container.appendChild(title);

    config.fields.forEach(field => {
      const group = document.createElement('div');
      group.style.cssText = 'margin-bottom: 10px;';

      const label = document.createElement('label');
      const localizedField = localizeLumlyUsaField(field);
      if (showOptionalInTitle) {
        localizedField.label = localizedField.label.replace(/\s*\(optional\)/gi, '').trim();
      }
      label.htmlFor = `customField_${field.id}`;
      label.textContent = localizedField.label + (field.required ? ' *' : '');
      label.style.cssText = 'display: block; font-size: 13px; font-weight: 500; margin-bottom: 4px; color: #444;';
      group.appendChild(label);

      let input;
      if (field.type === 'family-select') {
        input = document.createElement('select');
        input.style.cssText = 'width:100%;min-height:44px;padding:8px 10px;border:1px solid #ccc;border-radius:6px;font-size:16px;background:white;color:#222;cursor:pointer;';
        field.options.forEach(([value, name]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = name;
          option.selected = value === field.defaultValue;
          input.appendChild(option);
        });
      } else if (field.type === 'select') {
        input = document.createElement('select');
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; background: white; cursor: pointer;';
        if (!field.required && !field.defaultValue) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = '-- choose --';
          input.appendChild(placeholder);
        }
        field.options.forEach(opt => {
          const option = document.createElement('option');
          option.value = opt;
          const optionIndex = field.options.indexOf(opt) + 1;
          option.textContent = field.optionLocalizationKey && window.CustomifyI18n && typeof window.CustomifyI18n.t === 'function'
            ? window.CustomifyI18n.t(`${field.optionLocalizationKey}.${optionIndex}`)
            : opt;
          if (field.defaultValue && opt === field.defaultValue) option.selected = true;
          input.appendChild(option);
        });
      } else {
        input = document.createElement('input');
        input.type = 'text';
        const ph = localizedField.placeholder || field.placeholder || '';
        input.placeholder = ph;
        input.dataset.placeholder = ph;
        input.className = 'customify-personalization-input';
        if (Number.isInteger(field.maxLength)) input.maxLength = field.maxLength;
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; box-sizing: border-box;';
        if (field.defaultValue) input.value = field.defaultValue;
        // Placeholder znika od razu przy focus (kliknięciu), wraca przy blur gdy puste
        input.addEventListener('focus', () => { input.placeholder = ''; });
        input.addEventListener('blur', () => { if (!input.value.trim()) input.placeholder = input.dataset.placeholder || ph; });
      }
      input.id = `customField_${field.id}`;
      input.dataset.fieldId = field.id;
      if (field.required) input.dataset.required = 'true';

      group.appendChild(input);
      container.appendChild(group);
      if (field.showWhen) {
        const selector = container.querySelector(`#customField_${field.showWhen.id}`);
        const updateVisibility = () => {
          const visible = selector?.value === field.showWhen.value;
          group.hidden = !visible;
          input.disabled = !visible;
          input.required = visible;
          input.dataset.required = visible ? 'true' : 'false';
          label.textContent = localizedField.label + (visible ? ' *' : '');
        };
        selector?.addEventListener('change', updateVisibility);
        updateVisibility();
      }
    });

    actionsArea.parentNode.insertBefore(container, actionsArea);
    console.log('🎛️ [CUSTOM-FIELDS] Wyrenderowano pola personalizacji dla:', this.getProductLogicHandle());
  }

  /**
   * Validates personalization fields.
   * Prompt construction is server-only.
   * Returns null when no config exists for current product.
   */
  collectCustomFieldsPrompt() {
    const config = this.getCustomFieldConfig();
    if (!config) return null;

    const missingLabels = [];
    config.fields.forEach(field => {
      const el = document.getElementById(`customField_${field.id}`);
      const value = el ? el.value.trim() : '';
      if (!el?.disabled && (field.required || el?.dataset.required === 'true') && !value) {
        missingLabels.push(localizeLumlyUsaField(field).label);
      }
    });
    if (missingLabels.length > 0) {
      const germanFamily = this.getProductHandle() === 'personalisiertes-familienportraet-aus-mehreren-fotos';
      throw new Error(`${germanFamily ? 'Bitte fülle die Pflichtfelder aus' : 'Please complete required fields'}: ${missingLabels.join(', ')}`);
    }

    // Prompt templates are server-only. The browser only validates and sends raw fields.
    return null;
  }

  isCropperProduct() {
    return this.isSpotifyProduct() || this.isPhoneCaseProduct() || this.isPhonePhotoCaseProduct();
  }

  // 🎵 Produkt Spotify BEZ generacji AI - od razu do koszyka po kadrowanie
  isSpotifyNoAIProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('zdjecie-na-szkle-ramka-spotify');
  }

  // 📱 Produkt telefon
  isPhoneCaseProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    const isPhone = currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem-karykatura');
    console.log('📱 [DEBUG] isPhoneCaseProduct:', { currentUrl, isPhone });
    return isPhone;
  }
  
  // 📱 Produkt etui (zdjęcie) - osobny cropper
  isPhonePhotoCaseProduct() {
    const currentUrl = window.location.pathname.toLowerCase();
    return currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem') &&
      !currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem-karykatura');
  }

  isExpandableFamilyUpload() {
    return Boolean(this.isMultiUploadProduct?.());
  }

  setupExpandableFamilyUpload(grid) {
    if (!this.isExpandableFamilyUpload()) return;
    const area = grid.closest('#multiUploadArea');
    if (!area || grid.dataset.expandedUploadSetup) return;
    grid.dataset.expandedUploadSetup = 'true';
    const initialSlots = grid.querySelectorAll('.multi-upload-slot').length;
    this._multiUploadInitialSlots = initialSlots;
    const german = String(window.CustomifyI18n?.locale || document.documentElement.lang || 'en').startsWith('de');
    const template = grid.querySelector('.multi-upload-slot');
    if (!template) return;
    for (let idx = initialSlots; idx < 8; idx++) {
      const slot = template.cloneNode(true);
      slot.id = 'multiSlot' + idx;
      slot.classList.remove('has-photo');
      slot.removeAttribute('data-upload-bound');
      slot.style.display = 'none';
      slot.querySelectorAll('[id]').forEach(node => { node.id = node.id.replace(/\d+$/, String(idx)); });
      const label = slot.querySelector('.multi-slot-label');
      label.removeAttribute('data-customify-i18n');
      label.textContent = (german ? 'Foto ' : 'Photo ') + (idx + 1);
      const photoLabel = slot.querySelector('.family-pilot-photo-label');
      if (photoLabel) photoLabel.textContent = (german ? 'Foto ' : 'Photo ') + (idx + 1);
      const captionLabel = slot.querySelector('.family-pilot-caption-label');
      if (captionLabel) captionLabel.htmlFor = 'familyPilotCaption' + idx;
      const preview = slot.querySelector('.multi-slot-preview');
      preview.style.backgroundImage = '';
      preview.style.display = 'none';
      preview.removeAttribute('role');
      preview.removeAttribute('aria-label');
      const input = slot.querySelector('.multi-slot-input');
      input.value = '';
      slot.querySelector('.multi-slot-remove').style.display = 'none';
      grid.appendChild(slot);
    }
    grid.querySelectorAll('.multi-slot-placeholder').forEach((placeholder, idx) => {
      placeholder.setAttribute('role', 'button');
      placeholder.tabIndex = 0;
      placeholder.setAttribute('aria-label', (german ? 'Foto hinzufügen ' : 'Add photo ') + (idx + 1));
    });
    const heading = area.querySelector('[data-customify-i18n="customizer.multi_upload.title"]');
    if (heading) { heading.removeAttribute('data-customify-i18n'); heading.textContent = german ? 'Fotos der Personen hochladen' : 'Upload photos of people'; }
    const counter = document.getElementById('multiUploadCount');
    counter?.parentElement?.childNodes.forEach(node => {
      if (node.nodeType === 3) node.textContent = node.textContent.replace(/\/[24]\b/, '/8');
    });
    const pilotIntro = area.querySelector('.family-pilot-intro');
    if (pilotIntro) pilotIntro.textContent = german ? 'Jedes Foto kann eine Person oder eine Gruppe zeigen. Bis zu 8 Fotos kombinieren.' : 'Each photo can show one person or a group. Combine up to 8 photos.';
    if (this.isFamilyGrandparentsPilot()) return;
    const button = document.createElement('button');
    button.id = 'familyAddPhoto';
    button.type = 'button';
    button.className = 'family-add-photo';
    button.textContent = german ? '+ Weiteres Foto hinzufügen' : '+ Add another photo';
    button.style.cssText = 'display:block!important;width:min(380px,100%)!important;min-height:44px!important;margin:12px auto 0!important;padding:10px 14px!important;border:1px solid #ddd!important;border-radius:6px!important;background:#fff!important;color:#444!important;font-size:14px!important;font-weight:500!important;cursor:pointer!important;';
    counter?.parentElement?.insertAdjacentElement('afterend', button);
    if (this.isTogetherCoupleProduct()) {
      const help = document.createElement('p');
      help.textContent = german ? 'Weitere Fotos können zusätzliche Personen oder Tiere zeigen. Auf jedem Foto kann eine Person oder eine Gruppe sein.' : 'Add more photos to include additional people or pets. Each photo can show one person or a group.';
      help.style.cssText = 'text-align:center;font-size:12px;color:#777;margin:8px 0;';
      button.insertAdjacentElement('afterend', help);
    }
    button.addEventListener('click', () => {
      if (this._familyCropLocked || this._familyHasPendingCrops()) return;
      const idx = Array.from({ length: 8 - initialSlots }, (_, offset) => initialSlots + offset).find(index => !this.multiUploadFiles[index]);
      if (idx === undefined) return;
      const input = grid.querySelectorAll('.multi-upload-slot')[idx]?.querySelector('.multi-slot-input');
      if (!input) return;
      this._familyCropReturnFocus = this._familyCropReturnFocus || Array(8).fill(null);
      this._familyCropReturnFocus[idx] = button;
      input.click();
    });
  }

  // 📸 Produkt multi-upload (dodaj osobę do zdjęcia)
  isTogetherCoupleProduct() {
    return ['together-couple-portrait-from-two-photos', 'custom-couple-painting-from-two-photos', 'personalisiertes-paarportraet-aus-zwei-fotos'].includes(this.getProductHandle());
  }

  isMultiUploadProduct() {
    const h = this.getProductLogicHandle();
    return h === 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk';
  }

  setupMultiUpload() {
    if (!this.isMultiUploadProduct()) return;
    const grid = document.querySelector('.multi-upload-grid');
    if (!grid) return;
    this.setupExpandableFamilyUpload(grid);
    grid.closest('#multiUploadArea')?.classList.toggle('family-visible-upload', this.getProductHandle() === 'grandparents-and-grandchildren-portrait-from-photos');
    grid.closest('#multiUploadArea')?.classList.toggle('family-square-upload', ['family-portrait-add-loved-one', 'personalisiertes-familienportraet-aus-mehreren-fotos'].includes(this.getProductHandle()));
    grid.querySelectorAll('.multi-upload-slot').forEach((slot, idx) => {
      if (slot.dataset?.uploadBound) return;
      if (slot.dataset) slot.dataset.uploadBound = 'true';
      const input = slot.querySelector('.multi-slot-input');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const preview = slot.querySelector('.multi-slot-preview');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      const editPilotCrop = (returnFocus) => {
        if (!this.usesFamilyPhotoCrop()) return;
        const acceptedFile = this.multiUploadFiles[idx];
        const acceptedCropper = this.familyCropperBySlot?.[idx];
        if (!acceptedFile || !acceptedCropper || this._familyCropLocked || this._familyHasPendingCrops()) return;
        this.handleGrandparentsPilotFileSelect(acceptedFile, idx, {
          initialRect: acceptedCropper.getRect(),
          preserveCaption: true,
          allowReplace: true,
          returnFocus
        });
      };
      if (placeholder) {
        placeholder.addEventListener('click', () => !this._familyCropLocked && input && input.click());
        placeholder.addEventListener('keydown', (event) => {
          if ((event.key === 'Enter' || event.key === ' ') && !this._familyCropLocked) {
            event.preventDefault();
            input && input.click();
          }
        });
      }
      if (preview && this.usesFamilyPhotoCrop()) {
        preview.addEventListener('click', () => editPilotCrop(preview));
        preview.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            editPilotCrop(preview);
          }
        });
      }
      if (input) {
        input.addEventListener('change', (e) => {
          if (e.target.files && e.target.files[0]) {
            if (this.usesFamilyPhotoCrop()) {
              const returnFocus = this._familyCropReturnFocus?.[idx] || placeholder;
              this.handleGrandparentsPilotFileSelect(e.target.files[0], idx, { returnFocus });
              if (this._familyCropReturnFocus) this._familyCropReturnFocus[idx] = null;
            }
            else this.handleMultiFileSelect(e.target.files[0], idx);
          }
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeMultiFile(idx);
        });
      }
      if (this.isFamilyGrandparentsPilot()) {
        const caption = slot.querySelector('.family-pilot-caption');
        if (caption) caption.addEventListener('input', () => {
          this.multiUploadCaptions = this.multiUploadCaptions || Array(this.multiUploadFiles?.length || 4).fill('');
          this.multiUploadCaptions[idx] = caption.value.slice(0, 120);
        });
      }
    });
    if (this.isFamilyGrandparentsPilot()) {
      const addPhoto = document.getElementById('familyPilotAddPhoto');
      if (addPhoto) addPhoto.addEventListener('click', () => {
        if (this._familyCropLocked || this._familyHasPendingCrops()) return;
        const nextSlot = window.FamilyInlineCrop?.firstEmptySlot(this.multiUploadFiles, this.multiUploadFiles.length) ?? this.multiUploadFiles.findIndex(file => !file);
        if (nextSlot < 0) return;
        const input = document.querySelectorAll('.multi-upload-slot')[nextSlot]?.querySelector('.multi-slot-input');
        if (!input) return;
        this._familyCropReturnFocus = this._familyCropReturnFocus || Array(4).fill(null);
        this._familyCropReturnFocus[nextSlot] = addPhoto;
        input.click();
      });
      this.updateMultiUploadCounter();
    }
    this.updateMultiUploadCounter();
    console.log('📸 [MULTI-UPLOAD] Setup complete');
  }

  async handleMultiFileSelect(file, slotIndex) {
    if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex >= this.multiUploadFiles.length) return;
    this._multiPhotoVersions = this._multiPhotoVersions || [];
    const version = this._multiPhotoVersions[slotIndex] = (this._multiPhotoVersions[slotIndex] || 0) + 1;
    const token = `multi-${slotIndex}-${version}`;
    this._photoUploadPendingTokens = this._photoUploadPendingTokens || new Set();
    this._photoUploadPendingTokens.add(token);
    try {
      window.CustomifyPhotoUpload.validateFile(file);
      this._uploadFeedback(file, slotIndex);
      await window.CustomifyPhotoUpload.probe(file);
      const dataUrl = await window.CustomifyPhotoUpload.readDataURL(file);
      if (this._multiPhotoVersions[slotIndex] !== version) return;
      this.multiUploadFiles[slotIndex] = file;
      this.multiUploadPreviews[slotIndex] = dataUrl;
      const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      if (slot) {
        const preview = slot.querySelector('.multi-slot-preview');
        if (preview) { preview.style.backgroundImage = `url(${dataUrl})`; preview.style.display = 'block'; }
        const placeholder = slot.querySelector('.multi-slot-placeholder');
        if (placeholder) placeholder.style.display = 'none';
        const removeBtn = slot.querySelector('.multi-slot-remove');
        if (removeBtn) removeBtn.style.display = 'flex';
      }
      this.uploadedFile = this.multiUploadFiles.find(Boolean) || null;
      this.trackStatsEvent('image_upload');
      this.trackGoogleAdsPhotoUpload(file);
      this.updateMultiUploadCounter();
    } catch (error) {
      if (this._multiPhotoVersions[slotIndex] === version) this._showUploadError(error, file, 'multi-preview', slotIndex);
    } finally {
      this._photoUploadPendingTokens.delete(token);
      const input = document.querySelectorAll('.multi-upload-slot')[slotIndex]?.querySelector('.multi-slot-input');
      if (input && this._multiPhotoVersions[slotIndex] === version) input.value = '';
    }
  }

  async handleGrandparentsPilotFileSelect(file, slotIndex, options = {}) {
    if (this._familyCropLocked) return;
    if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex >= (this.multiUploadFiles?.length || 4)) return;
    try { window.CustomifyPhotoUpload.validateFile(file, 30 * 1024 * 1024); }
    catch (error) {
      this._showUploadError(error, file, 'crop-open', slotIndex);
      const rejectedInput = document.querySelectorAll('.multi-upload-slot')[slotIndex]?.querySelector('.multi-slot-input');
      if (rejectedInput) rejectedInput.value = '';
      return;
    }
    this._uploadFeedback(file, slotIndex);
    this._familyUploadVersions = this._familyUploadVersions || Array(this.multiUploadFiles?.length || 4).fill(0);
    this.familyCropperBySlot = this.familyCropperBySlot || Array(this.multiUploadFiles?.length || 4).fill(null);
    this.multiUploadCaptions = this.multiUploadCaptions || Array(this.multiUploadFiles?.length || 4).fill('');
    const version = ++this._familyUploadVersions[slotIndex];
    this._familyPendingCropTokens = this._familyPendingCropTokens || new Set();
    const token = `${slotIndex}:${version}`;
    this._familyPendingCropTokens.add(token);
    this.updateMultiUploadCounter();
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    if (!slot) { this._familyPendingCropTokens.delete(token); return; }
    const preview = slot.querySelector('.multi-slot-preview');
    const placeholder = slot.querySelector('.multi-slot-placeholder');
    const removeBtn = slot.querySelector('.multi-slot-remove');
    const caption = slot.querySelector('.family-pilot-caption');
    const input = slot.querySelector('.multi-slot-input');
    let candidateCropper = null;
    try {
      if (!window.FamilyInlineCrop || typeof window.FamilyInlineCrop.openDialog !== 'function') throw window.CustomifyPhotoUpload.error('crop_unavailable');
      if (file.size > 10 * 1024 * 1024) {
        file = await window.CustomifyPhotoUpload.prepareCropFile(file);
        if (version !== this._familyUploadVersions[slotIndex]) return;
      }
      const germanCrop = String(window.CustomifyI18n?.locale || document.documentElement?.lang || 'en').toLowerCase().startsWith('de');
      candidateCropper = await window.FamilyInlineCrop.openDialog(file, {
        alt: `Photo ${slotIndex + 1} crop`,
        aspectRatio: ['family-portrait-add-loved-one', 'personalisiertes-familienportraet-aus-mehreren-fotos'].includes(this.getProductHandle()) ? 1 : undefined,
        initialRect: options.initialRect,
        returnFocus: options.returnFocus || placeholder,
        allowReplace: true,
        formatError: (error, selectedFile, retained) => window.CustomifyPhotoUpload.message(error, selectedFile, slotIndex, retained || Boolean(this.multiUploadFiles[slotIndex])),
        onError: (error, selectedFile, stage) => this._reportUploadError(error, selectedFile, stage, slotIndex),
        title: germanCrop ? 'Foto zuschneiden' : 'Crop your photo',
        labels: germanCrop ? { help: 'Wähle die Personen aus, die enthalten sein sollen', loading: 'Foto wird vorbereitet…', change: 'Anderes Foto wählen', cancel: 'Abbrechen', done: 'Fertig' } : undefined,
        replacementTitle: germanCrop ? 'Foto ändern' : undefined
      });
      if (!candidateCropper) return;
      const acceptedFile = candidateCropper.getFile?.() || file;
      const croppedPreview = candidateCropper.acceptedPreview || await candidateCropper.toFile();
      if (version !== this._familyUploadVersions[slotIndex]) { candidateCropper.destroy(); candidateCropper = null; return; }

      const previewUrl = URL.createObjectURL(croppedPreview);
      const previousCropper = this.familyCropperBySlot[slotIndex];
      const previousPreviewUrl = this._familyPreviewUrls?.[slotIndex];
      if (previousCropper && previousCropper !== candidateCropper) previousCropper.destroy();
      if (previousPreviewUrl) URL.revokeObjectURL(previousPreviewUrl);
      this._familyPreviewUrls = this._familyPreviewUrls || Array(this.multiUploadFiles?.length || 4).fill(null);
      this._familyPreviewUrls[slotIndex] = previewUrl;
      this.familyCropperBySlot[slotIndex] = candidateCropper;
      this.multiUploadFiles[slotIndex] = acceptedFile;
      this.multiUploadPreviews[slotIndex] = previewUrl;
      const captionPreserved = options.preserveCaption && acceptedFile === file;
      if (!captionPreserved) this.multiUploadCaptions[slotIndex] = '';
      if (preview) {
        preview.style.backgroundImage = `url("${previewUrl}")`;
        preview.style.display = 'block';
        preview.setAttribute('role', 'button');
        preview.tabIndex = 0;
        preview.setAttribute('aria-label', `Edit crop for photo ${slotIndex + 1}`);
      }
      if (placeholder) placeholder.style.display = 'none';
      if (removeBtn) removeBtn.style.display = 'flex';
      if (caption) {
        caption.value = this.multiUploadCaptions[slotIndex] || '';
        caption.disabled = false;
      }
      slot.classList.add('has-photo');
      candidateCropper = null;
      if (!captionPreserved) {
        this.trackStatsEvent('image_upload');
        this.trackGoogleAdsPhotoUpload(acceptedFile);
      }
      this.uploadedFile = this.multiUploadFiles.find(Boolean) || null;
      this.updateMultiUploadCounter();
    } catch (error) {
      candidateCropper?.destroy();
      if (version === this._familyUploadVersions[slotIndex]) this._showUploadError(error, file, 'crop-export', slotIndex);
    } finally {
      this._familyPendingCropTokens.delete(token);
      if (input) input.value = '';
      this.updateMultiUploadCounter();
    }
  }

  _familyHasPendingCrops() {
    return Boolean(this._familyPendingCropTokens?.size);
  }

  removeMultiFile(slotIndex) {
    if (this._multiPhotoVersions) this._multiPhotoVersions[slotIndex] = (this._multiPhotoVersions[slotIndex] || 0) + 1;
    this._uploadFeedback(null, slotIndex);
    if (this.usesFamilyPhotoCrop() && this._familyCropLocked) return;
    if (this.usesFamilyPhotoCrop()) {
      this._familyUploadVersions = this._familyUploadVersions || Array(this.multiUploadFiles?.length || 4).fill(0);
      this._familyUploadVersions[slotIndex] += 1;
      this.familyCropperBySlot?.[slotIndex]?.destroy();
      if (this.familyCropperBySlot) this.familyCropperBySlot[slotIndex] = null;
      const previewUrl = this._familyPreviewUrls?.[slotIndex];
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      if (this._familyPreviewUrls) this._familyPreviewUrls[slotIndex] = null;
      if (this.multiUploadCaptions) this.multiUploadCaptions[slotIndex] = '';
      const pilotSlot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      const pilotCaption = pilotSlot?.querySelector('.family-pilot-caption');
      const pilotPreview = pilotSlot?.querySelector('.multi-slot-preview');
      if (pilotPreview) { pilotPreview.style.backgroundImage = ''; pilotPreview.style.display = 'none'; }
      pilotPreview?.removeAttribute('role');
      pilotPreview?.removeAttribute('aria-label');
      if (pilotPreview) pilotPreview.tabIndex = -1;
      if (pilotCaption) { pilotCaption.value = ''; pilotCaption.disabled = true; }
      pilotSlot?.classList.remove('has-photo');
    }
    this.multiUploadFiles[slotIndex] = null;
    this.multiUploadPreviews[slotIndex] = null;
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    if (slot) {
      const preview = slot.querySelector('.multi-slot-preview');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      const input = slot.querySelector('.multi-slot-input');
      if (preview) { preview.style.backgroundImage = ''; preview.style.display = 'none'; }
      if (placeholder) placeholder.style.display = 'flex';
      if (removeBtn) removeBtn.style.display = 'none';
      if (input) input.value = '';
    }
    this.updateMultiUploadCounter();
    const remaining = this.getMultiUploadFiles();
    if (remaining.length === 0) this.uploadedFile = null;
    else this.uploadedFile = remaining[0];
  }

  updateMultiUploadCounter() {
    if (this.isExpandableFamilyUpload?.()) {
      const slots = document.querySelectorAll('.multi-upload-slot');
      const initialSlots = this._multiUploadInitialSlots || (this.isTogetherCoupleProduct() ? 2 : 4);
      for (let idx = initialSlots; idx < 8; idx++) {
        if (slots[idx]) slots[idx].style.display = this.multiUploadFiles[idx] ? '' : 'none';
      }
      const addPhoto = document.getElementById('familyAddPhoto');
      if (addPhoto) {
        const full = this.multiUploadFiles.slice(initialSlots).every(Boolean);
        addPhoto.disabled = full || this._familyCropLocked || this._familyHasPendingCrops();
        addPhoto.style.opacity = addPhoto.disabled ? '0.5' : '1';
        addPhoto.setAttribute('aria-disabled', String(addPhoto.disabled));
      }
    }
    const counter = document.getElementById('multiUploadCount');
    if (counter) {
      const count = this.multiUploadFiles.filter(f => f !== null).length;
      counter.textContent = count;
    }
    if (this.isFamilyGrandparentsPilot()) {
      const count = window.FamilyInlineCrop?.acceptedPhotoCount?.(this.multiUploadFiles, this.multiUploadFiles.length) ?? this.multiUploadFiles.filter(Boolean).length;
      const title = document.querySelector('.family-pilot-title');
      const addPhoto = document.getElementById('familyPilotAddPhoto');
      if (title) title.textContent = count ? `Your photos · ${count}/${this.multiUploadFiles.length}` : 'Add your photos';
      if (addPhoto) {
        addPhoto.textContent = count ? '+ Add another photo' : 'Add photo';
        addPhoto.hidden = count >= this.multiUploadFiles.length;
        addPhoto.disabled = this._familyCropLocked || this._familyHasPendingCrops();
      }
    }
  }

  getMultiUploadFiles() {
    if (this.usesFamilyPhotoCrop() && this._familyPilotSnapshot) return this._familyPilotSnapshot.files.slice();
    return this.multiUploadFiles.filter(f => f !== null);
  }

  setFamilyPilotBusy(isBusy) {
    this._familyCropLocked = Boolean(isBusy);
    const area = document.getElementById('multiUploadArea');
    if (area) area.classList.toggle('is-busy', this._familyCropLocked);
    document.querySelectorAll('#multiUploadArea .multi-slot-input, #multiUploadArea .family-crop-handle').forEach(control => { control.disabled = this._familyCropLocked; });
    document.querySelectorAll('#multiUploadArea .family-pilot-caption').forEach(control => {
      control.disabled = this._familyCropLocked || !control.closest('.family-pilot-slot')?.classList.contains('has-photo');
    });
    document.querySelectorAll('#multiUploadArea .multi-slot-remove').forEach(control => {
      control.disabled = this._familyCropLocked;
    });
    const addPhoto = document.getElementById('familyPilotAddPhoto');
    if (addPhoto) addPhoto.disabled = this._familyCropLocked || this._familyHasPendingCrops();
    this.updateMultiUploadCounter();
  }

  // 💝 Produkty "dla niej" + Biznes Woman — jeden styl (caricature-new), bez wyboru, generacja bez klikania w miniaturkę
  isDlaNiejProduct() {
    const h = this.getProductLogicHandle();
    return h === 'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-policjantka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-psycholog' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-kucharka' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-fitness' || h === 'obraz-ze-zdjecia-karykatura-dla-niej-szefowa' || h === 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || h === 'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem' || h === 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata' || h === 'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego' || h === 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny' || h === 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta' || h === 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty' || h === 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta' || h === 'obraz-ze-zdjecia-karykatura-szefa' || h === 'obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || h === 'plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia' || h === DIAMENTOWE_GODY_PRODUCT_HANDLE || h === WIESELI_STARUSZKOWIE_PRODUCT_HANDLE || h === PODROZNICY_PARA_PRODUCT_HANDLE || h === MLODA_PARA_SLUB_PRODUCT_HANDLE || h === ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE || h === ROCZNICA_50_SLUBU_PRODUCT_HANDLE || h === ROCZNICA_40_SLUBU_PRODUCT_HANDLE || h === 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza' || h === 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka' || h === 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty' || h === 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz' || h === 'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz' || h === 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle' || h === 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy' || h === 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa' || h === 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle' || h === 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan' || h === 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent' || h === 'obraz-ze-zdjecia-biznes-woman-personalizowany-prezent' || h === 'obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman' || h === 'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman' || h === 'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety';
  }

  // 🦸 Produkt Superbohater dla chłopca — Nano Banana, ukryty wybór, pole imienia
  isSuperheroBoyProduct() {
    return this.getProductLogicHandle() === 'portret-ze-zdjecia-superbohater-prezent-dla-chlopca';
  }

  // 🌹 Produkt Love Rose — jeden styl (love-rose), ukryty wybór, pole na napis zastępujący LOVE
  isLoveRoseProduct() {
    return this.getProductLogicHandle() === 'prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia';
  }

  // 💕 Produkt Royal Love — jeden styl (royal-love), ukryty wybór, pole na napis zastępujący Neverending Love
  isRoyalLoveProduct() {
    return this.getProductLogicHandle() === 'portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany';
  }

  // 🎮 Produkt GTA — jeden styl (gta), ukryty wybór, pole na napis na dole obrazka
  isGTAProduct() {
    return this.getProductLogicHandle() === 'portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent';
  }

  // 🎨 Produkt Watercolor — jeden styl, bez wyboru użytkownika
  isWatercolorProduct() {
    return this.getProductLogicHandle() === 'obraz-ze-zdjecia-akwarela';
  }

  // 🎤 Produkt Hip-Hop — jeden styl (hiphop), ukryty wybór stylu
  isHipHopProduct() {
    const h = this.getProductLogicHandle();
    return h === 'portret-w-stylu-hip-hop-obraz-na-plotnie-z-twojego-zdjecia' || h === 'portret-ze-zdjecia-hip-hop-personalizowany-obraz-na-plotnie';
  }

  // 📷 Produkt Retusz starych zdjęć (prezent dla dziadków) — FLUX Kontext Restore
  isRetuszStarychZdjecProduct() {
    return this.getProductLogicHandle() === 'prezent-dla-dziadkow-retusz-starych-zdjec';
  }

  // ✏️ Produkt Szkic ołówkowy — Nano Banana 2
  isSzkicOlowekProduct() {
    return this.getProductLogicHandle() === 'szkic-ze-zdjecia-obraz-na-plotnie-plakat-ramka';
  }

  getCropConfig() {
    return { aspectRatio: 1, width: 1024, height: 1024, filePrefix: 'spotify-crop' };
  }

  getPhoneCropConfig() {
    return { aspectRatio: 2 / 1, width: 2048, height: 1024, filePrefix: 'phone-crop' };
  }
  
  getPhonePhotoCropConfig() {
    return { aspectRatio: 1 / 2, width: 1000, height: 2000, filePrefix: 'phone-photo-crop' };
  }

  /** 📱 TYLKO etui: Inicjalizacja selektorów marka/model */
  async setupPhoneSelectors() {
    const slot = document.getElementById('phone-selectors-slot');
    if (!slot || !this.isPhonePhotoCaseProduct()) return;

    this.selectedPhoneBrand = null;
    this.selectedPhoneModel = null;
    this.phoneModelsData = null;

    try {
      const res = await fetch(window.CustomifyApi.url('/api/phone-models'));
      if (!res.ok) throw new Error('HTTP ' + res.status);
      this.phoneModelsData = await res.json();
    } catch (err) {
      console.error('❌ [PHONE] Nie można załadować listy modeli:', err);
      this._reportToSentry(err, 'phone-models-load');
      slot.innerHTML = `<p class="customify-error">${this.t('phone.error.load_models')}</p>`;
      return;
    }

    const brands = this.phoneModelsData.brands || [];
    const modelsByBrand = this.phoneModelsData.models || {};
    if (brands.length === 0) {
      slot.innerHTML = `<p class="customify-error">${this.t('phone.error.no_brands')}</p>`;
      return;
    }

    const wrap = document.createElement('div');
    wrap.className = 'phone-selectors-wrap';

    const brandField = document.createElement('div');
    brandField.className = 'phone-selector-field';
    const brandLabel = document.createElement('label');
    brandLabel.htmlFor = 'phoneBrandSelect';
    brandLabel.textContent = this.t('phone.brand.label');
    brandField.appendChild(brandLabel);
    const brandSelect = document.createElement('select');
    brandSelect.id = 'phoneBrandSelect';
    brandSelect.className = 'phone-selector-select';
    const brandOpt0 = document.createElement('option');
    brandOpt0.value = '';
    brandOpt0.textContent = this.t('phone.brand.placeholder');
    brandSelect.appendChild(brandOpt0);
    brands.forEach(b => {
      const opt = document.createElement('option');
      opt.value = b.id;
      opt.textContent = b.name;
      brandSelect.appendChild(opt);
    });
    brandField.appendChild(brandSelect);
    wrap.appendChild(brandField);

    const modelField = document.createElement('div');
    modelField.className = 'phone-selector-field';
    const modelLabel = document.createElement('label');
    modelLabel.htmlFor = 'phoneModelSelect';
    modelLabel.textContent = this.t('phone.model.label');
    modelField.appendChild(modelLabel);
    const modelSelect = document.createElement('select');
    modelSelect.id = 'phoneModelSelect';
    modelSelect.className = 'phone-selector-select';
    modelSelect.disabled = true;
    const modelOpt0 = document.createElement('option');
    modelOpt0.value = '';
    modelOpt0.textContent = this.t('phone.model.select_brand_first');
    modelSelect.appendChild(modelOpt0);
    modelField.appendChild(modelSelect);
    wrap.appendChild(modelField);

    const populateModels = (brandId) => {
      modelSelect.innerHTML = '';
      const models = modelsByBrand[brandId] || [];
      if (!brandId || models.length === 0) {
        const ph = document.createElement('option');
        ph.value = '';
        ph.textContent = this.t('phone.model.select_brand_first');
        modelSelect.appendChild(ph);
        modelSelect.disabled = true;
        this.selectedPhoneModel = null;
        return;
      }
      const def = document.createElement('option');
      def.value = '';
      def.textContent = this.t('phone.model.placeholder');
      modelSelect.appendChild(def);
      models.forEach(m => {
        const opt = document.createElement('option');
        opt.value = m.id;
        opt.textContent = m.name;
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = false;
    };

    brandSelect.addEventListener('change', () => {
      this.selectedPhoneBrand = brandSelect.value || null;
      this.selectedPhoneModel = null;
      populateModels(this.selectedPhoneBrand);
      this.hideError();
    });

    modelSelect.addEventListener('change', () => {
      this.selectedPhoneModel = modelSelect.value || null;
      if (this.selectedPhoneModel) this.hideError();
    });

    populateModels(null);
    slot.innerHTML = '';
    slot.appendChild(wrap);
    console.log('📱 [PHONE] Selektory marka/model zainicjalizowane');
  }

  getPhoneBrandLabel() {
    if (!this.selectedPhoneBrand || !this.phoneModelsData?.brands) return null;
    const b = this.phoneModelsData.brands.find(x => x.id === this.selectedPhoneBrand);
    return b ? b.name : this.selectedPhoneBrand;
  }

  getPhoneModelLabel() {
    if (!this.selectedPhoneBrand || !this.selectedPhoneModel || !this.phoneModelsData?.models) return null;
    const models = this.phoneModelsData.models[this.selectedPhoneBrand] || [];
    const m = models.find(x => x.id === this.selectedPhoneModel);
    return m ? m.name : this.selectedPhoneModel;
  }

  init() {
    const historyCustomer = this.getCustomerInfo();
    if (historyCustomer?.customerId && window.CustomifyHistoryRecovery) window.CustomifyHistoryRecovery.recover(historyCustomer.customerId).catch(() => {});
    if (!document.getElementById('uploadArea')) {
      return; // Jeśli nie ma elementów, nie rób nic
    }
    
    // ✅ STATS: Wyświetlenie strony produktu (każda odsłona = 1)
    try {
      const productPath = window.location.pathname || '';
      fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType: 'login_modal_page_entry',
          productUrl: productPath,
          timestamp: new Date().toISOString()
        })
      }).catch(() => {});
    } catch (_) {}
    
    this.setupEventListeners();
    this.setupMultiUpload(); // 📸 Multi-upload slots (jeśli produkt je obsługuje)
    this.positionApp();
    this.showStyles(); // Pokaż style od razu
    this.renderCustomFields(); // Pola personalizacji (jeśli produkt je obsługuje)
    // filterStylesForProduct() USUNIĘTE - logika przeniesiona na server-side (Shopify Liquid)
    
    // Setup expandable description USUNIĘTE - opisy produktów są teraz pełne
    
    // Setup accordion for product details - BEZ setTimeout!
    this.setupAccordion();
    
    // ✅ USAGE LIMITS: Pokaż licznik użyć
    console.log('🔍 [INIT] Calling showUsageCounter()...');
    this.showUsageCounter().catch(error => {
      console.error('❌ [INIT] Error in showUsageCounter:', error);
    });
    
    // 🎨 GALERIA: Załaduj galerię przy starcie (jeśli są zapisane generacje)
    console.log('🎨 [GALLERY] Calling updateGallery from init()');
    this.updateGallery().catch(error => {
      console.error('❌ [GALLERY] Error updating gallery on init:', error);
    });
    
    // 💰 CENA: Ustaw domyślny rozmiar i aktualizuj cenę
    this.initializeDefaultPrice();

    // 🎯 SYNC: Zsynchronizuj początkowy typ produktu i rozmiar z aktywnymi przyciskami w DOM
    try {
      // ✅ Dla WSZYSTKICH produktów: użyj domyślnego z HTML (Plakat)
      const activeTypeBtn = document.querySelector('.customify-product-type-btn.active');
      if (activeTypeBtn && activeTypeBtn.dataset.productType) {
        this.selectedProductType = activeTypeBtn.dataset.productType;
        console.log('🔄 [INIT] Synced selectedProductType from DOM:', this.selectedProductType);
      }
      const activeSizeBtn = document.querySelector('.customify-size-btn.active');
      if (activeSizeBtn && activeSizeBtn.dataset.size) {
        this.selectedSize = activeSizeBtn.dataset.size;
        console.log('🔄 [INIT] Synced selectedSize from DOM:', this.selectedSize);
      }
    } catch(e) {
      console.warn('⚠️ [INIT] Failed to sync initial selections from DOM:', e);
      this._reportToSentry(e, 'init-sync');
    }

    if (!window.CustomifyHideGlassPrint && this.isSpotifyProduct()) {
      const szkloBtn = document.querySelector('.customify-product-type-btn[data-product-type="szklo"]');
      if (szkloBtn) {
        this.productTypeArea?.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
        szkloBtn.classList.add('active');
        this.selectedProductType = 'szklo';
        console.log('🎵 [SPOTIFY] Ustawiam selectedProductType = szklo');
      }
      // 🎵 Ustaw domyślny rozmiar A5 (najtańszy) dla produktów Spotify
      const a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
      if (a5Btn) {
        this.sizeArea?.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
        a5Btn.classList.add('active');
        this.selectedSize = 'a5';
        console.log('🎵 [SPOTIFY] Ustawiam domyślny rozmiar = a5 (15×21)');
      }
    }
    // 🎯 Rocznica 50-ta / Dla niej: domyślnie wydruk na szkle + rozmiar A5
    if (!window.CustomifyHideGlassPrint && (this.getProductLogicHandle() === 'obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-na-50-ta-rocznice' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-policjantka' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-rolniczka' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-lekarka' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-psycholog' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-kucharka' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-fitness' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-dla-niej-szefowa' || this.getProductLogicHandle() === 'karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny' || this.getProductLogicHandle() === 'kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny' || this.getProductLogicHandle() === 'karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta' || this.getProductLogicHandle() === 'karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem' || this.getProductLogicHandle() === 'karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata' || this.getProductLogicHandle() === 'motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego' || this.getProductLogicHandle() === 'karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-karykatura-szefa' || this.getProductLogicHandle() === DIAMENTOWE_GODY_PRODUCT_HANDLE || this.getProductLogicHandle() === WIESELI_STARUSZKOWIE_PRODUCT_HANDLE || this.getProductLogicHandle() === PODROZNICY_PARA_PRODUCT_HANDLE || this.getProductLogicHandle() === MLODA_PARA_SLUB_PRODUCT_HANDLE || this.getProductLogicHandle() === ROCZNICA_SLUBU_PARA_PRODUCT_HANDLE || this.getProductLogicHandle() === 'fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza' || this.getProductLogicHandle() === 'portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka' || this.getProductLogicHandle() === 'prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty' || this.getProductLogicHandle() === 'prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz' || this.getProductLogicHandle() === 'active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle' || this.getProductLogicHandle() === 'active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy' || this.getProductLogicHandle() === 'portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa' || this.getProductLogicHandle() === 'portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan' || this.getProductLogicHandle() === 'portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent' || this.getProductLogicHandle() === 'obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman' || this.getProductLogicHandle() === 'wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety')) {
      const szkloBtn = document.querySelector('.customify-product-type-btn[data-product-type="szklo"]');
      if (szkloBtn) {
        this.productTypeArea?.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
        szkloBtn.classList.add('active');
        this.selectedProductType = 'szklo';
      }
      const a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
      if (a5Btn) {
        this.sizeArea?.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
        a5Btn.classList.add('active');
        this.selectedSize = 'a5';
        console.log('🎯 [ROCZnica] Default: wydruk na szkle, rozmiar A5');
      }
    }
    this.updateSpotifyFrameScale();
    window.addEventListener('resize', () => this.updateSpotifyFrameScale());

    // Zaktualizuj dostępność rozmiarów po początkowej synchronizacji
    this.updateSizeAvailability();

    // Po synchronizacji wymuś przeliczenie cen (uwzględnia ramkę, jeśli plakat)
    this.updateProductPrice();
    this.updateCartPrice();

    // 📱 Phone case: Hide main cart price (phone case has its own price display)
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const cartPriceDisplay = document.getElementById('cartPriceDisplay');
      if (cartPriceDisplay) cartPriceDisplay.style.display = 'none';
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartPriceDisplay) phoneCaseCartPriceDisplay.style.setProperty('display','none','important');
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      if (phoneCaseCartActions) phoneCaseCartActions.style.setProperty('display','none','important');
      this.setupPhoneSelectors().catch(err => console.error('❌ [PHONE] setupPhoneSelectors error:', err));
    }

    // 🆕 Inicjalizacja napisów (pilotaż)
    this.setupTextOverlayUI();
  }
  

  // ===== USAGE LIMITS FUNCTIONS =====
  
  /**
   * Pobiera informacje o zalogowanym użytkowniku Shopify
   * @returns {Object|null} {customerId, email, customerAccessToken} lub null jeśli niezalogowany
   */
  getCustomerInfo() {
    // ⚠️ KRYTYCZNE: Jeśli Shopify Liquid mówi że użytkownik NIE jest zalogowany,
    // to NIE sprawdzaj fallbacków - po prostu zwróć null
    // Sprawdź czy window.ShopifyCustomer istnieje i ma wartość (nie null, nie undefined, nie false)
    if (!window.ShopifyCustomer || window.ShopifyCustomer === null) {
      return null;
    }
    
    const sanitizeId = (value) => {
      if (value === null || value === undefined) {
        return null;
      }
      if (typeof value === 'object' && value.id) {
        return sanitizeId(value.id);
      }
      const idStr = String(value).trim();
      if (!idStr || idStr.toLowerCase() === 'null' || idStr.toLowerCase() === 'undefined') {
        return null;
      }
      return idStr;
    };
    
    const sanitizeEmail = (value) => {
      if (!value) {
        return null;
      }
      const emailStr = String(value).trim();
      if (!emailStr || emailStr.toLowerCase() === 'null' || emailStr.toLowerCase() === 'undefined') {
        return null;
      }
      return emailStr;
    };
    
    const getStoredValue = (key) => {
      try {
        return safeLocalStorageGet(key);
      } catch (e) {
        return null;
      }
    };
    
    const persistCustomerContext = (info, source) => {
      if (!info || !info.customerId) {
        return null;
      }
      try {
        safeLocalStorageSet('customify_last_customer_id', info.customerId);
        if (info.email) {
          safeLocalStorageSet('customify_last_customer_email', info.email);
        }
      } catch (e) {
        // Ignore storage errors (Safari private mode etc.)
      }
      if (source) {
        // ⚠️ DEBUG: Sprawdź czy window.ShopifyCustomer jest null przed logowaniem
        if (window.ShopifyCustomer === null) {
          console.warn(`⚠️ [CUSTOMER DETECT] BŁĄD: Próba użycia ${source} gdy window.ShopifyCustomer === null!`);
          console.warn(`⚠️ [CUSTOMER DETECT] window.ShopifyCustomer:`, window.ShopifyCustomer);
          console.warn(`⚠️ [CUSTOMER DETECT] Zwracam null zamiast info z ${source}`);
          return null; // ⚠️ ZWRÓĆ NULL jeśli window.ShopifyCustomer jest null!
        }
        // Klient zidentyfikowany (bez logowania customerId)
      }
      return info;
    };
    const buildCustomerInfo = (idCandidate, emailCandidate, source) => {
      // ⚠️ KRYTYCZNE: Jeśli window.ShopifyCustomer jest null, NIE buduj customerInfo z fallbacków
      if (window.ShopifyCustomer === null || window.ShopifyCustomer === undefined) {
        console.warn(`⚠️ [CUSTOMER DETECT] buildCustomerInfo zablokowane - window.ShopifyCustomer jest null/undefined (source: ${source})`);
        return null;
      }
      
      const customerId = sanitizeId(idCandidate);
      if (!customerId) {
        return null;
      }
      const fallbackEmail = sanitizeEmail(emailCandidate) ||
        sanitizeEmail(getStoredValue('customify_last_customer_email')) ||
        'no-email@shopify.com';
      return persistCustomerContext({
        customerId,
        email: fallbackEmail,
        firstName: window.ShopifyCustomer?.firstName || '',
        lastName: window.ShopifyCustomer?.lastName || '',
        customerAccessToken: 'oauth_session'
      }, source);
    };
    const getShopifyCustomerField = (field) => {
      if (!window.ShopifyCustomer) {
        return null;
      }
      if (field in window.ShopifyCustomer) {
        return window.ShopifyCustomer[field];
      }
      const lowerField = field.toLowerCase();
      for (const key of Object.keys(window.ShopifyCustomer)) {
        if (key.toLowerCase() === lowerField) {
          return window.ShopifyCustomer[key];
        }
      }
      return null;
    };
    
    // METODA 1: NOWY SYSTEM - window.ShopifyCustomer (z Liquid w theme.liquid)
    // ⚠️ Sprawdź czy window.ShopifyCustomer istnieje i NIE jest null/undefined
    if (window.ShopifyCustomer && window.ShopifyCustomer !== null && (getShopifyCustomerField('id') || getShopifyCustomerField('customerId'))) {
      const shopifyId = getShopifyCustomerField('id') || getShopifyCustomerField('customerId');
      const shopifyEmail = getShopifyCustomerField('email') || null;
      return buildCustomerInfo(shopifyId, shopifyEmail, 'ShopifyCustomer');
    }
    
    // METODA 1B: Shopify Analytics (fallback)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      const analyticsMeta = window.ShopifyAnalytics.meta;
      const analyticsId =
        analyticsMeta.page?.customerId ??
        analyticsMeta.customerId ??
        analyticsMeta.page?.customer_id ??
        analyticsMeta.customer_id ??
        null;
      const analyticsEmail =
        analyticsMeta.page?.customerEmail ??
        analyticsMeta.customerEmail ??
        analyticsMeta.page?.customer_email ??
        analyticsMeta.customer_email ??
        null;
      
      const analyticsInfo = buildCustomerInfo(analyticsId, analyticsEmail, 'ShopifyAnalytics.meta');
      if (analyticsInfo) {
        return analyticsInfo;
      }
    }
    
    // METODA 1C: window.meta (Shopify storefront meta object)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null && window.meta) {
      const metaId = window.meta.page?.customerId ?? window.meta.customerId ?? null;
      const metaEmail = window.meta.page?.customerEmail ?? window.meta.customerEmail ?? null;
      
      const metaInfo = buildCustomerInfo(metaId, metaEmail, 'window.meta');
      if (metaInfo) {
        return metaInfo;
      }
    }
    
    // METODA 1D: Shopify tracking object (__st)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null) {
      const shopifyTrackingId = window.__st ? window.__st.cid : null;
      if (shopifyTrackingId) {
        const trackingInfo = buildCustomerInfo(shopifyTrackingId, getStoredValue('customify_last_customer_email'), '__st.cid');
        if (trackingInfo) {
          return trackingInfo;
        }
      }
    }
    
    // METODA 2: FALLBACK - Sprawdź cookie Shopify (customer_id)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nie null)
    if (window.ShopifyCustomer !== null) {
      const cookies = document.cookie.split(';').map(c => c.trim());
      if (cookies.length > 0) {
        const customerIdCookie = cookies.find(c => c.startsWith('customer_id='));
        if (customerIdCookie) {
          const cookieId = sanitizeId(customerIdCookie.split('=')[1]);
          const cookieInfo = buildCustomerInfo(cookieId, getStoredValue('customify_last_customer_email') || window.ShopifyCustomer?.email, 'customer_id cookie');
          if (cookieInfo) {
            return cookieInfo;
          }
        }
      }
    }
    
    // METODA 3: Pamięć lokalna (ostatni znany zalogowany użytkownik)
    // ⚠️ UŻYWAJ TYLKO jeśli window.ShopifyCustomer istnieje (nawet jeśli nie ma ID)
    // Jeśli window.ShopifyCustomer jest null = użytkownik NIE jest zalogowany w Shopify
    if (window.ShopifyCustomer !== null && window.ShopifyCustomer !== undefined) {
      const storedId = sanitizeId(getStoredValue('customify_last_customer_id'));
      if (storedId) {
        return buildCustomerInfo(storedId, getStoredValue('customify_last_customer_email'), 'localStorage');
      }
    }
    
    // METODA 4: STARY SYSTEM - window.Shopify.customerEmail (Classic Customer Accounts)
    if (window.Shopify && window.Shopify.customerEmail) {
      const legacyId = sanitizeId(window.meta?.customer?.id || window.ShopifyCustomer?.id || getStoredValue('customify_last_customer_id'));
      const legacyEmail = sanitizeEmail(window.Shopify.customerEmail) || getStoredValue('customify_last_customer_email');
      const legacyToken = getStoredValue('shopify_customer_access_token') || 'oauth_session';
      
      if (legacyId) {
        return persistCustomerContext({
          customerId: legacyId,
          email: legacyEmail || 'legacy-user@shopify.com',
          customerAccessToken: legacyToken
        }, 'Shopify.customerEmail');
      }
    }
    
    // No customer detected
    return null;
  }

  /**
   * Sprawdza liczbę użyć z localStorage (dla niezalogowanych)
   * @returns {number} Liczba użyć
   */
  /**
   * Określa productType na podstawie STRONY (URL) - to jest najważniejsze!
   * Strona = Produkt = Cena (król ma inną cenę niż boho)
   */
  getProductTypeFromStyle(style) {
    if (THEMED_STYLE_BY_HANDLE[this.getProductHandle()]) return THEMED_STYLE_BY_HANDLE[this.getProductHandle()];
    // 🎯 PRIORYTET 1: Sprawdź URL strony (NAJWAŻNIEJSZE - określa cenę!)
    const actualHandle = this.getProductHandle();
    const logicHandle = this.getProductLogicHandle();
    const currentUrl = logicHandle ? `/products/${logicHandle}` : window.location.pathname.toLowerCase();
    
    console.log('🔍 [PRODUCT-TYPE] Sprawdzam URL:', currentUrl, 'actualHandle:', actualHandle);
    
    // Mapuj URL → productType (określa który produkt Shopify = jaka cena)
    if (currentUrl.includes('krol-portret') || currentUrl.includes('krol-personalizowany') || currentUrl.includes('portret-krola-polski')) {
      console.log('👑 [PRODUCT-TYPE] URL = Król → productType: king');
      return 'king';
    }
    if (currentUrl.includes('koty-krolewskie') || currentUrl.includes('krolewskie-portrety-kotow')) {
      console.log('🐱 [PRODUCT-TYPE] URL = Koty → productType: cats');
      return 'cats';
    }
    if (currentUrl.includes('obraz-w-stylu-pop-art-z-twojego-zdjecia-personalizowany-na-prezent')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Pop Art → productType: pop_art');
      return 'pop_art';
    }

    if (currentUrl.includes('personalizowany-obraz-3d-cartoon-ilustracja-z-twojego-zdjecia')) {
      console.log('🎨 [PRODUCT-TYPE] URL = 3D Cartoon → productType: 3d_cartoon');
      return '3d_cartoon';
    }

    if (currentUrl.includes('portret-z-efektem-farb-olejnych-z-twojego-zdjecia-na-prezent')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Farby Olejne → productType: oil_paints');
      return 'oil_paints';
    }

    if (currentUrl.includes('obraz-olejny-portret-na-plotnie-z-twojego-zdjecia')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Obraz Olejny → productType: oil_painting');
      return 'oil_painting';
    }

    if (currentUrl.includes('obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Prezent dla Niej (Farby Olejne) → productType: oil_paints');
      return 'oil_paints';
    }
    if (currentUrl.includes('personalizowany-portret-w-stylu-boho')) {
      console.log('🎨 [PRODUCT-TYPE] URL = Boho → productType: boho');
      return 'boho';
    }
    if (currentUrl.includes('superbohater') || currentUrl.includes('portret-ze-zdjecia-superbohater-prezent-dla-chlopca')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superbohater → productType: superhero');
      return 'superhero';
    }
    if (currentUrl.includes('plakat-ze-zdjecia-w-stylu-komiks')) {
      console.log('🖍️ [PRODUCT-TYPE] URL = Komiks (test) → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-pary-na-50-ta-rocznice-wydruk-na-szkle')) {
      console.log('💑 [PRODUCT-TYPE] URL = Para rocznica wydruk na szkle → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-na-50-ta-rocznice')) {
      console.log('🎂 [PRODUCT-TYPE] URL = Karykatura 50-ta rocznica → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-biznes-woman-personalizowany-prezent')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('wydruk-na-szkle-biznes-woman-prezent-na-urodziny-dla-kobiety')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Wydruk na szkle Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-50-urodziny-dla-kobiety-biznes-woman')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Biznes Woman 50 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-30-urodziny-dla-kobiety-biznes-woman')) {
      console.log('👩‍💼 [PRODUCT-TYPE] URL = Prezent 30 urodziny Biznes Woman → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-zainteresowania')) {
      console.log('💝 [PRODUCT-TYPE] URL = Karykatura dla niej → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-policjantka')) {
      console.log('👮 [PRODUCT-TYPE] URL = Karykatura dla niej policjantka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-rolniczka')) {
      console.log('🌾 [PRODUCT-TYPE] URL = Karykatura dla niej rolniczka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-lekarka')) {
      console.log('🩺 [PRODUCT-TYPE] URL = Karykatura dla niej lekarka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-podrozniczka')) {
      console.log('✈️ [PRODUCT-TYPE] URL = Karykatura dla niej podróżniczka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-psycholog')) {
      console.log('🧠 [PRODUCT-TYPE] URL = Karykatura dla niej psycholog → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-kucharka')) {
      console.log('👩‍🍳 [PRODUCT-TYPE] URL = Karykatura dla niej kucharka → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-fitness')) {
      console.log('💪 [PRODUCT-TYPE] URL = Karykatura dla niej fitness → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-dla-niej-szefowa')) {
      console.log('🛒 [PRODUCT-TYPE] URL = Karykatura dla niej szefowa → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-rolnik-ze-zdjecia-personalizowany-prezent-dla-mezczyzny')) {
      console.log('🎣 [PRODUCT-TYPE] URL = Karykatura rolnik dla mężczyzny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-polskiego-rolnika-z-ciagnikiem-prezent-z-charakterem')) {
      console.log('🚜 [PRODUCT-TYPE] URL = Karykatura polski rolnik z ciągnikiem → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-mechanika-samochodowego-ze-zdjecia-personalizowany-prezent-dla-dziadka-taty-lub-brata')) {
      console.log('🔧 [PRODUCT-TYPE] URL = Karykatura mechanik samochodowy → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('motocyklista-karykatura-ze-zdjecia-personalizowany-prezent-dla-niego')) {
      console.log('🏍️ [PRODUCT-TYPE] URL = Karykatura motocyklista → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-dla-chlopca-pilkarz')) {
      console.log('⚽ [PRODUCT-TYPE] URL = Piłkarz chłopiec → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('fotoobraz-strazaka-ze-zdjecia-prezent-na-35-urodziny-dla-meza')) {
      console.log('🔥 [PRODUCT-TYPE] URL = Strażak → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-dla-lekarza-personalizowany-plakat-na-urodziny-dla-chlopaka')) {
      console.log('🩺 [PRODUCT-TYPE] URL = Lekarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-ze-zdjecia-dla-budowlanca-personalizowany-obraz-dla-taty')) {
      console.log('🏗️ [PRODUCT-TYPE] URL = Budowlaniec → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('prezent-z-wlasnym-zdjeciem-dla-kierowcy-tira-personalizowany-obraz')) {
      console.log('🚛 [PRODUCT-TYPE] URL = Kierowca tira → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-policjant-prezent-dla-faceta')) {
      console.log('👮 [PRODUCT-TYPE] URL = Karykatura policjant → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-karykatura-szefa')) {
      console.log('👔 [PRODUCT-TYPE] URL = Karykatura szef → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-w-stylu-forbes-gold-ze-zdjecia-personalizowany-prezent-dla-mezczyzny')) {
      console.log('📰 [PRODUCT-TYPE] URL = Forbes Gold → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('plakat-w-stylu-forbes-silver-dla-mezczyzny-personalizowany-prezent-ze-zdjecia')) {
      console.log('📰 [PRODUCT-TYPE] URL = Forbes Silver → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pary-na-diamentowe-gody-ze-zdjecia-60-rocznica-slubu')) {
      console.log('💎 [PRODUCT-TYPE] URL = Diamentowe Gody para → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-dziadkow-ze-zdjecia-wesola-para-personalizowany-prezent')) {
      console.log('👴👵 [PRODUCT-TYPE] URL = Weseli staruszkowie → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pary-podroznikow-ze-zdjecia-personalizowany-prezent-dla-pary')) {
      console.log('✈️ [PRODUCT-TYPE] URL = Para podróżników → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-slubna-ze-zdjecia-prezent-dla-mlodej-pary')) {
      console.log('💒 [PRODUCT-TYPE] URL = Młoda para ślub → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-rocznice-slubu-prezent-na-25-30-40-50-lecie')) {
      console.log('💍 [PRODUCT-TYPE] URL = Rocznica ślubu 25/30/40/50 → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-50-rocznice-slubu-prezent-na-50-lecie')) {
      console.log('🥇 [PRODUCT-TYPE] URL = 50 rocznica slubu → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-na-40-rocznice-slubu-obraz-ze-zdjecia-na-40-lecie')) {
      console.log('💎 [PRODUCT-TYPE] URL = 40 rocznica slubu → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-wedkarz-portret-ze-zdjecia-personalizowany-prezent-dla-faceta')) {
      console.log('🎣 [PRODUCT-TYPE] URL = Karykatura wędkarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('karykatura-pilkarza-ze-zdjecia-personalizowany-obraz-dla-chlopaka-dziadka-taty')) {
      console.log('⚽ [PRODUCT-TYPE] URL = Karykatura piłkarz → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('kulturysta-karykatura-ze-zdjecia-prezent-dla-mezczyzny')) {
      console.log('💪 [PRODUCT-TYPE] URL = Karykatura kulturysta dla mężczyzny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('active-woman-portret-ze-zdjecia-na-rocznice-dla-kolezanki-kobiety-druk-na-szkle')) {
      console.log('🏋️ [PRODUCT-TYPE] URL = Active woman fitness → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('active-woman-portret-ze-zdjecia-na-18-urodziny-dla-dziewczyny-druk-na-szkle-copy')) {
      console.log('🎂 [PRODUCT-TYPE] URL = Active woman 18 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-prezent-na-urodziny-dla-kolezanki-szefowej-salon-spa')) {
      console.log('💅 [PRODUCT-TYPE] URL = Szefowa salon spa → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-prezent-na-40-urodziny-dla-kobiety-czerwony-dywan')) {
      console.log('🎀 [PRODUCT-TYPE] URL = 40 urodziny czerwony dywan → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-na-18-urodziny-dla-dziewczyny-magic-z-wlasnego-zdjecia-druk-na-szkle')) {
      console.log('✨ [PRODUCT-TYPE] URL = Magic 18 urodziny → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-ze-zdjecia-na-30-rocznice-dla-nauczycielki-karykatura-na-prezent')) {
      console.log('📚 [PRODUCT-TYPE] URL = Nauczycielka 30 rocznica → productType: caricature-new');
      return 'caricature-new';
    }
    if (currentUrl.includes('portret-pary-z-okazji-rocznicy-z-twojego-zdjecia')) {
      console.log('🤴👸 [PRODUCT-TYPE] URL = Para królewska → productType: para_krolewska');
      return 'para_krolewska';
    }
    if (currentUrl.includes('portret-pary-w-stylu-anime-obraz-ze-zdjecia')) {
      console.log('🎌 [PRODUCT-TYPE] URL = Anime → productType: anime');
      return 'anime';
    }
    if (currentUrl.includes('ramka-spotify') || currentUrl.includes('zdjecie-na-szkle-ramka-spotify')) {
      console.log('🎵 [PRODUCT-TYPE] URL = Ramka Spotify → productType: spotify_frame');
      return 'spotify_frame';
    }
    if (currentUrl.includes('personalizowane-etui-na-telefon-z-twoim-zdjeciem') && !currentUrl.includes('-karykatura')) {
      console.log('📱 [PRODUCT-TYPE] URL = Etui na telefon → productType: etui');
      return 'etui';
    }
    if (currentUrl.includes('portret-z-twojego-zdjecia-neon-lights-dla-dziewczyny-prezent')) {
      console.log('💡 [PRODUCT-TYPE] URL = Neon Lights → productType: neo');
      return 'neo';
    }
    if (currentUrl.includes('personalizowany-obraz-z-twojego-zdjecia-dla-mezczyzny-w-stylu-western-wanted')) {
      console.log('🤠 [PRODUCT-TYPE] URL = Western Wanted → productType: wanted');
      return 'wanted';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-dla-kobiety-w-stylu-western-wanted-poszukiwana')) {
      console.log('🤠 [PRODUCT-TYPE] URL = Western Wanted (kobieta) → productType: wanted_k');
      return 'wanted_k';
    }
    if (currentUrl.includes('portret-superbohater-obraz-na-plotnie-z-twojego-zdjecia-superman')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superman → productType: superman');
      return 'superman';
    }
    if (currentUrl.includes('portret-dziecka-w-stroju-jednorozca') || currentUrl.includes('jednorozec')) {
      console.log('🦄 [PRODUCT-TYPE] URL = Jednorożec → productType: unicorn');
      return 'unicorn';
    }
    if (currentUrl.includes('portret-dziecka-w-stroju-misia') || currentUrl.includes('mis')) {
      console.log('🧸 [PRODUCT-TYPE] URL = Miś → productType: teddy_bear');
      return 'teddy_bear';
    }
    if (currentUrl.includes('portret-ze-zdjecia-dla-dziewczynki-zimowa-ksiezniczka') || currentUrl.includes('zimowa-ksiezniczka')) {
      console.log('❄️ [PRODUCT-TYPE] URL = Zimowa Księżniczka → productType: winter_princess');
      return 'winter_princess';
    }
    if (currentUrl.includes('obraz-ze-zdjecia-krolowa-sniegu') || currentUrl.includes('krolowa-sniegu')) {
      console.log('❄️👑 [PRODUCT-TYPE] URL = Królowa Śniegu → productType: snow_queen');
      return 'snow_queen';
    }
    if (currentUrl.includes('portret-krolowej-obraz-ze-zdjecia-prezent-dla-niej')) {
      console.log('👑 [PRODUCT-TYPE] URL = Portret królowej prezent → productType: queen_prezent');
      return 'queen_prezent';
    }
    if (currentUrl.includes('prezent-na-walentynki-obraz-na-plotnie-z-twojego-zdjecia')) {
      console.log('🌹 [PRODUCT-TYPE] URL = Love Rose → productType: love_rose');
      return 'love_rose';
    }
    if (currentUrl.includes('portret-zakochana-para-krolewska-prezent-na-walentynki-personalizowany')) {
      console.log('💕 [PRODUCT-TYPE] URL = Royal Love → productType: royal_love');
      return 'royal_love';
    }
    if (currentUrl.includes('prezent-na-walentynki-superpara-obraz-na-plotnie-z-twojego-zdjecia')) {
      console.log('🦸 [PRODUCT-TYPE] URL = Superpara → productType: superpara');
      return 'superpara';
    }
    if (currentUrl.includes('portret-w-stylu-gta-obraz-na-plotnie-z-twojego-zdjecia-super-prezent') || currentUrl.includes('portret-w-stylu-gta')) {
      console.log('🎮 [PRODUCT-TYPE] URL = GTA → productType: gta');
      return 'gta';
    }
    if (currentUrl.includes('portret-w-stylu-hip-hop-obraz-na-plotnie') || currentUrl.includes('portret-ze-zdjecia-hip-hop')) {
      console.log('🎤 [PRODUCT-TYPE] URL = Hip-Hop → productType: hiphop');
      return 'hiphop';
    }
    if (currentUrl.includes('dodaj-osobe-do-zdjecia-naturalny-efekt')) {
      console.log('📸 [PRODUCT-TYPE] URL = Dodaj osobę → productType: dodaj_osobe');
      return 'dodaj_osobe';
    }
    if (currentUrl.includes('prezent-dla-dziadkow-retusz-starych-zdjec')) {
      console.log('📷 [PRODUCT-TYPE] URL = Retusz starych zdjęć → productType: retusz_starych_zdjec');
      return 'retusz_starych_zdjec';
    }
    if (currentUrl.includes('szkic-ze-zdjecia-obraz-na-plotnie-plakat-ramka')) {
      console.log('✏️ [PRODUCT-TYPE] URL = Szkic ołówkowy → productType: szkic_olowek');
      return 'szkic_olowek';
    }

    // 🔄 PRIORYTET 2: Fallback - sprawdź styl (tylko dla starych generacji bez URL)
    console.log('⚠️ [PRODUCT-TYPE] Nie rozpoznano URL, sprawdzam styl:', style);
    
    const styleToProductType = {
      'pop-art': 'pop_art',
      '3d-cartoon': '3d_cartoon',
      'oil-paints': 'oil_paints',
      'oil-painting': 'oil_painting',
      'minimalistyczny': 'boho',
      'realistyczny': 'boho',
      'krol-krolewski': 'king',
      'krol-majestatyczny': 'king',
      'krol-triumfalny': 'king',
      'krol-imponujacy': 'king',
      'krol-polski': 'king',
      'krol-polski-krolewski': 'king',
      'krolowa-styl-1': 'queen',
      'krolowa-styl-2': 'queen',
      'krolowa-styl-3': 'queen',
      'krolowa-styl-4': 'queen',
      'krolowa-prezent-1': 'queen_prezent',
      'krolowa-prezent-2': 'queen_prezent',
      'krolewski': 'cats',
      'na-tronie': 'cats',
      'wojenny': 'cats',
      'wiktorianski': 'cats',
      'renesansowy': 'cats',
      'zamkowy': 'para_krolewska',
      'krolewski-para': 'para_krolewska',
      'superhero_kid': 'superhero',
      'superhero_boy': 'superhero',
      'karykatura': 'caricature',
      'caricature-new': 'caricature-new',
      'karykatura-olowek': 'caricature-new',
      'karykatura-prezent-szkic': 'caricature-new',
      'olowkiem-zam-karykatura': 'caricature',
      'olowkiem-zam-nowoczesna': 'caricature-new',
      'olowkiem-zam-szkic': 'caricature-new',
      'watercolor_ok': 'caricature-new',
      'swieta': 'caricature-new',
      'swieta_2': 'caricature-new',
      'akwarela': 'watercolor',
      'openai-art': 'openai-art', // OpenAI GPT-Image-1 style
      'love-rose': 'love_rose', // Love Rose - OpenAI GPT-Image-1.5 via Replicate
      'royal-love': 'royal_love', // Royal Love - OpenAI GPT-Image-1.5 via Replicate
      'gta': 'gta', // GTA - OpenAI GPT-Image-1.5 via Replicate
      'hiphop': 'hiphop', // Hip-Hop - OpenAI GPT-Image-1.5 via Replicate
      'szkic-love': 'szkic_love', // Szkic Love - OpenAI GPT-Image-1.5 via Replicate
      'jak-z-bajki': 'jak_z_bajki', // Jak z bajki - OpenAI GPT-Image-1.5 via Replicate
      'superpara': 'superpara', // Superpara - OpenAI GPT-Image-1.5 via Replicate
      'jednorozec': 'unicorn',
      'mis': 'teddy_bear',
      'zimowa-ksiezniczka': 'winter_princess',
      'krolowa-sniegu': 'snow_queen',
      'neo': 'neo',
      'wanted': 'wanted',
      'wanted_k': 'wanted_k',
      'anime': 'anime',
      'superman': 'superman',
      'dodaj-osobe': 'dodaj_osobe',
      'retusz-starych-zdjec': 'retusz_starych_zdjec',
      'szkic-olowek': 'szkic_olowek'
    };

    const productType = styleToProductType[style] || 'other';
    console.log('🔄 [PRODUCT-TYPE] Styl:', style, '→ productType:', productType);
    
    return productType;
  }

  getLocalUsageCount() {
    const key = 'customify_usage_count';
    const storedCount = parseInt(safeLocalStorageGet(key, '0'), 10);
    if (Number.isFinite(storedCount) && storedCount > 0) {
      return storedCount;
    }

    // Jednorazowa migracja starych liczników per produkt do jednego limitu globalnego.
    let migratedCount = 0;
    try {
      for (let index = 0; index < localStorage.length; index += 1) {
        const legacyKey = localStorage.key(index);
        if (!legacyKey || legacyKey === key || !legacyKey.startsWith('customify_usage_')) continue;
        const legacyCount = parseInt(localStorage.getItem(legacyKey) || '0', 10);
        if (Number.isFinite(legacyCount) && legacyCount > 0) migratedCount += legacyCount;
      }
    } catch (storageError) {
      console.warn('⚠️ [LOCAL-STORAGE] Nie udało się zmigrować starego licznika:', storageError);
    }

    if (migratedCount > 0) safeLocalStorageSet(key, migratedCount.toString());
    return migratedCount;
  }

  /**
   * Inkrementuje globalny licznik w localStorage (dla niezalogowanych).
   */
  incrementLocalUsage() {
    const key = 'customify_usage_count';
    const currentCount = this.getLocalUsageCount();
    const newCount = currentCount + 1;
    safeLocalStorageSet(key, newCount.toString());
    this.showUsageCounter(); // Odśwież licznik w UI
  }

  /**
   * Zapisuje generację AI w localStorage
   */
  async saveAIGeneration(originalImage, transformedImage, style, size, productType = null, watermarkedImageUrl = null, watermarkedImageBase64 = null, artworkId = null) {
    console.log('💾 [CACHE] Saving AI generation to localStorage...');
    
    // ⚠️ NIE zapisuj ponownie do Vercel Blob - już jest zapisane w transform.js jako generation-{timestamp}.jpg
    // Używamy URL z API response (generation-{timestamp}.jpg) zamiast duplikować jako ai-{timestamp}.jpg.jpg
    let transformedImageUrl = transformedImage; // Użyj URL z API (generation-{timestamp}.jpg lub base64)
    
    console.log('✅ [CACHE] Using existing URL from transform.js (no duplicate upload):', transformedImageUrl?.substring(0, 50));

    // ✅ DODAJ productType jeśli nie został przekazany (fallback dla starych generacji)
    if (!productType && style) {
      productType = this.getProductTypeFromStyle(style);
      console.log('🔄 [CACHE] ProductType wywnioskowany z stylu:', productType);
    }

    const generation = {
      id: Date.now(),
      artworkId: artworkId || this.artworkId || null,
      timestamp: new Date().toISOString(),
      originalImage: originalImage, // base64 lub URL (zachowaj)
      transformedImage: transformedImageUrl, // ZAWSZE URL (nie base64)
      watermarkedImageUrl: watermarkedImageUrl || null, // ✅ ZAPISZ watermarkedImageUrl (Vercel Blob z watermarkiem) - używany tylko w wyświetlaniu
      watermarkedImageBase64: watermarkedImageBase64 || null, // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
      style: style,
      size: size,
      productType: productType, // ✅ DODAJ productType (boho, king, cats, etc) - dla skalowalności
      productHandle: typeof this.getProductHandle === 'function' ? this.getProductHandle() : null, // strona produktu (Moje generacje → właściwy URL)
      thumbnail: transformedImageUrl // ✅ ZAWSZE transformedImageUrl (zachowaj oryginalną logikę)
    };

    // Pobierz istniejące generacje
    const existingGenerations = this.getAIGenerations();
    
    // Dodaj nową generację na początku
    existingGenerations.unshift(generation);
    
    // Zachowaj ostatnie 8 generacji (URL są małe, ~100 znaków zamiast 2-5MB base64)
    const limitedGenerations = existingGenerations.slice(0, 8);
    
    // Zapisz z powrotem do localStorage
    safeLocalStorageSet('customify_ai_generations', JSON.stringify(limitedGenerations));
    
    console.log('🎨 [GALLERY] Saved AI generation:', generation.id, style, size);
    
    // Odśwież galerię
    this.updateGallery().catch(error => {
      console.error('❌ [GALLERY] Error updating gallery after save:', error);
    });
  }

  /**
   * Pobiera zapisane generacje AI
   */
  getAIGenerations() {
    try {
      const stored = safeLocalStorageGet('customify_ai_generations');
      if (!stored) return [];
      
      const parsed = JSON.parse(stored);
      console.log('🎨 [GALLERY] Loaded generations from localStorage:', parsed.length);
      
      // TYMCZASOWO: zwróć wszystkie generacje bez filtrowania
      return parsed;
    } catch (error) {
      console.error('❌ [GALLERY] Error loading generations:', error);
      this._reportToSentry(error, 'getAIGenerations');
      return [];
    }
  }

  /**
   * Aktualizuje galerię ostatnich generacji
   */
  async updateGallery() {
    console.log('🎨 [GALLERY] updateGallery called');
    
    // 🧹 CLEANUP: Remove niedziałające generacje
    const generations = (await this.cleanupBrokenGenerations()).filter(generation => this.getGalleryImageUrl(generation));
    console.log('🎨 [GALLERY] After cleanup, renderable generations:', generations.length);
    
    if (generations.length === 0) {
      // Ukryj galerię jeśli brak generacji
      const gallery = document.getElementById('aiGallery');
      if (gallery) {
        gallery.style.display = 'none';
      }
      console.log('🎨 [GALLERY] No generations, hiding gallery');
      return;
    }

    // Znajdź lub stwórz kontener galerii
    let gallery = document.getElementById('aiGallery');
    if (!gallery) {
      gallery = this.createGalleryContainer();
    }

    // Wyczyść poprzednie elementy
    gallery.innerHTML = '';

    // Dodaj nagłówek
    const header = document.createElement('h4');
    header.textContent = this.t('customizer.gallery.title');
    header.style.cssText = `
      margin: 0 0 15px 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
      text-align: center;
    `;
    gallery.appendChild(header);

    // Stwórz grid z generacjami
    const grid = document.createElement('div');
    grid.style.cssText = `
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 12px;
      margin-bottom: 20px;
    `;

    generations.forEach(generation => {
      const item = this.createGalleryItem(generation);
      if (item) grid.appendChild(item);
    });

    gallery.appendChild(grid);
    gallery.style.display = 'block';
  }

  getGalleryImageUrl(generation) {
    if (!generation) return null;
    const imageUrl = generation.watermarkedImageUrl || generation.thumbnail || generation.transformedImage;
    return typeof imageUrl === 'string' && imageUrl.trim() ? imageUrl.trim() : null;
  }

  /**
   * Tworzy kontener galerii
   */
  createGalleryContainer() {
    const gallery = document.createElement('div');
    gallery.id = 'aiGallery';
    gallery.style.cssText = `
      margin: 20px 0;
      padding: 20px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    `;

    // Wstaw galerię przed accordion
    const accordion = document.querySelector('.product-details-accordion');
    console.log('🎨 [GALLERY] Looking for accordion:', accordion);
    if (accordion) {
      accordion.parentNode.insertBefore(gallery, accordion);
      console.log('🎨 [GALLERY] Gallery inserted before accordion');
    } else {
      // Fallback - wstaw w kontener aplikacji
      const appContainer = document.getElementById('customify-app-container');
      if (appContainer) {
        appContainer.appendChild(gallery);
        console.log('🎨 [GALLERY] Gallery inserted in app container');
      } else {
        // Ostatni fallback - wstaw na końcu body
        document.body.appendChild(gallery);
        console.log('🎨 [GALLERY] Gallery inserted at end of body (fallback)');
      }
    }

    return gallery;
  }

  /**
   * Tworzy element galerii dla pojedynczej generacji
   */
  createGalleryItem(generation) {
    const item = document.createElement('div');
    item.style.cssText = `
      position: relative;
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      transition: transform 0.2s ease;
    `;

    // ✅ PRIORYTET: watermarkedImageUrl (Vercel Blob z watermarkiem) > thumbnail > transformedImage
    const imageUrl = this.getGalleryImageUrl(generation);
    if (!imageUrl) return null;
    if (generation.watermarkedImageUrl) {
      console.log('✅ [GALLERY] Using watermarkedImageUrl from Vercel Blob:', generation.watermarkedImageUrl.substring(0, 50));
    } else if (generation.thumbnail) {
      console.log('✅ [GALLERY] Using thumbnail:', generation.thumbnail.substring(0, 50));
    } else {
      console.log('✅ [GALLERY] Using transformedImage:', generation.transformedImage?.substring(0, 50));
    }

    // Obraz
    const img = document.createElement('img');
    img.src = imageUrl;
    img.loading = 'lazy'; // ✅ Lazy loading - nie preloaduj wszystkich obrazków na raz
    img.style.cssText = `
      width: 100%;
      height: 120px;
      object-fit: cover;
      display: block;
    `;
    img.alt = `${generation.style} - ${generation.size}`;
    
    // Obsługa błędów ładowania obrazu
    img.onerror = function() {
      console.error('❌ [GALLERY] Image failed to load:', imageUrl?.substring(0, 50));
      console.log('🔄 [GALLERY] Generation data:', generation);
      const gallery = document.getElementById('aiGallery');
      const grid = item.parentElement;
      item.remove();
      if (grid && grid.children.length === 0 && gallery) {
        gallery.style.display = 'none';
      }
    };
    
    img.onload = function() {
      console.log('✅ [GALLERY] Image loaded successfully:', imageUrl?.substring(0, 50));
    };

    // Overlay z informacjami
    const overlay = document.createElement('div');
    overlay.style.cssText = `display: none;`;

    // Hover effect
    item.addEventListener('mouseenter', () => {
      item.style.transform = 'translateY(-4px)';
    });
    item.addEventListener('mouseleave', () => {
      item.style.transform = 'translateY(0)';
    });

    // Kliknięcie - użyj ponownie
    item.addEventListener('click', () => {
      this.reuseGeneration(generation);
    });

    item.appendChild(img);
    item.appendChild(overlay);

    return item;
  }

  /**
   * Zwraca URL bezpieczny dla canvas (proxy dla Vercel Blob - CORS)
   * Używane w text overlay i innych miejscach gdzie ładujemy obraz do canvas
   */
  getCanvasSafeImageUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.startsWith('data:')) return url;
    if (url.includes('blob.vercel-storage.com')) {
      return window.CustomifyApi.url(`/api/proxy-image?url=${encodeURIComponent(url)}`);
    }
    return url;
  }

  /**
   * Konwertuje URL na File object
   * Dla Vercel Blob używa proxy (CORS blokuje bezpośredni fetch)
   */
  urlToFile(url, filename) {
    const fetchUrl = (url && url.includes('blob.vercel-storage.com'))
      ? window.CustomifyApi.url(`/api/proxy-image?url=${encodeURIComponent(url)}`)
      : url;
    return new Promise((resolve, reject) => {
      fetch(fetchUrl)
        .then(response => {
          if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
          return response.blob();
        })
        .then(blob => {
          const file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
          resolve(file);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /**
   * Konwertuje URL na base64 string
   */
  async urlToBase64(url) {
    try {
      console.log('🔄 [CACHE] Converting URL to base64:', url);
      const response = await fetch(url);
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          console.log('✅ [CACHE] URL converted to base64 successfully');
          resolve(reader.result);
        };
        reader.onerror = () => {
          console.error('❌ [CACHE] Error reading blob to base64');
          reject(new Error('Failed to convert blob to base64'));
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('❌ [CACHE] Error converting URL to base64:', error);
      throw error;
    }
  }

  /**
   * Kompresuje obraz base64 do małego thumbnail (150x150px)
   * Zwraca kompresowany base64 string (~50-100KB zamiast 2-5MB)
   */
  async compressBase64Thumbnail(base64String, maxWidth = 150, maxHeight = 150, quality = 0.6) {
    return new Promise((resolve, reject) => {
      try {
        console.log('🗜️ [COMPRESS] Compressing thumbnail to', maxWidth, 'x', maxHeight, 'px');
        
        const img = new Image();
        img.onload = () => {
          // Oblicz nowe wymiary zachowując proporcje
          let width = img.width;
          let height = img.height;
          
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }
          
          // Stwórz canvas i narysuj skompresowany obraz
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          // Konwertuj do base64 z kompresją
          const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
          
          const originalSize = Math.round(base64String.length / 1024); // KB
          const compressedSize = Math.round(compressedBase64.length / 1024); // KB
          const compressionRatio = Math.round((1 - compressedSize / originalSize) * 100);
          
          console.log(`✅ [COMPRESS] Compressed: ${originalSize}KB → ${compressedSize}KB (${compressionRatio}% reduction)`);
          
          resolve(compressedBase64);
        };
        
        img.onerror = () => {
          console.error('❌ [COMPRESS] Failed to load image for compression');
          reject(new Error('Failed to compress image'));
        };
        
        img.src = base64String;
      } catch (error) {
        console.error('❌ [COMPRESS] Error compressing thumbnail:', error);
        reject(error);
      }
    });
  }

  /**
   * Zapisuje obraz base64 do Vercel Blob Storage i zwraca URL
   */
  async saveToVercelBlob(base64String, filename) {
    const maxAttempts = 3;
    const isRetryable = (err) => err?.message && (
      err.message.includes('Failed to fetch') ||
      err.message.includes('NetworkError') ||
      err.message.includes('Load failed') ||
      err.message.includes('Error completing request') ||
      err.message.includes('network failure')
    );

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        console.log(`📤 [VERCEL-BLOB] Upload attempt ${attempt}/${maxAttempts}...`);
        const response = await fetch(window.CustomifyApi.url('/api/upload-temp-image'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            imageData: base64String,
            filename: filename,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to upload: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        if (result.success && result.url) {
          console.log('✅ [VERCEL-BLOB] Uploaded successfully:', result.url);
          return result.url;
        }
        throw new Error('No URL in response');
      } catch (error) {
        console.warn(`❌ [VERCEL-BLOB] Attempt ${attempt}/${maxAttempts} failed:`, error?.message || error);
        if (attempt < maxAttempts && isRetryable(error)) {
          const delay = attempt * 1500;
          console.log(`🔄 [VERCEL-BLOB] Retrying in ${delay}ms...`);
          await new Promise(r => setTimeout(r, delay));
        } else {
          throw error;
        }
      }
    }
  }

  /**
   * Nakłada napis na obraz i zapisuje na Vercel Blob (pilotaż)
   */
  async previewTextOverlay() {
    if (!this.textOverlayEnabled) return;
    if (!this.transformedImage) {
      this.showError('No image available for text preview', 'cart');
      return;
    }

    const text = (this.textOverlayInput?.value || '').trim();
    this.textOverlayState = { ...this.textOverlayState, text };

    // Jeśli tekst pusty – wróć do oryginału (z proxy dla Vercel Blob – jak w showResult)
    if (!text) {
      this.textOverlayState = { ...this.textOverlayState, text: '', previewUrl: null };
      this.updateTextOverlayHint('The field is empty');
      if (this.resultImage && this.watermarkedImageUrl) {
        const url = this.getCanvasSafeImageUrl(this.watermarkedImageUrl);
        if (this.isPhonePhotoCaseProduct()) {
          const photoBg = document.getElementById('phoneCasePhotoBg');
          const resultBg = document.getElementById('phoneCaseResultBg');
          if (photoBg) photoBg.style.backgroundImage = `url(${url})`;
          if (resultBg) resultBg.style.backgroundImage = `url(${url})`;
        }
        this.resultImage.src = url;
      }
      return;
    }

    const options = {
      preset: this.textOverlayState.preset || 'classic',
      color: this.textOverlayState.color || 'white',
      font: this.textOverlayState.font || 'sans',
      size: this.textOverlayState.size || 'medium'
    };

    // ✅ PREVIEW: Dla etui z cropem – baza = wykadrowany obraz (nie pełny przed cropem)
    let baseUrl;
    if (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl) {
      baseUrl = this.phonePhotoCropDataUrl;
    } else {
      baseUrl = this.watermarkedImageBase64
        ? `data:image/jpeg;base64,${this.watermarkedImageBase64}`
        : (this.watermarkedImageUrl || this.textOverlayBaseImage || this.transformedImage);
    }
    baseUrl = this.getCanvasSafeImageUrl(baseUrl);
    const base64WithText = await this.renderTextOverlayPreview(baseUrl, text, options);

    // ✅ PREVIEW: ZAWSZE z watermarkem - user nie może widzieć obrazu bez watermarku
    let toDisplay = base64WithText;
    try {
      toDisplay = await this.addWatermark(base64WithText);
    } catch (e) {
      console.warn('⚠️ [TEXT-OVERLAY] addWatermark preview failed:', e);
    }
    this.textOverlayState = { ...this.textOverlayState, previewUrl: base64WithText };

    if (this.resultImage) {
      // 📱 Phone case: aktualizuj oba (preview + result) - podgląd napisu Z watermarkem
      if (this.isPhonePhotoCaseProduct() && toDisplay) {
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        if (photoBg) photoBg.style.backgroundImage = `url(${toDisplay})`;
        if (resultBg) resultBg.style.backgroundImage = `url(${toDisplay})`;
      }
      this.resultImage.src = toDisplay;
    }
  }

  /**
   * Zapisuje napis na Vercel Blob (po zatwierdzeniu)
   */
  async saveTextOverlay() {
    if (!this.textOverlayEnabled) return;
    if (!this.transformedImage) {
      this.showError('No image available to save the text', 'cart');
      return;
    }

    const text = (this.textOverlayInput?.value || '').trim();
    this.textOverlayState = { ...this.textOverlayState, text };

    if (!text) {
      this.showError('Enter text before saving', 'cart');
      return;
    }

    const options = {
      preset: this.textOverlayState.preset || 'classic',
      color: this.textOverlayState.color || 'white',
      font: this.textOverlayState.font || 'sans',
      size: this.textOverlayState.size || 'medium'
    };

    // 📱 Etui: baza = wykadrowany obraz (phonePhotoCropDataUrl), nie pełny przed cropem
    let baseUrl = (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl)
      ? this.phonePhotoCropDataUrl
      : (this.textOverlayBaseImage || this.transformedImage);
    baseUrl = this.getCanvasSafeImageUrl(baseUrl);
    console.log('📝 [TEXT-OVERLAY] Rozpoczynam renderowanie napisu na obrazie:', baseUrl.substring(0, 100) + '...');
    const base64WithText = await this.renderTextOverlay(baseUrl, text, options);
    console.log('✅ [TEXT-OVERLAY] Napis wyrenderowany pomyślnie (base64 length:', base64WithText.length, ')');

    // Upload wersji z napisem
    const filename = `text-overlay-${Date.now()}.jpg`;
    console.log('📤 [TEXT-OVERLAY] Wysyłam wersję z napisem do Vercel Blob...');
    const overlayUrl = await this.saveToVercelBlob(base64WithText, filename);
    console.log('✅ [TEXT-OVERLAY] Wersja z napisem zapisana:', overlayUrl);

    // Watermark na wersji z tekstem
    console.log('🎨 [TEXT-OVERLAY] Nakładam watermark na wersję z napisem...');
    const watermarkedBase64 = await this.addWatermark(base64WithText);
    console.log('✅ [TEXT-OVERLAY] Watermark nałożony (base64 length:', watermarkedBase64.length, ')');
    
    console.log('📤 [TEXT-OVERLAY] Wysyłam wersję z watermarkiem do Vercel Blob...');
    const watermarkedUrl = await this.saveToVercelBlob(watermarkedBase64, `text-overlay-watermarked-${Date.now()}.jpg`);
    console.log('✅ [TEXT-OVERLAY] Wersja z watermarkiem zapisana:', watermarkedUrl);

    // Aktualizuj stan (dopiero po zapisie)
    this.transformedImage = overlayUrl;
    this.watermarkedImageUrl = watermarkedUrl;
    this.watermarkedImageBase64 = watermarkedBase64;
    this.textOverlayWatermarkedUrl = watermarkedUrl;
    this.textOverlayState = { ...this.textOverlayState, text, applied: true, previewUrl: null };
    this.updateTextOverlayHint('Text saved - it will be added to your order');

    // Zamknij panel po zapisie
    const toggleBtn = this.textOverlayToggleBtn;
    if (this.textOverlayPanel && toggleBtn) {
      this.textOverlayPanel.style.display = 'none';
      toggleBtn.setAttribute('data-overlay-open', 'false');
    }

    if (this.resultImage) {
      // 📱 Phone case: aktualizuj oba (preview + result) - po zapisie napisu (proxy dla Vercel Blob)
      const imageUrl = this.getCanvasSafeImageUrl(watermarkedUrl || overlayUrl);
      if (this.isPhonePhotoCaseProduct()) {
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        if (photoBg && imageUrl) photoBg.style.backgroundImage = `url(${imageUrl})`;
        if (resultBg && imageUrl) resultBg.style.backgroundImage = `url(${imageUrl})`;
      }
      this.resultImage.src = imageUrl;
    }

    // Zaktualizuj najnowszą generację w localStorage
    try {
      const generations = this.getAIGenerations();
      if (generations.length > 0) {
        generations[0] = {
          ...generations[0],
          transformedImage: overlayUrl,
          watermarkedImageUrl: watermarkedUrl,
          watermarkedImageBase64: watermarkedBase64,
          textOverlay: {
            text,
            ...options
          }
        };
        safeLocalStorageSet('customify_ai_generations', JSON.stringify(generations.slice(0, 8)));
        console.log('✅ [TEXT-OVERLAY] Zapisano overlay w localStorage');
      }
    } catch (err) {
      console.warn('⚠️ [TEXT-OVERLAY] Nie udało się zaktualizować localStorage:', err);
    }
  }

  /**
   * Szybki preview tekstu overlay (bez czekania na fonty, bez watermarku)
   * Używany TYLKO podczas wpisywania tekstu - finalny render używa renderTextOverlay()
   */
  async renderTextOverlayPreview(imageUrl, text, options) {
    return new Promise(async (resolve, reject) => {
      try {
        // ✅ PREVIEW: NIE CZEKAJ na fonty - użyj system font stack natychmiast
        const img = new Image();
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous';
        }
        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const padding = canvas.width * 0.06;
            const areaHeight = canvas.height * 0.22;
            const baseY = canvas.height - areaHeight * 0.35;
            const maxWidth = canvas.width - padding * 2;

            const sizeMap = { small: 0.05, medium: 0.075, large: 0.11 };
            const fontSize = Math.max(32, canvas.height * (sizeMap[options.size] || sizeMap.medium));

            // ✅ PREVIEW: Te same czcionki co w renderTextOverlay(), ale bez czekania na fonty
    const fontMapPreview = {
      serif: `700 ${fontSize}px "Times New Roman", "Georgia", serif`,
      sans: `700 ${fontSize}px "Montserrat", "Poppins", "Inter", Arial, sans-serif`,
      script: `700 ${fontSize}px "Dancing Script", "Pacifico", cursive`,
      script2: `700 ${fontSize}px "Pacifico", "Dancing Script", cursive`,
      script3: `700 ${fontSize}px "Satisfy", "Dancing Script", cursive`,
      script4: `700 ${fontSize}px "Great Vibes", "Satisfy", cursive`,
      script5: `700 ${fontSize}px "Indie Flower", "Pacifico", cursive`,
      western_1: `700 ${fontSize}px "Rye", "Times New Roman", serif`,
      western_2: `700 ${fontSize}px "Creepster", "Rye", "Times New Roman", serif`,
      hiphop: `400 ${fontSize}px "Rubik Wet Paint", "Creepster", "Rye", "Times New Roman", serif`
    };
            const font = fontMapPreview[options.font] || fontMapPreview.sans;

            const colorMap = {
              white: '#ffffff',
              black: '#111111',
              gold: '#d6b36a',
              red: '#dc2626',
              green: '#16a34a',
              blue: '#2563eb',
              yellow: '#eab308',
              brown: '#92400e'
            };
            const fillColor = colorMap[options.color] || '#ffffff';

            ctx.font = font;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const words = text.split(' ');
            const lines = [];
            let current = '';
            words.forEach(word => {
              const testLine = current ? `${current} ${word}` : word;
              const { width } = ctx.measureText(testLine);
              if (width > maxWidth && current) {
                lines.push(current);
                current = word;
              } else {
                current = testLine;
              }
            });
            if (current) lines.push(current);
            const limitedLines = lines.slice(0, 2);

            // 🛟 Safety: nie pozwól spaść niżej niż 10% od dołu
            const lineYs = limitedLines.map((_, idx) =>
              baseY + (idx - (limitedLines.length - 1) / 2) * (fontSize * 1.2)
            );
            const maxAllowedY = canvas.height * 0.90;
            const shiftY = Math.max(0, Math.max(...lineYs) - maxAllowedY);

            // Skorygowane pozycje linii
            const correctedLineYs = lineYs.map(y => y - shiftY);

            if (options.preset === 'banner') {
              const topLineY = Math.min(...correctedLineYs);
              const bottomLineY = Math.max(...correctedLineYs);
              const bannerPadding = fontSize * 0.5;
              const bannerTop = topLineY - fontSize * 0.6 - bannerPadding;
              const bannerBottom = bottomLineY + fontSize * 0.6 + bannerPadding;
              const bannerHeight = bannerBottom - bannerTop;
              const bannerBg = options.color === 'black' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'gold' ? 'rgba(40,25,15,0.45)' :
                               options.color === 'red' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'green' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'blue' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                               options.color === 'brown' ? 'rgba(255,255,255,0.4)' :
                               'rgba(0,0,0,0.4)';
              ctx.fillStyle = bannerBg;
              ctx.fillRect(padding * 0.9, bannerTop, canvas.width - padding * 1.8, bannerHeight);
            }

            limitedLines.forEach((line, idx) => {
              const lineY = correctedLineYs[idx];

              if (options.preset === '3d') {
                const shadowColor =
                  options.color === 'white' ? 'rgba(0,0,0,0.45)' :
                  options.color === 'black' ? 'rgba(255,255,255,0.45)' :
                  options.color === 'gold' ? 'rgba(95, 70, 30, 0.55)' :
                  options.color === 'red' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'green' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'blue' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                  options.color === 'brown' ? 'rgba(0,0,0,0.4)' :
                  'rgba(0,0,0,0.45)';
                ctx.fillStyle = shadowColor;
                ctx.fillText(line, canvas.width / 2 + Math.max(2, fontSize * 0.04), lineY + Math.max(2, fontSize * 0.04));
              }

              const strokeColor =
                options.color === 'white' ? 'rgba(0,0,0,0.65)' :
                options.color === 'black' ? 'rgba(255,255,255,0.65)' :
                options.color === 'gold' ? 'rgba(95, 70, 30, 0.75)' :
                options.color === 'red' ? 'rgba(0,0,0,0.5)' :
                options.color === 'green' ? 'rgba(0,0,0,0.5)' :
                options.color === 'blue' ? 'rgba(0,0,0,0.5)' :
                options.color === 'yellow' ? 'rgba(0,0,0,0.5)' :
                options.color === 'brown' ? 'rgba(255,255,255,0.5)' :
                'rgba(0,0,0,0.65)';
              ctx.strokeStyle = strokeColor;
              ctx.lineWidth = Math.max(2.5, fontSize * 0.09);
              ctx.strokeText(line, canvas.width / 2, lineY);

              ctx.fillStyle = fillColor;
              ctx.fillText(line, canvas.width / 2, lineY);
            });

            const result = canvas.toDataURL('image/jpeg', 0.92);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = (err) => reject(err);
        img.src = imageUrl;
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Renderuje napis na kanwie
   */
  async renderTextOverlay(imageUrl, text, options) {
    return new Promise(async (resolve, reject) => {
      try {
        // ✅ CZEKAJ NA ZAŁADOWANIE CZCIONEK (Google Fonts)
        if (document.fonts && document.fonts.status !== 'loaded') {
          console.log('🔤 [TEXT-OVERLAY] Czekam na document.fonts.ready...');
          await document.fonts.ready;
          console.log('✅ [TEXT-OVERLAY] Fonty załadowane!');
        }

        const img = new Image();
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous';
        }
        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const padding = canvas.width * 0.06;
            const areaHeight = canvas.height * 0.22;
            const baseY = canvas.height - areaHeight * 0.35;
            const maxWidth = canvas.width - padding * 2;

    const sizeMap = { small: 0.05, medium: 0.075, large: 0.11 };
    const fontSize = Math.max(32, canvas.height * (sizeMap[options.size] || sizeMap.medium));

    // Mapowanie nazw czcionek do nazw Google Fonts
    const fontNameMap = {
      serif: 'Times New Roman', // Systemowa
      sans: 'Montserrat',
      script: 'Dancing Script',
      script2: 'Pacifico',
      script3: 'Satisfy',
      script4: 'Great Vibes',
      script5: 'Indie Flower',
      western_1: 'Rye',
      western_2: 'Creepster',
      hiphop: 'Rubik Wet Paint'
    };
    
    const fontName = fontNameMap[options.font] || fontNameMap.sans;
    const fontWeight = options.font === 'hiphop' ? '400' : '700';
    
    // ✅ SPRAWDŹ CZY KONKRETNA CZCIONKA JEST ZAŁADOWANA (przed użyciem w canvas)
    if (document.fonts && fontName !== 'Times New Roman') {
      const fontSpec = `${fontWeight} ${fontSize}px "${fontName}"`;
      try {
        const isLoaded = document.fonts.check(fontSpec);
        if (!isLoaded) {
          console.log(`🔤 [TEXT-OVERLAY] Czekam na czcionkę "${fontName}"...`);
          // Czekaj maksymalnie 3 sekundy na załadowanie konkretnej czcionki
          let attempts = 0;
          while (!document.fonts.check(fontSpec) && attempts < 30) {
            await new Promise(resolve => setTimeout(resolve, 100));
            attempts++;
          }
          if (document.fonts.check(fontSpec)) {
            console.log(`✅ [TEXT-OVERLAY] Czcionka "${fontName}" załadowana!`);
          } else {
            console.warn(`⚠️ [TEXT-OVERLAY] Czcionka "${fontName}" nie załadowała się w czasie, używam fallback`);
          }
        }
      } catch (e) {
        console.warn('⚠️ [TEXT-OVERLAY] Błąd podczas sprawdzania czcionki:', e);
      }
    }

    const fontMap = {
      serif: `700 ${fontSize}px "Times New Roman", "Georgia", serif`,
      sans: `700 ${fontSize}px "Montserrat", "Poppins", "Inter", Arial, sans-serif`,
      script: `700 ${fontSize}px "Dancing Script", "Pacifico", cursive`,
      script2: `700 ${fontSize}px "Pacifico", "Dancing Script", cursive`,
      script3: `700 ${fontSize}px "Satisfy", "Dancing Script", cursive`,
      script4: `700 ${fontSize}px "Great Vibes", "Satisfy", cursive`,
      script5: `700 ${fontSize}px "Indie Flower", "Pacifico", cursive`,
      western_1: `700 ${fontSize}px "Rye", "Times New Roman", serif`,
      western_2: `700 ${fontSize}px "Creepster", "Rye", "Times New Roman", serif`,
      hiphop: `400 ${fontSize}px "Rubik Wet Paint", "Creepster", "Rye", "Times New Roman", serif`
    };
            const font = fontMap[options.font] || fontMap.sans;

    const colorMap = {
      white: '#ffffff',
      black: '#111111',
      gold: '#d6b36a',
      red: '#dc2626',      // Czerwony
      green: '#16a34a',    // Zielony
      blue: '#2563eb',     // Niebieski
      yellow: '#eab308',   // Żółty
      brown: '#92400e'     // Brązowy
    };
    const fillColor = colorMap[options.color] || '#ffffff';

            ctx.font = font;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const words = text.split(' ');
            const lines = [];
            let current = '';
            words.forEach(word => {
              const testLine = current ? `${current} ${word}` : word;
              const { width } = ctx.measureText(testLine);
              if (width > maxWidth && current) {
                lines.push(current);
                current = word;
              } else {
                current = testLine;
              }
            });
            if (current) lines.push(current);
            const limitedLines = lines.slice(0, 2);

            // 🛟 Safety: nie pozwól spaść niżej niż 10% od dołu
            const lineYs = limitedLines.map((_, idx) =>
              baseY + (idx - (limitedLines.length - 1) / 2) * (fontSize * 1.2)
            );
            const maxAllowedY = canvas.height * 0.90;
            const shiftY = Math.max(0, Math.max(...lineYs) - maxAllowedY);

            // Skorygowane pozycje linii
            const correctedLineYs = lineYs.map(y => y - shiftY);

            if (options.preset === 'banner') {
              // Oblicz banner na podstawie faktycznych pozycji linii
              const topLineY = Math.min(...correctedLineYs);
              const bottomLineY = Math.max(...correctedLineYs);
              const bannerPadding = fontSize * 0.5;
              const bannerTop = topLineY - fontSize * 0.6 - bannerPadding;
              const bannerBottom = bottomLineY + fontSize * 0.6 + bannerPadding;
              const bannerHeight = bannerBottom - bannerTop;
              // Kolor tła zależy od koloru tekstu: biały→czarne, czarny→białe, złoty→ciemnobrązowe
              const bannerBg = options.color === 'black' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'gold' ? 'rgba(40,25,15,0.45)' :
                               options.color === 'red' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'green' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'blue' ? 'rgba(255,255,255,0.4)' :
                               options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
                               options.color === 'brown' ? 'rgba(255,255,255,0.4)' :
                               'rgba(0,0,0,0.4)'; // fallback
              ctx.fillStyle = bannerBg;
              ctx.fillRect(padding * 0.9, bannerTop, canvas.width - padding * 1.8, bannerHeight);
            }

            limitedLines.forEach((line, idx) => {
              const lineY = correctedLineYs[idx];

      if (options.preset === '3d') {
        const shadowColor =
          options.color === 'white' ? 'rgba(0,0,0,0.45)' :
          options.color === 'black' ? 'rgba(255,255,255,0.45)' :
          options.color === 'gold' ? 'rgba(95, 70, 30, 0.55)' :
          options.color === 'red' ? 'rgba(0,0,0,0.4)' :
          options.color === 'green' ? 'rgba(0,0,0,0.4)' :
          options.color === 'blue' ? 'rgba(0,0,0,0.4)' :
          options.color === 'yellow' ? 'rgba(0,0,0,0.4)' :
          options.color === 'brown' ? 'rgba(0,0,0,0.4)' :
          'rgba(0,0,0,0.45)'; // fallback
        ctx.fillStyle = shadowColor;
        ctx.fillText(line, canvas.width / 2 + Math.max(2, fontSize * 0.04), lineY + Math.max(2, fontSize * 0.04));
      }

      // Stroke for better contrast per color
      const strokeColor =
        options.color === 'white' ? 'rgba(0,0,0,0.65)' :
        options.color === 'black' ? 'rgba(255,255,255,0.65)' :
        options.color === 'gold' ? 'rgba(95, 70, 30, 0.75)' :
        options.color === 'red' ? 'rgba(0,0,0,0.5)' :
        options.color === 'green' ? 'rgba(0,0,0,0.5)' :
        options.color === 'blue' ? 'rgba(0,0,0,0.5)' :
        options.color === 'yellow' ? 'rgba(0,0,0,0.5)' :
        options.color === 'brown' ? 'rgba(255,255,255,0.5)' :
        'rgba(0,0,0,0.65)'; // fallback
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = Math.max(2.5, fontSize * 0.09);
      ctx.strokeText(line, canvas.width / 2, lineY);

              ctx.fillStyle = fillColor;
              ctx.fillText(line, canvas.width / 2, lineY);
            });

            const result = canvas.toDataURL('image/jpeg', 0.92);
            resolve(result);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = (err) => reject(err);
        img.src = imageUrl;
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Sprawdza czy URL do obrazu działa
   */
  async checkImageUrl(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok;
    } catch (error) {
      console.log('🔍 [CLEANUP] URL not working:', url);
      return false;
    }
  }

  /**
   * Usuwa niedziałające generacje z localStorage
   */
  async cleanupBrokenGenerations() {
    console.log('🧹 [CLEANUP] Checking for broken generations...');
    const generations = this.getAIGenerations();
    const workingGenerations = [];
    
    for (const generation of generations) {
      // Sprawdź czy thumbnail to URL (nie base64)
      if (generation.thumbnail && 
          (generation.thumbnail.startsWith('http://') || generation.thumbnail.startsWith('https://'))) {
        
        // ✅ NIE SPRAWDZAJ Replicate URLs (CORS blokuje) - zachowaj jeśli to Replicate
        if (generation.thumbnail.includes('replicate.delivery')) {
          workingGenerations.push(generation);
          console.log('✅ [CLEANUP] Replicate URL kept (CORS safe):', generation.id);
          continue;
        }
        // ✅ NIE SPRAWDZAJ Vercel Blob URLs (CORS blokuje HEAD) - obrazy działają do wyświetlania
        if (generation.thumbnail.includes('blob.vercel-storage.com')) {
          workingGenerations.push(generation);
          console.log('✅ [CLEANUP] Vercel Blob URL kept (CORS):', generation.id);
          continue;
        }
        
        // Sprawdź inne URLs
        const isWorking = await this.checkImageUrl(generation.thumbnail);
        if (isWorking) {
          workingGenerations.push(generation);
          console.log('✅ [CLEANUP] Working generation kept:', generation.id);
        } else {
          console.log('🗑️ [CLEANUP] Broken generation removed:', generation.id);
        }
      } else {
        // Base64 lub inne formaty - zachowaj
        workingGenerations.push(generation);
        console.log('✅ [CLEANUP] Base64 generation kept:', generation.id);
      }
    }
    
    // Zapisz tylko działające generacje
    if (workingGenerations.length !== generations.length) {
      safeLocalStorageSet('customify_ai_generations', JSON.stringify(workingGenerations));
      console.log(`🧹 [CLEANUP] Cleaned up: ${generations.length} → ${workingGenerations.length} generations`);
    }
    
    return workingGenerations;
  }

  /**
   * Konwertuje base64 na File object
   */
  base64ToFile(base64String, filename) {
    return new Promise((resolve, reject) => {
      try {
        // Sprawdź czy to już jest string (base64)
        if (typeof base64String !== 'string') {
          reject(new Error('originalImage is not a base64 string'));
          return;
        }
        
        // Wyciągnij typ MIME i dane z base64
        const [header, data] = base64String.split(',');
        const mimeMatch = header.match(/data:([^;]+)/);
        if (!mimeMatch) {
          reject(new Error('Invalid base64 data URI format'));
          return;
        }
        const mimeType = mimeMatch[1];
        
        // Konwertuj base64 na binary
        const binaryString = atob(data);
        const bytes = new Uint8Array(binaryString.length);
        
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        
        // Utwórz File object
        const file = new File([bytes], filename, { type: mimeType });
        resolve(file);
      } catch (error) {
        reject(error);
      }
    });
  }

  dataUrlToBlob(dataUrl) {
    if (!dataUrl || !dataUrl.startsWith('data:')) return null;
    try {
      const [header, data] = dataUrl.split(',');
      const mimeMatch = header.match(/data:([^;]+)/);
      if (!mimeMatch) return null;
      const binary = atob(data);
      const arr = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
      return new Blob([arr], { type: mimeMatch[1] });
    } catch (e) {
      return null;
    }
  }

  /**
   * Używa ponownie wybraną generację
   */
  reuseGeneration(generation) {
    console.log('🔄 [GALLERY] Reusing generation:', generation.id);
    console.log('🔄 [GALLERY] Generation data:', generation);
    console.log('🔄 [GALLERY] originalImage type:', typeof generation.originalImage);
    console.log('🔄 [GALLERY] originalImage value:', generation.originalImage);
    console.log('🔄 [GALLERY] transformedImage type:', typeof generation.transformedImage);
    console.log('🔄 [GALLERY] transformedImage length:', generation.transformedImage?.length);
    console.log('🔄 [GALLERY] transformedImage preview:', generation.transformedImage?.substring(0, 100));
    console.log('🔄 [GALLERY] watermarkedImageUrl:', generation.watermarkedImageUrl?.substring(0, 100) || 'brak');
    
    // Pokaż wynik AI (transformedImage) w result area
    if (generation.transformedImage) {
      console.log('🔄 [GALLERY] Showing AI result in result area:', generation.transformedImage);
      
      // ✅ KLUCZOWE: Ustaw this.transformedImage żeby addToCart() działało
      this.transformedImage = generation.transformedImage;
      this.artworkId = generation.artworkId || null;
      this.generationId = generation.generationId || generation.id || null;
      console.log('✅ [GALLERY] Set this.transformedImage for addToCart:', this.transformedImage?.substring(0, 100));
      console.log('✅ [GALLERY] this.transformedImage is base64?', this.transformedImage?.startsWith('data:'));
      console.log('✅ [GALLERY] this.transformedImage is URL?', this.transformedImage?.startsWith('http'));
      
      // ✅ KLUCZOWE: Ustaw this.watermarkedImageUrl z galerii (backend watermark)
      this.watermarkedImageUrl = generation.watermarkedImageUrl || null;
      console.log('✅ [GALLERY] Set this.watermarkedImageUrl from generation:', this.watermarkedImageUrl?.substring(0, 100) || 'brak');
      if (!this.watermarkedImageUrl) {
        console.warn('⚠️ [GALLERY] Stara generacja bez watermarkedImageUrl - showResult() pokaże bez watermarku');
      }
      
      // ✅ NOWE: Ustaw this.watermarkedImageBase64 z galerii (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
      this.watermarkedImageBase64 = generation.watermarkedImageBase64 || null;
      console.log('✅ [GALLERY] Set this.watermarkedImageBase64 from generation:', this.watermarkedImageBase64 ? `${this.watermarkedImageBase64.length} chars` : 'brak');

      // 🆕 Tekst na obrazie - odtwórz stan z generacji (tylko produkt pilota)
      if (this.textOverlayEnabled) {
        this.watermarkedImageUrl = generation.watermarkedImageUrl || generation.transformedImage;
        this.textOverlayBaseImage = generation.transformedImage;
        this.textOverlayOriginalWatermarked = generation.watermarkedImageUrl || null;
        const textOverlay = generation.textOverlay || null;
        if (this.textOverlayInput) {
          this.textOverlayInput.value = textOverlay?.text || '';
          this.updateTextOverlayCounter();
        }
        this.textOverlayState = {
          ...this.textOverlayState,
          text: textOverlay?.text || '',
          preset: textOverlay?.preset || 'classic',
          color: textOverlay?.color || 'white',
          font: textOverlay?.font || 'sans',
          size: textOverlay?.size || 'medium',
          applied: !!textOverlay
        };
        if (this.textOverlayPanel) {
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn?.setAttribute('data-overlay-open', 'false');
        }
        if (textOverlay?.text) {
          this.updateTextOverlayHint('Text added. You can edit it and apply it again.');
        } else {
          this.updateTextOverlayHint('');
        }
      }
      
      // ✅ KLUCZOWE: Ustaw this.originalImageFromGallery żeby addToCart() działało
      this.originalImageFromGallery = generation.originalImage;
      console.log('✅ [GALLERY] Set this.originalImageFromGallery for addToCart:', this.originalImageFromGallery);
      
      this.showResult(generation.transformedImage);
      this.hideError();
    } else {
      console.error('❌ [GALLERY] No transformedImage in generation');
      this.showError('Brak wyniku AI w generacji.');
    }
    
    // Ustaw styl - bezpośrednio z generacji
    console.log('🎨 [GALLERY] Setting style:', generation.style);
    if (generation.style) {
      this.selectedStyle = generation.style;
      console.log('✅ [GALLERY] Style set directly from generation:', this.selectedStyle);
      
      // Opcjonalnie: zaznacz też element w DOM jeśli istnieje
      const styleCard = document.querySelector(`[data-style="${generation.style}"]`);
      if (styleCard) {
        this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
        styleCard.classList.add('active');
        console.log('✅ [GALLERY] Style card also highlighted in DOM');
      }
    } else {
      console.warn('⚠️ [GALLERY] No style in generation');
    }
    
    // Ustaw rozmiar
    if (generation.size) {
      const sizeBtn = document.querySelector(`[data-size="${generation.size}"]`);
      if (sizeBtn) {
        this.selectSize(sizeBtn);
      }
    }

    // Po reuse: zsynchronizuj rozmiar z aktualnym typem wydruku (e.g. A5 ze szkła → A4 na plakacie)
    try {
      this.updateSizeAvailability();
      this.syncActiveSizeButton();
      this.updateProductPrice();
      this.updateCartPrice();
    } catch (e) {
      console.warn('⚠️ [GALLERY] reuseGeneration price/sync:', e);
    }

    // Komunikat usunięty - nie potrzebny
  }

  /**
   * Sprawdza czy użytkownik może wykonać transformację
   * @returns {Promise<boolean>} true jeśli może, false jeśli przekroczył limit
   */
  async checkUsageLimit() {
    const customerInfo = this.getCustomerInfo();
    
    // ✅ ZABEZPIECZENIE: Jeśli selectedStyle jest null, nie sprawdzaj limitu (pozwól wybrać styl)
    if (!this.selectedStyle) {
      console.warn(`⚠️ [USAGE-LIMIT] selectedStyle jest null - pomijam sprawdzanie limitu (user musi najpierw wybrać styl)`);
      return true; // Pozwól wybrać styl
    }
    
    // Pobierz productType z aktualnie wybranego stylu
    const productType = this.getProductTypeFromStyle(this.selectedStyle);
    
    console.log(`🔍 [USAGE-LIMIT] Sprawdzam limit:`, {
      selectedStyle: this.selectedStyle,
      productType: productType,
      isLoggedIn: !!customerInfo
    });
    
    if (!customerInfo) {
      // Niezalogowany - 1 udana generacja łącznie, niezależnie od produktu.
      const localCount = this.getLocalUsageCount();
      const FREE_LIMIT = 3;
      
      console.log(`🔍 [USAGE-LIMIT] Niezalogowany: ${localCount}/${FREE_LIMIT} łącznie`);
      
      if (localCount >= FREE_LIMIT) {
        console.log(`❌ [USAGE-LIMIT] Globalny limit przekroczony: ${localCount} >= ${FREE_LIMIT}`);
        this.showLoginModal(localCount, FREE_LIMIT);
        return false;
      }
      
      return true;
    } else {
      // Zalogowany - sprawdź Shopify Metafields przez API (per productType)
      // Checking usage limit via API for logged-in user
      
      try {
        const response = await fetch(window.CustomifyApi.url('/api/check-usage'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({
            customerId: customerInfo.customerId,
            customerAccessToken: customerInfo.customerAccessToken,
            productType: productType // ✅ Przekaż productType
          })
        });
        
        if (!response.ok) {
          console.error(`❌ [USAGE] API error: ${response.status} ${response.statusText}`);
          // ⚠️ KRYTYCZNE: Jeśli błąd API, BLOKUJ (bezpieczniejsze niż pozwalanie)
          this.showError(`Usage limit check failed. Try again shortly.`, 'transform');
          return false;
        }
        
        const data = await response.json();
        
        if (data.remainingCount <= 0) {
          console.error(`❌ [USAGE] Limit przekroczony - przerwano transformację`);
          this.showError('You have used your available generations. Contact us for more.', 'transform');
          return false;
        }
        
        // Limit OK - remainingCount > 0
        return true;
      } catch (error) {
        console.error('❌ [USAGE] Błąd sprawdzania limitu:', error);
        this._reportToSentry(error, 'checkUsageLimit');
        // ⚠️ KRYTYCZNE: Jeśli błąd, BLOKUJ (bezpieczniejsze niż pozwalanie)
        // Użytkownik może spróbować ponownie, ale nie może obejść limitu przez błąd
        this.showError(`Usage limit check failed. Try again shortly.`, 'transform');
        return false;
      }
    }
  }

  /**
   * Pokazuje modal z wymogiem rejestracji + auto-redirect
   */
  showLoginModal(usedCount, limit) {
    // Return URL - wróć na tę samą stronę po rejestracji
    const returnUrl = window.location.pathname + window.location.search;
    
    // ⚠️ DEBUG: Pokaż dokładnie co zapisujemy
    console.log('🔍 [DEBUG] window.location.pathname:', window.location.pathname);
    console.log('🔍 [DEBUG] window.location.search:', window.location.search);
    console.log('🔍 [DEBUG] returnUrl (złożony):', returnUrl);
    console.log('🔍 [DEBUG] window.location.href (pełny):', window.location.href);
    
    // Zapisz return URL w localStorage (Shopify może ignorować return_url parameter)
    safeLocalStorageSet('customify_return_url', returnUrl);
    safeLocalStorageSet('customify_return_url_timestamp', Date.now().toString());
    console.log('💾 [USAGE] Saved return URL to localStorage:', returnUrl);
    console.log('💾 [USAGE] Timestamp:', Date.now());
    
    // Nowe Customer Accounts Shopify (account.lumly.pl) wymagają /customer_authentication/login?return_to=ŚCIEŻKA
    // Dokumentacja: https://shopify.dev/docs/storefronts/themes/login (changelog Dec 19, 2024)
    // WAŻNE: return_to przyjmuje TYLKO ścieżkę względną (nie pełny URL)
    const encodedReturnPath = encodeURIComponent(returnUrl);
    console.log('🔐 [DEBUG] Encoded return path:', encodedReturnPath);
    
    // Jeden endpoint dla rejestracji i logowania (nowe konta Shopify nie mają osobnego /register)
    const registerUrl = `/customer_authentication/login?return_to=${encodedReturnPath}`;
    const loginUrl = `/customer_authentication/login?return_to=${encodedReturnPath}`;
    
    console.log('🔗 [DEBUG] Login/Register URL:', loginUrl);
    
    const markAuthIntent = (type) => {
      try {
        safeLocalStorageSet('customify_auth_intent', type);
        safeLocalStorageSet('customify_auth_intent_timestamp', Date.now().toString());
        safeLocalStorageSet('customify_auth_source', window.location.pathname + window.location.search);
        console.log('🔐 [AUTH] Marked auth intent:', type);
      } catch (error) {
        console.warn('⚠️ [AUTH] Failed to mark auth intent:', error);
      }
    };
    
    const modalHTML = `
      <div id="loginModal" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.75);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        animation: fadeIn 0.3s ease;
      ">
        <div style="
          background: white;
          padding: 50px 40px;
          border-radius: 16px;
          max-width: 550px;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,0.4);
          animation: slideUp 0.3s ease;
          position: relative;
        ">
          <button onclick="window.customifyLoginModal.cancel()" style="
            position: absolute;
            top: 15px;
            right: 15px;
            background: transparent;
            border: none;
            font-size: 24px;
            color: #999;
            cursor: pointer;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.2s;
            padding: 0;
            line-height: 1;
          " onmouseover="this.style.background='#f5f5f5'; this.style.color='#333'" onmouseout="this.style.background='transparent'; this.style.color='#999'">
            ×
          </button>
          <h2 style="
            margin-bottom: 15px; 
            color: #333; 
            font-size: 18px;
            font-weight: 600;
            line-height: 1.5;
          ">Want to generate another version?</h2>
          
          <p style="
            margin-bottom: 30px;
            color: #666;
            font-size: 15px;
            line-height: 1.5;
          ">Log in for free generations and saved projects</p>
          
          <div style="
            display: flex; 
            gap: 12px; 
            justify-content: center;
            flex-wrap: wrap;
          ">
            <a href="${registerUrl}" onclick="window.customifyLoginModal.trackRegisterClick()" style="
              background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
              color: white;
              padding: 14px 32px;
              border-radius: 8px;
              text-decoration: none;
              font-weight: bold;
              font-size: 16px;
              display: inline-block;
              box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
              transition: transform 0.2s;
            " onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
              Yes, I want to use it
            </a>
            
            <button onclick="window.customifyLoginModal.cancel()" style="
              background: #f5f5f5;
              color: #666;
              padding: 14px 32px;
              border-radius: 8px;
              border: 2px solid #ddd;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.2s;
            " onmouseover="this.style.background='#e0e0e0'" onmouseout="this.style.background='#f5f5f5'">
              Not now
            </button>
          </div>
          
          <div style="
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #eee;
            text-align: center;
          ">
            <p style="
              color: #666;
              font-size: 14px;
              margin: 0;
            ">
              Quick login with Google or email.
            </p>
          </div>
        </div>
      </div>
    `;
    
    // CSS Animations
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from { transform: translateY(50px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(styleEl);
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // ✅ ŚLEDZENIE: Wyświetlenie modala logowania
    // GA4
    if (typeof gtag !== 'undefined') {
      gtag('event', 'login_modal_shown', {
        'event_category': 'Customify',
        'event_label': 'Usage Limit Reached',
        'used_count': usedCount,
        'limit': limit,
        'product_url': window.location.pathname,
        'is_logged_in': false
      });
      console.log('📊 [GA4] Event sent: login_modal_shown', {
        usedCount: usedCount,
        limit: limit,
        url: window.location.pathname
      });
    }
    
    // Własny endpoint (widoczne na żywo)
    fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType: 'login_modal_shown',
        usedCount: usedCount,
        limit: limit,
        productUrl: window.location.pathname,
        timestamp: new Date().toISOString()
      })
    }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
    
    // Auto-redirect do REJESTRACJI po 5 sekundach (bez widocznego countdown)
    const countdownInterval = setInterval(() => {
      // Sprawdź czy modal nadal istnieje
      const modal = document.getElementById('loginModal');
      if (!modal) {
        clearInterval(countdownInterval);
        return;
      }
      
      // Po 5 sekundach przekieruj
      clearInterval(countdownInterval);
      markAuthIntent('register_auto_redirect');
      
      // ✅ ŚLEDZENIE: Auto-redirect do rejestracji (po 5 sekundach)
      // GA4
      if (typeof gtag !== 'undefined') {
        gtag('event', 'login_modal_auto_redirect', {
          'event_category': 'Customify',
          'event_label': 'Auto Redirect to Register',
          'used_count': usedCount,
          'limit': limit,
          'product_url': window.location.pathname
        });
        console.log('📊 [GA4] Event sent: login_modal_auto_redirect');
      }
      
      // Własny endpoint
      fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType: 'login_modal_auto_redirect',
          usedCount: usedCount,
          limit: limit,
          productUrl: window.location.pathname,
          timestamp: new Date().toISOString()
        })
      }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      
      window.location.href = registerUrl;
    }, 5000);
    
    // Global function to close modal
    window.customifyLoginModal = {
      cancel: () => {
        // ✅ ŚLEDZENIE: Kliknięcie w Anuluj
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_cancel_click', {
            'event_category': 'Customify',
            'event_label': 'Modal Cancelled',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_cancel_click');
        }
        
        // Własny endpoint
        fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_cancel_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
        
        clearInterval(countdownInterval);
        document.getElementById('loginModal')?.remove();
        console.log('🚫 [USAGE] Użytkownik zamknął modal');
      },
      
      trackRegisterClick: () => {
        markAuthIntent('register_click');
        // ✅ ŚLEDZENIE: Kliknięcie w Kontynuuj (rejestracja)
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_register_click', {
            'event_category': 'Customify',
            'event_label': 'Register Button Clicked',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_register_click');
        }
        
        // Własny endpoint
        fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_register_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      },
      
      trackLoginClick: () => {
        markAuthIntent('login_click');
        // ✅ ŚLEDZENIE: Kliknięcie w Zaloguj się
        // GA4
        if (typeof gtag !== 'undefined') {
          gtag('event', 'login_modal_login_click', {
            'event_category': 'Customify',
            'event_label': 'Login Link Clicked',
            'used_count': usedCount,
            'limit': limit,
            'product_url': window.location.pathname
          });
          console.log('📊 [GA4] Event sent: login_modal_login_click');
        }
        
        // Własny endpoint
        fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: 'login_modal_login_click',
            usedCount: usedCount,
            limit: limit,
            productUrl: window.location.pathname,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
      }
    };
  }

  /**
   * Limit zalogowanego: pierwsza ściana = formularz + doładowanie; kolejne = komunikat o mailu następnego dnia.
   */
  showLimitWallModal(customerInfo, errorJson = {}) {
    const existing = document.getElementById('limitWallModal');
    if (existing) existing.remove();

    const tier = errorJson.wallTier || 'unknown';
    const isFirstWall = tier === 'first_wall';

    const introFirst =
      'You have used your available generations. Tell us what we can improve - in about 5 minutes, we will add more generations to your account.';
    const introRetry =
      errorJson.message ||
      'You have used all available generations. We may increase your limit the next day and will email you with an update.';

    const formBlock = isFirstWall
      ? `
          <form id="limitWallForm">
            <label style="display:block; font-size: 14px; font-weight: 600; color: #444; margin-bottom: 6px;">
              What would you like to improve in the image? <span style="color:#c00">*</span>
            </label>
            <textarea name="fixImage" required minlength="10" rows="3" style="
              width: 100%; box-sizing: border-box; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px;
              font-size: 14px; margin-bottom: 14px; resize: vertical; font-family: inherit;
            " placeholder="E.g. face, colors, background..."></textarea>

            <label style="display:block; font-size: 14px; font-weight: 600; color: #444; margin-bottom: 6px;">
              Can't find the gift you are looking for? What is it?
            </label>
            <textarea name="giftSearch" rows="2" style="
              width: 100%; box-sizing: border-box; padding: 10px 12px; border: 1px solid #ddd; border-radius: 8px;
              font-size: 14px; margin-bottom: 14px; resize: vertical; font-family: inherit;
            " placeholder="Optional - this helps us match the offer"></textarea>

            <p id="limitWallFormError" style="display:none; color:#c00; font-size: 14px; margin: 0 0 12px;"></p>
            <div style="display: flex; gap: 10px; flex-wrap: wrap; justify-content: flex-end;">
              <button type="button" onclick="window.customifyLimitWallModal.close()" style="
                background: #f5f5f5; color: #666; padding: 12px 22px; border-radius: 8px; border: 2px solid #ddd;
                font-weight: 600; font-size: 15px; cursor: pointer;
              ">Close</button>
              <button type="submit" id="limitWallSubmit" style="
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white; padding: 12px 22px; border-radius: 8px; border: none;
                font-weight: 600; font-size: 15px; cursor: pointer;
              ">Send and top up account</button>
            </div>
          </form>`
      : `
          <p style="margin: 0 0 22px; color: #555; font-size: 15px; line-height: 1.55;">${introRetry.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>
          <div style="text-align: right;">
            <button type="button" onclick="window.customifyLimitWallModal.close()" style="
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white; padding: 12px 22px; border-radius: 8px; border: none;
              font-weight: 600; font-size: 15px; cursor: pointer;
            ">Got it</button>
          </div>`;

    const modalHTML = `
      <div id="limitWallModal" style="
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.75); display: flex; align-items: center; justify-content: center;
        z-index: 99999; padding: 16px; box-sizing: border-box;
      ">
        <div style="
          background: white; padding: 32px 26px; border-radius: 16px; max-width: 520px; width: 100%;
          text-align: left; box-shadow: 0 20px 60px rgba(0,0,0,0.4); position: relative; max-height: 90vh; overflow-y: auto;
        ">
          <button type="button" onclick="window.customifyLimitWallModal.close()" style="
            position: absolute; top: 10px; right: 10px; background: transparent; border: none;
            font-size: 24px; color: #999; cursor: pointer; width: 32px; height: 32px; line-height: 1;
          ">×</button>
          <h2 style="margin: 0 0 12px; color: #333; font-size: 18px; font-weight: 600;">Get free generations</h2>
          ${isFirstWall ? `<p style="margin: 0 0 18px; color: #666; font-size: 15px; line-height: 1.55;">${introFirst.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>` : ''}
          ${formBlock}
        </div>
      </div>`;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    window.customifyLimitWallModal = {
      close: () => document.getElementById('limitWallModal')?.remove(),
    };

    if (!isFirstWall) return;

    const form = document.getElementById('limitWallForm');
    const errEl = document.getElementById('limitWallFormError');
    const submitBtn = document.getElementById('limitWallSubmit');
    if (!form || !errEl || !submitBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errEl.style.display = 'none';
      errEl.textContent = '';
      const fd = new FormData(form);
      const body = {
        customerId: customerInfo.customerId,
        fixImage: (fd.get('fixImage') || '').trim(),
        giftSearch: (fd.get('giftSearch') || '').trim(),
        productUrl: window.location.pathname + window.location.search,
      };
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      try {
        const r = await fetch(window.CustomifyApi.url('/api/limit-wall-feedback'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) {
          errEl.textContent = data.message || data.error || 'Could not send. Try again.';
          errEl.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send and top up account';
          return;
        }
        window.customifyLimitWallModal.close();
        this.showSuccess(data.message || 'Thank you! Your account has been topped up - check your email.', { html: false });
      } catch (err) {
        console.error('❌ [LIMIT-WALL] Submit failed:', err);
        this._reportToSentry(err, 'limit-wall-submit');
        errEl.textContent = 'Network error. Try again.';
        errEl.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send and top up account';
      }
    });
  }

  /**
   * Pokazuje licznik użyć w UI
   */
  async showUsageCounter() {
    // Licznik ukryty - użytkownik zobaczy komunikat dopiero gdy wyczerpie limit
    return;
    
    // Usage counter initialization
    const customerInfo = this.getCustomerInfo();
    console.log('🔍 [USAGE] Customer info:', customerInfo ? 'logged in' : 'not logged in');
    let counterHTML = '';
    
    if (!customerInfo) {
      // Niezalogowany - UKRYJ licznik (nie pokazuj komunikatu)
      console.log(`🔍 [USAGE] Not logged in - hiding usage counter`);
      counterHTML = ''; // Nie pokazuj komunikatu dla niezalogowanych
    } else {
      // Zalogowany - pobierz z API
      console.log('🔍 [USAGE] Fetching usage data from API...');
      try {
        const response = await fetch(window.CustomifyApi.url('/api/check-usage'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            customerId: customerInfo.customerId,
            customerAccessToken: customerInfo.customerAccessToken
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          const remaining = data.remainingCount || 0;
          const totalLimit = data.totalLimit || 3;
          
          console.log(`🔍 [USAGE] API response - remaining: ${remaining}, totalLimit: ${totalLimit}`);
          
          if (remaining > 0) {
            // Niebieski - zalogowany, pozostało transformacji
            counterHTML = `
              <div id="usageCounter" class="usage-counter usage-counter-blue">
                ✅ Zalogowany: ${remaining}/${totalLimit} transformacji
              </div>
            `;
          } else {
            // Czerwony - limit wykorzystany
            counterHTML = `
              <div id="usageCounter" class="usage-counter usage-counter-red">
                ❌ Wykorzystano ${totalLimit}/${totalLimit} transformacji
              </div>
            `;
          }
        } else {
          console.warn('⚠️ [USAGE] Failed to fetch usage data:', response.status);
          // Fallback - pokaż że jest zalogowany ale nie wiemy ile ma transformacji
          counterHTML = `
            <div id="usageCounter" class="usage-counter usage-counter-blue">
              ✅ Zalogowany - sprawdzanie limitów...
            </div>
          `;
        }
      } catch (error) {
        console.error('❌ [USAGE] Error fetching usage counter:', error);
        this._reportToSentry(error, 'usage-counter');
        // Fallback - pokaż że jest zalogowany ale nie wiemy ile ma transformacji
        counterHTML = `
          <div id="usageCounter" class="usage-counter usage-counter-blue">
            ✅ Zalogowany - sprawdzanie limitów...
          </div>
        `;
      }
    }
    
    console.log('🔍 [USAGE] counterHTML generated:', counterHTML ? 'YES' : 'NO', counterHTML.substring(0, 100));
    
    // Wstaw licznik do DOM (przed upload area)
    const uploadArea = document.getElementById('uploadArea');
    console.log('🔍 [USAGE] uploadArea found:', !!uploadArea);
    
    if (uploadArea && counterHTML) {
      // Remove stary licznik jeśli istnieje
      const oldCounter = document.getElementById('usageCounter');
      if (oldCounter) {
        oldCounter.remove();
        console.log('🔍 [USAGE] Removed old counter');
      }
      
      // Wstaw nowy licznik przed upload area
      uploadArea.insertAdjacentHTML('beforebegin', counterHTML);
      console.log('✅ [USAGE] Usage counter displayed successfully');
    } else {
      if (!uploadArea) {
        console.warn('⚠️ [USAGE] Upload area not found - counter not displayed');
      }
      if (!counterHTML) {
        console.warn('⚠️ [USAGE] counterHTML is empty - counter not displayed');
      }
    }
  }

  // filterStylesForProduct() USUNIĘTE - logika przeniesiona na server-side (Shopify Liquid)

  // ETSY-STYLE EXPANDABLE DESCRIPTION USUNIĘTE - opisy produktów są teraz pełne

  // ACCORDION: SZCZEGÓŁY PRODUKTU
  setupAccordion() {
    console.log('🎯 [CUSTOMIFY] Setting up accordion...');
    
    // Znajdź wszystkie accordion items
    const accordionItems = document.querySelectorAll('.accordion-item');
    
    if (!accordionItems || accordionItems.length === 0) {
      console.log('⚠️ [CUSTOMIFY] No accordion items found');
      return;
    }
    
    console.log('✅ [CUSTOMIFY] Found', accordionItems.length, 'accordion items');
    
    // Dodaj event listener do każdego accordion header
    accordionItems.forEach((item, index) => {
      const header = item.querySelector('.accordion-header');
      
      if (!header) {
        console.log('⚠️ [CUSTOMIFY] No header found for item', index);
        return;
      }
      
      // Event listener - TYLKO toggle klasy (BEZ DOM manipulation)
      header.addEventListener('click', () => {
        const isExpanded = item.classList.contains('expanded');
        
        if (isExpanded) {
          // Zwiń
          item.classList.remove('expanded');
          console.log('🔽 [CUSTOMIFY] Collapsed:', item.dataset.accordion);
        } else {
          // Rozwiń (opcjonalnie: zwiń inne)
          // accordionItems.forEach(otherItem => otherItem.classList.remove('expanded'));
          item.classList.add('expanded');
          console.log('🔼 [CUSTOMIFY] Expanded:', item.dataset.accordion);
        }
      });
      
      console.log('✅ [CUSTOMIFY] Accordion item', index, 'setup complete');
    });
    
    console.log('✅ [CUSTOMIFY] Accordion setup complete!');
  }

  // WSTRZYJ APLIKACJĘ DO KOLUMNY 2
  positionApp() {
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    const appContainer = document.getElementById('customify-app-container');
    if (!appContainer) return;

    // Znajdź kolumnę 2 (detale produktu)
    const productDetails = document.querySelector('#ProductInformation-template--26351135293765__main') || 
                          document.querySelector('.product-details') ||
                          document.querySelector('.product__info');

    if (productDetails) {
      console.log('🎯 [CUSTOMIFY] Found product details column, inserting app at top');
      
      // Dodaj elementy pod tytułem
      this.addProductBadges();
      
      // Pokaż aplikację
      appContainer.style.display = 'block';
      
      // Wstaw na górę kolumny 2
      productDetails.insertBefore(appContainer, productDetails.firstChild);
      
      // USTAW FINALNY UKŁAD ELEMENTÓW
      this.setFinalLayout();
    } else {
      console.warn('⚠️ [CUSTOMIFY] Could not find product details column');
    }
  }


  // USTAW FINALNY UKŁAD ELEMENTÓW - JEDNA FUNKCJA, BEZ HISTORII PRZENIESIEŃ
  setFinalLayout() {
    console.log('🎯 [LAYOUT] Ustawiam finalny układ elementów...');
    
    // 1. ZNAJDŹ GŁÓWNY KONTENER
    const productInfoColumn = document.querySelector('[id^="ProductInformation-"]');
    if (!productInfoColumn) {
      console.warn('⚠️ [LAYOUT] Nie znaleziono ProductInformation');
      return;
    }

    // Horizon keeps zero-height title/buy-button siblings inside a flex group.
    // Its gap and bottom padding still create a large blank area below the H1.
    const titleHeading = productInfoColumn.querySelector('h1');
    const innerTitleGroup = titleHeading?.closest('.group-block[data-testid="group-block"]');
    const titleSpacingGroup = innerTitleGroup?.parentElement?.closest('.group-block[data-testid="group-block"]');
    if (titleSpacingGroup) {
      titleSpacingGroup.style.setProperty('padding-bottom', '0px', 'important');
      const titleSpacingContent = titleSpacingGroup.querySelector(':scope > .group-block-content');
      if (titleSpacingContent) titleSpacingContent.style.setProperty('gap', '0px', 'important');
    }

    // 2. ZNAJDŹ WSZYSTKIE ELEMENTY
    const titleElement = document.querySelector('.group-block[data-testid="group-block"] [class*="product_title"]')?.parentElement?.parentElement;
    const descriptionElement = document.querySelector('rte-formatter');
    const priceElement = document.querySelector('product-price');
    const productTypeArea = document.getElementById('productTypeArea');
    const sizeArea = document.getElementById('sizeArea');

    console.log('📦 [LAYOUT] Znalezione elementy:', {
      title: !!titleElement,
      description: !!descriptionElement,
      price: !!priceElement,
      productType: !!productTypeArea,
      sizes: !!sizeArea
    });

    // 3. UTWÓRZ KONTENER DLA UPORZĄDKOWANYCH ELEMENTÓW
    let orderedContainer = productInfoColumn.querySelector('.customify-ordered-layout');
    if (!orderedContainer) {
      orderedContainer = document.createElement('div');
      orderedContainer.className = 'customify-ordered-layout';
      orderedContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 0;
        width: 100%;
      `;
      productInfoColumn.appendChild(orderedContainer);
    }

    // 4. USTAW KOLEJNOŚĆ: TYTUŁ > OPIS > CENA > TYPY > ROZMIARY
    if (titleElement && !titleElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(titleElement);
      titleElement.classList.add('layout-set');
      titleElement.style.setProperty('padding-bottom', '0px', 'important');
      const titleContent = titleElement.querySelector(':scope > .group-block-content');
      if (titleContent) titleContent.style.setProperty('gap', '0px', 'important');
      console.log('✅ [LAYOUT] Tytuł ustawiony');
    }

    if (descriptionElement && !descriptionElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(descriptionElement);
      descriptionElement.classList.add('layout-set');
      console.log('✅ [LAYOUT] Opis ustawiony');
    }

    if (priceElement && !priceElement.classList.contains('layout-set')) {
      orderedContainer.appendChild(priceElement);
      priceElement.classList.add('layout-set');
      console.log('✅ [LAYOUT] Cena ustawiona');
    }

    if (productTypeArea && !productTypeArea.classList.contains('layout-set')) {
      orderedContainer.appendChild(productTypeArea);
      productTypeArea.classList.add('layout-set');
      console.log('✅ [LAYOUT] Typy materiału ustawione');
    }

    if (sizeArea && !sizeArea.classList.contains('layout-set')) {
      orderedContainer.appendChild(sizeArea);
      sizeArea.classList.add('layout-set');
      console.log('✅ [LAYOUT] Rozmiary ustawione');
    }

    console.log('🎉 [LAYOUT] Finalny układ ustawiony!');

    // NIE ukrywamy ceny - zostawiamy oryginalną pozycję Shopify
    // (usunięto klonowanie ceny ze względu na potencjalne problemy z cloakingiem Google)

    // DODAJ DIVIDER POD ROZMIARAMI
    this.addDividerAfterSizes();

    console.log('✅ [CUSTOMIFY] Title moved to top successfully!');
  }



  // DODAJ DIVIDER POD ROZMIARAMI
  addDividerAfterSizes() {
    // Sprawdź czy już nie ma dividera
    if (document.querySelector('.customify-title-divider')) {
      console.log('🎯 [CUSTOMIFY] Divider already exists');
      return;
    }

    // Znajdź kontener z rozmiarami
    const sizeArea = document.getElementById('sizeArea');
    if (!sizeArea) {
      console.warn('⚠️ [CUSTOMIFY] Could not find sizeArea for divider');
      return;
    }

    // Stwórz divider
    const divider = document.createElement('div');
    divider.className = 'customify-title-divider';
    divider.style.cssText = `
      width: 100%;
      height: 1px;
      background-color: #ccc;
      margin: 15px 0;
      border-radius: 0.5px;
    `;

    // Dodaj divider po rozmiarach
    sizeArea.parentNode.insertBefore(divider, sizeArea.nextSibling);

    console.log('✅ [CUSTOMIFY] Divider added after sizes');
  }

  // FUNKCJA USUNIĘTA: showPriceBelowApp()
  // Powód: Potencjalne problemy z cloakingiem Google (klonowanie elementów DOM)
  // Cena pozostaje w oryginalnej pozycji Shopify

  // DODAJ GWIAZDKI DO OPISU PRODUKTU (rte-formatter)
  addProductBadges() {
    console.log('🎯 [CUSTOMIFY] Dodaję gwiazdki do opisu produktu...');
    
    // Znajdź opis produktu (rte-formatter)
    const descriptionElement = document.querySelector('rte-formatter');
    if (!descriptionElement) {
      console.log('⚠️ [CUSTOMIFY] Nie znaleziono rte-formatter');
      return;
    }

    // Sprawdź czy już nie ma badge'ów
    if (document.querySelector('.product-badges')) {
      console.log('⚠️ [CUSTOMIFY] Badge\'y już istnieją');
      return;
    }

    // Stwórz kontener dla badge'ów
    const badgesContainer = document.createElement('div');
    badgesContainer.className = 'product-badges';
    badgesContainer.style.cssText = 'margin-bottom: 8px; display: block;';

    // Dodaj sekcję z gwiazdkami
    const ratingSection = document.createElement('div');
    ratingSection.className = 'rating-section';

    const stars = document.createElement('div');
    stars.className = 'stars';
    for (let i = 0; i < 5; i++) {
      const star = document.createElement('span');
      star.className = 'star';
      star.innerHTML = '★';
      stars.appendChild(star);
    }

    const reviewCount = document.createElement('span');
    reviewCount.className = 'review-count';
    reviewCount.textContent = '(143)';

    ratingSection.appendChild(stars);
    ratingSection.appendChild(reviewCount);

    // Dodaj do kontenera
    badgesContainer.appendChild(ratingSection);

    // DODAJ GWIAZDKI NA POCZĄTEK OPISU (przed tekstem w rte-formatter)
    descriptionElement.insertBefore(badgesContainer, descriptionElement.firstChild);
    
    // DODAJ MARGINES DO TEKSTU OPISU (aby gwiazdki nie zasłaniały)
    const descriptionText = descriptionElement.querySelector('p, .p1');
    if (descriptionText) {
      descriptionText.style.setProperty('margin-top', '0px', 'important');
      console.log('✅ [CUSTOMIFY] Usunięto nadmiarowy margines nad opisem');
    }
    
    console.log('✅ [CUSTOMIFY] Gwiazdki dodane do opisu produktu');
  }

  setupEventListeners() {
    this.uploadArea.addEventListener('click', () => {
      const input = document.getElementById('fileInput');
      if (input) input.click();
    });
    // 🔧 Delegacja na document - działa nawet gdy fileInput jest przeniesiony w DOM (po tryAgain/showResult)
    document.addEventListener('change', (e) => {
      if (e.target.id === 'fileInput' && e.target.files?.length > 0) {
        this.handleFileSelect(e.target.files[0]);
      }
    });
    
    this.uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.uploadArea.classList.add('dragover');
    });
    
    this.uploadArea.addEventListener('dragleave', () => {
      this.uploadArea.classList.remove('dragover');
    });
    
    this.uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      this.uploadArea.classList.remove('dragover');
      this.handleFileSelect(e.dataTransfer.files[0]);
    });

    this.stylesArea.addEventListener('click', (e) => {
      console.log('🖱️ [CLICK] Kliknięcie w stylesArea:', e.target);
      console.log('🖱️ [CLICK] Czy to customify-style-card?', e.target.classList.contains('customify-style-card'));
      console.log('🖱️ [CLICK] Czy closest?', e.target.closest('.customify-style-card'));
      
      if (e.target.classList.contains('customify-style-card') || 
          e.target.closest('.customify-style-card')) {
        const card = e.target.classList.contains('customify-style-card') ? 
                    e.target : e.target.closest('.customify-style-card');
        console.log('🖱️ [CLICK] Znaleziona karta:', card);
        console.log('🖱️ [CLICK] data-style:', card?.dataset?.style);
        this.selectStyle(card);
      } else {
        console.log('🖱️ [CLICK] Kliknięcie poza kartą stylu');
      }
    });

    // Event listener dla rozmiarów - sprawdź zarówno główny jak i w resultArea
    document.addEventListener('click', (e) => {
      const sizeBtn = e.target.closest('.customify-size-btn');
      if (sizeBtn) {
        if (sizeBtn.classList.contains('disabled')) {
          e.preventDefault();
          return;
        }
        this.selectSize(sizeBtn);
      }
    });

    // Event listener dla wyboru typu produktu (Plakat vs Canvas)
    document.addEventListener('click', (e) => {
      if (e.target.closest?.('#textOverlayToggleBtn')) {
        return; // nie traktuj toggle jako wyboru typu produktu
      }
      const productTypeBtn = e.target.closest?.('.customify-product-type-btn');
      if (productTypeBtn) {
        this.selectProductType(productTypeBtn);
      }
    });

    document.getElementById('transformBtn').addEventListener('click', () => this.transformImage());
    document.getElementById('resetBtn').addEventListener('click', () => this.reset());
    document.getElementById('addToCartBtn').addEventListener('click', () => this.addToCart());
    document.getElementById('addToCartBtnMain').addEventListener('click', () => this.addToCart());
    const addToCartBtnPhoneCase = document.getElementById('addToCartBtnPhoneCase');
    if (addToCartBtnPhoneCase) addToCartBtnPhoneCase.addEventListener('click', () => this.addToCart());
    document.getElementById('tryAgainBtn').addEventListener('click', () => this.tryAgain());

    if (this.spotifyCropConfirmBtn) {
      this.spotifyCropConfirmBtn.addEventListener('click', () => this.confirmSpotifyCrop());
    }
    if (this.spotifyCropCancelBtn) {
      this.spotifyCropCancelBtn.addEventListener('click', () => this.cancelSpotifyCrop());
    }
    
    // 📱 Telefon - event listenery dla croppera (sprawdź w momencie użycia)
    const phoneCropConfirmBtn = document.getElementById('phoneCropConfirmBtn');
    const phoneCropCancelBtn = document.getElementById('phoneCropCancelBtn');
    if (phoneCropConfirmBtn) {
      phoneCropConfirmBtn.addEventListener('click', () => this.confirmPhoneCrop());
    }
    if (phoneCropCancelBtn) {
      phoneCropCancelBtn.addEventListener('click', () => this.cancelPhoneCrop());
    }
    
    // 📱 Telefon (etui) - event listenery dla croppera
    const phonePhotoCropConfirmBtn = document.getElementById('phonePhotoCropConfirmBtn');
    const phonePhotoCropCancelBtn = document.getElementById('phonePhotoCropCancelBtn');
    if (phonePhotoCropConfirmBtn) {
      phonePhotoCropConfirmBtn.addEventListener('click', () => this.confirmPhonePhotoCrop());
    }
    if (phonePhotoCropCancelBtn) {
      phonePhotoCropCancelBtn.addEventListener('click', () => this.cancelPhonePhotoCrop());
    }
    
    // 🎵 Kliknięcie w preview image otwiera cropper ponownie (ponowne kadrowanie)
    if (this.isCropperProduct()) {
      if (this.isPhonePhotoCaseProduct()) {
        // 📱 Phone case: click na preview (przed AI) i result (po AI) - ponowne kadrowanie
        const photoBg = document.getElementById('phoneCasePhotoBg');
        const resultBg = document.getElementById('phoneCaseResultBg');
        [photoBg, resultBg].forEach(el => {
          if (el) {
            el.style.cursor = 'pointer';
            el.title = 'Click to crop the photo again';
            el.addEventListener('click', () => this.reopenPhonePhotoCropper());
          }
        });
      } else if (this.previewImage) {
        this.previewImage.style.cursor = 'pointer';
        this.previewImage.title = 'Click to crop the photo again';
        if (this.isPhoneCaseProduct()) {
          this.previewImage.addEventListener('click', () => this.reopenPhoneCropper());
        } else {
          this.previewImage.addEventListener('click', () => this.reopenSpotifyCropper());
        }
      }
    }
    
    // 📱 Phone case preview initialization (background-image mode)
    if (this.isPhonePhotoCaseProduct()) {
      console.log('📱 [PHONE PREVIEW] Initializing phone case preview (background-image mode)...');
      const photoBg = document.getElementById('phoneCasePhotoBg');
      if (photoBg) {
        console.log(`📱 [PHONE PREVIEW] Found preview background div`);
      } else {
        console.warn('⚠️ [PHONE PREVIEW] No preview background div found - HTML may not be updated');
      }
      
      // Debug: Log rendered sizes
      setTimeout(() => {
        const inner = document.querySelector('#customify-app-container .phone-case-inner');
        const overlay = document.querySelector('#customify-app-container .phone-case-overlay');
        const photoBgEl = document.getElementById('phoneCasePhotoBg');
        if (inner) {
          const innerRect = inner.getBoundingClientRect();
          console.log('[PHONE PREVIEW] inner rect', {
            width: innerRect.width,
            height: innerRect.height,
            aspectRatio: innerRect.width / innerRect.height,
            expectedRatio: 559 / 1154
          });
        }
        if (overlay) {
          const overlayRect = overlay.getBoundingClientRect();
          console.log('[PHONE PREVIEW] overlay rect', {
            width: overlayRect.width,
            height: overlayRect.height,
            aspectRatio: overlayRect.width / overlayRect.height,
            expectedRatio: 559 / 1154
          });
        }
        if (photoBgEl) {
          const photoBgRect = photoBgEl.getBoundingClientRect();
          console.log('[PHONE PREVIEW] photo-bg rect', {
            width: photoBgRect.width,
            height: photoBgRect.height,
            aspectRatio: photoBgRect.width / photoBgRect.height
          });
        }
      }, 500);
    }
  }
  
  // 🎵 Ponowne otwarcie croppera z oryginalnym zdjęciem
  reopenSpotifyCropper() {
    if (!this.originalSpotifyFile) {
      console.warn('⚠️ [SPOTIFY] Brak oryginalnego zdjęcia do ponownego kadrowania');
      return;
    }
    console.log('🎵 [SPOTIFY] Ponowne otwieranie croppera z oryginalnym zdjęciem');
    
    // Resetuj flagę spotifyBezZmianActive żeby syncPosition znów działał
    window.spotifyBezZmianActive = false;
    
    // Otwórz cropper z oryginalnym zdjęciem
    this.openSpotifyCropper(this.originalSpotifyFile);
  }

  /**
   * Inicjalizacja UI napisów (tylko produkt pilota)
   */
  setupTextOverlayUI() {
    if (!this.textOverlayEnabled) {
      if (this.textOverlayPanel) {
        this.textOverlayPanel.style.display = 'none';
      }
      return;
    }

    if (this.getProductHandle() === 'personalisierte-paar-karikatur-vom-foto') {
      if (this.textOverlayToggleBtn) this.textOverlayToggleBtn.textContent = 'Text hinzufügen? Hier klicken';
      if (this.textOverlayInput) this.textOverlayInput.placeholder = 'Text eingeben';
      if (this.textOverlaySaveBtn) this.textOverlaySaveBtn.textContent = 'Speichern';
      if (this.textOverlayColorSelect?.options?.[0]) this.textOverlayColorSelect.options[0].textContent = 'Farbe';
      if (this.textOverlayFontSelect?.options?.[0]) this.textOverlayFontSelect.options[0].textContent = 'Schriftart';
      if (this.textOverlaySizeSelect?.options?.[0]) this.textOverlaySizeSelect.options[0].textContent = 'Größe';
    }

    if (this.textOverlayInput && this.textOverlayCounter) {
      this.textOverlayInput.addEventListener('input', () => {
        this.updateTextOverlayCounter();
        this.textOverlayState.applied = false;
        
        // ✅ DEBOUNCE: Opóźnij preview o 80ms żeby nie renderować przy każdym znaku
        if (this.textOverlayDebounceTimer) {
          clearTimeout(this.textOverlayDebounceTimer);
        }
        this.textOverlayDebounceTimer = setTimeout(() => {
          this.previewTextOverlay().catch(err => {
            console.error('❌ [TEXT-OVERLAY] auto-preview error:', err);
          });
        }, 80);
      });
      this.updateTextOverlayCounter();
    }

    const bindSelect = (selectEl, key) => {
      if (!selectEl) return;
      selectEl.addEventListener('change', () => {
        // Specjalna logika dla kolorów: opcje z "-banner" wymuszają tło
        if (selectEl === this.textOverlayColorSelect) {
          const value = selectEl.value;
          const isBanner = value?.endsWith('-banner');
          const baseColor = isBanner ? value.replace('-banner', '') : value;
          this.textOverlayState.color = baseColor;
          this.textOverlayState.preset = isBanner ? 'banner' : 'classic';
        } else {
          this.textOverlayState[key] = selectEl.value;
        }
        this.textOverlayState.applied = false;
        
        // ✅ DEBOUNCE: Opóźnij preview o 80ms (tak samo jak dla input)
        if (this.textOverlayDebounceTimer) {
          clearTimeout(this.textOverlayDebounceTimer);
        }
        this.textOverlayDebounceTimer = setTimeout(() => {
          this.previewTextOverlay().catch(err => {
            console.error('❌ [TEXT-OVERLAY] auto-preview error:', err);
          });
        }, 80);
      });
    };

    bindSelect(this.textOverlayColorSelect, 'color');
    bindSelect(this.textOverlayFontSelect, 'font');
    bindSelect(this.textOverlaySizeSelect, 'size');

    if (this.textOverlayToggleBtn && this.textOverlayPanel) {
      this.textOverlayToggleBtn.addEventListener('click', () => {
        const isOpen = this.textOverlayPanel.style.display !== 'none';
        if (isOpen) {
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn.setAttribute('data-overlay-open', 'false');
        } else {
          this.textOverlayPanel.style.display = 'block';
          this.textOverlayToggleBtn.setAttribute('data-overlay-open', 'true');
        }
      });
    }

    if (this.textOverlaySaveBtn) {
      this.textOverlaySaveBtn.addEventListener('click', () => {
        this.saveTextOverlay().catch(err => {
          console.error('❌ [TEXT-OVERLAY] save error:', err);
          this.showError('Could not save the text. Try again.', 'cart');
        });
      });
    }

    this.textOverlayState = {
      ...this.textOverlayState,
      preset: 'classic',
      color: this.textOverlayColorSelect?.value || null,
      font: this.textOverlayFontSelect?.value || null,
      size: this.textOverlaySizeSelect?.value || null
    };

    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = 'none';
    }
  }

  updateTextOverlayCounter() {
    if (!this.textOverlayInput || !this.textOverlayCounter) return;
    const current = this.textOverlayInput.value.length;
    const max = this.textOverlayInput.maxLength || 80;
    this.textOverlayCounter.textContent = `${current}/${max}`;
  }

  updateTextOverlayHint(message = '') {
    if (!this.textOverlayHint) return;
    if (message) {
      this.textOverlayHint.textContent = message;
      this.textOverlayHint.style.display = 'block';
    } else {
      this.textOverlayHint.style.display = 'none';
    }
  }

  updateSpotifyFrameScale(retryCount = 0) {
    if (!this.isSpotifyProduct()) return;
    const containers = document.querySelectorAll('.spotify-frame-preview, .spotify-frame-result');
    if (!containers.length) return;

    let needsRetry = false;
    containers.forEach(container => {
      const inner = container.querySelector('.spotify-frame-inner');
      if (!inner) return;
      const styles = window.getComputedStyle(container);
      const padX = parseFloat(styles.paddingLeft || '0') + parseFloat(styles.paddingRight || '0');
      const padY = parseFloat(styles.paddingTop || '0') + parseFloat(styles.paddingBottom || '0');
      const availableWidth = Math.max(0, container.clientWidth - padX);
      
      // Jeśli container nie ma jeszcze wymiarów, zaplanuj retry
      if (availableWidth <= 0) {
        needsRetry = true;
        return;
      }
      
      const scale = availableWidth / 1024;
      inner.style.transform = `scale(${scale})`;
      container.style.height = `${1536 * scale + padY}px`;
    });
    
    // Retry max 10 razy co 50ms jeśli container nie ma wymiarów
    if (needsRetry && retryCount < 10) {
      setTimeout(() => this.updateSpotifyFrameScale(retryCount + 1), 50);
    }
  }

  /**
   * 🎵 Komponuje finalny obraz dla ramka-spotify
   * Zawiera: tło + zdjęcie użytkownika + maska spotify + teksty
   * @returns {Promise<string>} Base64 skomponowanego obrazu
   */
  async composeSpotifyImage() {
    return new Promise((resolve, reject) => {
      console.log('🎵 [SPOTIFY COMPOSE] Starting image composition...');
      
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Wymiary ramki spotify
      canvas.width = 1024;
      canvas.height = 1536;
      
      // 1. Przezroczyste tło (dla druku na szkle - podświetlane ramki)
      // Canvas domyślnie ma przezroczyste tło
      
      // 2. Zdjęcie użytkownika (wykadrowane)
      const userImage = new Image();
      userImage.crossOrigin = 'anonymous';
      
      // Użyj wykadrowanego zdjęcia (base64) lub transformedImage (URL – przez proxy przy Vercel Blob)
      let imageSource = this.spotifyCropDataUrl || this.transformedImage;
      if (imageSource && typeof imageSource === 'string' && imageSource.startsWith('http')) {
        imageSource = this.getCanvasSafeImageUrl(imageSource);
      }
      if (!imageSource) {
        reject(new Error('No photo available for composition'));
        return;
      }
      
      userImage.onload = () => {
        console.log('🎵 [SPOTIFY COMPOSE] User image loaded:', userImage.width, 'x', userImage.height);
        
        // Rysuj zdjęcie użytkownika w pozycji 61,61 o rozmiarze 902x902
        ctx.drawImage(userImage, 61, 61, 902, 902);
        
        // 3. Nałóż maskę spotify
        const maskImage = new Image();
        maskImage.crossOrigin = 'anonymous';
        maskImage.src = 'https://lumlyusa.vercel.app/spotify/biale_male.png';
        
        maskImage.onload = () => {
          console.log('🎵 [SPOTIFY COMPOSE] Mask loaded');
          ctx.drawImage(maskImage, 0, 0, canvas.width, canvas.height);
          
          // 4. Dodaj teksty
          const titleInput = document.getElementById('spotifyTitle');
          const artistInput = document.getElementById('spotifyArtist');
          const titleText = titleInput ? titleInput.value : '';
          const artistText = artistInput ? artistInput.value : '';
          
          // Pozycja tekstów (między zdjęciem a kontrolerami) - zgodna z CSS (top: 1000px)
          // Używamy textBaseline = 'top' żeby pozycjonować od góry tekstu (jak w CSS)
          ctx.textBaseline = 'top';
          const textY = 1000; // Zgodne z CSS .spotify-text-overlay { top: 1000px; }
          
          // Nagłówek - gruby, BIAŁY, wyrównany do lewej
          if (titleText) {
            ctx.font = 'bold 72px Arial, sans-serif';
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'left';
            ctx.fillText(titleText, 61, textY);
            console.log('🎵 [SPOTIFY COMPOSE] Title added:', titleText);
          }
          
          // Podpis - cieńszy, BIAŁY, wyrównany do lewej
          // Oblicz pozycję na podstawie wysokości nagłówka (72px) + odstęp (6px jak w CSS margin-bottom)
          if (artistText) {
            ctx.font = '48px Arial, sans-serif';
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'left';
            ctx.fillText(artistText, 61, textY + 72 + 6); // 72px (wysokość nagłówka) + 6px (margin-bottom z CSS)
            console.log('🎵 [SPOTIFY COMPOSE] Artist added:', artistText);
          }
          
          // 5. Eksportuj jako PNG (przezroczystość dla druku na szkle!)
          const composedImagePNG = canvas.toDataURL('image/png');
          console.log('🎵 [SPOTIFY COMPOSE] PNG for print, size:', composedImagePNG.length);
          
          // 6. Eksportuj również JPEG z ciemniejszym szarym tłem (dla podglądu w koszyku - lepiej widać białe napisy)
          ctx.globalCompositeOperation = 'destination-over';
          ctx.fillStyle = '#9a9a9a';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          const composedImagePreview = canvas.toDataURL('image/jpeg', 0.92);
          console.log('🎵 [SPOTIFY COMPOSE] JPEG preview, size:', composedImagePreview.length);
          
          // Zwróć oba obrazy
          const composedImage = { png: composedImagePNG, preview: composedImagePreview };
          
          resolve(composedImage);
        };
        
        maskImage.onerror = (err) => {
          console.error('🎵 [SPOTIFY COMPOSE] Failed to load mask:', err);
          reject(new Error('Could not load the Spotify mask'));
        };
      };
      
      userImage.onerror = (err) => {
        console.error('🎵 [SPOTIFY COMPOSE] Failed to load user image:', err);
        reject(new Error('Could not load the photo'));
      };
      
      userImage.src = imageSource;
    });
  }

  getTextOverlayPayload() {
    if (!this.textOverlayEnabled || !this.textOverlayState.applied) return null;
    return {
      text: (this.textOverlayState.text || '').trim(),
      preset: this.textOverlayState.preset,
      color: this.textOverlayState.color,
      font: this.textOverlayState.font,
      size: this.textOverlayState.size
    };
  }

  openSpotifyCropper(file) {
    document.querySelectorAll('.photo-crop-error').forEach(notice => notice.remove());
    if (!this.spotifyCropModal || !this.spotifyCropImage) {
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [SPOTIFY] CropperJS not loaded, fallback to normal preview');
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }

    // 🎵 Zachowaj oryginalne zdjęcie do ponownego kadrowania
    this.originalSpotifyFile = file;
    console.log('🎵 [SPOTIFY] Zapisano oryginalne zdjęcie do ponownego kadrowania');

    this.spotifyCropConfirmed = false;
    if (this.spotifyCropper) {
      this.spotifyCropper.destroy();
      this.spotifyCropper = null;
    }
    if (this.spotifyCropSourceUrl) {
      URL.revokeObjectURL(this.spotifyCropSourceUrl);
      this.spotifyCropSourceUrl = null;
    }

    this.spotifyCropSourceUrl = URL.createObjectURL(file);
    this.spotifyCropImage.onerror = () => this._showUploadError(window.CustomifyPhotoUpload.error('file_decode'), file, 'crop-open');
    this.spotifyCropImage.src = this.spotifyCropSourceUrl;
    this.spotifyCropModal.classList.add('is-open');
    this.spotifyCropModal.setAttribute('aria-hidden', 'false');

    const cropConfig = this.getCropConfig();
    this.spotifyCropper = new Cropper(this.spotifyCropImage, {
      aspectRatio: cropConfig.aspectRatio,
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      movable: true,
      zoomable: true,
      zoomOnTouch: true,
      zoomOnWheel: true,
      background: false
    });
  }

  closeSpotifyCropper() {
    if (this.spotifyCropper) {
      this.spotifyCropper.destroy();
      this.spotifyCropper = null;
    }
    if (this.spotifyCropSourceUrl) {
      URL.revokeObjectURL(this.spotifyCropSourceUrl);
      this.spotifyCropSourceUrl = null;
    }
    if (this.spotifyCropModal) {
      this.spotifyCropModal.classList.remove('is-open');
      this.spotifyCropModal.setAttribute('aria-hidden', 'true');
    }
  }

  confirmSpotifyCrop() {
    if (!this.spotifyCropper) return;
    const cropConfig = this.getCropConfig();
    const canvas = this.spotifyCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this._showUploadError(window.CustomifyPhotoUpload.error('crop_export'), this.originalSpotifyFile, 'crop-export');
        return;
      }
      const croppedFile = new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' });
      this.uploadedFile = croppedFile;
      this.spotifyCropConfirmed = true;
      this.spotifyCropDataUrl = canvas.toDataURL('image/jpeg', 0.9); // Zapisz dla composeSpotifyImage
      this.closeSpotifyCropper();
      this.showPreview(croppedFile);
      this.hideError();
      
      // 🎵 Produkt bez AI - automatycznie aktywuj flow "bez-zmian" po kadrowanie
      if (this.isSpotifyNoAIProduct()) {
        console.log('🎵 [SPOTIFY NO-AI] Automatyczne przejście do koszyka po kadrowanie');
        this.selectedStyle = 'bez-zmian'; // Ustaw styl na "bez-zmian"
        setTimeout(() => this.handleBezZmianStyle(), 100); // Poczekaj na showPreview
      }
    }, 'image/jpeg', 0.9);
  }

  cancelSpotifyCrop() {
    this.uploadedFile = null;
    this.spotifyCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closeSpotifyCropper();
  }

  // 📱 TELEFON - Otwórz cropper
  openPhoneCropper(file) {
    document.querySelectorAll('.photo-crop-error').forEach(notice => notice.remove());
    // Sprawdź elementy w momencie użycia (nie w konstruktorze - mogą nie być w DOM)
    const phoneCropModal = document.getElementById('phoneCropModal');
    const phoneCropImage = document.getElementById('phoneCropImage');
    
    if (!phoneCropModal || !phoneCropImage) {
      console.warn('⚠️ [PHONE] Brak elementów croppera, fallback do normalnego preview');
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }
    
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [PHONE] CropperJS not loaded, fallback to normal preview');
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }

    this.originalPhoneFile = file;
    console.log('📱 [PHONE] Zapisano oryginalne zdjęcie do ponownego kadrowania');

    this.phoneCropConfirmed = false;
    if (this.phoneCropper) {
      this.phoneCropper.destroy();
      this.phoneCropper = null;
    }
    if (this.phoneCropSourceUrl) {
      URL.revokeObjectURL(this.phoneCropSourceUrl);
      this.phoneCropSourceUrl = null;
    }

    this.phoneCropSourceUrl = URL.createObjectURL(file);
    phoneCropImage.onerror = () => this._showUploadError(window.CustomifyPhotoUpload.error('file_decode'), file, 'crop-open');
    phoneCropImage.src = this.phoneCropSourceUrl;
    phoneCropModal.classList.add('is-open');
    phoneCropModal.setAttribute('aria-hidden', 'false');

    const cropConfig = this.getPhoneCropConfig();
    this.phoneCropper = new Cropper(phoneCropImage, {
      aspectRatio: cropConfig.aspectRatio,
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      movable: true,
      zoomable: true,
      zoomOnTouch: true,
      zoomOnWheel: true,
      background: false
    });
  }

  // 📱 TELEFON - Zamknij cropper
  closePhoneCropper() {
    if (this.phoneCropper) {
      this.phoneCropper.destroy();
      this.phoneCropper = null;
    }
    if (this.phoneCropSourceUrl) {
      URL.revokeObjectURL(this.phoneCropSourceUrl);
      this.phoneCropSourceUrl = null;
    }
    const phoneCropModal = document.getElementById('phoneCropModal');
    if (phoneCropModal) {
      phoneCropModal.classList.remove('is-open');
      phoneCropModal.setAttribute('aria-hidden', 'true');
    }
  }

  // 📱 TELEFON - Potwierdź kadrowanie
  confirmPhoneCrop() {
    if (!this.phoneCropper) return;
    const cropConfig = this.getPhoneCropConfig();
    const canvas = this.phoneCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this._showUploadError(window.CustomifyPhotoUpload.error('crop_export'), this.originalPhoneFile, 'crop-export');
        return;
      }
      const croppedFile = new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' });
      this.uploadedFile = croppedFile;
      this.phoneCropConfirmed = true;
      this.phoneCropDataUrl = canvas.toDataURL('image/jpeg', 0.9);
      this.closePhoneCropper();
      this.showPreview(croppedFile);
      this.hideError();
    }, 'image/jpeg', 0.9);
  }

  // 📱 TELEFON - Anuluj kadrowanie
  cancelPhoneCrop() {
    this.uploadedFile = null;
    this.phoneCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closePhoneCropper();
  }

  // 📱 TELEFON - Ponowne otwarcie croppera
  reopenPhoneCropper() {
    if (!this.originalPhoneFile) {
      console.warn('⚠️ [PHONE] Brak oryginalnego zdjęcia do ponownego kadrowania');
      return;
    }
    console.log('📱 [PHONE] Ponowne otwieranie croppera z oryginalnym zdjęciem');
    this.openPhoneCropper(this.originalPhoneFile);
  }
  
  // 📱 TELEFON (ETUI) - Otwórz cropper
  openPhonePhotoCropper(file) {
    document.querySelectorAll('.photo-crop-error').forEach(notice => notice.remove());
    const phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    const phonePhotoCropImage = document.getElementById('phonePhotoCropImage');
    
    if (!phonePhotoCropModal || !phonePhotoCropImage) {
      console.warn('⚠️ [PHONE-PHOTO] Brak elementów croppera, fallback do normalnego preview');
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }
    
    if (typeof Cropper === 'undefined') {
      console.warn('⚠️ [PHONE-PHOTO] CropperJS not loaded, fallback to normal preview');
      this._showUploadError(window.CustomifyPhotoUpload.error('crop_unavailable'), file, 'crop-open');
      return;
    }
    
    this.originalPhonePhotoFile = file;
    console.log('📱 [PHONE-PHOTO] Zapisano oryginalne zdjęcie do ponownego kadrowania');
    
    this.phonePhotoCropConfirmed = false;
    if (this.phonePhotoCropper) {
      this.phonePhotoCropper.destroy();
      this.phonePhotoCropper = null;
    }
    if (this.phonePhotoCropSourceUrl) {
      URL.revokeObjectURL(this.phonePhotoCropSourceUrl);
      this.phonePhotoCropSourceUrl = null;
    }
    
    this.phonePhotoCropSourceUrl = URL.createObjectURL(file);
    
    // Hide watermark overlay initially (will be shown in reopenPhonePhotoCropper if needed)
    const watermarkOverlay = document.getElementById('phonePhotoCropWatermark');
    if (watermarkOverlay) {
      watermarkOverlay.style.display = 'none';
    }
    
    phonePhotoCropModal.classList.add('is-open');
    phonePhotoCropModal.setAttribute('aria-hidden', 'false');
    
    const cropConfig = this.getPhonePhotoCropConfig();
    const initCropper = () => {
      if (this.phonePhotoCropper) return;
      this.phonePhotoCropper = new Cropper(phonePhotoCropImage, {
        aspectRatio: cropConfig.aspectRatio,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        movable: true,
        zoomable: true,
        zoomOnTouch: true,
        zoomOnWheel: false,
        background: false
      });
    };
    phonePhotoCropImage.onload = () => {
      phonePhotoCropImage.onload = null;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          initCropper();
        });
      });
    };
    phonePhotoCropImage.onerror = () => this._showUploadError(window.CustomifyPhotoUpload.error('file_decode'), file, 'crop-open');
    phonePhotoCropImage.src = this.phonePhotoCropSourceUrl;
    
    // Powiększone uchwyty croppera - z-index nad watermark, widoczne
    setTimeout(() => {
      const canvas = phonePhotoCropModal.querySelector('.phone-photo-crop-canvas');
      if (canvas) {
        const style = document.createElement('style');
        style.textContent = '.phone-photo-crop-canvas .cropper-point{width:20px!important;height:20px!important;background:#39f!important;border:2px solid #fff!important;box-shadow:0 0 0 1px rgba(0,0,0,.2)!important;z-index:10!important}.phone-photo-crop-canvas .cropper-line,.phone-photo-crop-canvas .cropper-face{border-color:#39f!important;border-width:2px!important;z-index:5!important}';
        document.head.appendChild(style);
      }
    }, 100);
  }
  
  // 📱 TELEFON (ETUI) - Zamknij cropper
  closePhonePhotoCropper() {
    if (this.phonePhotoCropper) {
      this.phonePhotoCropper.destroy();
      this.phonePhotoCropper = null;
    }
    if (this.phonePhotoCropSourceUrl) {
      URL.revokeObjectURL(this.phonePhotoCropSourceUrl);
      this.phonePhotoCropSourceUrl = null;
    }
    const phonePhotoCropModal = document.getElementById('phonePhotoCropModal');
    if (phonePhotoCropModal) {
      if (document.activeElement && phonePhotoCropModal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      phonePhotoCropModal.classList.remove('is-open');
      phonePhotoCropModal.setAttribute('aria-hidden', 'true');
    }
  }
  
  // 📱 TELEFON (ETUI) - Potwierdź kadrowanie
  confirmPhonePhotoCrop() {
    if (!this.phonePhotoCropper) return;
    const cropConfig = this.getPhonePhotoCropConfig();
    
    const finishWithCropped = (printDataUrl, displayDataUrl) => {
      displayDataUrl = displayDataUrl || printDataUrl;
      this.phonePhotoCropDataUrl = printDataUrl;
      this.closePhonePhotoCropper();
      if (this.transformedImage) {
        const resultBg = document.getElementById('phoneCaseResultBg');
        const photoBg = document.getElementById('phoneCasePhotoBg');
        if (resultBg) resultBg.style.backgroundImage = `url(${displayDataUrl})`;
        if (photoBg) photoBg.style.backgroundImage = `url(${displayDataUrl})`;
        if (this.resultImage) this.resultImage.src = displayDataUrl;
        this.transformedImage = printDataUrl;
        this.textOverlayBaseImage = printDataUrl; // 📱 Napis na wykadrowanym, nie na pełnym
      } else {
        const blob = this.dataUrlToBlob(printDataUrl);
        if (blob) this.showPreview(new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' }));
        else this._showUploadError(window.CustomifyPhotoUpload.error('crop_export'), this.originalPhonePhotoFile, 'crop-export');
      }
      this.phonePhotoCropConfirmed = true;
      const blob = this.dataUrlToBlob(printDataUrl);
      this.uploadedFile = blob ? new File([blob], `${cropConfig.filePrefix}-${Date.now()}.jpg`, { type: 'image/jpeg' }) : null;
      this.hideError();
    };
    
    if (this.phonePhotoCropSourceIsWatermarked && this.transformedImage) {
      const data = this.phonePhotoCropper.getData();
      const displayDataUrl = this.phonePhotoCropper.getCroppedCanvas({ width: cropConfig.width, height: cropConfig.height, imageSmoothingQuality: 'high' }).toDataURL('image/jpeg', 0.9);
      const cleanUrl = this.transformedImage.startsWith('http') ? this.getCanvasSafeImageUrl(this.transformedImage) : this.transformedImage;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const c = document.createElement('canvas');
        c.width = cropConfig.width;
        c.height = cropConfig.height;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, data.x, data.y, data.width, data.height, 0, 0, c.width, c.height);
        finishWithCropped(c.toDataURL('image/jpeg', 0.9), displayDataUrl);
      };
      img.onerror = () => finishWithCropped(displayDataUrl, displayDataUrl);
      img.src = cleanUrl;
      return;
    }
    
    const canvas = this.phonePhotoCropper.getCroppedCanvas({
      width: cropConfig.width,
      height: cropConfig.height,
      imageSmoothingQuality: 'high'
    });
    canvas.toBlob((blob) => {
      if (!blob) {
        this._showUploadError(window.CustomifyPhotoUpload.error('crop_export'), this.originalPhonePhotoFile, 'crop-export');
        return;
      }
      const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
      finishWithCropped(dataUrl);
    }, 'image/jpeg', 0.9);
  }
  
  // 📱 TELEFON (ETUI) - Anuluj kadrowanie
  cancelPhonePhotoCrop() {
    this.uploadedFile = null;
    this.phonePhotoCropConfirmed = false;
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.closePhonePhotoCropper();
  }
  
  // 📱 TELEFON (ETUI) - Ponowne otwarcie croppera
  async reopenPhonePhotoCropper() {
    // 📱 ZAWSZE watermark widoczny: ładujemy obraz Z watermarkem do croppera
    // Przy zapisie: stosujemy ten sam crop do czystego obrazu (dla druku)
    const watermarkedSource = this.watermarkedImageBase64 || this.watermarkedImageUrl;
    
    if (watermarkedSource && this.transformedImage) {
      try {
        let file;
        if (watermarkedSource.startsWith('data:')) {
          file = await this.base64ToFile(watermarkedSource, 'phone-photo-watermarked.jpg');
        } else if (watermarkedSource.startsWith('http') || watermarkedSource.includes('blob.vercel-storage.com')) {
          file = await this.urlToFile(this.getCanvasSafeImageUrl(watermarkedSource), 'phone-photo-watermarked.jpg');
        } else {
          // Backend zwraca raw base64 (bez prefiksu) dla etui
          const dataUrl = `data:image/jpeg;base64,${watermarkedSource}`;
          file = await this.base64ToFile(dataUrl, 'phone-photo-watermarked.jpg');
        }
        this.phonePhotoCropSourceIsWatermarked = true;
        this.openPhonePhotoCropper(file);
      } catch (error) {
        console.error('❌ [PHONE-PHOTO] Błąd ładowania watermarked:', error);
        this._reportToSentry(error, 'phone-photo-load');
        this.showError('Could not load the image for editing. Refresh the page and try again.', 'transform');
      }
    } else if (this.originalPhonePhotoFile) {
      this.phonePhotoCropSourceIsWatermarked = false;
      this.openPhonePhotoCropper(this.originalPhonePhotoFile);
    } else {
      console.warn('⚠️ [PHONE-PHOTO] Brak obrazu do kadrowania');
    }
  }

  trackGoogleAdsPhotoUpload(file) {
    if (this.googleAdsPhotoUploadTracked) return;

    const sendConversion = () => {
      if (this.googleAdsPhotoUploadTracked) return;

      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
      };

      if (!window.__giftedPhotoGoogleAdsTagInitialized) {
        window.__giftedPhotoGoogleAdsTagInitialized = true;
        window.gtag('js', new Date());
        window.gtag('config', GOOGLE_ADS_PHOTO_UPLOAD.tagId, { send_page_view: false });

        if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GOOGLE_ADS_PHOTO_UPLOAD.tagId}"]`)) {
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_PHOTO_UPLOAD.tagId}`;
          document.head.appendChild(script);
        }
      }

      window.gtag('event', 'conversion', {
        send_to: GOOGLE_ADS_PHOTO_UPLOAD.sendTo,
        event_category: 'Customify',
        event_label: 'Image Uploaded',
        product_url: window.location.pathname,
        file_size: file?.size || 0,
        file_type: file?.type || 'image'
      });

      this.googleAdsPhotoUploadTracked = true;
      console.log('[GOOGLE ADS] Photo upload conversion queued:', GOOGLE_ADS_PHOTO_UPLOAD.sendTo);
    };

    const privacy = window.Shopify?.customerPrivacy;
    if (privacy) {
      const analyticsAllowed = typeof privacy.analyticsProcessingAllowed !== 'function' ||
        privacy.analyticsProcessingAllowed();
      const marketingAllowed = typeof privacy.marketingAllowed !== 'function' ||
        privacy.marketingAllowed();

      if (!analyticsAllowed || !marketingAllowed) {
        if (!this.googleAdsConsentListenerBound) {
          this.googleAdsConsentListenerBound = true;
          document.addEventListener('visitorConsentCollected', () => {
            this.googleAdsConsentListenerBound = false;
            this.trackGoogleAdsPhotoUpload(file);
          }, { once: true });
        }
        console.log('[GOOGLE ADS] Photo upload conversion waiting for Shopify consent');
        return;
      }
    } else if (!this.googleAdsPrivacyLoadAttempted && typeof window.Shopify?.loadFeatures === 'function') {
      this.googleAdsPrivacyLoadAttempted = true;
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], (error) => {
        if (error) {
          console.warn('[GOOGLE ADS] Shopify privacy API could not be loaded; using storefront defaults');
          sendConversion();
          return;
        }
        this.trackGoogleAdsPhotoUpload(file);
      });
      return;
    }

    sendConversion();
  }

  async handleFileSelect(file) {
    if (!file) return;
    const version = this._singlePhotoVersion = (this._singlePhotoVersion || 0) + 1;
    this._singlePhotoPending = true;
    this._sentryCrumb('upload', 'Photo selected', { type: file.type, size: file.size });
    try {
      window.CustomifyPhotoUpload.validateFile(file);
      this._uploadFeedback(file);
      this.hideError();
      // Crop products retain their existing output-size policy. Family uploads
      // keep their existing policy; do not introduce a new resolution limit.
      await window.CustomifyPhotoUpload.probe(file, this.isCropperProduct() ? 0 : 300);
      if (version !== this._singlePhotoVersion) return;
      if (this.isCropperProduct()) {
        if (this.isPhoneCaseProduct()) { this.phoneCropConfirmed = false; this.openPhoneCropper(file); }
        else if (this.isPhonePhotoCaseProduct()) {
          this.phonePhotoCropConfirmed = false;
          this.phonePhotoCropSourceIsWatermarked = false;
          this.openPhonePhotoCropper(file);
        } else { this.spotifyCropConfirmed = false; this.openSpotifyCropper(file); }
      } else await this.showPreview(file, version);
    } catch (error) {
      if (version === this._singlePhotoVersion) this._showUploadError(error, file, 'single-open');
    } finally {
      if (version === this._singlePhotoVersion) {
        this._singlePhotoPending = false;
        if (this.fileInput) this.fileInput.value = '';
      }
    }
  }

  trackStatsEvent(eventType) {
    try {
      fetch(window.CustomifyApi.url('/api/admin/login-modal-stats'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventType,
          productUrl: window.location.pathname,
          timestamp: new Date().toISOString()
        })
      }).catch(err => console.log('📊 [STATS] Failed to send event:', err));
    } catch (err) {
      console.log('📊 [STATS] Tracking error:', err);
    }
  }

  async showPreview(file, version) {
    if (version === undefined) version = this._singlePhotoVersion = (this._singlePhotoVersion || 0) + 1;
    this._singlePhotoPending = true;
    try {
      const dimensions = await window.CustomifyPhotoUpload.probe(file, 300);
      const dataUrl = await window.CustomifyPhotoUpload.readDataURL(file);
      if (version !== this._singlePhotoVersion) return;
      this.uploadedFile = file;
      this._uploadFeedback(file);
      this._showResolutionWarning(dimensions);
      this.trackStatsEvent('image_upload');
      this.trackGoogleAdsPhotoUpload(file);
        // Zdjęcie OK - pokaż podgląd
        // 📱 Phone case: use background-image instead of img src
        if (this.isPhonePhotoCaseProduct()) {
          const photoBg = document.getElementById('phoneCasePhotoBg');
          const inner = document.querySelector('#customify-app-container .phone-case-inner');
          if (photoBg) {
            photoBg.style.backgroundImage = `url(${dataUrl})`;
            console.log('[PHONE PREVIEW] set background image', dataUrl.substring(0, 50) + '...');
            if (inner) {
              const innerRect = inner.getBoundingClientRect();
              console.log('[PHONE PREVIEW] inner rect', {
                width: innerRect.width,
                height: innerRect.height,
                aspectRatio: innerRect.width / innerRect.height
              });
            }
          }
          // Keep previewImage hidden but set src for compatibility
          if (this.previewImage) {
            this.previewImage.src = dataUrl;
          }
        } else {
          this.previewImage.src = dataUrl;
        }
        this.previewArea.style.display = 'block';


        // Po reset() actionsArea i stylesArea są ukryte. Odbuduj pełny stan
        // po każdym poprawnym uploadzie, również w sekwencji:
        // Try again -> Upload another photo -> nowy upload.
        this.showStyles();
        const transformBtn = document.getElementById('transformBtn');
        if (transformBtn) {
          transformBtn.style.display = '';
        }
        
        // 🎵 Spotify frame: przelicz skalę po pokazaniu preview (z opóźnieniem na layout)
        setTimeout(() => this.updateSpotifyFrameScale(), 50);
        
        // Ukryj "Dodaj do koszyka" i pokaż "Wgraj inne zdjęcie" po wgraniu zdjęcia
        const addToCartBtnMain = document.getElementById('addToCartBtnMain');
        const resetBtn = document.getElementById('resetBtn');
        if (addToCartBtnMain) {
          addToCartBtnMain.style.display = 'none';
        }
        // 🎵 Dla produktu bez AI nie pokazuj "Wgraj inne zdjęcie" - upload jest zawsze widoczny na górze
        if (resetBtn && !this.isSpotifyNoAIProduct()) {
          resetBtn.style.display = 'inline-block';
        }
    } catch (error) {
      if (version === this._singlePhotoVersion) this._showUploadError(error, file, 'single-preview');
    } finally {
      if (version === this._singlePhotoVersion) this._singlePhotoPending = false;
    }
  }

  showStyles() {
    // 🎵 Dla produktu bez AI nie pokazuj stylów
    if (!this.isSpotifyNoAIProduct()) {
      if (this.applySingleStyleSelection()) {
        console.log('🎨 [SINGLE-STYLE] Hidden selector and applied the only available style:', this.selectedStyle);
      } else if (this.applyDefaultWatercolourStyle()) {
        console.log('🎨 [WATERCOLOR] Applied the product-specific default style');
      } else if (this.isMultiUploadProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'dodaj-osobe';
        console.log('📸 [MULTI-UPLOAD] Ukryto wybór stylu, auto-select dodaj-osobe');
      } else if (this.isDlaNiejProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'caricature-new';
        console.log('💝 [DLA-NIEJ] Ukryto wybór stylu, auto-select caricature-new');
      } else if (this.isSuperheroBoyProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superhero_boy';
        console.log('🦸 [SUPERHERO] Ukryto wybór stylu, auto-select superhero_boy');
      } else if (this.isLoveRoseProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'love-rose';
        console.log('🌹 [LOVE-ROSE] Ukryto wybór stylu, auto-select love-rose');
      } else if (this.isRoyalLoveProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'royal-love';
        console.log('💕 [ROYAL-LOVE] Ukryto wybór stylu, auto-select royal-love');
      } else if (this.isGTAProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'gta';
        console.log('🎮 [GTA] Ukryto wybór stylu, auto-select gta');
      } else if (this.isWatercolorProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'watercolor_ok';
        console.log('🎨 [WATERCOLOR] Ukryto wybór stylu, auto-select watercolor_ok');
      } else if (this.isHipHopProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'hiphop';
        console.log('🎤 [HIP-HOP] Ukryto wybór stylu, auto-select hiphop');
      } else if (this.isRetuszStarychZdjecProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'retusz-starych-zdjec';
        console.log('📷 [RETUSZ] Ukryto wybór stylu, auto-select retusz-starych-zdjec');
      } else if (this.isSzkicOlowekProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'szkic-olowek';
        console.log('✏️ [SZKIC] Ukryto wybór stylu, auto-select szkic-olowek');
      } else {
        this.stylesArea.style.display = 'block';
      }
    }
    this.sizeArea.style.display = 'block'; // Pokaż rozmiary od razu
    
    // 🎵 Dla produktu bez AI ukryj przyciski "Zobacz podgląd" - upload jest zawsze widoczny
    if (this.isSpotifyNoAIProduct()) {
      this.actionsArea.style.display = 'none';
    } else {
      this.actionsArea.style.display = 'flex';
    }
    
    // Pokaż przycisk "Dodaj do koszyka" jeśli użytkownik nie wgrał zdjęcia
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    if (addToCartBtnMain) {
      addToCartBtnMain.style.display = 'inline-block';
    }
    
  }

  selectStyle(styleCard) {
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    styleCard.classList.add('active');
    this.selectedStyle = styleCard.dataset.style;
    this._sentryCrumb('style', 'Wybrano styl: ' + this.selectedStyle);
    
    // ✅ DEBUG: Pokaż który styl został wybrany
    console.log('🎨 [STYLE-SELECT] ===== WYBÓR STYLU =====');
    console.log('🎨 [STYLE-SELECT] Wybrany styl:', this.selectedStyle);
    console.log('🎨 [STYLE-SELECT] data-style attribute:', styleCard.dataset.style);
    console.log('🎨 [STYLE-SELECT] styleCard element:', styleCard);
    console.log('🎨 [STYLE-SELECT] this.selectedStyle type:', typeof this.selectedStyle);
    console.log('🎨 [STYLE-SELECT] =========================');
    
    // Ukryj komunikat błędu po wyborze stylu
    this.hideError();
    
    // 🎵 SPOTIFY: Styl "bez-zmian" - od razu przejdź do koszyka (bez "Zobacz podgląd")
    if (this.selectedStyle === 'bez-zmian' && this.uploadedFile) {
      console.log('🎵 [SPOTIFY] Styl "bez-zmian" - automatyczne przejście do koszyka');
      this.handleBezZmianStyle();
    }
    
    // Rozmiary już są widoczne od razu
  }
  
  // 🎵 SPOTIFY: Obsługa stylu "bez-zmian"
  handleBezZmianStyle() {
    // 🎵 SPOTIFY: Ustaw flagę żeby syncPosition() nie przenosiło elementów z powrotem
    window.spotifyBezZmianActive = true;
    
    // Użyj wykadrowanego zdjęcia jako transformedImage (dla addToCart)
    const reader = new FileReader();
    reader.onload = (e) => {
      this.transformedImage = e.target.result;
      this.originalCroppedImage = e.target.result; // 🎨 Zachowaj oryginał dla filtrów
      this.watermarkedImageUrl = null; // Będzie generowany przy dodaniu do koszyka
      
      // Ukryj sekcje jak po normalnej generacji
      if (this.uploadArea) this.uploadArea.style.display = 'none';
      if (this.stylesArea) this.stylesArea.style.display = 'none';
      
      // Ukryj "Zobacz Preview" i "Wgraj inne" oraz główny przycisk koszyka z actionsArea
      const transformBtn = document.getElementById('transformBtn');
      const resetBtn = document.getElementById('resetBtn');
      const addToCartBtnMain = document.getElementById('addToCartBtnMain');
      if (transformBtn) transformBtn.style.display = 'none';
      if (resetBtn) resetBtn.style.display = 'none';
      if (addToCartBtnMain) addToCartBtnMain.style.display = 'none';
      
      // UKRYJ actionsArea - będziemy używać tylko przycisków z resultArea
      if (this.actionsArea) this.actionsArea.style.display = 'none';
      
      // 🎨 Pokaż panel filtrów dla produktu bez AI
      if (this.isSpotifyNoAIProduct()) {
        const filtersPanel = document.getElementById('spotifyFiltersPanel');
        if (filtersPanel) {
          filtersPanel.style.display = 'block';
          this.initGlfxFilters(); // Inicjalizuj glfx.js
        }
      }
      
      // 🎵 SPOTIFY: Przenieś elementy typu i rozmiaru pod preview (nie na górę strony!)
      const spotifySlot = document.getElementById('spotify-type-size-slot');
      if (spotifySlot && this.productTypeArea && this.sizeArea) {
        spotifySlot.style.display = 'block';
        spotifySlot.appendChild(this.productTypeArea);
        spotifySlot.appendChild(this.sizeArea);
        
        // Przenieś też cenę
        const cartPriceDisplay = document.getElementById('cartPriceDisplay');
        if (cartPriceDisplay) {
          spotifySlot.appendChild(cartPriceDisplay);
          cartPriceDisplay.style.display = 'block';
        }
        
        // Przenieś przyciski koszyka z resultArea
        const addToCartBtn = document.getElementById('addToCartBtn');
        const tryAgainBtn = document.getElementById('tryAgainBtn');
        if (addToCartBtn) {
          // Stwórz kontener na przyciski jeśli nie istnieje
          let btnContainer = document.getElementById('spotify-cart-buttons');
          if (!btnContainer) {
            btnContainer = document.createElement('div');
            btnContainer.id = 'spotify-cart-buttons';
            btnContainer.style.cssText = 'display: flex; gap: 10px; justify-content: center; margin-top: 15px;';
            spotifySlot.appendChild(btnContainer);
          }
          btnContainer.appendChild(addToCartBtn);
          addToCartBtn.style.display = 'inline-block';
          
          // 🎵 Dla produktu bez AI ukryj "Spróbuj ponownie" - upload jest zawsze widoczny na górze
          if (tryAgainBtn && !this.isSpotifyNoAIProduct()) {
            btnContainer.appendChild(tryAgainBtn);
            tryAgainBtn.style.display = 'inline-block';
          } else if (tryAgainBtn) {
            tryAgainBtn.style.display = 'none';
          }
        }
        
        console.log('✅ [SPOTIFY] Przeniesiono elementy typu/rozmiaru/ceny/przycisków pod preview');
      } else {
        console.error('❌ [SPOTIFY] Nie znaleziono spotify-type-size-slot lub elementów do przeniesienia');
        console.log('spotifySlot:', !!spotifySlot, 'productTypeArea:', !!this.productTypeArea, 'sizeArea:', !!this.sizeArea);
      }
      
      // Pokaż rozmiary i typ wydruku
      if (this.sizeArea) this.sizeArea.style.display = 'block';
      if (this.productTypeArea) this.productTypeArea.style.display = 'block';
      
      // Aktualizuj cenę
      this.updateCartPrice();
      
      // Komunikat sukcesu
      this.showSuccess(this.t('customizer.success.project_ready'));
      
      console.log('✅ [SPOTIFY] Styl "bez-zmian" - widok koszyka aktywny');
    };
    reader.readAsDataURL(this.uploadedFile);
  }
  
  // 🎨 GLFX.JS: Ładowanie konfiguracji filtrów z API
  async loadFilterConfig() {
    if (this.filterConfig) {
      return this.filterConfig; // Już załadowane
    }
    
    if (this.filterConfigLoading) {
      // Czekaj na zakończenie ładowania
      return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
          if (this.filterConfig) {
            clearInterval(checkInterval);
            resolve(this.filterConfig);
          }
        }, 100);
      });
    }
    
    this.filterConfigLoading = true;
    
    try {
      const res = await fetch(window.CustomifyApi.url('/api/admin/filter-config'));
      if (res.ok) {
        const config = await res.json();
        this.filterConfig = config;
        console.log('✅ [GLFX] Konfiguracja filtrów załadowana z API');
        return config;
      } else {
        console.warn('⚠️ [GLFX] Błąd ładowania konfiguracji, używam domyślnej');
        return this.getDefaultFilterConfig();
      }
    } catch (err) {
      console.error('❌ [GLFX] Błąd ładowania konfiguracji:', err);
      this._reportToSentry(err, 'glfx-config');
      return this.getDefaultFilterConfig();
    } finally {
      this.filterConfigLoading = false;
    }
  }
  
  // 🎨 Domyślna konfiguracja (fallback)
  getDefaultFilterConfig() {
    return {
      brighten: { brightness: 0.15, contrast: 0.1 },
      vivid: { hue: 0, saturation: 0.2, vibrance: 0.2 },
      sharpen: { radius: 50, strength: 1.5 },
      warm: { hue: 0.05, saturation: 0.1, brightness: 0.05, contrast: 0.05 },
      bw: { saturation: -1, brightness: 0.05, contrast: 0.15 },
      vintage: { sepia: 0.3, vignetteSize: 0.3, vignetteAmount: 0.7, brightness: -0.05, contrast: 0.1 },
      dotScreen: { centerX: 0.5, centerY: 0.5, angle: 0, size: 3 }
    };
  }
  
  // 🎨 GLFX.JS: Inicjalizacja filtrów zdjęć
  async initGlfxFilters() {
    if (this.glfxInitialized) return;
    
    // Sprawdź czy glfx.js jest załadowane
    if (typeof fx === 'undefined') {
      console.warn('⚠️ [GLFX] Biblioteka glfx.js nie jest załadowana');
      return;
    }
    
    console.log('🎨 [GLFX] Inicjalizacja filtrów zdjęć...');
    
    // Załaduj konfigurację z API
    await this.loadFilterConfig();
    
    // Event listeners dla przycisków filtrów
    const filterBtns = document.querySelectorAll('.spotify-filter-btn');
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Remove active ze wszystkich
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        
        const filter = btn.dataset.filter;
        console.log('🎨 [GLFX] Wybrano filtr:', filter);
        this.applyGlfxFilter(filter);
      });
    });
    
    this.glfxInitialized = true;
    console.log('✅ [GLFX] Filtry zainicjalizowane');
  }
  
  // 🎨 GLFX.JS: Aplikuj filtr na zdjęcie
  async applyGlfxFilter(filterName) {
    if (!this.originalCroppedImage) {
      console.warn('⚠️ [GLFX] Brak oryginalnego zdjęcia');
      return;
    }
    
    console.log('🎨 [GLFX] Aplikuję filtr:', filterName);
    
    // Upewnij się że konfiguracja jest załadowana
    if (!this.filterConfig) {
      await this.loadFilterConfig();
    }
    
    // Stwórz tymczasowy obraz z oryginalnego
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        // Stwórz canvas glfx
        const canvas = fx.canvas();
        const texture = canvas.texture(img);
        
        // Aplikuj filtry w zależności od wyboru
        // 🎨 Pobierz konfigurację z API (lub domyślną)
        const cfg = this.filterConfig || this.getDefaultFilterConfig();
        
        canvas.draw(texture);
        
        switch(filterName) {
          case 'none':
            // Bez filtra - oryginał
            break;
          case 'brighten':
            const b = cfg.brighten || { brightness: 0.15, contrast: 0.1 };
            canvas.brightnessContrast(b.brightness, b.contrast);
            break;
          case 'vivid':
            const v = cfg.vivid || { hue: 0, saturation: 0.2, vibrance: 0.2 };
            canvas.hueSaturation(v.hue, v.saturation);
            canvas.vibrance(v.vibrance);
            break;
          case 'sharpen':
            const sh = cfg.sharpen || { radius: 50, strength: 1.5 };
            canvas.unsharpMask(sh.radius, sh.strength);
            break;
          case 'warm':
            const w = cfg.warm || { hue: 0.05, saturation: 0.1, brightness: 0.05, contrast: 0.05 };
            canvas.hueSaturation(w.hue, w.saturation);
            canvas.brightnessContrast(w.brightness, w.contrast);
            break;
          case 'bw':
            const bw = cfg.bw || { saturation: -1, brightness: 0.05, contrast: 0.15 };
            canvas.hueSaturation(0, bw.saturation);
            canvas.brightnessContrast(bw.brightness, bw.contrast);
            break;
          case 'vintage':
            const vt = cfg.vintage || { sepia: 0.3, vignetteSize: 0.3, vignetteAmount: 0.7, brightness: -0.05, contrast: 0.1 };
            canvas.sepia(vt.sepia);
            canvas.vignette(vt.vignetteSize, vt.vignetteAmount);
            canvas.brightnessContrast(vt.brightness, vt.contrast);
            break;
          case 'dotScreen':
            const ds = cfg.dotScreen || { centerX: 0.5, centerY: 0.5, angle: 0, size: 3 };
            canvas.dotScreen(ds.centerX, ds.centerY, ds.angle, ds.size);
            break;
        }
        
        canvas.update();
        
        // Pobierz wynik jako data URL
        const filteredImage = canvas.toDataURL('image/jpeg', 0.92);
        
        // Zaktualizuj transformedImage (dla addToCart)
        this.transformedImage = filteredImage;
        
        // Zaktualizuj podgląd na stronie
        const previewImg = document.querySelector('.spotify-frame-inner img');
        if (previewImg) {
          previewImg.src = filteredImage;
        }
        
        console.log('✅ [GLFX] Filtr zastosowany:', filterName);
        
      } catch (err) {
        console.error('❌ [GLFX] Błąd aplikowania filtra:', err);
        this._reportToSentry(err, 'glfx-apply');
        this.applyCssFilter(filterName);
      }
    };
    
    img.onerror = () => {
      console.error('❌ [GLFX] Nie można załadować obrazu');
    };
    
    img.src = this.originalCroppedImage;
  }
  
  // 🎨 CSS Fallback: Jeśli glfx.js nie działa
  applyCssFilter(filterName) {
    const previewImg = document.querySelector('.spotify-frame-inner img');
    if (!previewImg) return;
    
    let filter = '';
    switch(filterName) {
      case 'none':
        filter = 'none';
        break;
      case 'brighten':
        filter = 'brightness(1.15) contrast(1.1)';
        break;
      case 'vivid':
        filter = 'saturate(1.4)';
        break;
      case 'sharpen':
        filter = 'contrast(1.1)';
        break;
      case 'warm':
        filter = 'sepia(0.2) saturate(1.1)';
        break;
      case 'bw':
        filter = 'grayscale(1) contrast(1.15)';
        break;
      case 'vintage':
        filter = 'sepia(0.4) contrast(1.1)';
        break;
      case 'dotScreen':
        filter = 'contrast(1.2)'; // Prosty fallback dla halftone
        break;
    }
    
    previewImg.style.filter = filter;
    console.log('🎨 [CSS] Fallback filtr:', filterName, filter);
  }

  selectSize(sizeBtn) {
    if (sizeBtn.classList.contains('disabled')) {
      console.log('⚠️ [SIZE] Attempted to select disabled size:', sizeBtn.dataset.size);
      return;
    }
    
    // 🚨 WALIDACJA: Dla szkła tylko A5 i A4 są dozwolone
    const size = sizeBtn.dataset.size;
    if (this.selectedProductType === 'szklo') {
      const allowedSizes = ['a5', 'a4'];
      if (!allowedSizes.includes(size.toLowerCase())) {
        console.error('❌ [SIZE] Invalid size for szklo:', size);
        this.showError('This product type is not available. Choose canvas, poster, or digital.', 'size');
        return;
      }
    }
    
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    sizeBtn.classList.add('active');
    this.selectedSize = sizeBtn.dataset.size;
    this._sentryCrumb('size', 'Wybrano rozmiar: ' + this.selectedSize);
    console.log('📏 [SIZE] Selected size:', this.selectedSize);
    
    // Ukryj błąd jeśli rozmiar jest poprawny
    this.hideError();
    
    // Aktualizuj cenę po wyborze rozmiaru
    this.updateProductPrice();
    this.updateCartPrice(); // ✅ Dodaj aktualizację ceny nad przyciskiem
    this.syncActiveSizeButton();
  }

  selectProductType(typeBtn) {
    this.productTypeArea.querySelectorAll('.customify-product-type-btn').forEach(btn => btn.classList.remove('active'));
    typeBtn.classList.add('active');
    this.selectedProductType = typeBtn.dataset.productType;
    console.log('🎨 [PRODUCT-TYPE] Selected product type:', this.selectedProductType);

    // Aktualizuj ceny po zmianie typu (ramka dostępna dla posteru i canvasu)
    const sizeAdjusted = this.updateSizeAvailability();
    this.updateProductPrice();
    this.updateCartPrice();
    if (sizeAdjusted) {
      console.log('📏 [SIZE] Adjusted selection after product type change:', this.selectedSize || 'none');
    }
    console.log('🖼️ [FRAME] Type changed -> recalculated price with frame:', {
      selectedProductType: this.selectedProductType,
      frame: window.CustomifyFrame?.color || 'none'
    });
  }

  /**
   * Aktualizuje dostępność poszczególnych rozmiarów w zależności od typu produktu
   * Dla szkła: tylko A5 i A4 widoczne. Dla plakatów: A4, A3, A2, A1.
   * Dla canvas/digital: A4, A3, A2, A0, A1.
   * Zwraca true, jeśli wybrany rozmiar został zmieniony
   */
  updateSizeAvailability() {
    if (!this.sizeArea) {
      return false;
    }

    this.applyMarketSizeLabels();

    const sizeButtons = Array.from(this.sizeArea.querySelectorAll('.customify-size-btn'));
    const szkloSizes = ['a5', 'a4'];
    const posterSizes = ['a4', 'a3', 'a2', 'a1'];
    const standardSizes = ['a4', 'a3', 'a2', 'a0', 'a1'];

    if (this.selectedProductType === 'szklo') {
      sizeButtons.forEach(btn => {
        const size = btn.dataset.size?.toLowerCase();
        const isForSzklo = szkloSizes.includes(size);
        btn.style.display = isForSzklo ? '' : 'none';
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
      });
    } else {
      const visibleSizesForType = this.selectedProductType === 'plakat' ? posterSizes : standardSizes;
      sizeButtons.forEach(btn => {
        const size = btn.dataset.size?.toLowerCase();
        const isSupported = visibleSizesForType.includes(size);
        btn.style.display = isSupported ? '' : 'none';
        btn.classList.remove('disabled');
        btn.removeAttribute('aria-disabled');
      });
    }

    const visibleSizes = this.selectedProductType === 'szklo'
      ? szkloSizes
      : (this.selectedProductType === 'plakat' ? posterSizes : standardSizes);
    let selectionChanged = false;
    if (!visibleSizes.includes(this.selectedSize?.toLowerCase())) {
      const fallback = visibleSizes[0];
      this.selectedSize = fallback;
      selectionChanged = true;
    }

    this.syncActiveSizeButton();
    return selectionChanged;
  }

  /**
   * Synchronizuje klasę .active przycisków rozmiarów z aktualnie wybranym rozmiarem
   */
  syncActiveSizeButton() {
    if (!this.sizeArea) {
      return;
    }

    this.applyMarketSizeLabels();

    const sizeButtons = this.sizeArea.querySelectorAll('.customify-size-btn');
    sizeButtons.forEach(btn => {
      if (btn.classList.contains('disabled')) {
        btn.classList.remove('active');
        return;
      }
      const shouldBeActive = this.selectedSize && btn.dataset.size === this.selectedSize;
      btn.classList.toggle('active', !!shouldBeActive);
    });
  }

  /**
   * Aktualizuje cenę nad przyciskiem "Dodaj do koszyka"
   */
  updateCartPrice() {
    try {
      // Sprawdź czy mamy wybrany rozmiar
      if (!this.selectedSize) {
        console.log('🔍 [CART-PRICE] No selectedSize, hiding cart price');
        this.hideCartPrice();
        return;
      }

      // Pobierz oryginalną bazową cenę
      if (!this.originalBasePrice) {
        this.originalBasePrice = this.getDefaultBasePrice();
        console.log(`💰 [CART-PRICE] Using fallback base price: ${this.formatMoney ? this.formatMoney(this.originalBasePrice) : this.originalBasePrice}`);
      }

      // Pobierz cenę rozmiaru
      const sizePrice = this.getSizePrice(this.selectedSize);
      
      // Dopłata za ramkę dla posteru lub canvasu.
      const frameSelected = this.isFramePricingSupported(this.selectedProductType) && (window.CustomifyFrame && window.CustomifyFrame.color && window.CustomifyFrame.color !== 'none');
      const frameSurcharge = frameSelected ? this.getFrameSurcharge(this.selectedSize, this.selectedProductType) : 0;
      
      // Oblicz końcową cenę (bazowa + rozmiar + ramka)
      const finalPrice = this.originalBasePrice + sizePrice + frameSurcharge;

      // Price calculation completed

        // Znajdź element ceny w koszyku
        const cartPriceElement = document.getElementById('cartPriceValue');

        if (cartPriceElement) {
          cartPriceElement.textContent = this.formatMoney(finalPrice);
          console.log('✅ [CART-PRICE] Cart price updated:', this.formatMoney(finalPrice));
          console.log('🖼️ [FRAME] Cart price components:', {
            base: this.originalBasePrice,
            sizePrice,
            frameSelected,
            frame: window.CustomifyFrame?.color || 'none',
            frameSurcharge
          });

          // 📱 Phone case: Also update phone case specific price display (ONLY after AI generation)
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            // Phone case has its own price display - don't show main cart price
            // (phone case price is shown/hidden separately in phoneCaseCartPriceDisplay)
          } else {
            // Pokaż element ceny (tylko dla innych produktów, nie phone case)
            this.showCartPrice();
          }
          
          // 📱 Phone case: Update phone case specific price display (ONLY after AI generation)
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            const phoneCaseCartPriceValue = document.getElementById('phoneCaseCartPriceValue');
            if (phoneCaseCartPriceValue) {
              phoneCaseCartPriceValue.textContent = this.formatMoney(finalPrice);
              console.log('📱 [PHONE PREVIEW] Phone case cart price updated:', this.formatMoney(finalPrice));
            }
            // Show price and buttons ONLY if image is generated (after AI)
            const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
            const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
            if (this.transformedImage) {
              if (phoneCaseCartPriceDisplay) {
                phoneCaseCartPriceDisplay.style.display = 'block';
                console.log('📱 [PHONE PREVIEW] Cart price shown (after AI generation)');
              }
              if (phoneCaseCartActions) {
                phoneCaseCartActions.style.display = 'flex';
                console.log('📱 [PHONE PREVIEW] Cart actions shown (after AI generation)');
              }
            } else {
              if (phoneCaseCartPriceDisplay) phoneCaseCartPriceDisplay.style.display = 'none';
              if (phoneCaseCartActions) phoneCaseCartActions.style.display = 'none';
            }
          }
        } else {
          console.warn('⚠️ [CART-PRICE] Cart price element not found');
        }
    } catch (error) {
      console.error('❌ [CART-PRICE] Error updating cart price:', error);
      this._reportToSentry(error, 'cart-price');
    }
  }

  /**
   * Pokazuje element ceny nad przyciskiem
   */
  showCartPrice() {
    // Etui używa tego samego cartPriceDisplay (w resultArea) jak inne produkty
    const cartPriceDisplay = document.getElementById('cartPriceDisplay');
    if (cartPriceDisplay) {
      cartPriceDisplay.style.display = 'block';
      console.log('✅ [CART-PRICE] Cart price displayed');
    }
  }

  /**
   * Ukrywa element ceny nad przyciskiem
   */
  hideCartPrice() {
    const cartPriceDisplay = document.getElementById('cartPriceDisplay');
    if (cartPriceDisplay) {
      cartPriceDisplay.style.display = 'none';
      console.log('✅ [CART-PRICE] Cart price hidden');
    }
  }

  /**
   * Ustawia początkową cenę bazową (bez rozmiaru) przy starcie aplikacji
   */
  setInitialPrice() {
    try {
      const priceElement = this.getPriceElement();
      if (!priceElement) {
        console.warn('⚠️ [INIT-PRICE] Price element not found');
        return;
      }

      // Pobierz oryginalną bazową cenę (zapamiętaj przy pierwszym wywołaniu)
      if (!this.originalBasePrice) {
        // ✅ Użyj window.ShopifyProduct (niezmienione źródło) zamiast DOM
        this.originalBasePrice = this.getBasePriceFromShopify();
        
        if (this.originalBasePrice === null) {
          // Fallback: spróbuj z DOM jeśli window.ShopifyProduct nie dostępne
          const basePriceText = priceElement.textContent;
          this.originalBasePrice = this.extractBasePrice(basePriceText);
          
          if (this.originalBasePrice === null) {
            console.warn('⚠️ [INIT-PRICE] Could not get base price from Shopify or DOM, using fallback');
            this.originalBasePrice = this.getDefaultBasePrice();
            console.log(`💰 [INIT-PRICE] Using fallback base price: ${this.formatMoney(this.originalBasePrice)}`);
          } else {
            console.log(`💰 [INIT-PRICE] Base price from DOM (fallback): ${this.formatMoney(this.originalBasePrice)}`);
          }
        } else {
          console.log(`💰 [INIT-PRICE] Original base price saved: ${this.formatMoney(this.originalBasePrice)}`);
        }
      }

      // Ustaw TYLKO cenę bazową (bez rozmiaru)
      this.applyProductPriceDisplay(this.originalBasePrice);
      console.log(`💰 [INIT-PRICE] Set initial base price: ${this.formatMoney(this.originalBasePrice)}`);
      
    } catch (error) {
      console.error('❌ [INIT-PRICE] Error setting initial price:', error);
      this._reportToSentry(error, 'init-price');
    }
  }

  /**
   * Aktualizuje cenę na stronie produktu po wyborze rozmiaru
   */
  updateProductPrice() {
    try {
      const priceElement = this.getPriceElement();
      if (!priceElement) {
        console.warn('⚠️ [PRICE] Price element not found with any selector');
        return;
      }

      console.log('✅ [PRICE] Found price element:', priceElement, 'Text:', priceElement.textContent);

      // Pobierz oryginalną bazową cenę (zapamiętaj przy pierwszym wywołaniu)
      if (!this.originalBasePrice) {
        // ✅ Użyj window.ShopifyProduct (niezmienione źródło) zamiast DOM
        this.originalBasePrice = this.getBasePriceFromShopify();
        
        if (this.originalBasePrice === null) {
          // Fallback: spróbuj z DOM jeśli window.ShopifyProduct nie dostępne
          const basePriceText = priceElement.textContent;
          this.originalBasePrice = this.extractBasePrice(basePriceText);
          
          if (this.originalBasePrice === null) {
            console.warn('⚠️ [PRICE] Could not get base price from Shopify or DOM, using fallback');
            // Fallback - użyj domyślnej ceny
            this.originalBasePrice = this.getDefaultBasePrice();
            console.log(`💰 [PRICE] Using fallback base price: ${this.formatMoney(this.originalBasePrice)}`);
          } else {
            console.log(`💰 [PRICE] Base price from DOM (fallback): ${this.formatMoney(this.originalBasePrice)}`);
          }
        } else {
          console.log(`💰 [PRICE] Original base price saved: ${this.formatMoney(this.originalBasePrice)}`);
        }
      }

      // Pobierz cenę rozmiaru
      const sizePrice = this.getSizePrice(this.selectedSize);
      
      // Dopłata za ramkę dla posteru lub canvasu.
      const frameSelected = this.isFramePricingSupported(this.selectedProductType) && (window.CustomifyFrame && window.CustomifyFrame.color && window.CustomifyFrame.color !== 'none');
      const frameSurcharge = frameSelected ? this.getFrameSurcharge(this.selectedSize, this.selectedProductType) : 0;
      
      // Oblicz końcową cenę (oryginalna cena + rozmiar + ramka)
      const finalPrice = this.originalBasePrice + sizePrice + frameSurcharge;
      
      // Aktualizuj cenę na stronie
      this.applyProductPriceDisplay(finalPrice);
      this.schedulePriceConsistency(finalPrice);
      
      console.log(`💰 [PRICE] Updated: base ${this.formatMoney(this.originalBasePrice)} + size ${this.formatMoney(sizePrice)} + frame ${this.formatMoney(frameSurcharge)} = ${this.formatMoney(finalPrice)}`);
      console.log('🖼️ [FRAME] Product price components:', {
        base: this.originalBasePrice,
        sizePrice,
        frameSelected,
        frame: window.CustomifyFrame?.color || 'none',
        frameSurcharge,
        finalPrice
      });
      
    } catch (error) {
      console.error('❌ [PRICE] Error updating product price:', error);
      this._reportToSentry(error, 'update-price');
    }
  }

  /**
   * Kanoniczna cena bazowa aplikacji w walucie sklepu (USD).
   * Poster zaczyna się od $49, a canvas dodaje własną dopłatę w sizePricing.
   */
  getCanonicalBaseShopAmount() {
    return ['plakat', 'canvas', 'digital'].includes(this.selectedProductType || 'plakat') ? 49 : null;
  }

  isGermanyPricingContext() {
    const context = window.CustomifyMarketContext || window.CustomifyI18n || {};
    return String(context.country || '').toUpperCase() === 'DE'
      && String(context.currency || '').toUpperCase() === 'EUR';
  }

  isUkPricingContext() {
    const context = window.CustomifyMarketContext || window.CustomifyI18n || {};
    return String(context.country || '').toUpperCase() === 'GB'
      && String(context.currency || '').toUpperCase() === 'GBP';
  }

  isFixedPrintPricingMarket() {
    return (this.isGermanyPricingContext() || this.isUkPricingContext())
      && ['plakat', 'canvas'].includes(this.selectedProductType || 'plakat');
  }

  isGermanyPricingMarket() {
    return this.isGermanyPricingContext()
      && ['plakat', 'canvas'].includes(this.selectedProductType || 'plakat');
  }

  getDefaultBasePrice() {
    return this.isFixedPrintPricingMarket() ? 29 : 49;
  }

  isFramePricingSupported(productType = null) {
    const type = productType || this.selectedProductType;
    return this.isGermanyPricingContext()
      ? ['plakat', 'canvas'].includes(type)
      : ['plakat', 'canvas'].includes(type);
  }

  /**
   * Pobiera bazową cenę produktu z window.ShopifyProduct i normalizuje ją
   * z waluty prezentacyjnej Shopify Markets do waluty sklepu.
   */
  getBasePriceFromShopify() {
    if (window.ShopifyProduct && window.ShopifyProduct.variants && window.ShopifyProduct.variants.length > 0) {
      // Shopify variant price is stored in minor units (cents/pence/etc.).
      const priceInMinorUnits = parseFloat(window.ShopifyProduct.variants[0].price);
      const presentmentPrice = priceInMinorUnits / 100;
      const canonicalBase = this.getCanonicalBaseShopAmount();
      const nativePriceElement = this.getPriceElement();
      if (window.CustomifyMoney && nativePriceElement) {
        window.CustomifyMoney.observePresentmentPrice(nativePriceElement.textContent, presentmentPrice);
      }
      // Use the authoritative USA print base while catalog cards are being updated.
      // The checkout table uses the same base, so a stale product card cannot
      // show a different amount from the price that will be charged.
      const pricingContext = window.CustomifyMarketContext || window.CustomifyI18n || {};
      if (String(pricingContext.country || '').toUpperCase() === 'US'
          && String(pricingContext.currency || '').toUpperCase() === 'USD'
          && ['plakat', 'canvas'].includes(this.selectedProductType || 'plakat')) {
        return canonicalBase;
      }
      if (this.isFixedPrintPricingMarket()) {
        console.log('💰 [BASE-PRICE] Fixed market base price:', {
          priceInMinorUnits,
          presentmentPrice,
          nativePriceText: nativePriceElement ? nativePriceElement.textContent : null
        });
        return presentmentPrice;
      }
      const shopPrice = window.CustomifyMoney
        ? window.CustomifyMoney.toShopAmount(presentmentPrice, { baseShopAmount: canonicalBase })
        : presentmentPrice;
      console.log('💰 [BASE-PRICE] Shopify base price normalized to shop currency:', {
        priceInMinorUnits,
        presentmentPrice,
        nativePriceText: nativePriceElement ? nativePriceElement.textContent : null,
        shopPrice,
        canonicalBase,
        moneyContext: window.CustomifyMoney ? window.CustomifyMoney.diagnostics({ baseShopAmount: canonicalBase }) : null
      });
      return shopPrice;
    }
    console.warn('⚠️ [BASE-PRICE] window.ShopifyProduct.variants nie dostępne, używam fallback');
    return null;
  }

  /**
   * Wyciąga bazową cenę z tekstu ceny (stara metoda - tylko jako fallback)
   */
  extractBasePrice(priceText) {
    const normalized = String(priceText || '').replace(/\s/g, '');
    const match = normalized.match(/(\d+(?:[,.]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : null;
  }

  getActiveCurrency() {
    return window.CustomifyMoney
      ? window.CustomifyMoney.getDisplayCurrency()
      : ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD');
  }

  formatMoney(value) {
    if (window.CustomifyMoney) {
      if (this.isFixedPrintPricingMarket()) {
        return window.CustomifyMoney.formatPresentmentAmount(value);
      }
      return window.CustomifyMoney.formatShopAmount(value, {
        baseShopAmount: this.getCanonicalBaseShopAmount()
      });
    }
    const amount = Number(value) || 0;
    return `$${amount.toFixed(2)}`;
  }

  /**
   * Zwraca cenę dla wybranego rozmiaru
   */
  getSizePrice(size, productType = null) {
    const type = productType || this.selectedProductType || 'canvas';
    if (this.isUkPricingContext() && this.ukSizePricing[type]) {
      return this.ukSizePricing[type][size] ?? 0;
    }
    if (this.isGermanyPricingContext() && this.germanySizePricing[type]) {
      return this.germanySizePricing[type][size] ?? 0;
    }
    const table = this.sizePricing[type] || this.sizePricing.canvas;
    return table[size] ?? 0;
  }

  getFrameSurcharge(size, productType = null) {
    const type = productType || this.selectedProductType;
    if (this.isUkPricingContext()) return this.ukFramePricing[type]?.[size] ?? 0;
    if (this.isGermanyPricingContext()) {
      if (type === 'plakat') {
        const framedTotalSurcharge = this.germanyFramedPosterPricing[size];
        const unframedSurcharge = this.germanySizePricing.plakat[size];
        return Number.isFinite(framedTotalSurcharge) && Number.isFinite(unframedSurcharge)
          ? framedTotalSurcharge - unframedSurcharge
          : 0;
      }
      if (type === 'canvas') {
        return this.germanyCanvasFramePricing[size] ?? 0;
      }
      return 0;
    }
    const table = this.framePricing[type];
    return table?.[size] ?? 0;
  }

  /**
   * Zwraca wymiar dla wybranego rozmiaru (e.g. "20×30 cm")
   */
  getSizeUnit() {
    if (String(window.CustomifyMarketContext?.country || '').toUpperCase() === 'GB') return 'cm';
    const configuredUnit = String(window.CustomifyMarketContext?.sizeUnit || '').toLowerCase();
    if (configuredUnit === 'cm' || configuredUnit === 'in') {
      return configuredUnit;
    }
    return String(window.CustomifyMarketContext?.country || '').toUpperCase() === 'DE' ? 'cm' : 'in';
  }

  getSizeDimension(size) {
    const dimensionsByUnit = {
      in: {
        a5: '6×8 in',
        a4: '8×12 in',
        a3: '12×18 in',
        a2: '16×24 in',
        a0: '20×30 in',
        a1: '24×36 in'
      },
      cm: {
        a5: '15×20 cm',
        a4: '20×30 cm',
        a3: '30×45 cm',
        a2: '40×60 cm',
        a0: '50×75 cm',
        a1: '60×90 cm'
      }
    };
    if (size === 'etui') return 'Etui na telefon';
    return dimensionsByUnit[this.getSizeUnit()][String(size || '').toLowerCase()] || size;
  }

  applyMarketSizeLabels() {
    if (!this.sizeArea) {
      return;
    }

    const unit = this.getSizeUnit();
    if (this.isUkPricingContext()) {
      document.querySelectorAll('[data-customify-i18n="customizer.sizes.description_imperial"]').forEach((description) => {
        description.dataset.customifyI18n = 'customizer.sizes.description_metric';
        description.textContent = this.t('customizer.sizes.description_metric');
      });
    }
    const heading = this.sizeArea.querySelector('h4');
    if (heading) {
      const headingKey = unit === 'cm' ? 'customizer.size.metric' : 'customizer.size.imperial';
      heading.dataset.customifyI18n = headingKey;
      heading.textContent = this.t(headingKey);
    }

    const labelsByUnit = {
      in: {
        a5: '6×8″',
        a4: '8×12″',
        a3: '12×18″',
        a2: '16×24″',
        a0: '20×30″',
        a1: '24×36″'
      },
      cm: {
        a5: '15×20 cm',
        a4: '20×30 cm',
        a3: '30×45 cm',
        a2: '40×60 cm',
        a0: '50×75 cm',
        a1: '60×90 cm'
      }
    };
    const labels = labelsByUnit[unit];

    this.sizeArea.querySelectorAll('.customify-size-btn[data-size]').forEach(btn => {
      const size = btn.dataset.size?.toLowerCase();
      if (labels[size]) {
        btn.textContent = labels[size];
      }
    });
  }

  /**
   * Zwraca element ceny produktu
   */
  getPriceElement() {
    const productInformation = document.querySelector('[id^="ProductInformation-"]');
    const nativeProductPrice = productInformation?.querySelector('product-price')
      || document.querySelector('main product-price');

    if (!nativeProductPrice) {
      return null;
    }

    // Reuse the same marked node after the first update. Searching globally for
    // `.price` can select recommendation-card prices instead of the main product.
    const priceElement = nativeProductPrice.querySelector('[data-customify-price]')
      || nativeProductPrice.querySelector(':scope > div, :scope > span')
      || nativeProductPrice.querySelector('div, span')
      || nativeProductPrice;
    console.log('🔍 [PRICE] Using main ProductInformation product-price');
    return priceElement;
  }

  /**
   * Ustawia cenę produktu w DOM
   */
  applyProductPriceDisplay(value) {
    const priceElement = this.getPriceElement();
    if (!priceElement) {
      console.warn('⚠️ [PRICE] Price element not found when applying display');
      return;
    }
    const formatted = this.formatMoney(value);
    priceElement.textContent = formatted;
    priceElement.setAttribute('data-customify-price', formatted);
  }

  /**
   * Dodatkowe zabezpieczenie przed nadpisaniem ceny przez motyw
   */
  schedulePriceConsistency(finalPrice) {
    if (this.priceConsistencyTimers) {
      this.priceConsistencyTimers.forEach(timer => clearTimeout(timer));
    }

    const delays = [50, 250, 500, 1000, 2000];
    this.priceConsistencyTimers = delays.map(delay => setTimeout(() => {
      try {
        const priceElement = this.getPriceElement();
        if (!priceElement) {
          return;
        }
        const formatted = this.formatMoney(finalPrice);
        const displayed = String(priceElement.textContent || '').trim();
        if (displayed !== formatted) {
          console.log('♻️ [PRICE] Reapplying price after external update:', {
            displayed,
            formatted,
            delay
          });
          priceElement.textContent = formatted;
          priceElement.setAttribute('data-customify-price', formatted);
        }
      } catch (error) {
        console.warn('⚠️ [PRICE] Error in price consistency timer:', error);
      }
    }, delay));
  }

  /**
   * Inicjalizuje domyślny rozmiar i cenę przy starcie aplikacji
   */
  initializeDefaultPrice() {
    try {
      // Znajdź pierwszy dostępny rozmiar (domyślnie A4)
      const defaultSizeBtn = this.sizeArea?.querySelector('[data-size="a4"]') || 
                            this.sizeArea?.querySelector('.customify-size-btn');
      
      if (defaultSizeBtn) {
        // Ustaw domyślny rozmiar (bez podświetlania)
        this.selectedSize = defaultSizeBtn.dataset.size;
        // defaultSizeBtn.classList.add('active'); // USUNIĘTO - żaden rozmiar nie jest podświetlony domyślnie
        
        console.log('💰 [INIT] Default size selected (no highlight):', this.selectedSize);
        
        // Ustaw początkową cenę bazową (bez rozmiaru)
        this.setInitialPrice();
        this.updateCartPrice(); // ✅ Dodaj aktualizację ceny nad przyciskiem
      } else {
        console.warn('⚠️ [INIT] No size buttons found for default price');
      }
    } catch (error) {
      console.error('❌ [INIT] Error initializing default price:', error);
      this._reportToSentry(error, 'init-default-price');
    }
  }




  async transformImage(retryCount = 0) {
    this._sentryCrumb('transform', 'Start transformImage', { style: this.selectedStyle, retry: retryCount });
    console.log(`🔍🔍🔍 [TRANSFORM] START transformImage:`, {
      selectedStyle: this.selectedStyle,
      selectedStyleType: typeof this.selectedStyle,
      productType: this.selectedStyle ? this.getProductTypeFromStyle(this.selectedStyle) : 'BRAK STYLU',
      uploadedFile: !!this.uploadedFile,
      uploadedFileName: this.uploadedFile?.name
    });
    
    if (this._singlePhotoPending || this._photoUploadPendingTokens?.size) {
      this.showError(window.CustomifyPhotoUpload.text('still_loading'), 'transform');
      return;
    }

    if (this.usesFamilyPhotoCrop() && this._familyHasPendingCrops()) {
      this.showError('Finish or cancel the open photo crop before creating your portrait.', 'transform');
      return;
    }

    if (this.isMultiUploadProduct()) {
      const orderedMultiFiles = this.getMultiUploadFiles();
      if (this.isTogetherCoupleProduct() && (orderedMultiFiles.length < 2 || orderedMultiFiles.length > 8)) {
        this.showError('Upload at least two clear photos to create your portrait.', 'transform');
        return;
      }
      if (this.isTogetherCoupleProduct()) this.uploadedFile = orderedMultiFiles[0];
      if (orderedMultiFiles.length === 0) {
        this.showError('Upload at least one photo', 'transform');
        return;
      }
      if (!this.uploadedFile) this.uploadedFile = orderedMultiFiles[0];
    } else if (!this.uploadedFile || !this.selectedStyle) {
      console.error(`❌ [TRANSFORM] Brak wymaganych danych:`, {
        uploadedFile: !!this.uploadedFile,
        selectedStyle: this.selectedStyle
      });
      this.showError(this.t('customizer.error.upload_photo_style'), 'transform');
      return;
    }

    // Dla spotify: sprawdź czy zdjęcie zostało wykadrowane
    // - spotifyCropConfirmed = true (świeżo wykadrowane)
    // - lub uploadedFile.name zaczyna się od 'spotify-crop-' (już wykadrowane, po "spróbuj ponownie")
    const isSpotifyCropped = this.spotifyCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('spotify-crop-'));
    
    if (this.isSpotifyProduct() && !isSpotifyCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }

    // 📱 Dla telefonu: sprawdź czy zdjęcie zostało wykadrowane
    const isPhoneCropped = this.phoneCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-crop-'));
    
    if (this.isPhoneCaseProduct() && !isPhoneCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }
    
    // 📱 Dla etui (zdjęcie): sprawdź czy zdjęcie zostało wykadrowane
    const isPhonePhotoCropped = this.phonePhotoCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-photo-crop-'));
    
    if (this.isPhonePhotoCaseProduct() && !isPhonePhotoCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }

      // 🎛️ CUSTOM FIELDS: Validate required personalization fields. Prompt is built on backend.
      try {
        this.collectCustomFieldsPrompt();
      } catch (fieldError) {
        this._reportToSentry(fieldError, 'collectCustomFieldsPrompt');
        this.showError(fieldError.message, 'transform');
        this.hideLoading();
        return;
      }

      let spotifyPayload = null;
      if (!window.CustomifyHideGlassPrint && this.isSpotifyProduct()) {
        const spotifyTitle = (this.spotifyTitleInput?.value || '').trim().slice(0, 60);
        const spotifyArtist = (this.spotifyArtistInput?.value || '').trim().slice(0, 60);
        spotifyPayload = { title: spotifyTitle, artist: spotifyArtist };
      }

    // 🎵 SPOTIFY: Styl "bez-zmian" - pomijamy AI, pokazujemy widok jak po generacji
    if (this.selectedStyle === 'bez-zmian') {
      console.log('🎵 [SPOTIFY] Styl "bez-zmian" - pomijamy transformację AI');
      this.showLoading();
      
      // Użyj wykadrowanego zdjęcia jako transformedImage (dla addToCart)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.transformedImage = e.target.result;
        this.watermarkedImageUrl = null; // Będzie generowany przy dodaniu do koszyka
        
        // Ukryj sekcje jak po normalnej generacji
        if (this.uploadArea) this.uploadArea.style.display = 'none';
        if (this.stylesArea) this.stylesArea.style.display = 'none';
        if (this.actionsArea) this.actionsArea.style.display = 'none';
        
        // Pokaż przyciski koszyka
        if (this.cartActionsArea) this.cartActionsArea.style.display = 'flex';
        
        // Pokaż rozmiary i typ wydruku
        if (this.sizeArea) this.sizeArea.style.display = 'block';
        if (this.productTypeArea) this.productTypeArea.style.display = 'block';
        
        // Preview z maską pozostaje widoczny (nie zmieniamy na resultArea)
        // Komunikat sukcesu
        this.showSuccess(this.t('customizer.success.project_ready'));
        this.hideLoading();
        
        console.log('✅ [SPOTIFY] Styl "bez-zmian" - widok jak po generacji, gotowe do koszyka');
      };
      reader.readAsDataURL(this.uploadedFile);
      return;
    }

    // ✅ DEBUG: Sprawdź selectedStyle przed checkUsageLimit
    console.log(`🔍 [TRANSFORM] Przed checkUsageLimit:`, {
      selectedStyle: this.selectedStyle,
      productType: this.getProductTypeFromStyle(this.selectedStyle),
      uploadedFile: !!this.uploadedFile
    });

    // ✅ USAGE LIMITS: Sprawdź limit PRZED transformacją (ZAWSZE, nawet przy retry)
      const canTransform = await this.checkUsageLimit();
      if (!canTransform) {
        console.log('❌ [USAGE] Limit przekroczony - przerwano transformację');
        return;
    }

    let guestEmailAdmission = { proceed: true };
    if (window.CustomifyGuestEmail) {
      guestEmailAdmission = await window.CustomifyGuestEmail.beforeGenerate();
      if (!guestEmailAdmission.proceed) {
        if (guestEmailAdmission.error) this.showError(guestEmailAdmission.error, 'transform');
        return;
      }
    } else {
      this.showError('Please refresh the page and try again.', 'transform');
      return;
    }

    // ✅ Google Analytics Event Tracking - "Zobacz Preview" kliknięty
    if (retryCount === 0 && typeof gtag !== 'undefined') {
      gtag('event', 'zobacz_podglad_click', {
        'event_category': 'Customify',
        'event_label': this.selectedStyle,
        'style_name': this.selectedStyle,
        'product_url': window.location.pathname
      });
      console.log('📊 [GA4] Event sent: zobacz_podglad_click', {
        style: this.selectedStyle,
        url: window.location.pathname
      });
    }

    this.showLoading();
    this.hideError();
    
    if (retryCount > 0) {
      console.log(`🔄 [MOBILE] Retry attempt ${retryCount}/3`);
    }

    try {
      if (this.usesFamilyPhotoCrop()) {
        if (!window.FamilyInlineCrop || typeof window.FamilyInlineCrop.buildEntries !== 'function') throw new Error('The inline crop tool is still loading. Please wait a moment and try again.');
        const entries = window.FamilyInlineCrop.buildEntries(this.multiUploadFiles, this.multiUploadCaptions, this.multiUploadFiles.length).map(entry => ({
          ...entry,
          cropper: this.familyCropperBySlot?.[entry.slot],
          version: this._familyUploadVersions?.[entry.slot] || 0
        }));
        if (!entries.length || entries.some(entry => !entry.cropper || typeof entry.cropper.toFile !== 'function')) {
          throw new Error('Please wait for each photo crop to finish loading, then try again.');
        }
        this.setFamilyPilotBusy(true);
        const croppedFiles = await Promise.all(entries.map(async entry => {
          try { return entry.cropper.acceptedPreview || await entry.cropper.toFile(); }
          catch (_) {
            const error = window.CustomifyPhotoUpload.error('crop_export');
            error.photoFile = entry.file;
            error.photoSlot = entry.slot;
            throw error;
          }
        }));
        if (entries.some(entry => (this._familyUploadVersions?.[entry.slot] || 0) !== entry.version || this.multiUploadFiles[entry.slot] !== entry.file || this.familyCropperBySlot?.[entry.slot] !== entry.cropper)) {
          throw new Error('A photo changed while the crop was being prepared. Please review the photos and try again.');
        }
        this._familyPilotSnapshot = { entries, files: croppedFiles };
        this.uploadedFile = croppedFiles[0];
      }
      const base64 = (this.isSpotifyProduct() && this.spotifyCropConfirmed && this.spotifyCropDataUrl)
        ? this.spotifyCropDataUrl
        : (this.isPhoneCaseProduct() && this.phoneCropConfirmed && this.phoneCropDataUrl)
        ? this.phoneCropDataUrl
        : (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl)
        ? this.phonePhotoCropDataUrl
        : await this.fileToBase64(this.uploadedFile);
      
      
      
      // ✅ Użyj productType z stylu (zgodne z backend - config.productType)
      const productType = this.getProductTypeFromStyle(this.selectedStyle);
      
      // ✅ USAGE LIMITS: Pobierz dane użytkownika do przekazania do API
      const customerInfo = guestEmailAdmission.token ? null : this.getCustomerInfo();
      
      // ✅ Pobierz email z localStorage (jeśli był w formularzu) lub z customerInfo
      const email = customerInfo?.email || safeLocalStorageGet('customify_email_provided') || null;
      const marketContext = window.CustomifyMarketContext || window.CustomifyI18n || {};
      
      const requestBody = {
        imageData: base64,
        // ❌ USUNIĘTO: prompt - backend używa config.prompt z konfiguracji stylu (jak dla króla, kotów, etc.)
        style: this.selectedStyle, // ✅ STYL - API użyje tego do identyfikacji stylu i pobrania prompta z config
        productType: productType, // Przekaż typ produktu do API
        // Zawsze przekazuj rzeczywisty handle strony. Backend rozwiązuje alias do
        // wspólnej konfiguracji produktu, również gdy produkt nie ma pól personalizacji.
        productHandle: this.getProductHandle(),
        customerId: customerInfo?.customerId || null,
        // Fallback dla przeglądarek blokujących third-party cookie domeny Vercel.
        deviceToken: safeLocalStorageGet('customify_device_token', null),
        // ✅ EMAIL: ZAWSZE wysyłaj email jeśli dostępny (dla zalogowanych i niezalogowanych)
        // Backend użyje tego do ustawienia metafield generation_ready dla emaili Shopify Flow
        email: customerInfo?.email || email || null,
        locale: marketContext.locale || null,
        marketCountry: marketContext.country || null,
        marketHandle: marketContext.marketHandle || null,
        currency: marketContext.currency || null
        // ❌ USUNIĘTO: watermarkedImage - watermark generujemy PO transformacji AI, nie przed!
      };
      
      if (guestEmailAdmission.token) {
        requestBody.guestEmailToken = guestEmailAdmission.token;
        requestBody.customerId = null;
        requestBody.email = null;
      }
      if (guestEmailAdmission.customerSessionToken) requestBody.customerSessionToken = guestEmailAdmission.customerSessionToken;

      if (spotifyPayload) {
        requestBody.spotifyTitle = spotifyPayload.title;
        requestBody.spotifyArtist = spotifyPayload.artist;
      }

      // 📊 PERSONALIZATION: send raw field values only. Backend builds the prompt from productHandle + fields.
      const cfgForLog = this.getCustomFieldConfig();
      if (cfgForLog && cfgForLog.fields) {
        const rawFields = {};
        cfgForLog.fields.forEach(field => {
          // Segmind Caricature does not accept prompts. Keep the shared field
          // visible, but use its text in the browser overlay after generation.
          if (this.isGermanCoupleBrowserCaptionStyle() && field.id === 'napis') return;
          const el = document.getElementById(`customField_${field.id}`);
          if (el && !el.disabled && el.value && el.value.trim()) {
            rawFields[field.id] = el.value.trim();
          }
        });
        if (this.isFamilyGrandparentsPilot()) {
          rawFields.photoCaptions = window.FamilyInlineCrop.buildRequestMetadata(this._familyPilotSnapshot.entries).photoCaptions;
        }
        requestBody.personalizationFields = rawFields;
      }

      // 📸 MULTI-UPLOAD: Upload dodatkowych zdjęć do Vercel Blob i dodaj URL-e
      if (this.isMultiUploadProduct()) {
        const multiFiles = this.getMultiUploadFiles();
        const additionalImageUrls = [];
        for (let i = 1; i < multiFiles.length; i++) {
          const file = multiFiles[i];
          const sourceEntry = this._familyPilotSnapshot?.entries[i];
          const sourceFile = sourceEntry?.file || file;
          const storedSlot = this.multiUploadFiles?.indexOf(file);
          const sourceSlot = sourceEntry?.slot ?? (storedSlot >= 0 ? storedSlot : i);
          let fileBase64;
          try { fileBase64 = await this.fileToBase64(file); }
          catch (error) { error.photoFile = sourceFile; error.photoSlot = sourceSlot; throw error; }
          console.log(`📸 [MULTI-UPLOAD] Uploading image ${i+1}/${multiFiles.length} to Vercel Blob...`);
          try {
            if (this.usesFamilyPhotoCrop()) {
              additionalImageUrls.push(await window.CustomifyPhotoUpload.uploadReference(fileBase64, `multi-upload-${Date.now()}-${i}.jpg`));
            } else {
              const uploadResp = await fetch(window.CustomifyApi.url('/api/upload-temp-image'), {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ imageData: fileBase64, filename: `multi-upload-${Date.now()}-${i}.jpg` })
              });
              if (!uploadResp.ok) throw window.CustomifyPhotoUpload.error('file_upload', { status: uploadResp.status });
              const uploadResult = await uploadResp.json();
              if (!uploadResult.url) throw window.CustomifyPhotoUpload.error('file_upload');
              additionalImageUrls.push(uploadResult.url);
            }
          } catch (failure) {
            const error = failure?.code === 'file_upload' ? failure : window.CustomifyPhotoUpload.error('file_upload');
            error.photoFile = sourceFile;
            error.photoSlot = sourceSlot;
            throw error;
          }
        }
        if (additionalImageUrls.length !== Math.max(0, multiFiles.length - 1)) {
          throw new Error('Could not upload every photo. Please try again so everyone stays in the portrait.');
        }
        if (this.isFamilyGrandparentsPilot()) {
          requestBody.additionalImages = window.FamilyInlineCrop.buildRequestMetadata(this._familyPilotSnapshot.entries, additionalImageUrls).additionalImages;
        }
        if (this.isTogetherCoupleProduct() && (additionalImageUrls.length < 1 || additionalImageUrls.length > 7)) {
          throw new Error('Could not upload every reference photo. Please try again.');
        }
        if (additionalImageUrls.length > 0) {
          requestBody.additionalImages = additionalImageUrls;
          console.log(`📸 [MULTI-UPLOAD] Total additional images: ${additionalImageUrls.length}`);
        }
      }
      
      // Logi diagnostyczne - bez promptu, personalizacji, emaila (prywatność)
      
      
      
      // Upload retries must not consume the five-minute AI request deadline.
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 300000);
      const response = await fetch(window.CustomifyApi.url('/api/transform'), {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(requestBody),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('📱 [MOBILE] Response error:', errorText);

        let errorJson = null;
        try {
          errorJson = JSON.parse(errorText);
        } catch (parseError) {
          console.warn('⚠️ [MOBILE] Failed to parse error JSON:', parseError);
        }

        if (errorJson?.errorCode === 'GUEST_EMAIL_SESSION_EXPIRED') window.CustomifyGuestEmail?.reset();

        if (response.status === 403 && errorJson?.error === 'Usage limit exceeded') {
          console.warn('⚠️ [USAGE] Limit exceeded response from API:', errorJson);
          if (errorJson.showLoginModal === false) {
            this.showError(errorJson.message || 'Please try again later.', 'transform');
            return;
          }

          if (!customerInfo) {
            const usedCount = typeof errorJson.usedCount === 'number'
              ? errorJson.usedCount
              : (typeof errorJson.count === 'number' ? errorJson.count : 1);
            const totalLimit = typeof errorJson.totalLimit === 'number'
              ? errorJson.totalLimit
              : (typeof errorJson.limit === 'number' ? errorJson.limit : 1);

            try {
              const FREE_LIMIT = 3;
              const enforcedCount = Math.max(usedCount, FREE_LIMIT);
              safeLocalStorageSet('customify_usage_count', enforcedCount.toString());
              console.log('💾 [USAGE] Synced local usage count to', enforcedCount);
            } catch (storageError) {
              console.warn('⚠️ [USAGE] Failed to sync local usage count:', storageError);
            }

            this.showLoginModal(usedCount, totalLimit);
          } else {
            this.trackLimitFunnelShowLimit(customerInfo, {
              wallTier: errorJson.wallTier || 'unknown',
              source: 'transform_403'
            });
            this.showLimitWallModal(customerInfo, errorJson);
          }

          return;
        }

        if (response.status === 403 && errorJson?.error === 'Image already used') {
          console.warn('⚠️ [IMAGE-HASH] Image already used response from API:', errorJson);
          const baseMessage = errorJson.message || 'This photo already has a result. See it below, or try another photo or product';
          // Utwórz komunikat z linkiem do innych produktów
          const messageWithLink = `${baseMessage} <a href="/collections/see_also" style="color: #0066cc; text-decoration: underline;">See other products</a>`;
          this.showErrorWithHTML(messageWithLink, 'transform');
          return;
        }

        if (errorJson?.error === 'CROPPED_FACE') {
          const msg = errorJson.message || 'The photo must show the full face from the front. Use a photo where the face is fully visible and not cropped.';
          this.showError(msg, 'transform');
          return;
        }

        if (response.status === 400) {
          const backendError = (errorJson?.error || '').toString();
          const normalizedError = backendError.toLowerCase();
          const isModerationError =
            normalizedError.includes('odrzucone przez system bezpieczeństwa') ||
            normalizedError.includes('filtr bezpieczeństwa') ||
            normalizedError.includes('nsfw') ||
            normalizedError.includes('content detected') ||
            normalizedError.includes('moderation');

          if (isModerationError) {
            this.showError(
              'The photo was rejected by the safety filter. Use a photo with a clear face and neutral clothing.',
              'transform'
            );
            return;
          }
        }

        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();
      if (result.guestEmail) window.CustomifyGuestEmail?.notify(result.guestEmail);
      if (typeof result.deviceToken === 'string' && /^[a-f0-9]{32}$/i.test(result.deviceToken)) {
        safeLocalStorageSet('customify_device_token', result.deviceToken.toLowerCase());
      }
      
      if (result.success) {
        this.transformedImage = result.transformedImage;
        if (customerInfo?.customerId) {
          this.trackLimitFunnelGenerationSuccess(customerInfo);
        }
        // ✅ STATS: Generacje AI zlicza backend (transform.js) – jedna źródło prawdy, bez podwójnego liczenia
        // ✅ ZAPISZ watermarkedImageUrl z backendu (jeśli dostępny)
        this.watermarkedImageUrl = result.watermarkedImageUrl || null;
        // ✅ NOWE: ZAPISZ watermarkedImageBase64 z backendu (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        this.watermarkedImageBase64 = result.watermarkedImageBase64 || null;
        this.artworkId = result.artworkId || result.saveGenerationDebug?.artworkId || null;
        this.generationId = result.generationId || result.saveGenerationDebug?.generationId || null;
        this.hideError(); // Ukryj komunikat błędu po udanej transformacji
        
        // ✅ AWAIT: Czekaj aż wynik zostanie pokazany
        // showResult() użyje watermarkedImageUrl jeśli dostępny, w przeciwnym razie transformedImage
        await this.showResult(result.transformedImage);
        if (!this.isPhonePhotoCaseProduct || !this.isPhonePhotoCaseProduct()) {
          this.showGeneratedImageSuccess(customerInfo, !customerInfo || result.historySaved === true, !!result.historyRetryToken);
          if (customerInfo && result.historyRetryToken && window.CustomifyHistoryRecovery) {
            const token = result.historyRetryToken;
            window.CustomifyHistoryRecovery.enqueue(customerInfo.customerId, token);
            window.CustomifyHistoryRecovery.recover(customerInfo.customerId).then(recovered => {
              if (recovered.includes(token) && this.generationId === (result.generationId || result.saveGenerationDebug?.generationId || null)) {
                this.showGeneratedImageSuccess(customerInfo, true);
              }
            }).catch(() => {});
          }
        }
        
        // ✅ UKRYJ PASEK POSTĘPU - obraz jest już widoczny, reszta działa w tle
        this.hideLoading();

        // 🆕 Tekst na obrazie – pokaż panel dopiero po generacji (tylko produkt pilota)
        if (this.textOverlayEnabled && this.textOverlayPanel) {
          const browserCaption = this.isGermanCoupleBrowserCaptionStyle()
            ? (document.getElementById('customField_napis')?.value || '').trim()
            : '';
          this.watermarkedImageUrl = result.watermarkedImageUrl || result.transformedImage;
          this.textOverlayBaseImage = result.transformedImage || null;
          this.textOverlayOriginalWatermarked = result.watermarkedImageUrl || null;
          this.textOverlayState = { ...this.textOverlayState, text: browserCaption, applied: false };
          if (this.textOverlayInput) {
            this.textOverlayInput.value = browserCaption;
            this.updateTextOverlayCounter();
          }
          this.textOverlayPanel.style.display = browserCaption ? 'block' : 'none';
          this.textOverlayToggleBtn?.setAttribute('data-overlay-open', browserCaption ? 'true' : 'false');
          this.updateTextOverlayHint('');
          if (browserCaption) {
            try {
              await this.previewTextOverlay();
            } catch (error) {
              console.warn('⚠️ [TEXT-OVERLAY] Browser caption preview unavailable:', error);
            }
          }
        }
        
        // ✅ BACKEND WATERMARK: Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ Backend zapisuje watermarkedImageUrl w save-generation-v2 automatycznie
        // ✅ NIE WYSYŁAMY już frontend watermarku do /api/update-generation-watermark (stary system)
        if (result.watermarkedImageUrl) {
        } else {
          console.warn('⚠️ [TRANSFORM] Backend watermark nie jest dostępny - frontend użyje fallback w showResult()');
        }
        
        // ✅ STARY KOD USUNIĘTY: Frontend watermark generation i /api/update-generation-watermark
        // ✅ Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ showResult() w theme.liquid używa this.watermarkedImageUrl (ustawiony powyżej)
        
        // 🎨 GALERIA: Zapisz generację do localStorage z base64 cache
        // ✅ DODAJ productType do generacji (dla skalowalności)
        const productType = this.getProductTypeFromStyle(this.selectedStyle);
        this.saveAIGeneration(
          base64,                     // Oryginalne zdjęcie (base64)
          result.transformedImage,    // AI obraz URL
          this.selectedStyle,         // Styl (pixar, boho, etc)
          this.selectedSize,         // Rozmiar (a4, a3, etc)
          productType,                // ✅ ProductType (boho, king, cats, etc)
          result.watermarkedImageUrl || this.watermarkedImageUrl || null, // ✅ ZAPISZ watermarkedImageUrl (Vercel Blob z watermarkiem)
          result.watermarkedImageBase64 || this.watermarkedImageBase64 || null, // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
          this.artworkId || null
        ).then(() => {
          console.log('✅ [CACHE] AI generation saved with base64 cache');
          
          // ✅ KLUCZOWE: Pobierz zapisany generation z historii i użyj jego URL (z Vercel Blob)
          const generations = this.getAIGenerations();
          if (generations.length > 0) {
            const lastGeneration = generations[0];
            if (lastGeneration.transformedImage) {
              console.log('✅ [CACHE] Using saved URL from history:', lastGeneration.transformedImage.substring(0, 100));
              this.transformedImage = lastGeneration.transformedImage; // Użyj URL z Vercel Blob zamiast oryginału
              console.log('✅ [CACHE] Updated this.transformedImage to saved URL');
            }
          }
        }).catch(error => {
          console.error('❌ [CACHE] Failed to save AI generation:', error);
        });
        
        // Niezalogowani: inkrementuj licznik lokalny (zalogowani: backend API robi auto)
        if (!customerInfo) {
          this.incrementLocalUsage();
        }
      } else {
        this.showError(this.t('customizer.error.ai_failed', {
          reason: result.error || this.t('customizer.error.unknown')
        }), 'transform');
      }
    } catch (error) {
      console.error('📱 [MOBILE] Transform error:', error);

      // Blad odczytu pliku (FileReader/arrayBuffer nie umie odczytac - e.g. Google Photos content URI)
      if (error?.name === 'FileReadError' || error?.name === 'PhotoUploadError') {
        this._showUploadError(error, error.photoFile || this._familyPilotSnapshot?.entries[0]?.file || this.uploadedFile, error.code === 'file_upload' ? 'server-upload' : 'generation-read', error.photoSlot ?? this._familyPilotSnapshot?.entries[0]?.slot);
        return;
      }

      // Retry logic for network errors (w tym "Error completing request", "Load failed" z Sentry)
      const isNetworkError = error?.message && (
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Load failed') ||
        error.message.includes('Error completing request') ||
        error.message.includes('network failure')
      );
      if (isNetworkError || error.name === 'AbortError') {
        this._reportToSentry(error, 'transformImage_network', { retryCount, isAbort: error.name === 'AbortError' });
      } else {
        this._reportToSentry(error, 'transformImage');
      }
      if (retryCount < 3 && (error.name === 'AbortError' || isNetworkError)) {
        const retryDelay = (retryCount + 1) * 2000;
        console.log(`🔄 [MOBILE] Retrying in ${retryDelay}ms... (attempt ${retryCount + 1}/3)`);
        this.showError(this.t('customizer.error.network_retry', { attempt: retryCount + 1 }), 'transform');
        setTimeout(() => {
          this.transformImage(retryCount + 1);
        }, retryDelay);
        return;
      }
      
      let errorMessage = this.t('customizer.error.server_connection');
      
      if (error.name === 'AbortError') {
        errorMessage = this.t('customizer.error.transform_timeout');
      } else if (error?.message && (error.message.includes('Failed to fetch') || error.message.includes('Error completing request') || error.message.includes('Load failed'))) {
        errorMessage = this.t('customizer.error.network_check');
      } else if (error?.message && error.message.includes('NetworkError')) {
        errorMessage = this.t('customizer.error.network_short');
      } else if (error?.message && error.message.includes('TypeError')) {
        errorMessage = this.t('customizer.error.processing');
      } else if (error?.message) {
        errorMessage = 'Error: ' + error.message;
      } else if (typeof error === 'string') {
        errorMessage = 'Error: ' + error;
      }
      
      this.showError(errorMessage, 'transform');
    } finally {
      if (this.usesFamilyPhotoCrop()) {
        this._familyPilotSnapshot = null;
        this.setFamilyPilotBusy(false);
      }
      this.hideLoading();
    }
  }

  // FUNKCJA DODAWANIA WATERMARKU
  async addWatermark(imageUrl) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('🔤 [WATERMARK DEBUG] START - imageUrl:', imageUrl?.substring(0, 100));
        console.log('🔤 [WATERMARK DEBUG] document.fonts.status:', document.fonts.status);
        console.log('🔤 [WATERMARK DEBUG] Czekam na document.fonts.ready...');
        
        // 🔧 POZIOM 1: Poczekaj na załadowanie fontów PRZED renderowaniem
        await document.fonts.ready;
        console.log('✅ [WATERMARK DEBUG] document.fonts.ready - fonty załadowane!');
        
        const img = new Image();
        // ✅ crossOrigin tylko dla zdalnych URL-i (HTTP/HTTPS), NIE dla base64 data URI!
        // Base64 data URI nie wymaga crossOrigin - działa bezpośrednio
        if (imageUrl && !imageUrl.startsWith('data:')) {
          img.crossOrigin = 'anonymous'; // Tylko dla zdalnych URL-i
        }
        
        img.onload = () => {
          try {
            console.log('🖼️ [WATERMARK DEBUG] Image loaded:', img.width, 'x', img.height);
            
            // ✅ ZMNIEJSZENIE WATERMARKU: 50% rozmiaru oryginału (dla miniaturki w Shopify i emaili)
            // Oryginał BEZ watermarku pozostaje w pełnym rozmiarze na Vercel (do druku)
            const scale = 0.5; // 50% rozmiaru (zmniejszamy dla Shopify + Vercel watermark)
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            canvas.width = Math.round(img.width * scale);
            canvas.height = Math.round(img.height * scale);
            console.log(`📐 [WATERMARK DEBUG] Watermark canvas size: ${canvas.width}x${canvas.height} (${Math.round(scale * 100)}% of original)`);
            
            // Rysuj oryginalny obraz na zmniejszonym Canvas (automatycznie skaluje)
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            console.log('✅ [WATERMARK DEBUG] Original image drawn on resized canvas (50% scale)');
            
            // ===== WZÓR DIAGONALNY - "GiftedPhotos.com" =====
            ctx.save();
            
            // ✅ DOSTOSOWANY FONT SIZE: większy dla lepszej widoczności
            const fontSize = Math.max(20, Math.min(canvas.width, canvas.height) * 0.11); // 11% canvas
            console.log('📏 [WATERMARK DEBUG] fontSize:', fontSize);
            
            // 🔧 POZIOM 2: Użyj systemowych fontów z fallbackami + UPPERCASE bez polskich znaków
            const fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
            ctx.font = `bold ${fontSize}px ${fontFamily}`;
            console.log('🔤 [WATERMARK DEBUG] Font ustawiony:', ctx.font);
            
            // 🔒 Watermark podglądu: ZBALANSOWANY (opacity 0.45 + cieńszy obrys)
            ctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
            ctx.strokeStyle = 'rgba(0, 0, 0, 0.35)';
            ctx.lineWidth = 1.5;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            
            // 🔧 POZIOM 3: Test renderowania - sprawdź czy font działa
            const testText = 'TEST';
            const testMetrics = ctx.measureText(testText);
            console.log('🔍 [WATERMARK DEBUG] Test measureText("TEST"):', {
              width: testMetrics.width,
              actualBoundingBoxLeft: testMetrics.actualBoundingBoxLeft,
              actualBoundingBoxRight: testMetrics.actualBoundingBoxRight
            });
            
            if (testMetrics.width === 0) {
              console.error('❌ [WATERMARK DEBUG] Font test FAILED! width=0, próbuję fallback monospace');
              ctx.font = `bold ${fontSize}px monospace`;
              console.log('🔄 [WATERMARK DEBUG] Fallback font:', ctx.font);
              
              const fallbackMetrics = ctx.measureText(testText);
              console.log('🔍 [WATERMARK DEBUG] Fallback measureText("TEST"):', {
                width: fallbackMetrics.width
              });
            } else {
              console.log('✅ [WATERMARK DEBUG] Font test OK! width=' + testMetrics.width);
            }
            
            // Test canvas rendering - czy tekst się faktycznie renderuje?
            const testCanvas = document.createElement('canvas');
            testCanvas.width = 200;
            testCanvas.height = 100;
            const testCtx = testCanvas.getContext('2d');
            testCtx.font = ctx.font;
            testCtx.fillStyle = 'black';
            testCtx.fillText('GiftedPhotos.com', 100, 50);
            const testDataUrl = testCanvas.toDataURL();
            console.log('🧪 [WATERMARK DEBUG] Test canvas rendering:', testDataUrl.substring(0, 100) + '...');
            
            // Obróć canvas w przeciwną stronę niż backend (ok. +30°)
            ctx.translate(canvas.width/2, canvas.height/2);
            ctx.rotate(30 * Math.PI / 180);
            ctx.translate(-canvas.width/2, -canvas.height/2);
            console.log('🔄 [WATERMARK DEBUG] Canvas rotated +30°');
            
            // 🔧 WATERMARK TEXT - GiftedPhotos.com only
            const texts = ['GiftedPhotos.com'];
            console.log('📝 [WATERMARK DEBUG] Teksty watermarku:', texts);
            
            // Rysuj watermarki w siatce - na przemian
            const spacing = Math.max(200, Math.min(canvas.width, canvas.height) * 0.3);
            console.log('📏 [WATERMARK DEBUG] Spacing:', spacing);
            
            let textIndex = 0;
            let watermarkCount = 0;
            
            for(let y = -canvas.height; y < canvas.height * 2; y += spacing) {
              for(let x = -canvas.width; x < canvas.width * 2; x += spacing * 1.5) {
                const text = texts[0];
                // ✅ RYSUJ STROKE PRZED FILL (dla lepszej widoczności)
                ctx.strokeText(text, x, y);
                ctx.fillText(text, x, y);
                textIndex++;
                watermarkCount++;
              }
              // Zmień wzór co wiersz dla lepszego efektu
              textIndex++;
            }
            
            console.log('✅ [WATERMARK DEBUG] Narysowano', watermarkCount, 'watermarków');
            
            ctx.restore();
            
            // Zwróć obraz z watermarkiem jako Data URL
            // ✅ ZMNIEJSZONA JAKOŚĆ: 70% quality (watermark nie musi być w wysokiej jakości - tylko do podglądu/emaili)
            const result = canvas.toDataURL('image/jpeg', 0.70);
            const resultSizeKB = Math.round(result.length / 1024);
            console.log('✅ [WATERMARK DEBUG] Canvas.toDataURL() - rozmiar:', result.length, 'znaków (', resultSizeKB, 'KB /', (result.length / 1024 / 1024).toFixed(2), 'MB)');
            console.log('✅ [WATERMARK DEBUG] Watermark: 50% rozmiaru + 70% quality = kompaktowy plik');
            console.log('✅ [WATERMARK DEBUG] Result preview:', result.substring(0, 100) + '...');
            
            resolve(result);
          } catch (error) {
            console.error('❌ [WATERMARK DEBUG] Canvas error:', error);
            console.error('❌ [WATERMARK DEBUG] Error stack:', error.stack);
            this._reportToSentry(error, 'watermark-canvas');
            reject(error);
          }
        };
        
        img.onerror = (error) => {
          console.error('❌ [WATERMARK DEBUG] Image load error:', error);
          console.error('❌ [WATERMARK DEBUG] Failed imageUrl:', imageUrl?.substring(0, 100));
          reject(new Error('Could not load the image for watermarking: ' + error.message));
        };
        
        // ✅ Ustaw src - działa zarówno z URL jak i base64 data URI
        console.log('🖼️ [WATERMARK DEBUG] Setting img.src, type:', imageUrl?.startsWith('data:') ? 'base64' : 'URL');
        img.src = imageUrl;
      } catch (error) {
        console.error('❌ [WATERMARK DEBUG] Async error:', error);
        console.error('❌ [WATERMARK DEBUG] Error stack:', error.stack);
        this._reportToSentry(error, 'watermark-async');
        reject(error);
      }
    });
  }

  cancelPendingResultScroll() {
    this._resultScrollVersion = (this._resultScrollVersion || 0) + 1;
    this._resultScrollCleanup?.();
    this._resultScrollCleanup = null;
  }

  scrollToGeneratedResult() {
    this.cancelPendingResultScroll();
    const version = this._resultScrollVersion;
    const image = this.resultImage;
    const source = image?.getAttribute('src');
    if (!image || !source) return;
    const current = () => version === this._resultScrollVersion && image.getAttribute('src') === source && image.isConnected !== false;
    const scroll = () => {
      if (!current()) return;
      const area = this.resultArea;
      const imageRect = image.getBoundingClientRect();
      const target = imageRect.width > 0 && imageRect.height > 0 ? image : area;
      if (!target || target.isConnected === false) return;
      const rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const header = document.querySelector('.header-main');
      const headerPosition = header && window.getComputedStyle(header).position;
      const headerRect = header?.getBoundingClientRect();
      const headerOffset = headerRect && ['fixed', 'sticky'].includes(headerPosition) && headerRect.top <= 0 ? Math.max(0, headerRect.bottom) : 0;
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, window.scrollY + rect.top - headerOffset - 16), behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    const settle = () => {
      if (!current()) return;
      // Let loading/source fields disappear and the decoded image take its final size.
      window.requestAnimationFrame(() => window.requestAnimationFrame(scroll));
    };
    const cleanup = () => {
      image.removeEventListener('load', loaded);
      image.removeEventListener('error', cleanup);
      if (this._resultScrollCleanup === cleanup) this._resultScrollCleanup = null;
    };
    const loaded = () => { cleanup(); settle(); };
    this._resultScrollCleanup = cleanup;
    if (image.complete && image.naturalWidth > 0) {
      cleanup(); settle();
    } else {
      image.addEventListener('load', loaded, { once: true });
      image.addEventListener('error', cleanup, { once: true });
      if (typeof image.decode === 'function') {
        image.decode().then(() => { if (current() && this._resultScrollCleanup === cleanup) loaded(); }).catch(() => {});
      }
    }
  }

  async showResult(imageUrl) {
    console.log('🎯 [CUSTOMIFY] showResult called, hiding actionsArea and stylesArea');
    
    // ✅ POKAŻ PRZETWORZONY OBRAZ AI (bez watermarku w podglądzie)
    // Watermark będzie dodany PO transformacji i zapisany przez /api/update-generation-watermark
    // 📱 Phone case: use background-image in PREVIEW area (same place as uploaded image)
    if (this.isPhonePhotoCaseProduct()) {
      console.log('📱 [PHONE PREVIEW] Phone case detected, using preview area');
      // Use watermarkedImageUrl if available, otherwise use imageUrl
      const finalImageUrl = this.watermarkedImageUrl || imageUrl;
      console.log('📱 [PHONE PREVIEW] Using image URL:', finalImageUrl ? finalImageUrl.substring(0, 50) + '...' : 'none');
      
      const photoBg = document.getElementById('phoneCasePhotoBg');
      const resultBg = document.getElementById('phoneCaseResultBg');
      const inner = document.querySelector('#customify-app-container .phone-case-inner');
      
      // Set image in PREVIEW area (main location)
      if (photoBg) {
        photoBg.style.backgroundImage = `url(${finalImageUrl})`;
        console.log('[PHONE PREVIEW] set background image in PREVIEW area (phoneCasePhotoBg)', finalImageUrl.substring(0, 50) + '...');
      } else {
        console.warn('⚠️ [PHONE PREVIEW] phoneCasePhotoBg not found!');
      }
      
      // Also set in result area (backup, but resultArea will be hidden)
      if (resultBg) {
        resultBg.style.backgroundImage = `url(${finalImageUrl})`;
        console.log('[PHONE PREVIEW] set background image in RESULT area (phoneCaseResultBg) as backup');
      }
      
      if (inner) {
        const innerRect = inner.getBoundingClientRect();
        console.log('[PHONE PREVIEW] inner rect', {
          width: innerRect.width,
          height: innerRect.height,
          aspectRatio: innerRect.width / innerRect.height
        });
      }
      // Keep resultImage hidden but set src for compatibility
      if (this.resultImage) {
        this.resultImage.src = finalImageUrl;
      }
      // 📱 Phone case: hide resultArea, keep previewArea visible (like Spotify)
      if (this.resultArea) {
        this.resultArea.style.display = 'none !important';
        this.resultArea.style.setProperty('display', 'none', 'important');
        console.log('📱 [PHONE PREVIEW] resultArea hidden with !important');
      }
      if (this.previewArea) {
        this.previewArea.style.display = 'block';
        console.log('📱 [PHONE PREVIEW] previewArea shown');
      }
      // 📱 Phone case: Also hide resultArea after a delay (in case something shows it later)
      setTimeout(() => {
        if (this.resultArea && this.isPhonePhotoCaseProduct()) {
          this.resultArea.style.display = 'none !important';
          this.resultArea.style.setProperty('display', 'none', 'important');
          console.log('📱 [PHONE PREVIEW] resultArea hidden again (delayed)');
        }
      }, 100);
    } else {
      this.resultImage.src = imageUrl; // Pokaż PRZETWORZONY obraz AI (bez watermarku w podglądzie)
      this.resultArea.style.display = 'block';
    }
    console.log('✅ [CUSTOMIFY] Showing AI result (watermark will be added after)');
    
    // Rozmiary są zawsze widoczne na górze (poza resultArea)
    this.sizeArea.style.display = 'block';
    console.log('🎯 [CUSTOMIFY] Size area visible on top (outside resultArea)');
    
    // UKRYJ przyciski "Przekształć z AI" i "Resetuj" (główne actionsArea)
    this.actionsArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] actionsArea hidden:', this.actionsArea.style.display);
    
    // UKRYJ style po przekształceniu
    this.stylesArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] stylesArea hidden:', this.stylesArea.style.display);
    
    // Zmień kolory przycisków po wygenerowaniu AI
    this.swapButtonColors();
    
    // UKRYJ pole upload po przekształceniu
    this.uploadArea.style.display = 'none';
    console.log('🎯 [CUSTOMIFY] uploadArea hidden:', this.uploadArea.style.display);
    // 📸 UKRYJ multi-upload grid po przekształceniu
    const multiUploadArea = document.getElementById('multiUploadArea');
    if (multiUploadArea) multiUploadArea.style.display = 'none';

    // Ukryj previewArea po generacji TYLKO dla spotify
    if (this.isSpotifyProduct() && this.previewArea) {
      this.previewArea.style.display = 'none';
      console.log('🎯 [CUSTOMIFY] previewArea hidden after generation (spotify only)');
      // Ukryj ponownie po 200ms - na wypadek gdyby coś później ustawiło block
      setTimeout(() => {
        if (this.previewArea) {
          this.previewArea.style.display = 'none';
          console.log('🎯 [CUSTOMIFY] previewArea hidden again (delayed)');
        }
      }, 200);
    }
    
    if (this.isSpotifyProduct() && this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'block';
    }
    
    // ✅ POKAŻ CENĘ NAD PRZYCISKIEM po wygenerowaniu AI
    this.updateCartPrice();
    
    // 🎵 Spotify frame: przelicz skalę z opóźnieniem (czekaj na layout + załadowanie obrazka)
    setTimeout(() => this.updateSpotifyFrameScale(), 100);
    this.resultImage.onload = () => {
      setTimeout(() => this.updateSpotifyFrameScale(), 50);
    };
    this.scrollToGeneratedResult();
    
  }

  // NAPRAWIONA FUNKCJA: STWÓRZ NOWY PRODUKT Z OBRAZKIEM AI (UKRYTY W KATALOGU)
  async addToCart(retryCount = 0) {
    this._sentryCrumb('cart', 'Start addToCart', { style: this.selectedStyle, size: this.selectedSize, retry: retryCount });
    this.showLoading();
    
    console.log('🛒 [CUSTOMIFY] addToCart called with:', {
      transformedImage: !!this.transformedImage,
      selectedStyle: this.selectedStyle,
      selectedSize: this.selectedSize,
      selectedProductType: this.selectedProductType,
      retryCount: retryCount
    });
    
    // ✅ SPRAWDŹ ROZMIAR - dla etui brak selektora, używamy domyślnego
    if (this.isPhonePhotoCaseProduct()) {
      if (!this.selectedSize) this.selectedSize = 'etui';
      if (this.selectedProductType !== 'etui') this.selectedProductType = 'etui';
    }

    // Snapshot całej konfiguracji zamówienia przed pierwszym await.
    // Dzięki temu cena, produkt Shopify i line item properties zawsze opisują ten sam wybór.
    const cartSelection = Object.freeze({
      style: this.selectedStyle,
      size: this.selectedSize,
      productType: this.isPhonePhotoCaseProduct() ? 'etui' : (this.selectedProductType || 'canvas'),
      frame: window.CustomifyFrame?.color || 'none',
      stand: window.CustomifyStand?.type || 'none'
    });
    const cartSize = cartSelection.size;
    const cartProductType = cartSelection.productType;
    const cartSizeLabel = this.getSizeDimension(cartSize);

    if (!cartSize) {
      console.log('❌ [CUSTOMIFY] No selectedSize, showing error');
      this.showError(this.t('customizer.error.size_required'), 'cart');
      this.hideLoading();
      return;
    }
    
    if (cartProductType === 'plakat' && String(cartSize).toLowerCase() === 'a0') {
      this.showError('This poster size is not available.', 'cart');
      this.hideLoading();
      return;
    }

    // 🚨 WALIDACJA: Dla szkła tylko A5 i A4 są dozwolone (maksymalnie 20×30 cm)
    if (cartProductType === 'szklo') {
      const allowedSizes = ['a5', 'a4'];
      if (!allowedSizes.includes(cartSize.toLowerCase())) {
        console.error('❌ [CUSTOMIFY] Invalid size for szklo:', cartSize);
        this.showError(this.t('customizer.error.product_type_unavailable'), 'cart');
        this.hideLoading();
        return;
      }
    }
    
    console.log('✅ [CUSTOMIFY] selectedSize OK, proceeding with price calculation');

    // ✅ OBLICZ CENĘ NAJPIERW - niezależnie od obrazu AI
    const basePrice = this.originalBasePrice || this.getDefaultBasePrice();
    const sizePrice = this.getSizePrice(cartSize);
    const frameSelected = this.isFramePricingSupported(cartProductType) && cartSelection.frame !== 'none';
    const frameSurcharge = frameSelected ? this.getFrameSurcharge(cartSize, cartProductType) : 0;
    const finalPrice = basePrice + sizePrice + frameSurcharge;
    
    console.log('💰 [CUSTOMIFY] Price calculation:', {
      originalBasePrice: this.originalBasePrice,
      basePrice: basePrice,
      sizePrice: sizePrice,
      frameSelected: frameSelected,
      frameSurcharge: frameSurcharge,
      frameColor: cartSelection.frame,
      selectedProductType: cartProductType,
      finalPrice: finalPrice,
      size: cartSize
    });

    // ✅ SPRAWDŹ OBRAZ AI DOPIERO POTEM
    if (!this.transformedImage) {
      this.showError(this.t('customizer.error.generate_preview_first'), 'top');
      this.hideLoading();
      return;
    }
    
    // ✅ SPRAWDŹ STYL
    if (!cartSelection.style) {
      this.showError(this.t('customizer.error.choose_style'), 'cart');
      return;
    }

    // 📱 Etui: wymagana marka i model telefonu
    if (this.isPhonePhotoCaseProduct()) {
      if (!this.selectedPhoneBrand || !this.selectedPhoneModel) {
        this.showError('Choose brand i model telefonu', 'cart');
        this.hideLoading();
        return;
      }
    }

    // 🆕 Tekst na obrazie: jeśli użytkownik wpisał tekst, musi kliknąć „Zastosuj napis”
    let textOverlayPayload = null;
    if (this.textOverlayEnabled) {
      const draftText = (this.textOverlayInput?.value || '').trim();
      if (draftText && !this.textOverlayState.applied) {
        this.showError(
          this.getProductHandle() === 'personalisierte-paar-karikatur-vom-foto'
            ? 'Klicke auf „Speichern“, um den Text zum Bild hinzuzufügen.'
            : 'Click "Save" to add the text to your order',
          'cart'
        );
        return;
      }
      textOverlayPayload = this.getTextOverlayPayload();
    }

    console.log('🛒 [CUSTOMIFY] Starting addToCart process...');
    this.hideError();

    // Pokaż pasek postępu dla koszyka
    this.showCartLoading();

    // ⚠️ FLAGA: Produkt już został utworzony w Shopify → NIE TWÓRZ ponownie przy retry (duplikat!)
    let productCreated = false;

    try {
      // Pobierz ID produktu z różnych możliwych źródeł
      const productId = 
        document.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
        window.ShopifyAnalytics?.meta?.product?.id ||
        null;
      
      console.log('🆔 [CUSTOMIFY] Original product ID:', productId);
      
      // Sprawdź czy finalPrice jest poprawny
      if (!finalPrice || finalPrice <= 0) {
        console.error('❌ [CUSTOMIFY] Invalid finalPrice:', finalPrice);
        this.showError(this.t('customizer.error.price_calculation'), 'cart');
        return;
      }

      // Sprawdź czy mamy uploadedFile (z upload) czy originalImage (z galerii)
      console.log('[DEBUG] Before originalImage check');
      console.log('[DEBUG] this.uploadedFile:', !!this.uploadedFile);
      console.log('[DEBUG] this.originalImageFromGallery:', !!this.originalImageFromGallery);
      console.log('[DEBUG] this.transformedImage:', !!this.transformedImage);
      
      let originalImage;
      if (this.uploadedFile) {
        // Z upload - konwertuj plik na base64
        console.log('[DEBUG] Before fileToBase64 call');
        originalImage = await this.fileToBase64(this.uploadedFile);
        console.log('[DEBUG] After fileToBase64 call, originalImage length:', originalImage?.length);
      } else if (this.originalImageFromGallery) {
        // Z galerii - użyj zapisany originalImage
        originalImage = this.originalImageFromGallery;
      } else {
        // Fallback - użyj transformedImage jako originalImage
        originalImage = this.transformedImage;
        console.warn('⚠️ [CUSTOMIFY] No original image available, using transformed image as fallback');
      }

      console.log('[DEBUG] After originalImage assignment, before SPOTIFY section');
      console.log('[DEBUG] this.isSpotifyProduct() result:', this.isSpotifyProduct());

      // 🎵 SPOTIFY: Komponuj finalny obraz z maską i tekstami
      console.log('[SPOTIFY CHECK] Reached SPOTIFY section in addToCart');
      console.log('[SPOTIFY CHECK] this.transformedImage:', this.transformedImage?.substring(0, 50));
      console.log('[SPOTIFY CHECK] this.watermarkedImageUrl:', this.watermarkedImageUrl?.substring(0, 50));
      
      let finalTransformedImage = this.transformedImage;
      let watermarkedImageUrl = this.watermarkedImageUrl || null;
      let needsBackendWatermark = false;
      
      // DEBUG: Sprawdź isSpotifyProduct
      console.log('[SPOTIFY CHECK] Before isSpotifyProduct() call');
      const isSpotify = this.isSpotifyProduct();
      console.log('[SPOTIFY CHECK] After isSpotifyProduct() call, result:', isSpotify);
      console.log('[SPOTIFY DEBUG] isSpotifyProduct():', isSpotify);
      console.log('[SPOTIFY DEBUG] window.location.pathname:', window.location.pathname);
      console.log('[SPOTIFY DEBUG] pathname.toLowerCase():', window.location.pathname.toLowerCase());
      console.log('[SPOTIFY DEBUG] includes ramka-spotify:', window.location.pathname.toLowerCase().includes('ramka-spotify'));
      console.log('[SPOTIFY DEBUG] this.isSpotifyProduct direct:', this.isSpotifyProduct());
      
      if (isSpotify) {
        console.log('🎵 [SPOTIFY] Composing final image with mask and texts...');
        try {
          finalTransformedImage = await this.composeSpotifyImage();
          console.log('✅ [SPOTIFY] Image composed successfully, length:', finalTransformedImage.length);
          // Dla spotify - backend musi dodać watermark do skomponowanego obrazu
          watermarkedImageUrl = null;
          needsBackendWatermark = true;
        } catch (err) {
          console.error('❌ [SPOTIFY] Failed to compose image:', err);
          this._reportToSentry(err, 'spotify-compose');
          this.showError('Could not prepare the image. Try again.', 'cart');
          this.hideLoading();
          return;
        }
      }

      // Nie blokuj poprawnie wygenerowanego obrazu, gdy dostawca nie zwrócił
      // gotowego watermarku. Backend /api/products potrafi utworzyć bezpieczną
      // miniaturkę koszyka z finalTransformedImage.
      if (!watermarkedImageUrl && !this.watermarkedImageBase64 && finalTransformedImage) {
        needsBackendWatermark = true;
        console.warn('⚠️ [CUSTOMIFY] Watermark missing after transform - delegating watermark to /api/products');
      }
      
      // ✅ TYLKO BACKEND WATERMARK - już jest na Vercel Blob, nie trzeba uploadować ponownie!
      if (!watermarkedImageUrl && !this.watermarkedImageBase64 && !needsBackendWatermark) {
        console.error('❌ [CUSTOMIFY] Brak backend watermarkedImageUrl - nie można dodać do koszyka!');
        alert('An error occurred while generating the image. Please generate it again by clicking "Transform with AI".');
        this.hideLoading();
        return; // Blokada dodania do koszyka
      }
      
      if (watermarkedImageUrl) {
        console.log('✅ [CUSTOMIFY] Używam backend watermarkedImageUrl (już na Vercel Blob):', watermarkedImageUrl.substring(0, 100));
      } else {
        console.log('🎵 [SPOTIFY] Backend doda watermark do skomponowanego obrazu');
      }

      const productData = {
        originalImage: originalImage,
        transformedImage: finalTransformedImage, // 🎵 Dla spotify: skomponowany obraz, dla innych: this.transformedImage
        watermarkedImage: watermarkedImageUrl, // ✅ URL obrazka z watermarkiem (fallback dla starych wersji)
        watermarkedImageUrl: watermarkedImageUrl, // ✅ URL obrazka z watermarkiem (backend PNG - PRIORYTET), null dla spotify
        needsBackendWatermark: needsBackendWatermark, // 🎵 Dla spotify: backend musi dodać watermark
        watermarkedImageBase64: this.watermarkedImageBase64 || null, // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        artworkId: this.artworkId || null,
        generationId: this.generationId || null,
        style: cartSelection.style,
        size: cartSize,
        productType: cartProductType,
        originalProductTitle: document.querySelector('h1, .product-title, .view-product-title')?.textContent?.trim() || 'Produkt',
        originalProductId: productId, // ✅ Dodano ID produktu do pobrania ceny z Shopify
        finalPrice: finalPrice, // ✅ Przekaż obliczoną cenę do API
        frameColor: cartSelection.frame, // ✅ Informacja o ramce dla debugowania
        frameSurcharge: frameSurcharge, // ✅ Dopłata za ramkę dla weryfikacji
        textOverlay: textOverlayPayload,
        marketContext: {
          country: window.CustomifyMarketContext?.country || null,
          locale: window.CustomifyMarketContext?.locale || null,
          currency: window.CustomifyMarketContext?.currency || null,
          marketHandle: window.CustomifyMarketContext?.marketHandle || null,
          sizeUnit: this.getSizeUnit()
        }
      };

      console.log('🛒 [CUSTOMIFY] Creating product with data:', productData);
      console.log('🛒 [CUSTOMIFY] transformedImage type:', typeof this.transformedImage);
      console.log('🛒 [CUSTOMIFY] transformedImage length:', this.transformedImage?.length);
      console.log('🛒 [CUSTOMIFY] transformedImage is base64?', this.transformedImage?.startsWith('data:'));
      console.log('🛒 [CUSTOMIFY] transformedImage is URL?', this.transformedImage?.startsWith('http'));
      console.log('🛒 [CUSTOMIFY] transformedImage preview:', this.transformedImage?.substring(0, 200));
      
      // Stwórz nowy produkt z obrazkiem AI jako głównym obrazem
      // ✅ DODANO: Timeout i retry logic dla network errors
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 sekund timeout
      
      const response = await fetch(window.CustomifyApi.url('/api/products'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(productData),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);

      console.log('🛒 [CUSTOMIFY] API response status:', response.status);
      const result = await response.json();
      console.log('🛒 [CUSTOMIFY] API response:', result);

      if (result?.productCreated || result?.productId) {
        productCreated = true;
      }

      // URL bez watermarku (jak theme.liquid) — do ukrytej właściwości „Link do zdjęcia:” na linii zamówienia
      let cleanImageUrlForOrder = null;
      if (result && result.success) {
        try {
          const debugInfo = result.saveGenerationDebug;
          if (debugInfo && debugInfo.blobPath && debugInfo.generationId) {
            const blobBaseUrl = 'https://vzwqqb14qtsxe2wx.public.blob.vercel-storage.com';
            const normalizedPath = debugInfo.blobPath.startsWith('/')
              ? debugInfo.blobPath.slice(1)
              : debugInfo.blobPath;
            const blobUrl = `${blobBaseUrl}/${normalizedPath}`;
            const generationResponse = await fetch(blobUrl);
            if (generationResponse.ok) {
              const generationData = await generationResponse.json();
              const generationsArray = generationData?.generations || [];
              const matchedGeneration = generationsArray.find((gen) => gen.id === debugInfo.generationId);
              const candidateUrl = matchedGeneration?.imageUrl || matchedGeneration?.transformedImage || null;
              if (candidateUrl && typeof candidateUrl === 'string' && candidateUrl.startsWith('http')) {
                cleanImageUrlForOrder = candidateUrl;
              }
            }
          }
        } catch (cleanUrlErr) {
          console.warn('⚠️ [CUSTOMIFY] cleanImageUrlForOrder:', cleanUrlErr?.message || cleanUrlErr);
        }
      }

      if (result.success) {
        productCreated = true; // ✅ Produkt istnieje w Shopify - retry NIE może tworzyć kolejnego
        console.log('✅ [CUSTOMIFY] Product created:', result.product);
        
        // Obraz AI jest już głównym obrazem produktu
        
        if (result.variantId) {
          console.log('🛒 [CUSTOMIFY] Attempting to add to cart with Variant ID:', result.variantId);
          console.log('🛒 [CUSTOMIFY] Product ID:', result.productId);
          console.log('🛒 [CUSTOMIFY] Variant ID type:', typeof result.variantId);
          console.log('🛒 [CUSTOMIFY] Variant ID length:', result.variantId.toString().length);
          
          // Tytuł z wszystkimi parametrami (ramka, podstawka)
          const selectedFrame = ((cartProductType === 'plakat' || cartProductType === 'canvas') && cartSelection.frame)
            ? cartSelection.frame : 'none';
          const selectedStand = (cartProductType === 'szklo' && cartSelection.stand)
            ? cartSelection.stand : 'none';
          const frameLabelMap = { none: null, black: 'black', white: 'white', wood: 'wood' };
          const frameLabel = frameLabelMap[(selectedFrame || 'none').toLowerCase()] || null;
          const standLabelMap = { none: null, wood: 'wooden stand', led: 'LED stand' };
          const standLabelForTitle = standLabelMap[(selectedStand || 'none').toLowerCase()] || null;
          let productTypeName;
          if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
            productTypeName = PRODUCT_TYPE_LABELS.etui;
          } else if (cartProductType === 'szklo') {
            productTypeName = 'Unavailable print type';
          } else if (cartProductType === 'plakat' || cartProductType === 'canvas') {
            const base = cartProductType === 'plakat' ? 'Poster' : 'Canvas print';
            productTypeName = frameLabel ? `${base} with ${frameLabel} frame` : base;
          } else {
            productTypeName = PRODUCT_TYPE_LABELS[cartProductType] || PRODUCT_TYPE_LABELS.canvas;
          }
          const standLabelForRamka = { none: 'none', wood: 'wooden stand', led: 'wooden stand with LED' }[(selectedStand || 'none').toLowerCase()] || 'none';
          const frameLabelForRamka = { none: 'none', black: 'black', white: 'white', wood: 'wood' }[(selectedFrame || 'none').toLowerCase()] || 'none';
          
          const shortOrderId = result.shortOrderId || (result.orderId ? result.orderId.split('-').pop() : Date.now().toString());
          
          const spotifyTitle = (this.spotifyTitleInput?.value || '').trim().slice(0, 60);
          const spotifyArtist = (this.spotifyArtistInput?.value || '').trim().slice(0, 60);

          const properties = {
            'Size': cartSizeLabel,
            'Print type': productTypeName,
            'Frame': cartProductType === 'szklo' ? `stand - ` : `frame - `
          };
          if (!window.CustomifyHideGlassPrint && this.isSpotifyProduct()) {
            if (spotifyTitle) properties['Song title'] = spotifyTitle;
            if (spotifyArtist) properties['Artist'] = spotifyArtist;
          }
          if (textOverlayPayload?.text) {
            properties['Text on image'] = textOverlayPayload.text;
          }
          if (this.isPhonePhotoCaseProduct()) {
            const brandLabel = this.getPhoneBrandLabel();
            const modelLabel = this.getPhoneModelLabel();
            if (brandLabel) properties['Brand'] = brandLabel;
            if (modelLabel) properties['Model'] = modelLabel;
          }

          // 📊 PERSONALIZATION: Dodaj surowe wartości pól personalizacji do properties zamówienia
          const cfg = this.getCustomFieldConfig();
          if (cfg && cfg.fields) {
            cfg.fields.forEach(field => {
              const el = document.getElementById(`customField_${field.id}`);
              if (el && !el.disabled && el.value && el.value.trim()) {
                if (field.id === 'imiona') properties['Name / dedication'] = el.value.trim();
                if (field.id === 'rocznica') properties['Anniversary / years'] = el.value.trim();
                if (field.id === 'opis_charakteru') properties['Person description'] = el.value.trim();
              }
            });
          }

          const noteAttributes = {};
          
          // ✅ Dodaj tylko techniczne informacje dla admina (bez "Styl AI" - nie pokazywane w koszyku)
          if (result.orderId) {
            noteAttributes['Order ID Full'] = result.orderId;
          }
          if (result.imageUrl) {
            noteAttributes['AI Image URL'] = result.imageUrl;
          }
          if (result.permanentImageUrl) {
            noteAttributes['AI Image Backup'] = result.permanentImageUrl;
          }
          if (result.vercelBlobUrl) {
            noteAttributes['AI Image Vercel'] = result.vercelBlobUrl;
          }
          if (textOverlayPayload) {
            noteAttributes['AI Text Overlay'] = JSON.stringify(textOverlayPayload);
          }
          
          console.log('🛒 [CUSTOMIFY CART PROPERTIES VISIBLE]:', properties);
          console.log('📝 [CUSTOMIFY NOTE ATTRIBUTES]:', noteAttributes);

          const truncateLineProperties = (raw) => {
            const out = {};
            Object.entries(raw).forEach(([key, value]) => {
              if (value == null) return;
              const strVal = String(value);
              out[key] = strVal.length > 255 ? strVal.substring(0, 252) + '...' : strVal;
              if (strVal.length > 255) {
                console.warn('⚠️ [CUSTOMIFY] Property', key, 'truncated to 255 chars');
              }
            });
            return out;
          };

          const visibleOnlyForCart = truncateLineProperties({ ...properties });

          let linePropertiesForCart;
          let adminLinePropsMerged = false;
          try {
            const hiddenLineProps = {};
            if (result.orderId) {
              hiddenLineProps['_Order ID Full'] = result.orderId;
            }
            if (result.artworkId || this.artworkId) {
              hiddenLineProps['_lumly_artwork_id'] = result.artworkId || this.artworkId;
            }
            if (cartSize) {
              hiddenLineProps['_lumly_size'] = cartSize;
            }
            if (cartProductType) {
              hiddenLineProps['_lumly_product_type'] = cartProductType;
            }
            hiddenLineProps['_lumly_frame'] = cartSelection.frame;
            hiddenLineProps['_lumly_stand'] = cartSelection.stand;
            let finalAdminUrlLine = null;
            if (cleanImageUrlForOrder && cleanImageUrlForOrder.startsWith('http')) {
              finalAdminUrlLine = cleanImageUrlForOrder;
            } else if (result.vercelBlobUrl && result.vercelBlobUrl.startsWith('http')) {
              finalAdminUrlLine = result.vercelBlobUrl;
            } else if (result.permanentImageUrl && result.permanentImageUrl.startsWith('http')) {
              finalAdminUrlLine = result.permanentImageUrl;
            } else if (this.transformedImage && String(this.transformedImage).startsWith('http')) {
              finalAdminUrlLine = this.transformedImage;
            }
            if (finalAdminUrlLine) {
      hiddenLineProps['_Photo link'] = finalAdminUrlLine;
            }
            if (cleanImageUrlForOrder && cleanImageUrlForOrder.startsWith('http')) {
              hiddenLineProps['_AI_Image_Clean_URL'] = cleanImageUrlForOrder;
            }
            if (productId) {
              hiddenLineProps['_Original Product ID'] = String(productId);
            }
            linePropertiesForCart = truncateLineProperties({ ...properties, ...hiddenLineProps });
            adminLinePropsMerged = true;
            console.log('🔒 [CUSTOMIFY] Line properties (visible + admin):', Object.keys(linePropertiesForCart));
          } catch (propErr) {
            console.warn('⚠️ [CUSTOMIFY] Błąd budowy pól admin — koszyk tylko z widocznymi (zamówienie możliwe):', propErr?.message || propErr);
            linePropertiesForCart = visibleOnlyForCart;
            adminLinePropsMerged = false;
          }

          console.log('🖼️ [CUSTOMIFY] Image URLs:', {
            shopifyImageUrl: result.imageUrl,
            permanentImageUrl: result.permanentImageUrl,
            replicateImageUrl: this.transformedImage,
            orderId: result.orderId
          });

    // ✅ ZAPISZ NOTE ATTRIBUTES (linki dla admina) — timeout 8s, nie blokuje koszyka
    if (Object.keys(noteAttributes).length > 0) {
      try {
        await Promise.race([
          this.updateCartNoteAttributes(noteAttributes),
          new Promise((_, reject) => setTimeout(() => reject(new Error('noteAttributes timeout')), 8000))
        ]);
        console.log('✅ [CUSTOMIFY] Note attributes updated successfully');
      } catch (error) {
        console.error('⚠️ [CUSTOMIFY] Note attributes failed (nie blokuje koszyka):', error.message);
      }
    }

    // ✅ DODAJ DO KOSZYKA PRZEZ POST /cart/add.js (zamiast GET redirect)
    // POST: dostajemy JSON response → wiemy czy się udało
    // Retry tylko cart add (nie tworzy nowego produktu) → fix race condition "produkt nie gotowy"
    console.log('✅ [CUSTOMIFY] Adding to cart via POST /cart/add.js');
    const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let cartAddAttempt = 0;
    let cartAdded = false;
    while (cartAddAttempt < 3 && !cartAdded) {
      if (cartAddAttempt > 0) {
        console.log(`🔄 [CUSTOMIFY] Cart add retry ${cartAddAttempt}/2 — produkt może nie być jeszcze gotowy`);
        await new Promise(r => setTimeout(r, 1200 * cartAddAttempt)); // 1.2s, 2.4s
      }
      try {
        const addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(result.variantId, 10), quantity: 1, properties: linePropertiesForCart }] })
        });
        const addResult = await addResponse.json();
        if (addResponse.ok && addResult.items && addResult.items.length > 0) {
          cartAdded = true;
          console.log('✅ [CUSTOMIFY] Added to cart via POST successfully');
          this.hideCartLoading();
          window.location.href = cartRoot + 'cart';
        } else {
          const errMsg = addResult.description || addResult.message || addResult.error || 'Could not add to cart';
          console.warn(`⚠️ [CUSTOMIFY] Cart add attempt ${cartAddAttempt + 1} failed:`, errMsg);
          cartAddAttempt++;
        }
      } catch (addErr) {
        console.warn(`⚠️ [CUSTOMIFY] Cart add attempt ${cartAddAttempt + 1} error:`, addErr.message);
        cartAddAttempt++;
      }
    }
    if (!cartAdded && adminLinePropsMerged) {
      console.warn('⚠️ [CUSTOMIFY] Ostatnia próba: cart/add tylko z widocznymi właściwościami (bez linków admin)');
      try {
        const addResponse = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(result.variantId, 10), quantity: 1, properties: visibleOnlyForCart }] })
        });
        const addResult = await addResponse.json();
        if (addResponse.ok && addResult.items && addResult.items.length > 0) {
          cartAdded = true;
          console.log('✅ [CUSTOMIFY] Dodano do koszyka (fallback widoczne-only)');
          this.hideCartLoading();
          window.location.href = cartRoot + 'cart';
        }
      } catch (fallbackErr) {
        console.warn('⚠️ [CUSTOMIFY] Fallback cart add:', fallbackErr?.message || fallbackErr);
      }
    }
    if (!cartAdded) {
      this.hideCartLoading();
      this.showError(this.t('customizer.error.add_to_cart'), 'cart');
    }
        }
      } else {
        console.error('❌ [CUSTOMIFY] Product creation failed:', result);
        this.hideCartLoading();
        this.showError(this.t('customizer.error.product_creation', {
          reason: result.error || this.t('customizer.error.unknown')
        }), 'cart');
      }
    } catch (error) {
      console.error('❌ [CUSTOMIFY] Add to cart error:', error);
      this._reportToSentry(error, 'addToCart');
      
      // ✅ RETRY LOGIC: Ponów próbę dla network errors (max 3 próby)
      // ⚠️ TYLKO jeśli produkt NIE ZOSTAŁ JESZCZE UTWORZONY — inaczej powstają duplikaty w Shopify!
      const isNetworkErrorCart = error?.message && (
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Load failed') ||
        error.message.includes('Error completing request') ||
        error.message.includes('network failure')
      );
      if (!productCreated && retryCount < 3 && (error.name === 'AbortError' || isNetworkErrorCart)) {
        const retryDelay = (retryCount + 1) * 2000; // 2s, 4s, 6s
        console.log(`🔄 [CUSTOMIFY] Retrying addToCart in ${retryDelay}ms... (attempt ${retryCount + 1}/3)`);
        this.showError(this.t('customizer.error.network_retry', { attempt: retryCount + 1 }), 'cart');
        
        setTimeout(() => {
          this.addToCart(retryCount + 1);
        }, retryDelay);
        return;
      }
      
      this.hideCartLoading();
      
      let errorMessage = '❌ Server connection failed.';
      
      if (error.name === 'AbortError') {
        errorMessage = 'Request timed out (30 seconds).';
      } else if (error?.message && (error.message.includes('Failed to fetch') || error.message.includes('Error completing request') || error.message.includes('Load failed') || error.message.includes('NetworkError'))) {
        errorMessage = 'Network error. Check your internet connection.';
      } else if (error?.message) {
        errorMessage = '❌ Error: ' + error.message;
      } else if (typeof error === 'string') {
        errorMessage = '❌ Error: ' + error;
      }
      
      const recoveryHtml = errorMessage + ' Your image is saved - <a href="/pages/my-generations" style="color:#0066cc;text-decoration:underline;">find it in My images</a> and return to your order.';
      this.showErrorWithHTML(recoveryHtml, 'cart');
    }
  }

  async updateCartNoteAttributes(noteAttributes) {
    if (!noteAttributes || Object.keys(noteAttributes).length === 0) {
      return;
    }

    console.log('📝 [CUSTOMIFY] Updating cart note attributes:', noteAttributes);

    const payload = {
      attributes: noteAttributes
    };

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Cart note update failed: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ [CUSTOMIFY] Cart attributes saved:', data.attributes || data);
    return data;
  }

  // Ukrywanie produktu jest obsługiwane wyłącznie po stronie backendu.
  async hideProductAfterCartAdd(productId) {
    if (!productId) {
      console.log('⚠️ [CUSTOMIFY] No product ID to hide');
      return;
    }

    console.log('🔒 [CUSTOMIFY] Product visibility is handled by backend webhook:', productId);
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      
      // ZAWSZE kompresuj na frontend (optymalizacja dla Nano Banana)
      window.CustomifyPhotoUpload.withTimeout(this.compressImage(file), 'compression').then(compressedFile => {
        this.convertToBase64(compressedFile, resolve, reject);
      }).catch(error => {
        this._reportUploadError(window.CustomifyPhotoUpload.error('compression'), file, 'compression');
        // Fallback: użyj oryginalnego pliku bez kompresji — nie blokuj transformacji
        this.convertToBase64(file, resolve, reject);
      });
    });
  }

  convertToBase64(file, resolve, reject) {
    window.CustomifyPhotoUpload.readDataURL(file).then(result => resolve(result.split(',')[1]), reject);
  }

  compressImage(file) {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Oblicz nowe wymiary (max 1024px - dłuższy bok, optymalne dla Nano Banana)
        const maxSize = 1024;
        let { width, height } = img;
        
        // Znajdź dłuższy bok i przeskaluj zachowując proporcje
        const longerSide = Math.max(width, height);
        
        if (longerSide > maxSize) {
          const scale = maxSize / longerSide;
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Narysuj skompresowany obraz
        ctx.drawImage(img, 0, 0, width, height);
        
        // Konwertuj do blob z kompresją
        canvas.toBlob(blob => {
          if (blob) resolve(blob);
          else reject(window.CustomifyPhotoUpload.error('compression'));
        }, 'image/jpeg', 0.85); // 85% jakość (optymalne dla Nano Banana)
      };
      
      img.onerror = () => {
        console.error('📱 [MOBILE] Image load failed');
        reject(new Error('Could not load the photo for compression. Try another format (JPG/PNG).'));
      };
      
      img.src = URL.createObjectURL(file);
    });
  }

  reset() {
    this._singlePhotoVersion = (this._singlePhotoVersion || 0) + 1;
    this._singlePhotoPending = false;
    if (this._multiPhotoVersions) this._multiPhotoVersions = this._multiPhotoVersions.map(version => (version || 0) + 1);
    this._uploadFeedback(null);
    this.multiUploadFiles?.forEach((_, slot) => this._uploadFeedback(null, slot));
    this.uploadedFile = null;
    this.selectedStyle = null;
    this.selectedSize = null;
    this.transformedImage = null;
    this.artworkId = null;
    this.generationId = null;
    this.textOverlayBaseImage = null;
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
    this.spotifyCropConfirmed = false;
    this.closeSpotifyCropper();
    this.phoneCropConfirmed = false;
    this.closePhoneCropper();
    this.phonePhotoCropConfirmed = false;
    this.closePhonePhotoCropper();
    if (this.textOverlayInput) {
      this.textOverlayInput.value = '';
      this.updateTextOverlayCounter();
    }
    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = this.textOverlayEnabled ? 'none' : 'none';
    }
    if (this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'none';
    }
    
    this.fileInput.value = '';
    this.uploadArea.style.display = 'block'; // Pokaż pole upload z powrotem
    this.previewArea.style.display = 'none';
    this.stylesArea.style.display = 'none';
    
    // 📱 Phone case: Hide cart buttons in previewArea
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartActions) {
        phoneCaseCartActions.style.display = 'none';
      }
      if (phoneCaseCartPriceDisplay) {
        phoneCaseCartPriceDisplay.style.display = 'none';
      }
    }
    
    // Remove klasę has-result żeby previewArea mogło być widoczne po wgraniu nowego zdjęcia
    const container = document.getElementById('customify-app-container');
    if (container) {
      container.classList.remove('has-result');
    }
    this.sizeArea.style.display = 'block'; // ✅ ZAWSZE WIDOCZNE - nie ukrywaj rozmiarów
    this.actionsArea.style.display = 'none';
    this.resultArea.style.display = 'none';
    this.hideError();
    this.hideSuccess();
    
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    if (!this.applySingleStyleSelection()) this.applyDefaultWatercolourStyle();
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    
    // Przywróć stan początkowy przycisków
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    const resetBtn = document.getElementById('resetBtn');
    if (addToCartBtnMain) {
      addToCartBtnMain.style.display = 'inline-block';
    }
    if (resetBtn) {
      resetBtn.style.display = 'none';
    }
    
    // Przywróć kolory przycisków do stanu początkowego
    this.resetButtonColors();
  }

  tryAgain() {
    this.cancelPendingResultScroll();
    console.log('🔄 [CUSTOMIFY] tryAgain called - returning to style selection');
    
    // Ukryj wynik AI
    this.resultArea.style.display = 'none';
    
    // Pokaż style AI i przyciski (nie dla produktu bez AI)
    if (!this.isSpotifyNoAIProduct()) {
      if (this.applySingleStyleSelection()) {
        console.log('🎨 [SINGLE-STYLE] Restored the only available style:', this.selectedStyle);
      } else if (this.applyDefaultWatercolourStyle()) {
        console.log('🎨 [WATERCOLOR] Restored the product-specific default style');
      } else if (this.isMultiUploadProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'dodaj-osobe';
      } else if (this.isDlaNiejProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'caricature-new';
      } else if (this.isSuperheroBoyProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'superhero_boy';
      } else if (this.isLoveRoseProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'love-rose';
      } else if (this.isRoyalLoveProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'royal-love';
      } else if (this.isGTAProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'gta';
      } else if (this.isWatercolorProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'watercolor_ok';
        console.log('🎨 [WATERCOLOR] Ukryto wybór stylu, auto-select watercolor_ok');
      } else if (this.isHipHopProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'hiphop';
      } else if (this.isRetuszStarychZdjecProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'retusz-starych-zdjec';
      } else if (this.isSzkicOlowekProduct()) {
        this.stylesArea.style.display = 'none';
        this.selectedStyle = 'szkic-olowek';
      } else {
        this.stylesArea.style.display = 'block';
      }
      this.actionsArea.style.display = 'flex';
      // Przywróć transformBtn jeśli był ukryty inline stylem (e.g. przez handleBezZmianStyle)
      const transformBtnRestore = document.getElementById('transformBtn');
      if (transformBtnRestore) transformBtnRestore.style.display = '';
    }
    
    // Pokaż pole upload (jeśli było ukryte)
    this.uploadArea.style.display = 'block';
    // 🔧 Wyzeruj fileInput żeby kolejny wybór pliku zawsze odpalił change (przeglądarka nie odpala przy tym samym pliku)
    const fileInputEl = document.getElementById('fileInput');
    if (fileInputEl) fileInputEl.value = '';
    // 📸 Multi-upload: pokaż grid
    const multiUploadArea = document.getElementById('multiUploadArea');
    if (multiUploadArea && this.isMultiUploadProduct()) {
      multiUploadArea.style.display = 'block';
    }
    
    // 📱 Phone case: Hide cart buttons in previewArea
    if (this.isPhonePhotoCaseProduct && this.isPhonePhotoCaseProduct()) {
      const phoneCaseCartActions = document.getElementById('phoneCaseCartActions');
      const phoneCaseCartPriceDisplay = document.getElementById('phoneCaseCartPriceDisplay');
      if (phoneCaseCartActions) {
        phoneCaseCartActions.style.display = 'none';
      }
      if (phoneCaseCartPriceDisplay) {
        phoneCaseCartPriceDisplay.style.display = 'none';
      }
    }
    
    // Zresetuj wybrane style i rozmiary
    this.selectedStyle = this.getDefaultWatercolourStyle() || (this.isMultiUploadProduct() ? 'dodaj-osobe' : (this.isDlaNiejProduct() ? 'caricature-new' : (this.isSuperheroBoyProduct() ? 'superhero_boy' : (this.isLoveRoseProduct() ? 'love-rose' : (this.isRoyalLoveProduct() ? 'royal-love' : (this.isGTAProduct() ? 'gta' : (this.isWatercolorProduct() ? 'watercolor_ok' : (this.isHipHopProduct() ? 'hiphop' : (this.isRetuszStarychZdjecProduct() ? 'retusz-starych-zdjec' : (this.isSzkicOlowekProduct() ? 'szkic-olowek' : null))))))))));
    this.selectedSize = null;
    this.transformedImage = null;
    this.artworkId = null;
    this.generationId = null;
    this.textOverlayBaseImage = null;
    this.textOverlayWatermarkedUrl = null;
    this.textOverlayOriginalWatermarked = null;
    this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
    this.spotifyCropConfirmed = false;
    this.closeSpotifyCropper();
    this.phoneCropConfirmed = false;
    this.closePhoneCropper();
    this.phonePhotoCropConfirmed = false;
    this.closePhonePhotoCropper();
    if (this.textOverlayInput) {
      this.textOverlayInput.value = '';
      this.updateTextOverlayCounter();
    }
    if (this.textOverlayPanel) {
      this.textOverlayPanel.style.display = this.textOverlayEnabled ? 'none' : 'none';
    }
    if (this.spotifyFieldsPanel) {
      this.spotifyFieldsPanel.style.display = 'none';
    }
    
    // Remove aktywne style
    this.stylesArea.querySelectorAll('.customify-style-card').forEach(card => card.classList.remove('active'));
    if (!this.applySingleStyleSelection()) this.applyDefaultWatercolourStyle();
    
    // Remove aktywne rozmiary
    this.sizeArea.querySelectorAll('.customify-size-btn').forEach(btn => btn.classList.remove('active'));
    
    // Ukryj wiadomości
    this.hideSuccess();
    this.hideError();
    
    console.log('🔄 [CUSTOMIFY] tryAgain completed - user can select new style');
  }

  showLoading() {
    this.cancelPendingResultScroll();
    this.loadingArea.style.display = 'block';
    this.actionsArea.style.display = 'none';
    
    // Animacja paska postępu z etapami
    const progressBar = document.getElementById('progressBar');
    const loadingStage = document.getElementById('loadingStage');
    
    if (progressBar && loadingStage) {
      let progress = 0;
      const stages = [
        { percent: 20, text: this.t('customizer.loading.uploading_photo') },
        { percent: 40, text: this.t('customizer.loading.preparing_ai') },
        { percent: 60, text: this.t('customizer.loading.generating_image') },
        { percent: 80, text: this.t('customizer.loading.finalizing') },
        { percent: 95, text: this.t('customizer.loading.almost_ready') }
      ];
      
      let currentStage = 0;
      progressBar.style.width = '0%';
      loadingStage.textContent = stages[0].text;
      
      this.progressInterval = setInterval(() => {
        if (currentStage < stages.length) {
          const targetPercent = stages[currentStage].percent;
          if (progress < targetPercent) {
            progress += 1;
            progressBar.style.width = progress + '%';
          } else {
            loadingStage.textContent = stages[currentStage].text;
            currentStage++;
          }
        }
      }, 100); // Aktualizacja co 100ms
    }
  }

  hideLoading() {
    // Zatrzymaj animację paska postępu
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
    
    // Ustaw pasek na 100% przed ukryciem
    const progressBar = document.getElementById('progressBar');
    if (progressBar) {
      progressBar.style.width = '100%';
    }
    
    this.loadingArea.style.display = 'none';
    // NIE pokazuj actionsArea jeśli mamy już wynik AI
    console.log('🎯 [CUSTOMIFY] hideLoading called, transformedImage:', !!this.transformedImage);
    if (!this.transformedImage) {
      this.actionsArea.style.display = 'flex';
      console.log('🎯 [CUSTOMIFY] actionsArea shown because no transformedImage');
    } else {
      console.log('🎯 [CUSTOMIFY] actionsArea NOT shown because transformedImage exists');
    }
  }

  showCartLoading() {
    const cartLoadingArea = document.getElementById('cartLoadingArea');
    if (cartLoadingArea) {
      cartLoadingArea.style.display = 'block';
      
      // Animacja paska postępu dla koszyka
      const progressBar = document.getElementById('cartProgressBar');
      const loadingStage = document.getElementById('cartLoadingStage');
      
      if (progressBar && loadingStage) {
        let progress = 0;
        const stages = [
          { percent: 25, text: this.t('customizer.cart.creating_product') },
          { percent: 50, text: this.t('customizer.cart.uploading_image') },
          { percent: 75, text: this.t('customizer.cart.adding') },
          { percent: 90, text: this.t('customizer.loading.finalizing') }
        ];
        
        let currentStage = 0;
        progressBar.style.width = '0%';
        loadingStage.textContent = stages[0].text;
        
        this.cartProgressInterval = setInterval(() => {
          if (currentStage < stages.length) {
            const targetPercent = stages[currentStage].percent;
            if (progress < targetPercent) {
              progress += 1;
              progressBar.style.width = progress + '%';
            } else {
              loadingStage.textContent = stages[currentStage].text;
              currentStage++;
            }
          }
        }, 80); // Szybsza animacja dla koszyka
      }
    }
  }

  hideCartLoading() {
    const cartLoadingArea = document.getElementById('cartLoadingArea');
    if (cartLoadingArea) {
      // Zatrzymaj animację paska postępu
      if (this.cartProgressInterval) {
        clearInterval(this.cartProgressInterval);
        this.cartProgressInterval = null;
      }
      
      // Ustaw pasek na 100% przed ukryciem
      const progressBar = document.getElementById('cartProgressBar');
      if (progressBar) {
        progressBar.style.width = '100%';
      }
      
      cartLoadingArea.style.display = 'none';
    }
  }

  /** A/B wariant komunikatu o limicie (raz na przeglądarkę) */
  getLimitMessageVariant() {
    try {
      let v = safeLocalStorageGet('customify_limit_msg_variant');
      if (!v) {
        v = Math.random() < 0.5 ? 'A' : 'B';
        safeLocalStorageSet('customify_limit_msg_variant', v);
      }
      return v;
    } catch {
      return 'default';
    }
  }

  /** Lejek limitu → KV (panel /admin/limit-wall-users) */
  trackLimitFunnelShowLimit(customerInfo, opts = {}) {
    if (!customerInfo?.customerId) return;
    const body = {
      event: 'limit_message_shown',
      customerId: String(customerInfo.customerId),
      messageVariant: opts.messageVariant || this.getLimitMessageVariant(),
      wallTier: opts.wallTier || 'unknown',
      productHandle: typeof this.getProductHandle === 'function' ? this.getProductHandle() : null,
      source: opts.source || 'transform_403'
    };
    fetch(window.CustomifyApi.url('/api/limit-funnel-event'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(() => {});
  }

  trackLimitFunnelGenerationSuccess(customerInfo) {
    if (!customerInfo?.customerId) return;
    fetch(window.CustomifyApi.url('/api/limit-funnel-event'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: 'generation_success',
        customerId: String(customerInfo.customerId)
      })
    }).catch(() => {});
  }

  showError(message, location = 'top') {
    // Ukryj wszystkie komunikaty błędów najpierw
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
    
    // Pokaż błąd w odpowiednim miejscu
    if (location === 'transform' && this.errorMessageTransform) {
      // Błędy transformacji - nad przyciskiem "Zobacz Preview"
      this.errorMessageTransform.textContent = message;
      this.errorMessageTransform.style.display = 'block';

      // Na mobile komunikat może znajdować się nad widocznym obszarem po
      // kliknięciu "Add to cart". Przewiń tylko wtedy, gdy faktycznie go nie widać.
      const transformError = this.errorMessageTransform;
      // Pomiar synchroniczny wymusza aktualny layout i nie zależy od animacji karty.
      const rect = transformError.getBoundingClientRect();
      const isOutsideViewport = rect.top < 80 || rect.bottom > window.innerHeight - 24;
      if (isOutsideViewport) {
        const targetTop = Math.max(
          0,
          window.scrollY + rect.top - (window.innerHeight - rect.height) / 2
        );
        (document.scrollingElement || document.documentElement).scrollTop = targetTop;
      }
    } else if (location === 'cart') {
      // Błędy koszyka - nad przyciskiem "Dodaj do koszyka"
      // 📱 Etui: pokaż w errorMessageBottom (zaraz pod #cartPriceDisplay)
      if (this.errorMessageBottom) {
        this.errorMessageBottom.textContent = message;
        this.errorMessageBottom.style.display = 'block';
      }
    } else if (location === 'top' && this.errorMessage) {
      // Błędy uploadu/walidacji pliku - na górze
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    } else {
      // Fallback: pokaż w górze jeśli nie określono lokalizacji
      if (this.errorMessage) {
        this.errorMessage.textContent = message;
        this.errorMessage.style.display = 'block';
      }
    }
  }

  showErrorWithHTML(message, location = 'top') {
    // Ukryj wszystkie komunikaty błędów najpierw
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
    
    // Pokaż błąd z HTML w odpowiednim miejscu
    if (location === 'transform' && this.errorMessageTransform) {
      // Błędy transformacji - nad przyciskiem "Zobacz Preview"
      this.errorMessageTransform.innerHTML = message;
      this.errorMessageTransform.style.display = 'block';
    } else if (location === 'cart') {
      // Błędy koszyka - nad przyciskiem "Dodaj do koszyka"
      // 📱 Etui: pokaż w errorMessageBottom (zaraz pod #cartPriceDisplay)
      if (this.errorMessageBottom) {
        this.errorMessageBottom.innerHTML = message;
        this.errorMessageBottom.style.display = 'block';
      }
    } else if (location === 'top' && this.errorMessage) {
      // Błędy uploadu/walidacji pliku - na górze
      this.errorMessage.innerHTML = message;
      this.errorMessage.style.display = 'block';
    } else {
      // Fallback: pokaż w górze jeśli nie określono lokalizacji
      if (this.errorMessage) {
        this.errorMessage.innerHTML = message;
        this.errorMessage.style.display = 'block';
      }
    }
  }

  hideError() {
    // Ukryj wszystkie komunikaty błędów
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
    if (this.errorMessageTransform) {
      this.errorMessageTransform.style.display = 'none';
    }
    if (this.errorMessageBottom) {
      this.errorMessageBottom.style.display = 'none';
    }
    const phoneCaseCartError = document.getElementById('phoneCaseCartError');
    if (phoneCaseCartError) {
      phoneCaseCartError.style.display = 'none';
    }
  }

  showGeneratedImageSuccess(customerInfo, historySaved = true, canRetry = true) {
    if (customerInfo && !historySaved) {
      const german = /^de/i.test(window.CustomifyI18n?.locale || window.CustomifyMarketContext?.locale || 'en');
      this.showSuccess(!canRetry
        ? (german ? 'Dein Bild ist fertig, konnte aber noch nicht unter „Meine Bilder“ gespeichert werden. Bitte lass diese Seite geöffnet und kontaktiere uns.' : 'Your image is ready, but saving to My images is not confirmed. Please keep this page open and contact us for help.')
        : german
        ? 'Dein Bild ist fertig. Der Eintrag unter „Meine Bilder“ ist noch nicht bestätigt. Wir versuchen das Speichern erneut; bitte lass diese Seite geöffnet.'
        : 'Your image is ready. Saving to My images is not confirmed yet. We are retrying; please keep this page open.');
      return;
    }
    const locale = String(window.CustomifyI18n?.locale || window.CustomifyMarketContext?.locale || 'en').toLowerCase().split('-')[0];
    if (locale === 'en') {
      const saved = customerInfo
        ? 'Saved in <a href="https://giftedphoto.com/pages/my-generations" target="_blank" rel="noopener">My images</a>.'
        : 'Saved in My images.';
      this.showSuccess(`<div class="customify-success-next"><strong class="customify-success-title">Your portrait is ready!</strong><p><strong>Choose your print type and size below, then click “Add to cart”.</strong></p></div><p class="customify-success-adjustments">Want changes? Our designer will make them for free with your order. Tell us what to change in the cart notes.</p><p class="customify-success-saved">${saved}</p>`, { html: true, compact: true, generated: true });
      return;
    }
    // Preserve existing localized meaning and the saved-images link.
    const correctionNote = this.t('customizer.success.correction_note');
    if (customerInfo) {
      const myImagesLabel = this.t('customizer.success.my_images');
      const savedMessage = this.t('customizer.success.saved_logged_in');
      this.showSuccess(`${savedMessage} <a href="https://giftedphoto.com/pages/my-generations" target="_blank" rel="noopener">${myImagesLabel}</a>.<br><span style="font-size:0.88em;color:#555;">${correctionNote}</span>`, { html: true, compact: true });
    } else {
      this.showSuccess(`${this.t('customizer.success.saved_guest')}<br><span style="font-size:0.88em;color:#555;">${correctionNote}</span>`, { html: true, compact: true });
    }
  }

  showSuccess(message, options = {}) {
    this.successMessage.classList.toggle('customify-success-compact', Boolean(options.compact));
    this.successMessage.classList.toggle('customify-success-generated', Boolean(options.generated));
    if (options.html) {
      this.successMessage.innerHTML = message;
    } else {
      this.successMessage.textContent = message;
    }
    this.successMessage.style.display = 'block';
  }

  hideSuccess() {
    this.successMessage.style.display = 'none';
  }

  // Zmień kolory przycisków po wygenerowaniu AI
  swapButtonColors() {
    const transformBtn = document.getElementById('transformBtn');
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    
    if (transformBtn && addToCartBtnMain) {
      // Po AI: "Zobacz Preview" -> czarny, "Dodaj do koszyka" -> czerwony
      transformBtn.classList.remove('customify-btn-red');
      transformBtn.classList.add('customify-btn-primary');
      addToCartBtnMain.classList.remove('customify-btn-primary');
      addToCartBtnMain.classList.add('customify-btn-red');
      console.log('🔄 [CUSTOMIFY] Button colors swapped after AI generation');
    }
  }

  // Przywróć kolory przycisków do stanu początkowego
  resetButtonColors() {
    const transformBtn = document.getElementById('transformBtn');
    const addToCartBtnMain = document.getElementById('addToCartBtnMain');
    
    if (transformBtn && addToCartBtnMain) {
      // Na początku: "Zobacz Preview" -> czerwony, "Dodaj do koszyka" -> czarny
      transformBtn.classList.remove('customify-btn-primary');
      transformBtn.classList.add('customify-btn-red');
      addToCartBtnMain.classList.remove('customify-btn-red');
      addToCartBtnMain.classList.add('customify-btn-primary');
      console.log('🔄 [CUSTOMIFY] Button colors reset to initial state');
    }
  }
}

/**
 * CART - ukryj Order ID, Cena (w properties), sekcja ilości
 */
function hideCartOrderIdQuantityCena() {
  const items = document.querySelectorAll('.cart-item, .cart-items__row, tr[role="row"]');
  items.forEach(r => {
    r.querySelectorAll('.cart-items__properties dt').forEach(dt => {
      const t = (dt.textContent || '').trim().toLowerCase();
      const dd = dt.nextElementSibling;
      if ((t.includes('order id') || t === 'cena') && dd) {
        dt.style.display = dd.style.display = 'none';
      }
    });
    // Ukryj TYLKO kontrolki ilości (+/-, input), nie cały komponent – inaczej ukrywa się symbol Remove
    const quantitySelectors = 'quantity-selector-component .quantity-minus, quantity-selector-component .quantity-plus, quantity-selector-component input, quantity-input .quantity-minus, quantity-input .quantity-plus, quantity-input input';
    r.querySelectorAll(quantitySelectors).forEach(x => { x.style.display = 'none'; });
    // Przycisk usuwania – pokaż (ZACHOWAJ ikonę kosza SVG! el.textContent usuwało ją)
    const removeSelectors = 'a[href*="quantity=0"], a[href*="cart/change"], .cart-item__remove, .line-item__remove, [data-cart-remove], button[aria-label*="Remove"], button[aria-label*="Usuń"]';
    r.querySelectorAll(removeSelectors).forEach(el => {
      el.style.display = '';
      el.style.visibility = 'visible';
      if (el.querySelector('svg')) {
        // Ma ikonę – zachowaj SVG, usuń resztę (e.g. "Remove"), dodaj "Usuń"
        const svg = el.querySelector('svg');
        el.innerHTML = '';
        el.appendChild(svg.cloneNode(true));
        const txt = document.createElement('span');
        txt.className = 'customify-remove-text';
        txt.textContent = ' Remove';
        el.appendChild(txt);
      } else {
        // Brak ikony – dodaj ikonę kosza + tekst
        const iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
        el.innerHTML = iconSvg + ' <span class="customify-remove-text">Remove</span>';
      }
      el.setAttribute('aria-label', 'Remove');
    });
    // Fallback: znajdź w komórce ilości cokolwiek z "Remove"
    r.querySelectorAll('td:nth-child(3) a, td:nth-child(3) button').forEach(el => {
      if ((el.textContent || '').trim().toLowerCase().includes('remove') || (el.getAttribute('aria-label') || '').toLowerCase().includes('remove')) {
        el.style.display = '';
        el.style.visibility = 'visible';
        if (el.querySelector('svg')) {
          const svg = el.querySelector('svg');
          el.innerHTML = '';
          el.appendChild(svg.cloneNode(true));
          const txt = document.createElement('span');
          txt.className = 'customify-remove-text';
          txt.textContent = ' Remove';
          el.appendChild(txt);
        } else {
          const iconSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>';
          el.innerHTML = iconSvg + ' <span class="customify-remove-text">Remove</span>';
        }
        el.setAttribute('aria-label', 'Remove');
      }
    });
  });
  // Nagłówek kolumny – zmień na "Usuń" zamiast "Ilość"
  document.querySelectorAll('.cart-items th:nth-child(3)').forEach(h => {
    h.style.display = '';
    const t = (h.textContent || '').trim().toLowerCase();
    if (t.includes('ilość') || t.includes('quantity')) h.textContent = 'Remove';
  });
}

/**
 * CART INTEGRATION - AI Image Display
 */
function initCartIntegration() {
  if (window.location.pathname.includes('/cart')) hideCartOrderIdQuantityCena();
  // Znajdź wszystkie elementy koszyka z AI obrazkami
  const cartItems = document.querySelectorAll('.cart-item, .cart-items__row');
  
  cartItems.forEach(item => {
    // Ukryte property z URL obrazu (stara i nowa nazwa — zamówienie w adminie: „Link do zdjęcia:”)
    const aiImageProperty = item.querySelector('dd[data-property="_AI_Image_URL"], dd[data-property="_Photo link"], dd[data-property="Photo link"], dd[data-property="Link do zdjęcia"]');
    
    const imageUrl = aiImageProperty?.textContent?.trim() || '';
    const looksLikeHttpImageUrl = imageUrl.startsWith('http') && imageUrl.length > 24;
    if (aiImageProperty && looksLikeHttpImageUrl) {
      
      // Ukryj surowy URL
      const propertyDiv = aiImageProperty.closest('.cart-items__properties');
      if (propertyDiv) {
        propertyDiv.style.display = 'none';
      }
      
      // Dodaj miniaturkę
      const imageCell = item.querySelector('.cart-items__image, .cart-item__image-wrapper');
      if (imageCell && !imageCell.querySelector('.cart-item__ai-image')) {
        const aiImage = document.createElement('img');
        aiImage.src = imageUrl;
        aiImage.alt = 'AI Transformed Image';
        aiImage.className = 'cart-item__ai-image';
        aiImage.style.cssText = 'width: 80px; height: 80px; object-fit: cover; border-radius: 0; border: 2px solid #e0e0e0;';
        
        // Wstaw miniaturkę jako główny obrazek lub obok
        const existingImage = imageCell.querySelector('img');
        if (existingImage) {
          existingImage.replaceWith(aiImage);
        } else {
          imageCell.appendChild(aiImage);
        }
      }
    }
  });
}

/**
 * MOBILE THUMBNAILS - Dodaj miniaturki na mobile
 */
function addMobileThumbnails() {
  // Sprawdź czy jesteśmy na mobile
  if (window.innerWidth > 749) return;
  
  // Znajdź właściwy container - product information media (widoczny na mobile)
  const mediaContainer = document.querySelector('.product-information__media');
  if (!mediaContainer) {
    console.log('🎯 [CUSTOMIFY] Media container not found, skipping thumbnails');
    return;
  }
  
  // Sprawdź czy miniaturki już istnieją
  if (mediaContainer.querySelector('.customify-mobile-thumbnails')) return;
  
  // Znajdź wszystkie obrazy w kontenerze
  const productImages = mediaContainer.querySelectorAll('img');
  if (productImages.length < 2) return; // Potrzebujemy co najmniej 2 obrazy
  
  console.log('🎯 [CUSTOMIFY] Dodaję miniaturki na mobile, znaleziono', productImages.length, 'obrazów');
  
  // Stwórz container dla miniaturek
  const thumbnailsContainer = document.createElement('div');
  thumbnailsContainer.className = 'customify-mobile-thumbnails';
  thumbnailsContainer.style.cssText = `
    display: flex !important;
    gap: 8px !important;
    padding: 10px !important;
    justify-content: center !important;
    margin-top: 10px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  `;
  
  // Dodaj miniaturki (użyj pierwszych 3 obrazów - 0, 1, 2)
  for (let i = 0; i < Math.min(3, productImages.length); i++) {
    const img = productImages[i];
    const thumbnail = document.createElement('div');
    thumbnail.className = 'customify-mobile-thumbnail';
    thumbnail.style.cssText = `
      width: 60px !important;
      height: 60px !important;
      border-radius: 6px !important;
      border: 2px solid #e0e0e0 !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
      overflow: hidden !important;
      flex-shrink: 0 !important;
    `;
    
    // Stwórz nowy obraz z tym samym src
    const thumbnailImg = document.createElement('img');
    thumbnailImg.src = img.src;
    thumbnailImg.alt = img.alt || 'Thumbnail';
    thumbnailImg.style.cssText = `
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      border-radius: 4px !important;
    `;
    
    thumbnail.appendChild(thumbnailImg);
    
    // Dodaj event listener do kliknięcia
    thumbnail.addEventListener('click', () => {
      // Znajdź odpowiedni przycisk nawigacji i kliknij go
      const navButtons = document.querySelectorAll('.slideshow-control');
      if (navButtons[i]) {
        navButtons[i].click();
        console.log('🎯 [CUSTOMIFY] Kliknięto miniaturkę', i);
      }
    });
    
    // Hover effect
    thumbnail.addEventListener('mouseenter', () => {
      thumbnail.style.borderColor = '#dc3545';
      thumbnail.style.transform = 'scale(1.05)';
    });
    
    thumbnail.addEventListener('mouseleave', () => {
      thumbnail.style.borderColor = '#e0e0e0';
      thumbnail.style.transform = 'scale(1)';
    });
    
    thumbnailsContainer.appendChild(thumbnail);
  }
  
  // Dodaj container do media container
  mediaContainer.appendChild(thumbnailsContainer);
  console.log('✅ [CUSTOMIFY] Miniaturki na mobile dodane pomyślnie');
}

/**
 * INITIALIZATION
 */
document.addEventListener('DOMContentLoaded', () => {
  // B5: Stara przeglądarka bez obsługi ES Modules / nowoczesnego JS
  if (window.CUSTOMIFY_LEGACY_BROWSER) {
    const container = document.getElementById('customify-app-container');
    if (container) {
      container.innerHTML = '<div style="background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:16px;margin:16px 0;font-family:sans-serif;font-size:14px;color:#856404"><strong>⚠️ Your browser is too old</strong><br>Photo personalization requires a newer browser. Update your browser to the latest version (Chrome, Safari, Firefox) or try another device.</div>';
    }
    return;
  }

  // Simple-product: nie uruchamiaj Customify w ogóle (strona ma tylko przycisk Kup → koszyk)
  const p = window.ShopifyProduct;
  if (p && p.tags) {
    const tags = Array.isArray(p.tags) ? p.tags : String(p.tags).split(',');
    if (tags.some(t => String(t).toLowerCase().trim() === 'simple-product')) {
      return;
    }
  }

  // Initialize Customify app
  const customifyApp = new CustomifyEmbed();

  // An email link is a bearer grant for this artwork only. The token stays in
  // the URL fragment (never sent to Shopify in the page request or referrer).
  const artworkToken = new URLSearchParams(window.location.hash.slice(1)).get('gifted-artwork');
  if (artworkToken) {
    // Keep the email as the bookmark; remove the bearer token from visible
    // browser history and error-reporting URLs as soon as it is captured.
    try { window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search); } catch (_) {}
    const currentHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
    fetch(window.CustomifyApi.url('/api/artwork-return'), {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: artworkToken })
    }).then(async response => {
      if (!response.ok) throw new Error('ARTWORK_UNAVAILABLE');
      const { work } = await response.json();
      if (!work || work.productHandle !== currentHandle) throw new Error('ARTWORK_PRODUCT_MISMATCH');
      setTimeout(() => {
        customifyApp.reuseGeneration({
          id: work.id, artworkId: work.artworkId, generationId: work.generationId,
          transformedImage: work.imageUrl, watermarkedImageUrl: work.watermarkedImageUrl,
          style: work.style, productType: work.productType, size: work.size,
          originalImage: null
        });
        document.getElementById('resultArea')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 2000);
    }).catch(() => {
      const isGerman = window.location.pathname.startsWith('/de-de/');
      customifyApp.showError(isGerman
        ? 'Dieses Bild konnte nicht geöffnet werden. Bitte kontaktiere uns über die E-Mail.'
        : 'This artwork could not be opened. Please reply to the email for help.');
    });
  }
  
  // ✅ AUTO-LOAD: Sprawdź czy user wybrał generację na stronie "Moje generacje"
  try {
    const selectedData = artworkToken ? null : safeLocalStorageGet('customify_selected_generation');
    if (selectedData) {
      const { index, generation } = JSON.parse(selectedData);
      console.log('🎯 [CUSTOMIFY] Auto-loading generation from "Moje generacje":', index, generation);
      
      // Załaduj generację używając reuseGeneration() (ta sama funkcja co kliknięcie w galerii)
      setTimeout(() => {
        // Sprawdź czy DOM jest gotowy (resultImage musi istnieć)
        const resultImage = document.getElementById('resultImage');
        if (!resultImage) {
          console.warn('⚠️ [CUSTOMIFY] resultImage not found, retrying in 1s...');
          setTimeout(() => {
            customifyApp.reuseGeneration(generation);
            console.log('✅ [CUSTOMIFY] Generation loaded from "Moje generacje" (retry), ready for checkout');
          }, 1000);
          return;
        }
        
        customifyApp.reuseGeneration(generation);
        console.log('✅ [CUSTOMIFY] Generation loaded from "Moje generacje", ready for checkout');
        
        // Scroll do wyniku żeby user widział co się załadowało
        const resultArea = document.getElementById('resultArea');
        if (resultArea) {
          resultArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 2000); // 2s delay żeby DOM się załadował + galeria się zbudowała
      
      // Wyczyść po użyciu
      safeLocalStorageRemove('customify_selected_generation');
    }
  } catch (error) {
    console.error('❌ [CUSTOMIFY] Error loading selected generation:', error);
    if (typeof Sentry !== 'undefined' && Sentry.captureException) {
      Sentry.captureException(error, { tags: { customify_area: 'load-selected-generation' } });
    }
  }
  
  // Initialize cart integration
  initCartIntegration();
  
  // Add mobile thumbnails - WYŁĄCZONE (miniaturki są obsługiwane przez theme.liquid)
  // addMobileThumbnails();
  
  // Re-add thumbnails on resize - WYŁĄCZONE
  // window.addEventListener('resize', () => {
  //   addMobileThumbnails();
  // });
  
  // Clean up dividers and spacing
  window.addEventListener('load', () => {
    setTimeout(() => {
      // Add mobile thumbnails after load - WYŁĄCZONE
      // addMobileThumbnails();
      // USUŃ DIVIDERY FIZYCZNIE Z DOM
      const dividers = document.querySelectorAll('.divider, .divider__line, .divider-AM3M2YnhsTllLTUtCS__divider_VJhene');
      dividers.forEach(divider => {
        if (divider && divider.parentNode) {
          divider.parentNode.removeChild(divider);
          console.log('🎯 [CUSTOMIFY] Divider usunięty z DOM');
        }
      });

      // AGRESYWNE USUNIĘCIE ODSTĘPÓW MIĘDZY TYTUŁEM A BADGE'AMI
      const titleElement = document.querySelector('.view-product-title');
      const badgesElement = document.querySelector('.product-badges');
      
      if (titleElement) {
        titleElement.style.setProperty('margin-bottom', '0px', 'important');
        titleElement.style.setProperty('padding-bottom', '0px', 'important');
        titleElement.style.setProperty('margin', '0 0 0px 0', 'important');
        console.log('🎯 [CUSTOMIFY] Odstępy tytułu usunięte (inline)');
      }
      
      if (badgesElement) {
        badgesElement.style.setProperty('margin', '0 0 8px 0', 'important');
        badgesElement.style.setProperty('padding', '0', 'important');
        badgesElement.style.setProperty('gap', '8px', 'important');
        badgesElement.style.setProperty('display', 'block', 'important');
        console.log('🎯 [CUSTOMIFY] Odstęp badge\'ów ustawiony: 8px');
      }

      // DODATKOWE FORCE HIDE DIVIDERS - INLINE STYLES
      const allDividers = document.querySelectorAll('.divider, .divider__line, .divider-AM3M2YnhsTllLTUtCS__divider_VJhene');
      allDividers.forEach(divider => {
        divider.style.setProperty('display', 'none', 'important');
        divider.style.setProperty('visibility', 'hidden', 'important');
        divider.style.setProperty('opacity', '0', 'important');
        divider.style.setProperty('height', '0', 'important');
        divider.style.setProperty('margin', '0', 'important');
        divider.style.setProperty('padding', '0', 'important');
        divider.style.setProperty('border', 'none', 'important');
        console.log('🎯 [CUSTOMIFY] Divider ukryty (inline styles)');
      });
    }, 1000); // Zwiększ opóźnienie do 1 sekundy
  });
});

// FUNKCJA NAPRAWY POWIĘKSZONYCH ZDJĘĆ W DIALOGU - UNIWERSALNA
function fixDialogImages() {
  const dialog = document.querySelector('dialog[open]');
  if (!dialog) return;
  
  // Znajdź wszystkie zdjęcia w dialogu
  const allImages = dialog.querySelectorAll('img');
  let largestImg = null;
  let largestWidth = 0;
  
  allImages.forEach(img => {
    const width = img.clientWidth;
    if (width > largestWidth) {
      largestWidth = width;
      largestImg = img;
    }
  });
  
  if (!largestImg) return;
  
  // Wymuś poprawne style - WYPEŁNIA CAŁY KONTENER
  largestImg.style.setProperty('object-fit', 'cover', 'important');
  largestImg.style.setProperty('max-height', 'none', 'important');
  largestImg.style.setProperty('height', '100%', 'important');
  largestImg.style.setProperty('width', '100%', 'important');
  largestImg.style.setProperty('object-position', 'center', 'important');
  
  // Styluj kontener
  if (largestImg.parentElement) {
    largestImg.parentElement.style.setProperty('height', '100%', 'important');
  }
  
  console.log('✅ Zdjęcie w dialogu naprawione - brak białych pól!');
}

// Event listener dla kliknięć w przyciski powiększenia
document.addEventListener('click', function(e) {
  const zoomButton = e.target.closest('.product-media-container__zoom-button, button[class*="zoom"]');
  if (zoomButton) {
    setTimeout(fixDialogImages, 100);  // Czekaj aż dialog się otworzy
    setTimeout(fixDialogImages, 300);  // Ponownie po załadowaniu
    setTimeout(fixDialogImages, 600);  // I jeszcze raz dla pewności
  }
});

// Regularnie sprawdzaj czy dialog jest otwarty i naprawiaj
setInterval(fixDialogImages, 300);



// ====================================================
// DYNAMICZNE PRZENOSZENIE SEKCJI RODZAJU I ROZMIARU
// ====================================================
 document.addEventListener('DOMContentLoaded', function() {
 var resultArea = document.getElementById('resultArea');
 var inlineSlot = document.getElementById('type-size-inline-slot');
 var originalPlaceholder = document.getElementById('type-size-original-placeholder');
 var productTypeArea = document.getElementById('productTypeArea');
 var sizeArea = document.getElementById('sizeArea');
 // Elemente ramki
 var frameSelector = document.getElementById('frameSelector');
 var frameToggle = document.getElementById('frameToggle');
 var frameOptions = document.getElementById('frameOptions');
 var frameCurrentLabel = document.getElementById('frameCurrentLabel');

 if (!resultArea || !inlineSlot || !originalPlaceholder || !productTypeArea || !sizeArea) {
 return;
 }

 function isVisible(el) {
 if (!el) return false;
 var style = window.getComputedStyle(el);
 return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
 }

 function moveToResult() {
 if (!inlineSlot.contains(productTypeArea)) {
 inlineSlot.appendChild(productTypeArea);
 }
 // Przenieś selektor pakietów cyfrowych (między typem a rozmiarem)
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector && !inlineSlot.contains(pkgSelector)) {
 inlineSlot.appendChild(pkgSelector);
 }
 if (!inlineSlot.contains(sizeArea)) {
 inlineSlot.appendChild(sizeArea);
 }
 }

 function moveBack() {
 if (productTypeArea && productTypeArea.parentElement !== originalPlaceholder.parentElement) {
 originalPlaceholder.parentNode.insertBefore(productTypeArea, originalPlaceholder);
 }
 // Cofnij selektor pakietów cyfrowych
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector && pkgSelector.parentElement !== originalPlaceholder.parentElement) {
 originalPlaceholder.parentNode.insertBefore(pkgSelector, originalPlaceholder);
 }
 if (sizeArea && sizeArea.parentElement !== originalPlaceholder.parentElement) {
 originalPlaceholder.parentNode.insertBefore(sizeArea, originalPlaceholder);
 }
 }

 function syncPosition() {
 // 🎵 SPOTIFY: Nie przenoś elementów gdy "bez-zmian" jest aktywny
 if (window.spotifyBezZmianActive) {
 return;
 }
 if (isVisible(resultArea)) {
 moveToResult();
 } else {
 moveBack();
 }
 }

 // Obserwuj zmiany widoczności
 var observer = new MutationObserver(syncPosition);
 observer.observe(resultArea, { attributes: true, attributeFilter: ['style', 'class'], subtree: false });

 // Polling jako fallback (e.g. zmiany przez skrypty zewnętrzne)
 setInterval(syncPosition, 500);

 // Pierwsza synchronizacja
 syncPosition();

 // ============ LOGIKA RAMKI ============
 // Stan globalny (współdzielony między lokalizacjami)
 window.CustomifyFrame = window.CustomifyFrame || { color: 'none' };

 function setFrame(color) {
 window.CustomifyFrame.color = color;
 // Aktualizuj UI
 if (frameCurrentLabel) {
 var isCanvas = isCanvasSelected();
 var translateFrame = window.CustomifyI18n && typeof window.CustomifyI18n.t === 'function'
 ? window.CustomifyI18n.t
 : function(_key, fallback) { return fallback; };
 frameCurrentLabel.textContent =
 color === 'black' ? (isCanvas ? translateFrame('customizer.frame.black_canvas', 'Premium frame – American Box Black') : translateFrame('customizer.frame.black', 'Black')) :
 color === 'white' ? translateFrame('customizer.frame.white', 'White') :
 color === 'wood' ? (isCanvas ? translateFrame('customizer.frame.wood_canvas', 'Premium frame – American Box Natural Wood') : translateFrame('customizer.frame.wood', 'Wood')) :
 (isCanvas ? translateFrame('customizer.frame.classic_canvas', 'Classic frame – stretcher frame') : translateFrame('customizer.frame.none', 'No frame'));
 }
 if (frameOptions) {
 var opts = frameOptions.querySelectorAll('.frame-option');
 opts.forEach(function(opt){
 opt.setAttribute('aria-selected', opt.getAttribute('data-frame') === color ? 'true' : 'false');
 });
 }
 }

 function toggleOptions() {
 if (!frameOptions) return;
 var isOpen = frameOptions.style.display !== 'none';
 frameOptions.style.display = isOpen ? 'none' : 'block';
 if (frameSelector) frameSelector.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
 }

 function closeOptions() {
 if (frameOptions) {
 frameOptions.style.display = 'none';
 if (frameSelector) frameSelector.setAttribute('aria-expanded', 'false');
 }
 }

 function isPlakatSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'plakat';
 }

 function isCanvasSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'canvas';
 }

 // 🚨 ROLLBACK: START - Funkcje dla produktu cyfrowego
 function isDigitalProductSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'digital';
 }

 function updateDigitalProductUI() {
 var isDigital = isDigitalProductSelected();
 var sizeArea = document.getElementById('sizeArea');
 
 // Ukryj/pokaż rozmiary
 if (sizeArea) {
 if (isDigital) {
 sizeArea.style.display = 'none';
 console.log('📦 [DIGITAL] Size area hidden for digital product');
 } else {
 sizeArea.style.display = 'block';
 console.log('📦 [DIGITAL] Size area shown for physical product');
 }
 }

 // Pokaż/ukryj selektor pakietów cyfrowych
 var pkgSelector = document.getElementById('digitalPackageSelector');
 if (pkgSelector) {
 pkgSelector.style.display = isDigital ? 'block' : 'none';
 console.log('📦 [DIGITAL] Package selector:', isDigital ? 'shown' : 'hidden');
 }
 }
 // 🚨 ROLLBACK: END - Funkcje dla produktu cyfrowego

 function updateFrameAvailability() {
 var enabled = isPlakatSelected() || isCanvasSelected();
 // This family portrait uses a landscape print file. Gelato offers its classic
 // canvas in every size, but not the premium canvas frame or 16x24 poster frame.
 var isFamilyPortrait = window.__customify && window.__customify.isMultiUploadProduct();
 var selectedSize = window.__customify && window.__customify.selectedSize;
 var familyNoPremiumFrame = isFamilyPortrait &&
 (isCanvasSelected() || (isPlakatSelected() && selectedSize === 'a2'));
 if (frameOptions) {
 frameOptions.querySelectorAll('.frame-option').forEach(function(option) {
 option.style.display = familyNoPremiumFrame && option.getAttribute('data-frame') !== 'none' ? 'none' : '';
 });
 }
 if (familyNoPremiumFrame) {
 if (window.CustomifyFrame.color !== 'none') {
 setFrame('none');
 window.__customify.updateProductPrice();
 window.__customify.updateCartPrice();
 }
 }
 // 🚨 ROLLBACK: START - Ukryj ramkę dla produktu cyfrowego
 var isDigital = isDigitalProductSelected();
 if (isDigital) {
 enabled = false; // Produkt cyfrowy nie ma ramki
 }
 // 🚨 ROLLBACK: END - Ukryj ramkę dla produktu cyfrowego
 
 if (frameSelector) {
 if (enabled) {
 frameSelector.style.display = 'block'; // ✅ Pokazuje ramkę
 frameSelector.classList.remove('disabled');
 frameSelector.classList.toggle('canvas-frame-mode', isCanvasSelected());
 frameSelector.classList.toggle('poster-frame-mode', isPlakatSelected());
 if (isCanvasSelected() && window.CustomifyFrame && window.CustomifyFrame.color === 'white') {
 setFrame('none');
 } else {
 setFrame((window.CustomifyFrame && window.CustomifyFrame.color) || 'none');
 }
 } else {
 frameSelector.style.display = 'none'; // ✅ Całkowicie ukrywa ramkę
 frameSelector.classList.add('disabled');
 frameSelector.classList.remove('canvas-frame-mode', 'poster-frame-mode');
 closeOptions();
 }
 }
 }

 // ============ 🆕 LOGIKA PODSTAWKI (SZKŁO) ============
 var HIDE_GLASS_PRINT = true;
 window.CustomifyStand = window.CustomifyStand || { type: 'none' };
 
 var standSelector = document.getElementById('standSelector');
 var standToggle = document.getElementById('standToggle');
 var standOptions = document.getElementById('standOptions');
 var standCurrentLabel = document.getElementById('standCurrentLabel');

 function hideGlassPrintOption() {
 if (!HIDE_GLASS_PRINT || !productTypeArea) return;
 var glassBtns = productTypeArea.querySelectorAll('.customify-product-type-btn[data-product-type="szklo"]');
 glassBtns.forEach(function(btn) {
 btn.style.display = 'none';
 btn.classList.remove('active');
 });
 if (window.__customify && window.__customify.selectedProductType === 'szklo') {
 window.__customify.selectedProductType = 'plakat';
 }
 var hasActive = productTypeArea.querySelector('.customify-product-type-btn.active:not([data-product-type="szklo"])');
 if (!hasActive) {
 var fallback = productTypeArea.querySelector('.customify-product-type-btn[data-product-type="plakat"]') ||
 productTypeArea.querySelector('.customify-product-type-btn[data-product-type="canvas"]');
 if (fallback) fallback.classList.add('active');
 }
 }
 
 function isSzkloSelected() {
 if (HIDE_GLASS_PRINT) return false;
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'szklo';
 }
 
 function setStand(type) {
 window.CustomifyStand.type = type;
 // Aktualizuj UI
 if (standCurrentLabel) {
 standCurrentLabel.textContent =
 type === 'wood' ? `Wooden stand (+${window.customifyApp && window.customifyApp.formatMoney ? window.customifyApp.formatMoney(29) : '$29.00'})` :
 type === 'led' ? `Wooden stand with LED (+${window.customifyApp && window.customifyApp.formatMoney ? window.customifyApp.formatMoney(39.90) : '$39.90'})` :
 'Brak podstawki';
 }
 if (standOptions) {
 var opts = standOptions.querySelectorAll('.stand-option');
 opts.forEach(function(opt){
 opt.setAttribute('aria-selected', opt.getAttribute('data-stand') === type ? 'true' : 'false');
 });
 }
 
 // Aktualizuj ceny po zmianie podstawki
 if (window.__customify) {
 window.__customify.updateProductPrice();
 window.__customify.updateCartPrice();
 }
 }
 
 function toggleStandOptions() {
 if (!standOptions) return;
 var isOpen = standOptions.style.display !== 'none';
 standOptions.style.display = isOpen ? 'none' : 'block';
 if (standSelector) standSelector.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
 }
 
 function closeStandOptions() {
 if (standOptions) {
 standOptions.style.display = 'none';
 if (standSelector) standSelector.setAttribute('aria-expanded', 'false');
 }
 }
 
 // === PAKIETY CYFROWE ===
window.CustomifyDigitalPackage = window.CustomifyDigitalPackage || { count: 1, price: 24.90 };

var DIGITAL_PACKAGE_PRICES = { 1: 24.90, 3: 59.90, 5: 89.90, 10: 149.90 };

 function isDigitalSelected() {
 var active = productTypeArea && productTypeArea.querySelector('.customify-product-type-btn.active');
 return active && active.getAttribute('data-product-type') === 'digital';
 }

 function setDigitalPackage(count) {
 count = parseInt(count, 10) || 1;
 window.CustomifyDigitalPackage.count = count;
 window.CustomifyDigitalPackage.price = DIGITAL_PACKAGE_PRICES[count] || 24.90;

 // Aktualizuj active na przyciskach
 var pkgBtns = document.querySelectorAll('.digital-package-btn');
 pkgBtns.forEach(function(btn) {
 btn.classList.toggle('active', parseInt(btn.getAttribute('data-package'), 10) === count);
 });

 // Odśwież ceny w UI
 if (window.__customify) {
 window.__customify.updateProductPrice();
 window.__customify.updateCartPrice();
 }
 }

 function updateDigitalPackageSelector() {
 var el = document.getElementById('digitalPackageSelector');
 if (!el) return;
 el.style.display = isDigitalSelected() ? 'block' : 'none';
 }

 function initDigitalPackageSelector() {
 var el = document.getElementById('digitalPackageSelector');
 if (!el) return;

 // Obsługa kliknięcia w pakiet
 el.addEventListener('click', function(e) {
 var btn = e.target.closest('.digital-package-btn');
 if (!btn) return;
 setDigitalPackage(btn.getAttribute('data-package'));
 });

 // Ustaw domyślny (1 plik) i pokaż/ukryj
 setDigitalPackage(1);
 updateDigitalPackageSelector();
 }
 // === KONIEC PAKIETY CYFROWE ===

 function updateStandAvailability() {
 var enabled = isSzkloSelected();
 
 if (standSelector) {
 if (enabled) {
 standSelector.style.display = 'block';
 standSelector.classList.remove('disabled');
 } else {
 standSelector.style.display = 'none';
 standSelector.classList.add('disabled');
 closeStandOptions();
 }
 }
 }
 
 function updateSizeAvailability() {
 var isSzklo = isSzkloSelected();
 var isPlakat = isPlakatSelected();
 var marketContext = window.CustomifyMarketContext || window.CustomifyI18n || {};
 var isGermanyPricing = String(marketContext.country || '').toUpperCase() === 'DE'
 && String(marketContext.currency || '').toUpperCase() === 'EUR';
 var isUkPricing = String(marketContext.country || '').toUpperCase() === 'GB'
 && String(marketContext.currency || '').toUpperCase() === 'GBP';
 var sizeButtons = document.querySelectorAll('.customify-size-btn');
 
 sizeButtons.forEach(function(btn) {
 var size = btn.getAttribute('data-size');
 if (isSzklo) {
 // Dla szkła: tylko A5 i A4 widoczne
 if (size === 'a5' || size === 'a4') {
 btn.style.display = 'block';
 } else {
 btn.style.display = 'none';
 }
 } else if (isPlakat) {
 // Germany and UK have no exact Gelato 50×75 poster; do not substitute 50×70.
 if (size === 'a5' || size === 'a0') {
 btn.style.display = 'none';
 } else {
 btn.style.display = 'block';
 }
 } else {
 // Dla canvas: A4, A3, A2, A0, A1 widoczne (bez A5)
 if (size === 'a5') {
 btn.style.display = 'none';
 } else {
 btn.style.display = 'block';
 }
 }
 });
 
 // Jeśli aktualnie wybrany rozmiar jest ukryty, wybierz pierwszy widoczny
 if (window.__customify && window.__customify.selectedSize) {
 var currentBtn = document.querySelector('.customify-size-btn[data-size="' + window.__customify.selectedSize + '"]');
 if (currentBtn && currentBtn.style.display === 'none') {
 // Wybierz pierwszy widoczny rozmiar
 var firstVisible = Array.from(sizeButtons).find(function(b) { return b.style.display !== 'none'; });
 if (firstVisible) {
 firstVisible.click();
 }
 }
 }
 }

 // Inicjalizacja UI ramki i podstawki
 hideGlassPrintOption();
 setFrame(window.CustomifyFrame.color || 'none');
 setStand(window.CustomifyStand.type || 'none');
 updateFrameAvailability();
 updateStandAvailability();
 updateSizeAvailability();
 initDigitalPackageSelector();
 // 🚨 ROLLBACK: START - Inicjalizacja UI produktu cyfrowego
 updateDigitalProductUI();
 // 🚨 ROLLBACK: END - Inicjalizacja UI produktu cyfrowego

 // Zdarzenia UI
 if (frameToggle) {
 frameToggle.addEventListener('click', function(e){
 if (frameSelector && frameSelector.classList.contains('disabled')) return;
 toggleOptions();
 });
 }
 if (frameOptions) {
 frameOptions.addEventListener('click', function(e){
 var target = e.target.closest('.frame-option');
 if (!target) return;
 if (frameSelector && frameSelector.classList.contains('disabled')) return;
 if (target.style.display === 'none') return;
 var color = target.getAttribute('data-frame');
 setFrame(color);
 closeOptions();
 if (window.__customify && typeof window.__customify.updateCartPrice === 'function') {
 window.__customify.updateCartPrice();
 if (typeof window.__customify.updateProductPrice === 'function') {
 window.__customify.updateProductPrice();
 }
 }
 });
 }
 document.addEventListener('click', function(e){
 if (!frameSelector) return;
 if (!frameSelector.contains(e.target)) closeOptions();
 });
 
 // 🆕 Event listenery dla podstawki (szkło)
 if (standToggle) {
 standToggle.addEventListener('click', function(e){
 if (standSelector && standSelector.classList.contains('disabled')) return;
 toggleStandOptions();
 });
 }
 if (standOptions) {
 standOptions.addEventListener('click', function(e){
 var target = e.target.closest('.stand-option');
 if (!target) return;
 if (standSelector && standSelector.classList.contains('disabled')) return;
 var type = target.getAttribute('data-stand');
 setStand(type);
 closeStandOptions();
 });
 }
 document.addEventListener('click', function(e){
 if (!standSelector) return;
 if (!standSelector.contains(e.target)) closeStandOptions();
 });

 // Nasłuchiwanie na zmianę typu produktu (Plakat/Canvas/Szkło/Digital)
 var typeBtns = productTypeArea ? productTypeArea.querySelectorAll('.customify-product-type-btn') : [];
 typeBtns.forEach(function(btn){
 btn.addEventListener('click', function(){
 // Daj czas istniejącym handlerom na ustawienie .active
 setTimeout(function(){
 updateSizeAvailability(); // Najpierw ustal rozmiar, potem dostępność ramy.
 updateFrameAvailability();
 setFrame(window.CustomifyFrame.color || 'none');
 updateStandAvailability(); // 🆕 Aktualizuj dostępność podstawki
 updateDigitalPackageSelector(); // 🆕 Pakiety cyfrowe
 // 🚨 ROLLBACK: START - Aktualizuj UI produktu cyfrowego
 updateDigitalProductUI();
 // 🚨 ROLLBACK: END - Aktualizuj UI produktu cyfrowego
 }, 0);
 });
 });

 // A2 poster loses its frame when selected; other poster sizes retain frames.
 var sizeArea = document.getElementById('sizeArea');
 if (sizeArea) {
 sizeArea.addEventListener('click', function(e) {
 if (!e.target.closest('.customify-size-btn')) return;
 setTimeout(updateFrameAvailability, 0);
 });
 }
 
// 🆕 AUTO-INICJALIZACJA dla produktów ze szkłem
var currentUrl = window.location.pathname.toLowerCase();
var isSzkloProduct = currentUrl.includes('szkle') ||
currentUrl.includes('szklo') ||
currentUrl.includes('akryl') ||
currentUrl.includes('karykatura-dla-niej') ||
currentUrl.includes('salon-spa') ||
currentUrl.includes('nauczycielki-karykatura-na-prezent');
 
 if (isSzkloProduct && !HIDE_GLASS_PRINT) {
 console.log('🔍 [SZKLO] Produkt ze szkłem wykryty - automatyczne filtrowanie rozmiarów');
 // Ustaw szkło jako wybrany typ
 if (window.__customify) {
 window.__customify.selectedProductType = 'szklo';
 }
 // Wywoła updateSizeAvailability() żeby pokazać tylko A5 i A4
 updateStandAvailability();
 updateSizeAvailability();
 
 // 🆕 AUTO-ZAZNACZ ROZMIAR A5 jako domyślny dla szkła
 setTimeout(function() {
 var a5Btn = document.querySelector('.customify-size-btn[data-size="a5"]');
 var activeBtn = document.querySelector('.customify-size-btn.active');
 var activeSize = activeBtn ? activeBtn.getAttribute('data-size') : null;
 if (a5Btn && activeSize !== 'a5') {
 a5Btn.click();
 console.log('✅ [SZKLO] Automatycznie zaznaczono rozmiar A5');
 }
 }, 100);
 
 console.log('✅ [SZKLO] Automatycznie pokazano tylko rozmiary dla szkła (A5, A4)');
 }
 });

// ====================================================
// CART WATERMARK INTEGRATION
// ====================================================
 (function() {
 
 // Funkcja dodawania watermarku do obrazka
 async function addWatermarkToImage(imageUrl) {
 return new Promise((resolve, reject) => {
 const img = new Image();
 img.crossOrigin = 'anonymous';
 
 img.onload = () => {
 try {
 const canvas = document.createElement('canvas');
 const ctx = canvas.getContext('2d');
 
 canvas.width = img.width;
 canvas.height = img.height;
 
 // Rysuj oryginalny obraz
 ctx.drawImage(img, 0, 0);
 
 // ===== WZÓR DIAGONALNY - "GiftedPhotos.com" =====
 ctx.save();
 
 // ✅ ZWIĘKSZONY FONT I OPACITY DLA LEPSZEJ WIDOCZNOŚCI
 const fontSize = Math.max(40, Math.min(canvas.width, canvas.height) * 0.08); // Min 40px, max 8% obrazu
 
 // ✅ FIX: Użyj systemowego fontu z fallbackami (Arial może nie być dostępny w Canvas)
 // Użyj fontu który ZAWSZE jest dostępny w przeglądarce
 const fontFamily = 'sans-serif'; // Systemowy font - zawsze dostępny
 ctx.font = `bold ${fontSize}px ${fontFamily}`;
 
 // ✅ SPRAWDŹ CZY FONT JEST ZAŁADOWANY (test renderowania)
 ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'; // ✅ ZWIĘKSZONA OPACITY (było 0.5)
 ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)'; // ✅ ZWIĘKSZONA OPACITY (było 0.35)
 ctx.lineWidth = 2; // ✅ ZWIĘKSZONA GRUBOŚĆ (było 1.5)
 ctx.textAlign = 'center';
 ctx.textBaseline = 'middle';
 
 // ✅ TEST: Sprawdź czy tekst się renderuje (jeśli nie - użyj innego fontu)
 const testText = 'Test';
 const testMetrics = ctx.measureText(testText);
 if (testMetrics.width === 0) {
 console.warn('⚠️ [WATERMARK] Font test failed, using fallback');
 ctx.font = `bold ${fontSize}px monospace`; // Fallback na monospace
 }
 
 // Obróć canvas
 ctx.translate(canvas.width/2, canvas.height/2);
 ctx.rotate(-30 * Math.PI / 180);
 ctx.translate(-canvas.width/2, -canvas.height/2);
 
 // Rysuj watermarki w siatce
 const spacing = Math.max(200, Math.min(canvas.width, canvas.height) * 0.3); // ✅ DYNAMICZNY SPACING
 let textIndex = 0;
 const texts = ['GiftedPhotos.com'];
 
 for(let y = -canvas.height; y < canvas.height * 2; y += spacing) {
 for(let x = -canvas.width; x < canvas.width * 2; x += spacing * 1.5) {
 const text = texts[0];
 // ✅ RYSUJ STROKE PRZED FILL (dla lepszej widoczności)
 ctx.strokeText(text, x, y);
 ctx.fillText(text, x, y);
 textIndex++;
 }
 // Zmień wzór co wiersz dla lepszego efektu
 textIndex++;
 }
 
 ctx.restore();
 
 // Zwróć obraz z watermarkiem jako Data URL
 resolve(canvas.toDataURL('image/jpeg', 0.92));
 console.log('✅ [CUSTOMIFY CART] Watermark dodany do miniaturki');
 } catch (error) {
 console.error('❌ [CUSTOMIFY CART] Watermark error:', error);
 if (typeof Sentry !== 'undefined' && Sentry.captureException) { Sentry.captureException(error, { tags: { customify_area: 'cart-watermark' } }); }
 reject(error);
 }
 };
 
 img.onerror = (error) => {
 console.error('❌ [CUSTOMIFY CART] Image load error:', error);
 reject(error);
 };
 
 img.src = imageUrl;
 });
 }
 
 function showImageLightbox(imageUrl) {
 console.log('🔍 [CUSTOMIFY CART] Pokazuję lightbox dla:', imageUrl);
 
 // Stwórz overlay
 const overlay = document.createElement('div');
 overlay.className = 'customify-lightbox';
 
 // Dodaj powiększony obraz
 const img = document.createElement('img');
 img.src = imageUrl;
 img.alt = 'Enlarged AI image';
 
 // Przycisk zamknięcia
 const closeBtn = document.createElement('button');
 closeBtn.className = 'customify-lightbox-close';
 closeBtn.innerHTML = '×';
 closeBtn.setAttribute('aria-label', 'Zamknij');
 
 overlay.appendChild(img);
 overlay.appendChild(closeBtn);
 
 // Zamknij po kliknięciu overlay lub przycisku
 overlay.addEventListener('click', (e) => {
 if (e.target === overlay || e.target === closeBtn) {
 overlay.remove();
 console.log('🔍 [CUSTOMIFY CART] Lightbox zamknięty');
 }
 });
 
 // Zamknij po ESC
 const handleEsc = (e) => {
 if (e.key === 'Escape') {
 overlay.remove();
 document.removeEventListener('keydown', handleEsc);
 console.log('🔍 [CUSTOMIFY CART] Lightbox zamknięty (ESC)');
 }
 };
 document.addEventListener('keydown', handleEsc);
 
 document.body.appendChild(overlay);
 }
 
 function disableAIProductLinks() {

 
 // Znajdź wszystkie elementy koszyka (różne selektory dla różnych motywów)
 const cartItems = document.querySelectorAll(
 '.cart-item, .cart-items__table-row, .cart-items__row, [data-line-item], .line-item, .cart__line-item, tr[role="row"]'
 );
 

 
 cartItems.forEach((item, index) => {
 // Znajdź wszystkie linki w tym elemencie (miniaturka + tytuł)
 const links = item.querySelectorAll('a[href*="/products/"]');
 console.log(`🔗 [CUSTOMIFY CART] Element ${index} - znaleziono linków: ${links.length}`);
 
 links.forEach(async (link, linkIndex) => {
 // Sprawdź czy już przetworzono ten link (unikaj wielokrotnego dodawania event listenerów)
 if (link.dataset.customifyProcessed === 'true') {
 console.log(`⏭️ [CUSTOMIFY CART] Link ${linkIndex} już przetworzony - pomijam`);
 return;
 }
 
 // Oznacz jako przetworzony
 link.dataset.customifyProcessed = 'true';
 
 // Znajdź obrazek w linku
 const img = link.querySelector('img');
 
 if (img) {
 // To jest link z miniaturką - sprawdź czy mamy URL z watermarkiem w cart properties
 console.log(`🖼️ [CUSTOMIFY CART] Link ${linkIndex} ma obrazek`);
 console.log(` Obrazek src: ${img.src}`);
 
 // Znajdź cart properties dla tego produktu
 const cartItem = link.closest('.cart-item, .cart-items__table-row, tr[role="row"]');
 let watermarkedUrl = null;
 
if (cartItem) {
const properties = cartItem.querySelectorAll('dd, .product-option dd');
 properties.forEach(prop => {
 const dt = prop.previousElementSibling;
 if (!dt) return;

 const propertyName = dt.textContent.trim();
 const normalizedName = propertyName.replace(/\s+/g, '').toLowerCase();

 if (normalizedName.includes('ai_image_watermarked')) {
 watermarkedUrl = prop.textContent.trim();
 console.log('✅ [CUSTOMIFY CART] Znaleziono URL z watermarkiem:', watermarkedUrl);
 }

// ✅ UKRYJ "Styl AI", "Rozmiar", "Rodzaj wydruku" i wszystkie ukryte properties
if (propertyName.startsWith('_') || 
normalizedName.includes('ai_image_') || 
normalizedName.includes('styl ai') || 
normalizedName === 'stylai' ||
propertyName === 'Styl AI' ||
propertyName.toLowerCase() === 'styl ai' ||
propertyName.includes('Styl AI') ||
propertyName.includes('styl ai') ||
propertyName === 'Rozmiar' || propertyName === 'Size' ||
propertyName === 'Print type' ||
propertyName.includes('Photo link') || propertyName.includes('Link do zdjęcia')) {
dt.style.display = 'none';
prop.style.display = 'none';
console.log('🙈 [CUSTOMIFY CART] Ukryto property:', propertyName);
}
 });
 }
 
 // ✅ Główny obrazek produktu w Shopify jest już Z watermarkiem (uploadowany z watermarkedImage)
 // ✅ Miniaturka: mała (250px) - Shopify automatycznie
 // ✅ Lightbox: DUŻA (1200px) - zmieniamy parametr width w URL
 
 let originalSrc = img.src;
 console.log('🖼️ [CUSTOMIFY CART] Oryginalny src:', originalSrc);
 
 // Zmień URL Shopify na większy rozmiar dla lightbox (1200px zamiast 250px)
 if (originalSrc.includes('cdn.shopify.com') || originalSrc.includes('lumly.pl/cdn/')) {
 let largeImageSrc = originalSrc;
 
 if (largeImageSrc.includes('width=')) {
 // Zmień istniejący parametr width
 largeImageSrc = largeImageSrc.replace(/width=\d+/, 'width=1200');
 } else {
 // Dodaj parametr width
 largeImageSrc = largeImageSrc + (largeImageSrc.includes('?') ? '&' : '?') + 'width=1200';
 }
 
 img.dataset.watermarkedSrc = largeImageSrc;
 console.log('✅ [CUSTOMIFY CART] Przygotowano większy obrazek (1200px):', largeImageSrc);
 } else {
 // Nie ma cdn.shopify.com - zostaw oryginalny
 img.dataset.watermarkedSrc = originalSrc;
 console.log('⚠️ [CUSTOMIFY CART] To nie jest Shopify CDN URL - używam oryginalnego');
 }
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 console.log('🖼️ [CUSTOMIFY CART] Kliknięto miniaturkę - pokazuję lightbox');
 
 // Użyj większego obrazka (1200px) przygotowanego wcześniej
 const imageToShow = img.dataset.watermarkedSrc || img.src;
 console.log('📏 [CUSTOMIFY CART] Pokazuję obrazek:', imageToShow);
 
 showImageLightbox(imageToShow);
 });
 
 // Zmień cursor na zoom-in
 link.style.cursor = 'zoom-in';
 link.title = 'Click to enlarge';
 } else {
 // To jest link z tytułem - wyłącz całkowicie
 console.log(`📝 [CUSTOMIFY CART] Link ${linkIndex} to tytuł - wyłączam`);
 console.log(` Link href: ${link.href}`);
 console.log(` Link text: ${link.textContent.trim()}`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 console.log('📝 [CUSTOMIFY CART] Kliknięto tytuł - blokuję');
 });
 
 link.style.cursor = 'default';
 link.style.pointerEvents = 'none';
 link.style.textDecoration = 'none';
 }
 });
 });
 
 console.log(`✅ [CUSTOMIFY CART] Wyłączono linki dla ${cartItems.length} produktów`);
 }
 
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', disableAIProductLinks);
} else {
disableAIProductLinks();
}

document.addEventListener('cart:updated', () => {
setTimeout(disableAIProductLinks, 500);
});
 
 // Obserwuj zmiany w DOM (dla dynamicznych aktualizacji koszyka)
 const observer = new MutationObserver((mutations) => {
 // Sprawdź czy zmiana nie jest w lightbox (ignoruj zmiany w lightbox)
 const isLightboxChange = mutations.some(mutation => {
 return Array.from(mutation.addedNodes).some(node => {
 return node.classList && node.classList.contains('customify-lightbox');
 }) || Array.from(mutation.removedNodes).some(node => {
 return node.classList && node.classList.contains('customify-lightbox');
 });
 });
 
 if (isLightboxChange) {

 return;
 }
 

 disableAIProductLinks();
 });
 
 // Obserwuj zmiany tylko w kontenerze koszyka (nie w całym body)
 const cartContainer = document.querySelector('.cart-items, .cart, [data-cart-items]') || document.body;
 observer.observe(cartContainer, {
 childList: true,
 subtree: true
 });
 
 console.log('✅ [CUSTOMIFY CART] Inicjalizacja zakończona - obserwuję zmiany');
 })();

// ====================================================
// CHECKOUT LINK MODIFICATION
// ====================================================
 (function() {
 // Sprawdź czy jesteśmy na checkout lub thank you page
 const isCheckout = window.location.pathname.includes('/checkout') || 
 window.location.pathname.includes('/thank_you') ||
 window.Shopify?.Checkout;
 
 if (!isCheckout) {
 console.log('🛒 [CUSTOMIFY CHECKOUT] Nie jesteśmy na checkout - pomijam');
 return;
 }
 
 console.log('🛒 [CUSTOMIFY CHECKOUT] Inicjalizacja wyłączania linków produktów AI');
 
 function showImageLightbox(imageUrl) {
 console.log('🔍 [CUSTOMIFY CHECKOUT] Pokazuję lightbox dla:', imageUrl);
 
 // Stwórz overlay
 const overlay = document.createElement('div');
 overlay.style.cssText = `
 position: fixed;
 top: 0;
 left: 0;
 width: 100vw;
 height: 100vh;
 background: rgba(0, 0, 0, 0.9);
 z-index: 99999;
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: zoom-out;
 animation: fadeIn 0.2s ease;
 `;
 
 // Dodaj powiększony obraz
 const img = document.createElement('img');
 img.src = imageUrl;
 img.alt = 'Enlarged AI image';
 img.style.cssText = `
 max-width: 90vw;
 max-height: 90vh;
 object-fit: contain;
 border-radius: 8px;
 box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
 `;
 
 // Przycisk zamknięcia
 const closeBtn = document.createElement('button');
 closeBtn.innerHTML = '×';
 closeBtn.setAttribute('aria-label', 'Zamknij');
 closeBtn.style.cssText = `
 position: absolute;
 top: 20px;
 right: 20px;
 width: 40px;
 height: 40px;
 background: white;
 border: none;
 border-radius: 50%;
 cursor: pointer;
 font-size: 24px;
 font-weight: bold;
 color: #333;
 display: flex;
 align-items: center;
 justify-content: center;
 box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
 transition: all 0.2s ease;
 `;
 
 overlay.appendChild(img);
 overlay.appendChild(closeBtn);
 
 // Zamknij po kliknięciu overlay lub przycisku
 overlay.addEventListener('click', (e) => {
 if (e.target === overlay || e.target === closeBtn) {
 overlay.remove();
 console.log('🔍 [CUSTOMIFY CHECKOUT] Lightbox zamknięty');
 }
 });
 
 // Zamknij po ESC
 const handleEsc = (e) => {
 if (e.key === 'Escape') {
 overlay.remove();
 document.removeEventListener('keydown', handleEsc);
 console.log('🔍 [CUSTOMIFY CHECKOUT] Lightbox zamknięty (ESC)');
 }
 };
 document.addEventListener('keydown', handleEsc);
 
 document.body.appendChild(overlay);
 }
 
 function disableAIProductLinks() {
 console.log('🛒 [CUSTOMIFY CHECKOUT] Wyłączam linki dla wszystkich produktów w checkout...');
 
 // Znajdź wszystkie elementy checkout (różne selektory dla Shopify checkout)
 const checkoutItems = document.querySelectorAll(
 '.product, .product-thumbnail, [data-product-table], .order-summary__section--product-list .product, .review-block__content .product'
 );
 
 console.log('🛒 [CUSTOMIFY CHECKOUT] Znaleziono elementów checkout:', checkoutItems.length);
 
 checkoutItems.forEach((item, index) => {
 // Znajdź wszystkie linki w tym elemencie
 const links = item.querySelectorAll('a[href*="/products/"]');
 console.log(`🔗 [CUSTOMIFY CHECKOUT] Element ${index} - znaleziono linków: ${links.length}`);
 
 links.forEach((link, linkIndex) => {
 // Znajdź obrazek w linku
 const img = link.querySelector('img');
 
 if (img) {
 // To jest link z miniaturką - wyłącz i dodaj lightbox
 console.log(`🖼️ [CUSTOMIFY CHECKOUT] Link ${linkIndex} ma obrazek - dodaję lightbox`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 showImageLightbox(img.src);
 });
 
 // Zmień cursor na zoom-in
 link.style.cursor = 'zoom-in';
 link.title = 'Click to enlarge';
 } else {
 // To jest link z tytułem - wyłącz całkowicie
 console.log(`📝 [CUSTOMIFY CHECKOUT] Link ${linkIndex} to tytuł - wyłączam`);
 
 link.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 });
 
 link.style.cursor = 'default';
 link.style.pointerEvents = 'none';
 link.style.textDecoration = 'none';
 }
 });
 });
 
 console.log(`✅ [CUSTOMIFY CHECKOUT] Wyłączono linki dla ${checkoutItems.length} produktów`);
 }
 
 // Uruchom po załadowaniu DOM
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', disableAIProductLinks);
 } else {
 disableAIProductLinks();
 }
 
 // Uruchom ponownie po zmianach (Shopify checkout może się dynamicznie aktualizować)
 setTimeout(disableAIProductLinks, 1000);
 setTimeout(disableAIProductLinks, 2000);
 
 console.log('✅ [CUSTOMIFY CHECKOUT] Inicjalizacja zakończona');
 })();


// ====================================================
// CONTACT PAGE FUNCTIONALITY
// ====================================================
 document.addEventListener('DOMContentLoaded', function() {
 // Sprawdź czy jesteśmy na stronie kontakt
 if (window.location.pathname.includes('/pages/kontakt') || window.location.pathname.includes('/policies/contact-information')) {
 // Czekaj chwilę, żeby DOM się załadował
 setTimeout(function() {
 // Znajdź główną treść strony - szukaj po różnych selektorach
 let targetElement = null;
 
 // Próbuj znaleźć główną sekcję z treścią
 const selectors = [
 '#MainContent',
 'main',
 '.main-content',
 '.page-content',
 '.rte',
 '.page__content',
 '.page-content-wrapper',
 '[class*="policy"]',
 '[class*="content"]',
 'article',
 '.content-for-layout',
 '[class*="page"]'
 ];
 
 for (const selector of selectors) {
 const element = document.querySelector(selector);
 if (element && element.offsetHeight > 0) {
 targetElement = element;
 break;
 }
 }
 
 // Jeśli nie znaleziono, szukaj po nagłówku h1
 if (!targetElement) {
 const h1 = document.querySelector('h1');
 if (h1) {
 // Znajdź najbliższy kontener z treścią
 targetElement = h1.closest('div, section, article, main') || h1.parentElement;
 }
 }
 
 // Ostatecznie użyj body, ale znajdź miejsce przed footerem
 if (!targetElement) {
 const footer = document.querySelector('footer, [class*="footer"]');
 if (footer) {
 targetElement = footer;
 } else {
 targetElement = document.body;
 }
 }
 
 if (targetElement) {
 // Utwórz formularz kontaktowy
 const contactFormHTML = `
 <div id="contact-form-container" style="
 max-width: 600px;
 margin: 40px auto;
 padding: 30px;
 background: #fff;
 border-radius: 8px;
 box-shadow: 0 2px 8px rgba(0,0,0,0.1);
 ">
 <h2 style="
 font-size: 24px;
 font-weight: 600;
 margin-bottom: 20px;
 color: #333;
 ">Send a message</h2>
 
 <form id="contactForm" style="display: flex; flex-direction: column; gap: 16px;">
 <div>
 <label for="contactName" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Full name *
 </label>
 <input 
 type="text" 
 id="contactName" 
 name="name" 
 required
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactEmail" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Email *
 </label>
 <input 
 type="email" 
 id="contactEmail" 
 name="email" 
 required
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactSubject" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Temat
 </label>
 <input 
 type="text" 
 id="contactSubject" 
 name="subject"
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 box-sizing: border-box;
 "
 >
 </div>
 
 <div>
 <label for="contactMessage" style="display: block; margin-bottom: 6px; font-weight: 500; color: #555;">
 Message *
 </label>
 <textarea 
 id="contactMessage" 
 name="message" 
 required
 rows="6"
 style="
 width: 100%;
 padding: 12px;
 border: 1px solid #ddd;
 border-radius: 4px;
 font-size: 16px;
 font-family: inherit;
 box-sizing: border-box;
 resize: vertical;
 "
 ></textarea>
 </div>
 
 <button 
 type="submit"
 style="
 background: #000;
 color: #fff;
 padding: 14px 28px;
 border: none;
 border-radius: 4px;
 font-size: 16px;
 font-weight: 600;
 cursor: pointer;
 transition: background 0.2s;
 "
 onmouseover="this.style.background='#333'"
 onmouseout="this.style.background='#000'"
 >
 Send message
 </button>
 
 <div id="contactFormMessage" style="
 margin-top: 12px;
 padding: 12px;
 border-radius: 4px;
 display: none;
 "></div>
 </form>
 </div>
 `;
 
 // Jeśli targetElement to footer, dodaj przed nim
 if (targetElement.tagName === 'FOOTER' || targetElement.className.includes('footer')) {
 targetElement.insertAdjacentHTML('beforebegin', contactFormHTML);
 } else {
 // W przeciwnym razie dodaj na końcu elementu
 targetElement.insertAdjacentHTML('beforeend', contactFormHTML);
 }
 
 // Obsługa formularza
 const form = document.getElementById('contactForm');
 const messageDiv = document.getElementById('contactFormMessage');
 
 if (form) {
 form.addEventListener('submit', async function(e) {
 e.preventDefault();
 
 const formData = {
 name: document.getElementById('contactName').value,
 email: document.getElementById('contactEmail').value,
 subject: document.getElementById('contactSubject').value || 'Website contact',
 message: document.getElementById('contactMessage').value
 };
 
 // Wyłącz przycisk podczas wysyłania
 const submitBtn = form.querySelector('button[type="submit"]');
 submitBtn.disabled = true;
 submitBtn.textContent = 'Sending...';
 
 try {
 const response = await fetch(window.CustomifyApi.url('/api/contact-form'), {
 method: 'POST',
 headers: {
 'Content-Type': 'application/json'
 },
 body: JSON.stringify(formData)
 });
 
 const result = await response.json();
 
 if (response.ok && result.success) {
 messageDiv.style.display = 'block';
 messageDiv.style.background = '#E8F5E9';
 messageDiv.style.color = '#2E7D32';
 messageDiv.textContent = '✅ ' + result.message;
 form.reset();
 } else {
 throw new Error(result.error || 'Message sending failed');
 }
 } catch (error) {
 messageDiv.style.display = 'block';
 messageDiv.style.background = '#FFEBEE';
 messageDiv.style.color = '#C62828';
 messageDiv.textContent = 'Error: ' + error.message;
 } finally {
 submitBtn.disabled = false;
 submitBtn.textContent = 'Send message';
 }
}); // Zamknij addEventListener
} // Zamknij if (form)
} // Zamknij if (targetElement)
}, 500); // Czekaj 500ms na załadowanie DOM
}
});

// ============================================================
// SYSTEM KREDYTÓW – pobieranie pliku cyfrowego za kredyt
// ============================================================
(function() {
  'use strict';

 var CREDITS_API_BASE = window.CustomifyApi.baseUrl;

  var el = {};
  var currentCredits = 0;
  var creditsChecked = false;

  function getCustomerId() {
    return window.ShopifyCustomer && window.ShopifyCustomer.id ? window.ShopifyCustomer.id : null;
  }
  function getCustomerEmail() {
    return window.ShopifyCustomer && window.ShopifyCustomer.email ? window.ShopifyCustomer.email : '';
  }

  function initCreditsUI() {
    el.section    = document.getElementById('creditsSection');
    el.loading    = document.getElementById('creditsLoading');
    el.available  = document.getElementById('creditsAvailable');
    el.empty      = document.getElementById('creditsEmpty');
    el.notLogged  = document.getElementById('creditsNotLoggedIn');
    el.success    = document.getElementById('creditsSuccess');
    el.error      = document.getElementById('creditsError');
    el.useBtn     = document.getElementById('useCreditsBtn');
    el.balanceInfo= document.getElementById('creditsBalanceInfo');
    el.successMsg = document.getElementById('creditsSuccessMsg');
    el.errorMsg   = document.getElementById('creditsErrorMsg');

    if (!el.section) return;

    var productTypeArea = document.getElementById('productTypeArea');
    if (productTypeArea) {
      productTypeArea.addEventListener('click', function(e) {
        var btn = e.target.closest('.customify-product-type-btn');
        if (!btn) return;
        setTimeout(function() {
          onProductTypeChanged(btn.getAttribute('data-product-type'));
        }, 50);
      });
    }

    if (el.useBtn) el.useBtn.addEventListener('click', handleUseCredit);

    var activBtn = document.querySelector('.customify-product-type-btn.active');
    if (activBtn) onProductTypeChanged(activBtn.getAttribute('data-product-type'));

    watchResultArea();
  }

  function onProductTypeChanged(type) {
    if (!el.section) return;
    if (type !== 'digital') { el.section.style.display = 'none'; return; }

    var resultArea = document.getElementById('resultArea');
    if (resultArea && resultArea.style.display === 'none') {
      el.section.style.display = 'none';
      return;
    }

    el.section.style.display = 'block';
    hideAll();

    var customerId = getCustomerId();
    if (!customerId) { showState('notLogged'); return; }
    if (creditsChecked) { showByBalance(); return; }
    fetchCredits();
  }

  function fetchCredits() {
    showState('loading');
    creditsChecked = false;
    var customerId = getCustomerId();

    fetch(CREDITS_API_BASE + '/api/credits/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ customerId: customerId })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      currentCredits = data.credits || 0;
      creditsChecked = true;
      showByBalance();
    })
    .catch(function(err) {
      console.error('[CREDITS] Błąd sprawdzania kredytów:', err);
      if (el.section) el.section.style.display = 'none';
    });
  }

  function showByBalance() {
    if (currentCredits > 0) {
      showState('available');
      if (el.balanceInfo) el.balanceInfo.textContent = 'Masz ' + currentCredits + ' ' + label(currentCredits);
    } else {
      showState('empty');
    }
  }

  function handleUseCredit() {
    var inst = window.__customify;
    if (!inst) { showError('Application error. Refresh the page.'); return; }

    var imageUrl = null;
    if (inst.cleanImageUrl && inst.cleanImageUrl.startsWith('http')) imageUrl = inst.cleanImageUrl;
    else if (inst.transformedImage && inst.transformedImage.startsWith('http')) imageUrl = inst.transformedImage;

    if (!imageUrl) { showError('No image found. Generate your portrait first.'); return; }

    var customerId = getCustomerId();
    if (!customerId) { showError('You must be logged in.'); return; }

    if (el.useBtn) { el.useBtn.disabled = true; el.useBtn.textContent = 'Sending...'; }

    fetch(CREDITS_API_BASE + '/api/credits/use', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ customerId: customerId, imageUrl: imageUrl, style: inst.selectedStyle || '' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.success) {
        currentCredits = data.creditsRemaining || 0;
        creditsChecked = true;
        showState('success');
        if (el.successMsg) {
          el.successMsg.textContent = 'Email sent to ' + getCustomerEmail() + '. Remaining: ' + currentCredits + ' ' + label(currentCredits) + '.';
        }
      } else {
        showError(data.error || 'Could not use the credit.');
        if (el.useBtn) { el.useBtn.disabled = false; el.useBtn.textContent = 'Download for 1 credit'; }
      }
    })
    .catch(function(err) {
      console.error('[CREDITS] Błąd użycia kredytu:', err);
      showError('Connection error. Try again.');
      if (el.useBtn) { el.useBtn.disabled = false; el.useBtn.textContent = 'Download for 1 credit'; }
    });
  }

  function watchResultArea() {
    var resultArea = document.getElementById('resultArea');
    if (!resultArea) { setTimeout(watchResultArea, 500); return; }

    new MutationObserver(function() {
      var isVisible = resultArea.style.display !== 'none';
      var activeBtn = document.querySelector('.customify-product-type-btn.active');
      var isDigital = activeBtn && activeBtn.getAttribute('data-product-type') === 'digital';
      if (isVisible && isDigital && el.section) {
        el.section.style.display = 'block';
        var customerId = getCustomerId();
        if (!creditsChecked && customerId) fetchCredits();
        else if (creditsChecked) showByBalance();
        else if (!customerId) showState('notLogged');
      }
    }).observe(resultArea, { attributes: true, attributeFilter: ['style'] });
  }

  function showState(state) {
    hideAll();
    var map = { loading: el.loading, available: el.available, empty: el.empty, notLogged: el.notLogged, success: el.success };
    if (map[state]) map[state].style.display = 'block';
  }
  function hideAll() {
    [el.loading, el.available, el.empty, el.notLogged, el.success, el.error].forEach(function(e) { if (e) e.style.display = 'none'; });
  }
  function showError(msg) {
    hideAll();
    if (el.error && el.errorMsg) { el.errorMsg.textContent = msg; el.error.style.display = 'block'; }
  }
  function label(n) {
    if (n === 1) return 'credit';
    return 'credits';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCreditsUI);
  } else {
    initCreditsUI();
  }
})();

// Runtime currency display guard.
// Some legacy inline theme code can still write "zł"; keep all product-page prices aligned to Shopify.currency.active.
(function() {
  function activeCurrency() {
    return window.CustomifyMoney
      ? window.CustomifyMoney.getDisplayCurrency()
      : ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD');
  }

  function formatMoney(value) {
    if (window.CustomifyMoney) {
      return window.CustomifyMoney.formatShopAmount(value, { baseShopAmount: 39 });
    }
    var amount = Number(value) || 0;
    var currency = activeCurrency();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      var symbol = currency === 'USD' ? '$' : currency === 'CAD' ? 'CA$' : currency + ' ';
      return symbol + amount.toFixed(2);
    }
  }

  function numberFromText(text) {
    var match = String(text || '').replace(/\s/g, '').match(/(\d+(?:[,.]\d+)?)/);
    return match ? Number(match[1].replace(',', '.')) : null;
  }

  function fixStaticCurrencyLabels() {
    document.querySelectorAll('.pkg-price').forEach(function(el) {
      var button = el.closest('[data-price]');
      var value = button ? Number(button.getAttribute('data-price')) : numberFromText(el.textContent);
      if (Number.isFinite(value)) el.textContent = formatMoney(value);
    });

    document.querySelectorAll('.pkg-save').forEach(function(el) {
      var value = numberFromText(el.textContent);
      if (value !== null) el.textContent = 'save ' + formatMoney(value);
    });

    document.querySelectorAll('#cartPriceValue, #phoneCaseCartPriceValue').forEach(function(el) {
      if (String(el.textContent || '').includes('zł')) {
        var value = numberFromText(el.textContent);
        if (value !== null) el.textContent = formatMoney(value);
      }
    });
  }

  function patchInstanceCurrency() {
    var inst = window.__customify || window.customifyApp;
    if (!inst) return false;

    if (!inst.formatMoney) {
      inst.formatMoney = formatMoney;
    }

    var proto = Object.getPrototypeOf(inst);
    if (!proto || proto.__customifyCurrencyGuardPatched) return true;
    proto.__customifyCurrencyGuardPatched = true;

    if (!proto.formatMoney) proto.formatMoney = formatMoney;

    var originalUpdateCartPrice = proto.updateCartPrice;
    if (typeof originalUpdateCartPrice === 'function') {
      proto.updateCartPrice = function() {
        var result = originalUpdateCartPrice.apply(this, arguments);
        setTimeout(fixStaticCurrencyLabels, 0);
        return result;
      };
    }

    var originalUpdateProductPrice = proto.updateProductPrice;
    if (typeof originalUpdateProductPrice === 'function') {
      proto.updateProductPrice = function() {
        var result = originalUpdateProductPrice.apply(this, arguments);
        setTimeout(fixStaticCurrencyLabels, 0);
        return result;
      };
    }

    return true;
  }

  function startCurrencyGuard() {
    fixStaticCurrencyLabels();
    var attempts = 0;
    var timer = setInterval(function() {
      attempts += 1;
      fixStaticCurrencyLabels();
      if (patchInstanceCurrency() || attempts > 80) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCurrencyGuard);
  } else {
    startCurrencyGuard();
  }
})();
